{
  "common.save": "บันทึก",
  "common.cancel": "ยกเลิก",
  "common.delete": "ลบ",
  "common.add": "เพิ่ม",
  "common.remove": "นำออก",
  "common.edit": "แก้ไข",
  "common.more_actions": "การดำเนินการเพิ่มเติม",
  "common.confirm": "ยืนยัน",
  "common.search": "ค้นหา",
  "common.select_placeholder": "เลือก…",
  "common.no_results": "ไม่พบรายการที่ตรงกัน",
  "common.keep_typing_to_narrow": "อีก {{count}} รายการ — พิมพ์ต่อเพื่อจำกัดผลลัพธ์",
  "common.search_placeholder": "ค้นหา…",
  "common.drop_files_hint": "ลากและวางไฟล์ที่นี่ หรือเลือกไฟล์ด้านล่าง",
  "common.items": "รายการ",
  "common.saving": "กำลังบันทึก…",
  "common.deleting": "กำลังลบ…",
  "common.something_went_wrong": "เกิดข้อผิดพลาด",
  "common.updating_to_latest_version": "กำลังอัปเดตเป็นเวอร์ชันล่าสุด…",
  "common.reload": "โหลดใหม่",
  "common.error_body": "เกิดข้อผิดพลาดที่ไม่คาดคิด ข้อมูลของคุณปลอดภัยดี การโหลดหน้าใหม่มักจะช่วยแก้ไขปัญหานี้ได้",
  "common.chunk_update_body": "แอปเพิ่งมีการอัปเดตเวอร์ชันใหม่ หน้านี้จะรีเฟรชให้โดยอัตโนมัติในอีกสักครู่",
  "common.back_to_dashboard": "กลับไปหน้าแดชบอร์ด",
  "common.reference": "รหัสอ้างอิง",
  "common.copy": "คัดลอก",
  "common.record_not_found": "ไม่พบข้อมูลรายการนี้",
  "common.review_form_fields": "กรุณาตรวจสอบข้อมูลในฟอร์มแล้วลองใหม่อีกครั้ง",
  "common.nothing_here_yet": "ยังไม่มีข้อมูล",
  "common.language": "ภาษา",
  "common.theme_light": "เปลี่ยนเป็นโหมดสว่าง",
  "common.theme_dark": "เปลี่ยนเป็นโหมดมืด",
  "common.all": "ทั้งหมด",
  "common.previous": "ก่อนหน้า",
  "common.open_profile": "เปิดโปรไฟล์",
  "common.next": "ถัดไป",
  "common.item_of_total": "{{index}} จาก {{total}}",
  "common.pagination_page_of": "แสดงหน้า {{current}} จาก {{total}}",
  "common.pagination_page_of_with_items": "แสดงหน้า {{current}} จาก {{total}} — {{count}} {{label}}",
  "common.rows_per_page": "แถวต่อหน้า",
  "common.go_to_page": "ไปที่หน้า {{page}}",
  "common.pick_date": "เลือกวันที่",
  "common.pick_datetime": "เลือกวันที่และเวลา",
  "common.time": "เวลา",
  "common.clear": "ล้าง",
  "common.published": "เผยแพร่แล้ว",
  "common.draft": "ฉบับร่าง",
  "common.drafts": "ฉบับร่าง",
  "common.status": "สถานะ",
  "common.active": "กำลังใช้งาน",
  "common.closed": "สิ้นสุดแล้ว",
  "common.coming_soon": "เร็ว ๆ นี้",
  "common.sst_private": "ส่วนตัวสำหรับ SST",
  "common.period_label": "ช่วงเวลา",
  "common.period.all": "ทั้งหมด",
  "common.period.active": "ที่ยังไม่สิ้นสุด",
  "common.period.yesterday": "เมื่อวาน",
  "common.period.today": "วันนี้",
  "common.period.tomorrow": "พรุ่งนี้",
  "common.period.this-week": "สัปดาห์นี้",
  "common.period.next-week": "สัปดาห์หน้า",
  "common.period.expired": "สิ้นสุดแล้ว",
  "common.title": "หัวข้อ",
  "common.date": "วันที่",
  "common.from": "จาก",
  "common.to": "ถึง",
  "common.actions": "การดำเนินการ",
  "common.category": "หมวดหมู่",
  "common.views": "ยอดเข้าชม",
  "common.manage_categories": "จัดการหมวดหมู่",
  "common.publish": "เผยแพร่",
  "common.unpublish": "ยกเลิกการเผยแพร่",
  "common.unpublish_tooltip": "ซ่อนจากเว็บไซต์สาธารณะ (กลับเป็นฉบับร่าง)",
  "common.approve": "อนุมัติ",
  "common.reject": "ปฏิเสธ",
  "common.approving": "กำลังอนุมัติ…",
  "common.rejecting": "กำลังปฏิเสธ…",
  "common.message_optional": "ข้อความ (ไม่บังคับ)",
  "common.staff": "เจ้าหน้าที่",
  "common.record": "บันทึก",
  "common.all_fields_required": "กรุณากรอกข้อมูลให้ครบทุกช่อง",
  "common.select_student": "เลือกนักเรียน",
  "common.student": "นักเรียน",
  "common.reason": "เหตุผล",
  "common.submitted_by": "ผู้ส่งคำขอ",
  "common.action": "การดำเนินการ",
  "common.this_student": "นักเรียนคนนี้",
  "common.update_failed": "ไม่สามารถอัปเดตข้อมูลได้",
  "common.search_by_student": "ค้นหาด้วยชื่อนักเรียน…",
  "common.yes": "ใช่",
  "common.no": "ไม่ใช่",
  "common.loading": "กำลังโหลด…",
  "common.download": "ดาวน์โหลด",
  "common.back": "กลับ",
  "shell.staff_portal": "พอร์ทัลบุคลากร",
  "shell.sign_out": "ออกจากระบบ",
  "role.admin": "ผู้ดูแลระบบ",
  "role.teacher": "ครู",
  "role.student": "นักเรียน",
  "role.employee": "พนักงาน",
  "role.parent": "ผู้ปกครอง",
  "nav.sparky": "การเรียนรู้กับ Sparky",
  "nav.dashboard": "แดชบอร์ด",
  "nav.open_menu": "เปิดเมนู",
  "nav.news": "ข่าวสาร",
  "nav.school_calendar": "ปฏิทินโรงเรียน",
  "nav.thai_events": "กิจกรรมไทย",
  "nav.announcements": "ประกาศ",
  "nav.communications": "การสื่อสาร",
  "nav.statistics": "สถิติ",
  "nav.teachers": "ครู",
  "nav.weekly_menus": "เมนูอาหารประจำสัปดาห์",
  "nav.contact_inquiries": "ข้อความติดต่อสอบถาม",
  "nav.tour_requests": "คำขอเยี่ยมชม",
  "nav.inquiries": "ข้อความติดต่อ",
  "nav.sand_dollars_award": "มอบรางวัล",
  "nav.all_awards": "รางวัลทั้งหมด",
  "nav.sand_dollars_stats": "สถิติแซนด์ดอลลาร์",
  "nav.sand_dollars_records": "รางวัลและสถิติ",
  "nav.sand_dollars_config": "ตั้งค่าแซนด์ดอลลาร์",
  "nav.house_points": "คะแนนบ้าน",
  "nav.my_leaves": "การลาของฉัน",
  "nav.leave_requests": "คำขอลา",
  "nav.immigration_compliance": "การปฏิบัติตามกฎหมายตรวจคนเข้าเมือง",
  "nav.my_it_tickets": "แจ้งปัญหา IT ของฉัน",
  "nav.it_board": "บอร์ด IT",
  "nav.it_archive": "IT ที่เก็บถาวร",
  "nav.it_assets": "ทรัพย์สิน IT",
  "nav.my_bookings": "การจองของฉัน",
  "nav.all_bookings": "การจองทั้งหมด",
  "nav.tablet_pool": "จำนวนแท็บเล็ต",
  "nav.student_directory": "ทำเนียบนักเรียน",
  "nav.student_absences": "การขาดเรียนของนักเรียน",
  "nav.arrivals_dismissals": "มาสายและกลับก่อนเวลา",
  "nav.sst": "SST",
  "nav.students": "นักเรียน",
  "nav.credential_export": "ส่งออกข้อมูลนักเรียน",
  "nav.report_cards": "สมุดรายงานผล",
  "nav.parents": "ผู้ปกครอง",
  "nav.period_attendance": "การเช็คชื่อรายคาบ",
  "nav.attendance": "การเช็คชื่อรายวัน",
  "nav.checkout": "รับกลับ",
  "nav.attendance_report": "รายงานการเข้าเรียน",
  "nav.attendance_calendar": "วันเปิดเรียน",
  "nav.sessions": "รอบเรียน",
  "nav.users": "ผู้ใช้งาน",
  "nav.timetable": "ตารางเรียน",
  "nav.timetable_view": "ดูตารางเรียน",
  "nav.timetable_setup": "ตั้งค่าตารางเรียน",
  "nav.temperature": "อุณหภูมิ",
  "nav.infirmary_log": "บันทึกห้องพยาบาล",
  "nav.medical_settings": "ตั้งค่าทางการแพทย์",
  "nav.import": "นำเข้าข้อมูล",
  "nav.school_years": "ปีการศึกษา",
  "nav.settings": "ตั้งค่า",
  "nav.audit_log": "บันทึกการตรวจสอบ",
  "nav.integration": "การเชื่อมต่อ",
  "nav.door_log": "บันทึกการเข้าออกประตู",
  "nav.cafeteria": "โรงอาหาร",
  "nav.shop": "ร้านค้า",
  "nav.shop_pos": "จุดขายร้านค้า",
  "nav.shop_inventory": "คลังสินค้า",
  "nav.shop_reports": "รายงาน",
  "nav.section.website": "เว็บไซต์",
  "nav.section.admissions": "การรับสมัคร",
  "nav.section.sand_dollars": "แซนด์ดอลลาร์",
  "nav.section.hr": "ฝ่ายบุคคล",
  "nav.section.it_support": "ฝ่ายสนับสนุน IT",
  "nav.section.bookings": "การจองแท็บเล็ตและห้อง",
  "nav.section.student": "นักเรียน",
  "nav.section.administration": "การบริหารจัดการ",
  "nav.section.cafeteria": "โรงอาหาร",
  "nav.section.shop": "ร้านค้า",
  "nav.section.medical": "การแพทย์",
  "nav.section.config": "ตั้งค่าระบบ",
  "dashboard.subtitle": "ภาพรวมสิ่งที่ต้องให้ความสนใจ",
  "dashboard.no_widgets": "ยังไม่มีวิดเจ็ตแดชบอร์ดสำหรับบัญชีของคุณ",
  "dashboard.for_you.title": "สำหรับคุณ",
  "dashboard.for_you.group.assigned": "มอบหมายให้คุณ",
  "dashboard.for_you.group.teaching": "การสอน",
  "dashboard.for_you.group.queue": "รอตรวจสอบ",
  "dashboard.for_you.all_caught_up": "ไม่มีงานค้าง เรียบร้อยแล้ว",
  "dashboard.for_you.failed_to_load": "ไม่สามารถโหลดรายการงานของคุณได้",
  "dashboard.for_you.oldest": "เก่าสุด {{ago}}",
  "dashboard.for_you.due": "ครบกำหนด {{when}}",
  "dashboard.for_you.was_due": "เลยกำหนดแล้ว ({{when}})",
  "dashboard.for_you.register_partial": "เช็คชื่อไม่ครบ",
  "dashboard.for_you.today.title": "วันนี้",
  "dashboard.for_you.today.birthdays": "วันเกิด: {{names}}",
  "dashboard.for_you.today.colleague_out": "ไม่อยู่วันนี้: {{names}}",
  "dashboard.for_you.today.document_due_today": "{{doc}}: ครบกำหนดวันนี้",
  "dashboard.for_you.today.document_days_left_one": "{{doc}}: เหลืออีก {{count}} วัน",
  "dashboard.for_you.today.document_days_left_other": "{{doc}}: เหลืออีก {{count}} วัน",
  "dashboard.for_you.today.document_days_overdue_one": "{{doc}}: เลยกำหนด {{count}} วัน",
  "dashboard.for_you.today.document_days_overdue_other": "{{doc}}: เลยกำหนด {{count}} วัน",
  "dashboard.for_you.kind.it-assigned_one": "แจ้งปัญหา IT ที่มอบหมายให้คุณ {{count}} รายการ",
  "dashboard.for_you.kind.it-assigned_other": "แจ้งปัญหา IT ที่มอบหมายให้คุณ {{count}} รายการ",
  "dashboard.for_you.kind.it-unassigned_one": "แจ้งปัญหา IT ที่ยังไม่มีผู้รับผิดชอบ {{count}} รายการ",
  "dashboard.for_you.kind.it-unassigned_other": "แจ้งปัญหา IT ที่ยังไม่มีผู้รับผิดชอบ {{count}} รายการ",
  "dashboard.for_you.kind.mss-days-to-mark_one": "วัน MSS ที่ต้องเช็คชื่อ {{count}} วัน",
  "dashboard.for_you.kind.mss-days-to-mark_other": "วัน MSS ที่ต้องเช็คชื่อ {{count}} วัน",
  "dashboard.for_you.kind.mss-decision-unseen_one": "ผลการพิจารณา MSS ที่คุณเสนอ {{count}} รายการ",
  "dashboard.for_you.kind.mss-decision-unseen_other": "ผลการพิจารณา MSS ที่คุณเสนอ {{count}} รายการ",
  "dashboard.for_you.kind.mss-proposed_one": "ข้อเสนอ MSS ที่รอการพิจารณาของคุณ {{count}} รายการ",
  "dashboard.for_you.kind.mss-proposed_other": "ข้อเสนอ MSS ที่รอการพิจารณาของคุณ {{count}} รายการ",
  "dashboard.for_you.kind.edp-proposal-returned_one": "ข้อเสนอ EDP ที่ส่งกลับมาให้คุณแก้ไข {{count}} รายการ",
  "dashboard.for_you.kind.edp-proposal-returned_other": "ข้อเสนอ EDP ที่ส่งกลับมาให้คุณแก้ไข {{count}} รายการ",
  "dashboard.for_you.kind.incident-unread_one": "ข้อความเหตุการณ์ที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "dashboard.for_you.kind.incident-unread_other": "ข้อความเหตุการณ์ที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "dashboard.for_you.kind.suspension-unread_one": "ข้อความการพักการเรียนที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "dashboard.for_you.kind.suspension-unread_other": "ข้อความการพักการเรียนที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "dashboard.for_you.kind.register-missing_one": "การเช็คชื่อรายคาบที่ต้องทำให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.register-missing_other": "การเช็คชื่อรายคาบที่ต้องทำให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.edp-register-missing_one": "การเช็คชื่อ EDP ที่ต้องทำให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.edp-register-missing_other": "การเช็คชื่อ EDP ที่ต้องทำให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.report-card-outstanding_one": "สมุดรายงานผลที่ต้องกรอกให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.report-card-outstanding_other": "สมุดรายงานผลที่ต้องกรอกให้เสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.newsletter-slot-missing_one": "บทความจดหมายข่าวที่ต้องเขียน {{count}} รายการ",
  "dashboard.for_you.kind.newsletter-slot-missing_other": "บทความจดหมายข่าวที่ต้องเขียน {{count}} รายการ",
  "dashboard.for_you.kind.sparky-attention-open_one": "ติดตามผล Sparky ที่ยังเปิดอยู่ {{count}} รายการ",
  "dashboard.for_you.kind.sparky-attention-open_other": "ติดตามผล Sparky ที่ยังเปิดอยู่ {{count}} รายการ",
  "dashboard.for_you.kind.sparky-lesson-running_one": "บทเรียน Sparky ที่ยังดำเนินอยู่ {{count}} บท",
  "dashboard.for_you.kind.sparky-lesson-running_other": "บทเรียน Sparky ที่ยังดำเนินอยู่ {{count}} บท",
  "dashboard.for_you.kind.sparky-lesson-draft_one": "บทเรียน Sparky ที่เตรียมไว้แต่ยังไม่เริ่ม {{count}} บท",
  "dashboard.for_you.kind.sparky-lesson-draft_other": "บทเรียน Sparky ที่เตรียมไว้แต่ยังไม่เริ่ม {{count}} บท",
  "dashboard.for_you.kind.leave-pending_one": "คำขอลาที่รอการพิจารณา {{count}} รายการ",
  "dashboard.for_you.kind.leave-pending_other": "คำขอลาที่รอการพิจารณา {{count}} รายการ",
  "dashboard.for_you.kind.allergy-change-pending_one": "การแก้ไขข้อมูลการแพ้ที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.allergy-change-pending_other": "การแก้ไขข้อมูลการแพ้ที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.contact-inquiry-new_one": "ข้อความติดต่อสอบถามใหม่ {{count}} รายการ",
  "dashboard.for_you.kind.contact-inquiry-new_other": "ข้อความติดต่อสอบถามใหม่ {{count}} รายการ",
  "dashboard.for_you.kind.tour-request-new_one": "คำขอเยี่ยมชมใหม่ {{count}} รายการ",
  "dashboard.for_you.kind.tour-request-new_other": "คำขอเยี่ยมชมใหม่ {{count}} รายการ",
  "dashboard.for_you.kind.trial-ending_one": "ทดลองเรียนครบกำหนด {{count}} คน",
  "dashboard.for_you.kind.trial-ending_other": "ทดลองเรียนครบกำหนด {{count}} คน",
  "dashboard.for_you.kind.edp-proposal-submitted_one": "ข้อเสนอ EDP ที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.edp-proposal-submitted_other": "ข้อเสนอ EDP ที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.edp-payment-declared_one": "การชำระเงิน EDP ที่รอยืนยัน {{count}} รายการ",
  "dashboard.for_you.kind.edp-payment-declared_other": "การชำระเงิน EDP ที่รอยืนยัน {{count}} รายการ",
  "dashboard.for_you.kind.tuition-payment-declared_one": "การชำระค่าเล่าเรียนที่รอยืนยัน {{count}} รายการ",
  "dashboard.for_you.kind.tuition-payment-declared_other": "การชำระค่าเล่าเรียนที่รอยืนยัน {{count}} รายการ",
  "dashboard.for_you.kind.receipt-copy-requested_one": "คำขอสำเนาใบเสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.receipt-copy-requested_other": "คำขอสำเนาใบเสร็จ {{count}} รายการ",
  "dashboard.for_you.kind.parent-profile-change_one": "การแก้ไขข้อมูลผู้ปกครองที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.parent-profile-change_other": "การแก้ไขข้อมูลผู้ปกครองที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.teacher-profile-change_one": "การแก้ไขข้อมูลครูที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.for_you.kind.teacher-profile-change_other": "การแก้ไขข้อมูลครูที่รอตรวจสอบ {{count}} รายการ",
  "dashboard.failed_to_load": "ไม่สามารถโหลดข้อมูลได้",
  "dashboard.view_all": "ดูทั้งหมด",
  "dashboard.empty_default": "ไม่มีข้อมูลให้แสดง",
  "dashboard.out_now": "ออกอยู่ตอนนี้",
  "dashboard.widget.staff_leave": "การลาของเจ้าหน้าที่",
  "dashboard.widget.staff_leave_empty": "ไม่มีการลาที่รอดำเนินการหรือกำลังลาอยู่",
  "dashboard.widget.staff_out": "เจ้าหน้าที่ไม่อยู่",
  "dashboard.widget.staff_out_today_label": "ไม่อยู่วันนี้",
  "dashboard.widget.staff_out_week_label": "ไม่อยู่สัปดาห์นี้",
  "dashboard.widget.student_absences": "การขาดเรียนของนักเรียน",
  "dashboard.widget.student_absences_empty": "ไม่มีผู้ที่ไม่อยู่",
  "dashboard.widget.arrivals_dismissals": "มาสายและกลับก่อนเวลา",
  "dashboard.widget.arrivals_dismissals_empty": "ไม่มีการมาสายหรือกลับก่อนเวลา",
  "dashboard.widget.lesson_excusals": "การลาเป็นรายคาบ",
  "dashboard.widget.lesson_excusals_empty": "ไม่มีการลาเป็นรายคาบ",
  "dashboard.widget.missing_today_label": "ไม่เข้าเรียนบางคาบวันนี้",
  "dashboard.widget.excusals_upcoming_label": "คาบเรียนที่จะขาด",
  "dashboard.widget.missing_today_upcoming_label": "ขาดเรียนวันนี้ · อีก {{count}} รายการที่จะถึง",
  "dashboard.widget.missing_today_badge": "วันนี้",
  "dashboard.widget.lunch_detention": "MSS",
  "dashboard.widget.lunch_detention_count_label": "ต้องดำเนินการ",
  "dashboard.widget.lunch_detention_queue_title": "รอการพิจารณา",
  "dashboard.widget.lunch_detention_room_title": "ห้องกักตัวช่วงพักเที่ยงวันนี้",
  "dashboard.widget.lunch_detention_decisions_title": "ผลการพิจารณาข้อเสนอของคุณ",
  "dashboard.widget.contact_inquiries": "ข้อความติดต่อสอบถาม",
  "dashboard.widget.contact_inquiries_empty": "ยังไม่มีข้อความติดต่อสอบถาม",
  "dashboard.widget.tour_requests": "คำขอเยี่ยมชม",
  "dashboard.widget.tour_requests_empty": "ยังไม่มีคำขอเยี่ยมชม",
  "dashboard.widget.upcoming_events": "กิจกรรมที่จะมาถึง",
  "dashboard.widget.upcoming_events_count_label": "ใน 7 วันข้างหน้า",
  "dashboard.widget.upcoming_events_empty": "ไม่มีกิจกรรมที่จะมาถึง",
  "dashboard.widget.door_agent": "ประตูและเอเจนต์",
  "dashboard.widget.agent_unreachable_count_label": "เชื่อมต่อไม่ได้",
  "dashboard.widget.agent_online": "เอเจนต์ออนไลน์",
  "dashboard.widget.agent_offline": "เอเจนต์ออฟไลน์",
  "dashboard.widget.agent_last_seen": "พบล่าสุด {{time}}",
  "dashboard.widget.door_agent_no_devices": "ไม่มีอุปกรณ์ประตู",
  "dashboard.widget.bell_status": "กริ่ง",
  "dashboard.widget.bell_active": "ทำงานอยู่",
  "dashboard.widget.bell_silent": "วันนี้เงียบ",
  "dashboard.widget.bell_off": "ปิดอยู่",
  "dashboard.widget.bell_next": "กริ่งถัดไป {{time}}",
  "dashboard.widget.bell_no_more_today": "ไม่มีกริ่งอีกแล้ววันนี้",
  "dashboard.widget.bell_reason_disabled": "ปิดใช้งานในการตั้งค่ากริ่ง",
  "dashboard.widget.bell_reason_no_active_year": "ไม่มีปีการศึกษาที่ใช้งานอยู่",
  "dashboard.widget.bell_reason_not_school_day": "วันนี้ไม่ใช่วันเรียน",
  "dashboard.widget.bell_reason_no_schedule": "วันนี้ไม่มีตารางเวลา",
  "dashboard.widget.bell_audio_error": "ตรวจไม่พบการ์ดเสียง",
  "dashboard.widget.bell_audio_error_detail": "กริ่งจะดังไม่ได้จนกว่าจะแก้ไข — ดูที่หน้า Integration",
  "dashboard.widget.bell_schedule_warning": "ปัญหาตารางเวลา",
  "dashboard.widget.news": "ข่าวสาร",
  "dashboard.widget.allergy_changes": "คำขอเปลี่ยนแปลงภูมิแพ้และอาหาร",
  "dashboard.widget.allergy_changes_empty": "ไม่มีคำขอเปลี่ยนแปลงภูมิแพ้หรืออาหารที่รอตรวจสอบ",
  "dashboard.widget.news_empty": "ยังไม่มีข่าวสาร",
  "dashboard.widget.out_now_count_label": "ออกอยู่ตอนนี้",
  "dashboard.widget.absences_upcoming_label": "จะไม่อยู่ในสัปดาห์นี้",
  "dashboard.widget.out_now_upcoming_label": "ไม่อยู่ตอนนี้ · อีก {{count}} รายการที่จะถึง",
  "dashboard.widget.out_now_pending_label": "ออกอยู่ตอนนี้ · รอดำเนินการ {{count}} รายการ",
  "dashboard.widget.pending_count_label": "รอดำเนินการ",
  "dashboard.widget.pending_out_now_label": "รอดำเนินการ · ออกอยู่ตอนนี้ {{count}} คน",
  "dashboard.widget.more_count": "อีก {{count}} รายการ",
  "dashboard.widget.new_count_label": "ใหม่",
  "dashboard.widget.open_count_label": "ยังไม่ปิด",
  "dashboard.widget.published_articles": "บทความที่เผยแพร่แล้ว",
  "dashboard.widget.student_attendance": "การเข้าเรียนของนักเรียน",
  "dashboard.widget.staff_attendance": "การเข้างานของเจ้าหน้าที่",
  "dashboard.widget.on_campus": "อยู่ในโรงเรียนตอนนี้",
  "dashboard.widget.on_campus_label": "อยู่ในโรงเรียน",
  "dashboard.widget.att_present": "มาเรียน",
  "dashboard.widget.att_late": "สาย",
  "dashboard.widget.att_absent": "ขาด",
  "dashboard.widget.att_suspended": "พักการเรียน",
  "dashboard.widget.att_unmarked": "ยังไม่เช็ค",
  "dashboard.widget.att_checked_in": "เช็คอินแล้ว",
  "dashboard.widget.on_campus_students": "นักเรียน",
  "dashboard.widget.on_campus_staff": "เจ้าหน้าที่",
  "dashboard.widget.attendance_no_school": "วันนี้ไม่มีการเรียน",
  "dashboard.widget.immigration_compliance": "การปฏิบัติตามกฎหมายตรวจคนเข้าเมือง",
  "dashboard.widget.immigration_compliance_empty": "ไม่มีรายการที่ใกล้ครบกำหนด",
  "dashboard.widget.immigration_compliance_count_label": "ใกล้ครบกำหนดหรือเลยกำหนด",
  "dashboard.widget.it_support": "ช่วยเหลือด้าน IT",
  "dashboard.widget.it_support_empty": "คุณยังไม่ได้แจ้งปัญหา IT",
  "dashboard.widget.it_support_none_active": "ขณะนี้ไม่มีเรื่องที่ค้างอยู่",
  "dashboard.widget.it_queue": "คิวเรื่องแจ้งปัญหา IT",
  "dashboard.widget.it_queue_empty": "ไม่มีเรื่องแจ้งปัญหา IT ในขณะนี้",
  "doc_type.visa": "วีซ่า",
  "doc_type.workPermit": "ใบอนุญาตทำงาน",
  "doc_type.ninetyDayReport": "รายงานตัว 90 วัน",
  "dashboard.overdue": "เลยกำหนด",
  "immigration_compliance.list_title": "การปฏิบัติตามกฎหมายตรวจคนเข้าเมือง",
  "immigration_compliance.list_subtitle": "ติดตามกำหนดวันหมดอายุวีซ่า ใบอนุญาตทำงาน และการรายงานตัว 90 วัน สำหรับเจ้าหน้าที่และนักเรียน",
  "immigration_compliance.filter_all": "ทั้งหมด",
  "immigration_compliance.filter_staff": "เจ้าหน้าที่",
  "immigration_compliance.filter_students": "นักเรียน",
  "immigration_compliance.col_name": "ชื่อ",
  "immigration_compliance.col_visa": "วันหมดอายุวีซ่า",
  "immigration_compliance.col_work_permit": "วันหมดอายุใบอนุญาตทำงาน",
  "immigration_compliance.col_ninety_day": "กำหนดรายงานตัว 90 วัน",
  "immigration_compliance.not_set": "ยังไม่ระบุ",
  "immigration_compliance.list_empty": "ยังไม่มีผู้ที่อยู่ระหว่างการติดตาม",
  "immigration_compliance.add_person_placeholder": "เพิ่มบุคคลเพื่อติดตาม…",
  "immigration_compliance.add_person_action": "เพิ่มบุคคล",
  "immigration_compliance.add_person_title": "เพิ่มบุคคลเพื่อติดตาม",
  "immigration_compliance.add_person_description": "เลือกผู้ที่ต้องการติดตาม จากนั้นบันทึกของบุคคลนั้นจะเปิดขึ้นเพื่อกรอกวันที่ที่ทราบ",
  "immigration_compliance.add_person_who": "ใคร",
  "immigration_compliance.add_person_staff_all_tracked": "เจ้าหน้าที่ทุกคนอยู่ระหว่างการติดตามแล้ว",
  "immigration_compliance.add_person_students_all_tracked": "นักเรียนทุกคนอยู่ระหว่างการติดตามแล้ว",
  "immigration_compliance.settings_action": "เกณฑ์การแจ้งเตือน",
  "immigration_compliance.settings_title": "เกณฑ์การแจ้งเตือน",
  "immigration_compliance.settings_subtitle": "จำนวนวันก่อนถึงกำหนดที่แดชบอร์ดและสรุปรายวันจะเริ่มแจ้งเตือน",
  "immigration_compliance.settings_breadcrumb": "การตั้งค่า",
  "immigration_compliance.settings_back": "กลับไปยังรายการ",
  "immigration_compliance.settings_saved": "บันทึกเกณฑ์แล้ว",
  "immigration_compliance.edit_title": "แก้ไขข้อมูลการปฏิบัติตามกฎหมาย — {{name}}",
  "immigration_compliance.requires_tracking_label": "ต้องมีการติดตาม",
  "immigration_compliance.visa_expiry_label": "วันหมดอายุวีซ่า",
  "immigration_compliance.work_permit_expiry_label": "วันหมดอายุใบอนุญาตทำงาน",
  "immigration_compliance.work_permit_not_applicable": "ไม่เกี่ยวข้องสำหรับนักเรียน",
  "immigration_compliance.ninety_day_due_label": "วันครบกำหนดรายงานตัว 90 วัน",
  "immigration_compliance.save": "บันทึก",
  "immigration_compliance.saving": "กำลังบันทึก…",
  "immigration_compliance.error_save_failed": "บันทึกข้อมูลการปฏิบัติตามกฎหมายไม่สำเร็จ",
  "immigration_compliance.visa_warn_days_label": "แจ้งเตือนล่วงหน้า N วันก่อนวีซ่าหมดอายุ",
  "immigration_compliance.work_permit_warn_days_label": "แจ้งเตือนล่วงหน้า N วันก่อนใบอนุญาตทำงานหมดอายุ",
  "immigration_compliance.ninety_day_warn_days_label": "แจ้งเตือนล่วงหน้า N วันก่อนครบกำหนดรายงานตัว 90 วัน",
  "immigration_compliance.error_warn_days_number": "กรุณากรอกจำนวนวันเป็นเลขจำนวนเต็ม",
  "modules.teachers": "ครู",
  "modules.calendar": "ปฏิทินโรงเรียน",
  "modules.thai-events": "กิจกรรมไทย",
  "modules.weekly-menus": "เมนูอาหารประจำสัปดาห์",
  "modules.contact-inquiries": "ข้อความติดต่อสอบถาม",
  "modules.tour-requests": "คำขอเยี่ยมชม",
  "modules.leave-requests": "คำขอลา (ฝ่ายบุคคล)",
  "modules.immigration-compliance": "การปฏิบัติตามกฎหมายตรวจคนเข้าเมือง (ฝ่ายบุคคล)",
  "modules.sand-dollars-config": "ตั้งค่าแซนด์ดอลลาร์",
  "modules.student-management": "นักเรียน",
  "modules.student-credentials": "ข้อมูลเข้าสู่ระบบนักเรียน",
  "modules.student-management.description": "จัดการข้อมูลนักเรียนแบบเต็มรูปแบบ: แก้ไขโปรไฟล์ เหตุการณ์ ข้อมูลสุขภาพ และรูปภาพ พนักงานทุกคนสามารถดูทำเนียบนักเรียนได้โดยไม่ต้องมีสิทธิ์นี้",
  "modules.student-credentials.description": "ส่งออกและเปิดเผยข้อมูลเข้าสู่ระบบของนักเรียน (รหัสผ่าน, WiFi, Google Classroom ฯลฯ) สามารถมอบสิทธิ์นี้ให้ครูได้เช่นเดียวกับผู้ดูแลระบบ",
  "modules.parents": "ผู้ปกครอง",
  "modules.sst": "ทีมสนับสนุนนักเรียน (SST)",
  "modules.medical": "การแพทย์ / พยาบาล",
  "modules.school-years": "ปีการศึกษา",
  "modules.statistics": "สถิติ",
  "modules.users": "การจัดการผู้ใช้และสิทธิ์",
  "modules.settings": "ตั้งค่าเว็บไซต์",
  "modules.audit-log": "บันทึกการตรวจสอบ",
  "modules.timetable": "ตารางเรียน",
  "modules.cafeteria": "โรงอาหาร",
  "modules.shop": "ร้านค้าโรงเรียน",
  "modules.announcements": "ประกาศ",
  "modules.communications": "การสื่อสาร",
  "modules.it-support": "ช่วยเหลือด้าน IT",
  "modules.bookings": "การจอง",
  "modules.edp": "โครงการหลังเลิกเรียน (EDP)",
  "modules.report-cards": "สมุดรายงานผล",
  "modules.conferences": "ประชุมผู้ปกครองและครู (PTC)",
  "modules.billing": "การเรียกเก็บค่าเล่าเรียน",
  "modules.sparky": "การเรียนรู้กับ Sparky",
  "auth.welcome_back": "ยินดีต้อนรับกลับ",
  "auth.subtitle": "เข้าสู่ระบบเพื่อใช้งานแดชบอร์ดผู้ดูแลระบบ RISP",
  "auth.sign_in": "เข้าสู่ระบบ",
  "auth.signing_in": "กำลังเข้าสู่ระบบ...",
  "auth.card_description": "ใช้บัญชี Google ของโรงเรียนหรืออีเมลและรหัสผ่าน",
  "auth.or": "หรือ",
  "auth.email": "อีเมล",
  "auth.email_placeholder": "you@risphuket.ac.th",
  "auth.password": "รหัสผ่าน",
  "auth.password_placeholder": "กรอกรหัสผ่านของคุณ",
  "auth.error_invalid_email": "กรุณากรอกอีเมลที่ถูกต้อง",
  "auth.error_email_required": "กรุณากรอกอีเมล",
  "auth.error_password_required": "กรุณากรอกรหัสผ่าน",
  "auth.error_fill_required": "กรุณากรอกอีเมลและรหัสผ่าน",
  "auth.error_google_sign_in": "ไม่สามารถเข้าสู่ระบบให้คุณได้",
  "auth.error_google_unavailable": "ไม่สามารถโหลดการเข้าสู่ระบบด้วย Google ได้ กรุณาตรวจสอบการเชื่อมต่อ หรือใช้อีเมลและรหัสผ่านด้านล่าง",
  "auth.error_login_failed": "เข้าสู่ระบบไม่สำเร็จ",
  "auth.error_not_staff": "บัญชีนี้ไม่ได้รับอนุญาตให้เข้าใช้งานระบบผู้ดูแล เนื่องจากไม่ใช่บัญชีของบุคลากรโรงเรียน",
  "auth.risp_administration": "ระบบบริหารจัดการ RISP",
  "auth.hero_heading": "ทุกส่วนของวันในโรงเรียน รวมไว้ในที่เดียว",
  "auth.hero_feature_operations": "การเช็คชื่อ ตารางเรียน และรายชื่อประจำวัน",
  "auth.hero_feature_cafeteria": "ระบบขายโรงอาหาร กระเป๋าเงิน และรายงานมื้ออาหาร",
  "auth.hero_feature_rewards": "รางวัล Sand-dollar และคะแนนบ้าน",
  "auth.hero_feature_community": "ข่าวสาร ปฏิทิน และการสื่อสารกับผู้ปกครอง",
  "auth.authorized_staff_only": "สำหรับเจ้าหน้าที่ที่ได้รับอนุญาตเท่านั้น",
  "users.title": "ผู้ใช้งาน",
  "users.subtitle": "จัดการเจ้าหน้าที่ที่สามารถเข้าสู่ระบบผู้ดูแล",
  "users.import": "นำเข้าข้อมูล",
  "users.add_user": "เพิ่มผู้ใช้งาน",
  "users.edit_user": "แก้ไขผู้ใช้งาน",
  "users.search_placeholder": "ค้นหาด้วยชื่อ อีเมล หรือชื่อเล่น…",
  "users.search_aria": "ค้นหาผู้ใช้งานด้วยชื่อ อีเมล หรือชื่อเล่น",
  "users.status_all": "สถานะทั้งหมด",
  "users.status_active": "เปิดใช้งาน",
  "users.status_disabled": "ปิดใช้งาน",
  "users.item_label": "ผู้ใช้งาน",
  "users.empty": "ไม่พบผู้ใช้งาน",
  "users.help_note": "เพิ่มเจ้าหน้าที่ทีละคนได้ที่นี่ หรือนำเข้าจำนวนมากจาก Excel ผ่าน <strong>นำเข้าข้อมูล</strong> เจ้าหน้าที่ต้องมีอีเมลเฉพาะกรณีที่ต้องเข้าสู่ระบบเท่านั้น",
  "users.photo": "รูปภาพ",
  "users.last_login": "เข้าสู่ระบบล่าสุด",
  "users.last_login_never": "ไม่เคย",
  "users.email": "อีเมล",
  "users.name": "ชื่อ",
  "users.role": "บทบาท",
  "users.status": "สถานะ",
  "users.linked": "เชื่อมโยง",
  "users.linked_google": "Google",
  "users.created": "สร้างเมื่อ",
  "users.resend_onboarding": "ส่งอีเมลเริ่มต้นใช้งานอีกครั้ง",
  "users.onboarding_sent": "ส่งอีเมลเริ่มต้นใช้งานแล้ว",
  "users.onboarding_error": "ส่งอีเมลเริ่มต้นใช้งานไม่สำเร็จ",
  "users.cannot_change_self": "คุณไม่สามารถเปลี่ยนบทบาทหรือสิทธิ์ของตัวเองได้",
  "users.full_name": "ชื่อ-นามสกุล",
  "users.nickname": "ชื่อเล่น (ไม่บังคับ)",
  "users.person_id": "รหัสประจำตัว (ไม่บังคับ)",
  "users.passport_or_thai_id": "หมายเลขบัตรประชาชน / พาสปอร์ต",
  "users.vacation_days": "วันลาพักร้อนต่อปี",
  "users.vacation_days_hint": "จำนวนวันลาพักร้อนที่บุคลากรท่านนี้ได้รับในแต่ละปีการศึกษา หากสัญญาไม่มีวันลาพักร้อน ให้คงค่า 0 ไว้ บุคลากรจะขอลาพักร้อนไม่ได้",
  "users.error_vacation_days_range": "กรอกจำนวนวันเต็มระหว่าง 0 ถึง 365",
  "users.field_photo": "รูปโปรไฟล์ (สี่เหลี่ยมจัตุรัส)",
  "users.select_role_placeholder": "เลือกบทบาท",
  "users.password_optional": "รหัสผ่าน (ไม่บังคับ)",
  "users.password_hint": "เว้นว่างไว้สำหรับการเข้าสู่ระบบด้วย Google ต้องกรอกสำหรับอีเมลที่ไม่ใช่ของ Workspace",
  "users.modules": "โมดูล",
  "users.additional_permissions": "สิทธิ์เพิ่มเติม",
  "users.send_invitation": "ส่งอีเมลเชิญเข้าใช้งาน",
  "users.send_invitation_hint": "ส่งอีเมลลิงก์เข้าสู่ระบบให้เจ้าหน้าที่ในโดเมนโรงเรียน ยกเลิกการเลือกเพื่อเพิ่มโดยไม่ส่งอีเมล",
  "users.pos_operator": "ผู้ใช้งานจุดขาย (บัญชีเครื่องคิดเงิน)",
  "users.pos_operator_hint": "บัญชีนี้ใช้ได้เฉพาะเครื่องคิดเงินของโมดูลที่เลือกด้านล่างเท่านั้น — ไม่เห็นข้อมูลนักเรียนและไม่มีสิทธิ์เข้าหน้าจัดการ",
  "users.pos_operator_badge": "ผู้ใช้งานจุดขาย",
  "users.error_invalid_email": "กรุณากรอกอีเมลที่ถูกต้อง",
  "users.error_email_required": "กรุณากรอกอีเมล",
  "users.error_role_required": "กรุณาเลือกบทบาท",
  "users.error_full_name_short": "ชื่อ-นามสกุลสั้นเกินไป",
  "users.error_full_name_required": "กรุณากรอกชื่อ-นามสกุล",
  "users.error_save_failed": "บันทึกผู้ใช้งานไม่สำเร็จ",
  "users.placeholder_email": "user@risphuket.ac.th",
  "users.placeholder_full_name": "สมชาย ใจดี",
  "users.placeholder_nickname": "ชาย",
  "users.placeholder_person_id": "T-001",
  "news.title": "ข่าวสาร",
  "news.subtitle": "จัดการข่าวสารและเรื่องเด่นบนเว็บไซต์",
  "news.add": "เพิ่มข่าวสาร",
  "news.error": "ไม่สามารถโหลดบทความข่าวได้",
  "news.empty": "ไม่พบบทความข่าว สร้างบทความแรกของคุณ!",
  "news.empty_draft": "ไม่พบบทความข่าวที่เป็นฉบับร่าง",
  "news.empty_published": "ไม่พบบทความข่าวที่เผยแพร่แล้ว",
  "news.summary": "แสดง {{filtered}} จาก {{total}} บทความ",
  "news.featured": "แนะนำ",
  "news.publish_tooltip": "เผยแพร่บทความ",
  "news.publish_dialog.title": "เผยแพร่บทความ",
  "news.publish_dialog.now_label": "เผยแพร่ตอนนี้",
  "news.publish_dialog.now_hint": "ขึ้นเว็บไซต์ทันที",
  "news.publish_dialog.schedule_label": "ตั้งเวลาเผยแพร่",
  "news.publish_dialog.schedule_hint": "จะยังเป็นฉบับร่างจนถึงวันและเวลาที่เลือก",
  "news.publish_dialog.date_label": "เผยแพร่เมื่อ (ขึ้นเว็บภายใน 5 นาที)",
  "news.publish_dialog.date_required": "กรุณาเลือกวันและเวลา",
  "news.publish_dialog.date_past": "กรุณาเลือกเวลาในอนาคต",
  "news.publish_dialog.confirm_schedule": "ตั้งเวลา",
  "news.publish_dialog.clear_schedule": "ยกเลิกการตั้งเวลา",
  "news.preview_tooltip": "ดูตัวอย่าง",
  "news.scheduled_for": "กำหนดเผยแพร่ {{date}}",
  "news.edit_info_tooltip": "แก้ไขข้อมูล",
  "news.edit_content_tooltip": "แก้ไขเนื้อหา",
  "news.delete_title": "ลบบทความข่าว",
  "news.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบบทความข่าวนี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "news.edit_content": "แก้ไขเนื้อหา",
  "news.edit_subtitle": "แก้ไขเนื้อหาบทความ",
  "news.back_to_news": "กลับไปที่ข่าวสาร",
  "news.load_error": "ไม่สามารถโหลดบทความข่าวนี้ได้",
  "news.content_label": "เนื้อหา",
  "news.save_error": "บันทึกเนื้อหาไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "news.save_content": "บันทึกเนื้อหา",
  "thai_events.title": "กิจกรรมไทย",
  "thai_events.subtitle": "จัดการแบนเนอร์วันหยุดประจำชาติไทย",
  "thai_events.add_event": "เพิ่มกิจกรรม",
  "thai_events.error": "ไม่สามารถโหลดกิจกรรมไทยได้",
  "thai_events.empty": "ยังไม่มีกิจกรรมไทย คลิก \"เพิ่มกิจกรรม\" เพื่อสร้างกิจกรรมแรก",
  "thai_events.empty_filtered": "ไม่พบกิจกรรมไทยที่ตรงกับตัวกรองปัจจุบัน",
  "thai_events.enabled": "เปิดใช้งาน",
  "thai_events.disabled": "ปิดใช้งาน",
  "thai_events.summary": "แสดง {{filtered}} จาก {{total}} กิจกรรมไทย",
  "thai_events.col_days_after": "จำนวนวันหลังจากนั้น",
  "thai_events.image": "รูปภาพ",
  "thai_events.same_day_only": "เฉพาะวันเดียวกัน",
  "thai_events.day_after": "วันหลังจากนั้น",
  "thai_events.days_after": "วันหลังจากนั้น",
  "thai_events.no_image": "ไม่มีรูปภาพ",
  "thai_events.enable_tooltip": "เปิดใช้งานกิจกรรม",
  "thai_events.enable": "เปิดใช้งาน",
  "thai_events.delete_title": "ลบกิจกรรมไทย",
  "thai_events.delete_description": "การดำเนินการนี้จะลบกิจกรรมออกอย่างถาวร แบนเนอร์จะไม่ปรากฏอีกต่อไป",
  "announcements.title": "ประกาศ",
  "announcements.subtitle": "จัดการแบนเนอร์ประกาศทั่วเว็บไซต์",
  "announcements.add_announcement": "เพิ่มประกาศ",
  "announcements.error": "ไม่สามารถโหลดประกาศได้",
  "announcements.empty": "ยังไม่มีประกาศ คลิก \"เพิ่มประกาศ\" เพื่อสร้างประกาศแรก",
  "announcements.empty_filtered": "ไม่พบประกาศที่ตรงกับตัวกรองปัจจุบัน",
  "announcements.active": "ใช้งานอยู่",
  "announcements.inactive": "ไม่ได้ใช้งาน",
  "announcements.summary": "แสดง {{filtered}} จาก {{total}} ประกาศ",
  "announcements.message": "ข้อความ",
  "announcements.type": "ประเภท",
  "announcements.window": "ช่วงเวลา",
  "announcements.urgent": "ด่วน",
  "announcements.info": "ทั่วไป",
  "announcements.activate": "เปิดใช้งาน",
  "announcements.activate_tooltip": "แสดงประกาศนี้บนเว็บไซต์",
  "announcements.deactivate": "ปิดใช้งาน",
  "announcements.deactivate_tooltip": "ซ่อนประกาศนี้จากเว็บไซต์",
  "announcements.delete_title": "ลบประกาศ",
  "announcements.delete_description": "การดำเนินการนี้จะลบประกาศออกอย่างถาวร หากประกาศนี้กำลังใช้งานอยู่ แบนเนอร์จะไม่ปรากฏอีกต่อไป",
  "newsletter.my_entries_card_title": "เนื้อหาของฉัน",
  "newsletter.my_entries_title": "เนื้อหาจดหมายข่าวของฉัน",
  "newsletter.issue_title": "จดหมายข่าวประจำสัปดาห์",
  "newsletter.week_of": "สัปดาห์ที่ {{start}} – {{end}}",
  "newsletter.issue_selector_label": "ฉบับ",
  "newsletter.issue_status_draft": "ฉบับร่าง",
  "newsletter.issue_status_published": "เผยแพร่แล้ว",
  "newsletter.no_open_issue": "ยังไม่มีฉบับจดหมายข่าวที่เปิดอยู่ในสัปดาห์นี้",
  "newsletter.from_timetable": "จากตารางสอนของคุณ",
  "newsletter.not_from_timetable": "ไม่ได้มาจากตารางสอนของคุณ",
  "newsletter.not_from_timetable_hint": "รายการที่คุณเพิ่มเอง และรายการของระดับชั้นหรือวิชาที่เปลี่ยนไปเป็นของผู้อื่นแล้ว หากไม่ใช่ของคุณอีกต่อไป ให้เปิดแล้วลบออก",
  "newsletter.no_timetable_slots": "ไม่มีระดับชั้นหรือวิชาจากตารางสอนของคุณในสัปดาห์นี้",
  "newsletter.added_by_you": "เพิ่มโดยคุณ",
  "newsletter.add_another": "เพิ่มระดับชั้น / วิชาอื่น",
  "newsletter.status_write": "เขียน",
  "newsletter.status_edit": "แก้ไข",
  "newsletter.status_view": "ดู",
  "newsletter.skip_slot": "ข้ามสัปดาห์นี้",
  "newsletter.skipped": "ข้ามสัปดาห์นี้แล้ว",
  "newsletter.undo_skip": "เลิกข้าม",
  "newsletter.new_entry_title": "เนื้อหาจดหมายข่าวใหม่",
  "newsletter.edit_entry_title": "แก้ไขเนื้อหาจดหมายข่าว",
  "newsletter.title_field": "หัวข้อ",
  "newsletter.grade_field": "ระดับชั้น",
  "newsletter.grade_placeholder": "เลือกระดับชั้น",
  "newsletter.subject_field": "วิชา",
  "newsletter.subject_placeholder": "เลือกวิชา",
  "newsletter.body": "เนื้อหา",
  "newsletter.save_draft": "บันทึกฉบับร่าง",
  "newsletter.submit_entry": "ส่ง",
  "newsletter.error_title_required": "กรุณากรอกหัวข้อ",
  "newsletter.error_grade_required": "กรุณาเลือกระดับชั้น",
  "newsletter.error_save_failed": "ไม่สามารถบันทึกเนื้อหาได้",
  "newsletter.error_submit_failed": "ไม่สามารถส่งเนื้อหาได้",
  "newsletter.copy_from_label": "คัดลอกจาก…",
  "newsletter.copy_from_placeholder": "เลือกเนื้อหาของคุณที่จะคัดลอก",
  "newsletter.copy_confirm_title": "แทนที่เนื้อหานี้หรือไม่?",
  "newsletter.copy_confirm_description": "การดำเนินการนี้จะเขียนทับสิ่งที่คุณเขียนไว้ที่นี่ด้วยเนื้อหาที่คัดลอกมา ส่วนหัวข้อจะไม่เปลี่ยนแปลง",
  "newsletter.copy_confirm_action": "แทนที่",
  "newsletter.new_front_page_title": "หน้าแรกใหม่",
  "newsletter.edit_front_page_title": "แก้ไขหน้าแรก",
  "newsletter.front_pages": "หน้าแรก",
  "newsletter.add_front_page": "เพิ่มหน้า",
  "newsletter.no_front_pages": "ยังไม่มีหน้าแรก",
  "newsletter.status_submitted": "ส่งแล้ว",
  "newsletter.status_draft": "ฉบับร่าง",
  "newsletter.reorder_aria": "จัดลำดับ \"{{title}}\"",
  "newsletter.grade_entries": "เนื้อหาตามระดับชั้น",
  "newsletter.no_grade_entries": "ยังไม่มีเนื้อหาตามระดับชั้น",
  "newsletter.submitted_count": "ส่งแล้ว {{count}} รายการ",
  "newsletter.draft_count": "ฉบับร่าง {{count}} รายการ",
  "newsletter.outstanding_title": "ค้างส่ง",
  "newsletter.outstanding_none": "ครูทุกคนส่งครบแล้ว",
  "newsletter.outstanding_count": "ครู {{count}} คนยังค้างส่งเนื้อหา",
  "newsletter.missing_count": "ค้าง {{count}} รายการ",
  "newsletter.preview_action": "ดูตัวอย่าง",
  "newsletter.publish_action": "เผยแพร่",
  "newsletter.publish_confirm_title": "เผยแพร่ฉบับนี้หรือไม่?",
  "newsletter.publish_confirm_outstanding": "ครู {{count}} คนยังค้างส่งเนื้อหา ต้องการเผยแพร่ต่อหรือไม่?",
  "newsletter.publish_confirm_ready": "การเผยแพร่จะทำให้ครอบครัวสามารถอ่านฉบับนี้ได้ คุณสามารถส่งอีเมลแยกต่างหากเมื่อพร้อม",
  "newsletter.published_badge": "เผยแพร่เมื่อ {{date}}",
  "newsletter.unpublish_action": "ยกเลิกการเผยแพร่",
  "newsletter.unpublish_locked_tooltip": "ฉบับนี้ถูกส่งให้ครอบครัวแล้ว การยกเลิกการเผยแพร่จะทำให้ลิงก์ที่ส่งไปใช้งานไม่ได้",
  "newsletter.unpublish_confirm_title": "ยกเลิกการเผยแพร่ฉบับนี้หรือไม่?",
  "newsletter.unpublish_confirm_description": "ครอบครัวจะไม่สามารถอ่านฉบับนี้ได้จนกว่าจะเผยแพร่อีกครั้ง",
  "newsletter.send_to_families": "ส่งให้ครอบครัว",
  "newsletter.send_started": "เริ่มส่งเมื่อ {{date}} ให้ {{count}} ครอบครัว",
  "newsletter.send_preview_title": "ส่งให้ครอบครัว",
  "newsletter.recipient_count": "ผู้รับ",
  "newsletter.batch_count": "ชุดการส่ง",
  "newsletter.email_subject": "หัวข้ออีเมล",
  "newsletter.email_preview": "ตัวอย่าง",
  "newsletter.email_body_intro": "จดหมายข่าวประจำสัปดาห์นี้พร้อมแล้ว",
  "newsletter.send_now": "ส่งตอนนี้ ({{count}})",
  "newsletter.error_send_failed": "ไม่สามารถส่งจดหมายข่าวได้",
  "newsletter.delete_front_page_title": "ลบหน้าแรก",
  "newsletter.delete_front_page_description": "การดำเนินการนี้จะลบ \"{{title}}\" ออกจากฉบับนี้อย่างถาวร",
  "newsletter.no_issue_admin": "ยังไม่มีฉบับจดหมายข่าว",
  "newsletter.create_issue": "สร้างฉบับใหม่",
  "newsletter.create_issue_title": "ฉบับจดหมายข่าวใหม่",
  "newsletter.school_year_field": "ปีการศึกษา",
  "newsletter.school_year_placeholder": "เลือกปีการศึกษา",
  "newsletter.week_start_field": "เริ่มสัปดาห์",
  "newsletter.week_end_field": "สิ้นสุดสัปดาห์",
  "newsletter.error_school_year_required": "กรุณาเลือกปีการศึกษา",
  "newsletter.error_week_start_required": "กรุณาเลือกวันเริ่มสัปดาห์",
  "newsletter.error_week_end_required": "กรุณาเลือกวันสิ้นสุดสัปดาห์",
  "newsletter.error_create_issue_failed": "ไม่สามารถสร้างฉบับได้",
  "newsletter.auto_publish_label": "เผยแพร่อัตโนมัติ",
  "newsletter.auto_publish_hint": "ฉบับนี้จะเผยแพร่ตามเวลาด้านล่าง แม้ว่ายังมีบางส่วนที่ยังไม่ได้เขียน",
  "newsletter.schedule_time_label": "เผยแพร่เมื่อ",
  "newsletter.schedule_time_required": "กรุณาเลือกเวลาที่จะเผยแพร่ฉบับนี้",
  "newsletter.schedule_time_past": "เวลาเผยแพร่ต้องเป็นเวลาในอนาคต",
  "newsletter.auto_send_label": "ส่งอีเมลให้ครอบครัวเมื่อเผยแพร่",
  "newsletter.auto_send_hint": "ส่งอีเมลจดหมายข่าวให้ผู้ปกครองทุกคนในเวลาเดียวกัน ส่งได้เพียงครั้งเดียว",
  "newsletter.schedule_action": "ตั้งเวลา",
  "newsletter.scheduled_publish_only": "เผยแพร่ {{date}}",
  "newsletter.scheduled_with_send": "เผยแพร่และส่งอีเมล {{date}}",
  "newsletter.schedule_modal_title": "กำหนดเวลาเผยแพร่",
  "newsletter.error_schedule_failed": "ไม่สามารถบันทึกกำหนดเวลาได้",
  "newsletter.stats_title": "สถิติการอ่าน",
  "newsletter.stats_empty": "ยังไม่มีการอ่านบันทึกไว้",
  "newsletter.stats_reach": "อัตราการเข้าถึง",
  "newsletter.stats_reach_detail": "ผู้ปกครอง {{readers}} จาก {{notified}} คนที่ได้รับอีเมลเปิดอ่าน",
  "newsletter.stats_unique_readers": "ผู้อ่านที่ไม่ซ้ำกัน",
  "newsletter.stats_unique_readers_detail": "เป็นผู้ปกครอง {{parents}} คนจากทั้งหมดนี้",
  "newsletter.stats_views": "จำนวนการเข้าชม",
  "newsletter.stats_average_time": "เวลาอ่านเฉลี่ย",
  "newsletter.stats_by_grade": "แยกตามระดับชั้น",
  "newsletter.stats_col_readers": "ผู้อ่าน",
  "newsletter.stats_col_views": "การเข้าชม",
  "newsletter.stats_col_average": "เฉลี่ย",
  "events.breadcrumb": "กิจกรรม",
  "events.title": "กิจกรรมบนเว็บไซต์",
  "events.subtitle": "จัดการกิจกรรมสาธารณะและการลงทะเบียน",
  "events.add_event": "เพิ่มกิจกรรม",
  "events.error": "ไม่สามารถโหลดกิจกรรมได้ กรุณาลองใหม่อีกครั้ง",
  "events.empty": "ไม่พบกิจกรรม สร้างกิจกรรมแรกของคุณ!",
  "events.empty_filtered": "ไม่พบกิจกรรมที่ตรงกับตัวกรองปัจจุบัน",
  "events.summary": "แสดง {{filtered}} จาก {{total}} กิจกรรม",
  "events.location": "สถานที่",
  "events.registration_required": "ต้องลงทะเบียน",
  "events.delete_title": "ลบกิจกรรม",
  "events.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบกิจกรรมนี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "weekly_menus.title": "เมนูอาหารประจำสัปดาห์",
  "weekly_menus.subtitle": "จัดการแผนอาหารกลางวันประจำสัปดาห์ที่แสดงให้ครอบครัวเห็นบนเว็บไซต์",
  "weekly_menus.add_week": "เพิ่มสัปดาห์",
  "weekly_menus.error": "ไม่สามารถโหลดเมนูประจำสัปดาห์ได้",
  "weekly_menus.empty": "ยังไม่มีเมนูประจำสัปดาห์ คลิก \"เพิ่มสัปดาห์\" เพื่อสร้างรายการแรก",
  "weekly_menus.empty_filtered": "ไม่พบเมนูประจำสัปดาห์ที่ตรงกับตัวกรองปัจจุบัน",
  "weekly_menus.summary": "แสดง {{filtered}} จาก {{total}} เมนูประจำสัปดาห์",
  "weekly_menus.week": "สัปดาห์",
  "weekly_menus.days": "วัน",
  "weekly_menus.school_day": "วันเรียน",
  "weekly_menus.school_days": "วันเรียน",
  "weekly_menus.holiday": "วันหยุด",
  "weekly_menus.holidays": "วันหยุด",
  "weekly_menus.delete_title": "ลบเมนูประจำสัปดาห์",
  "weekly_menus.delete_description": "การดำเนินการนี้จะลบเมนูออกอย่างถาวร ครอบครัวจะไม่เห็นเมนูนี้บนเว็บไซต์อีกต่อไป",
  "tour_requests.title": "คำขอเยี่ยมชม",
  "tour_requests.subtitle": "คำขอเยี่ยมชมที่ส่งผ่านแบบฟอร์มรับสมัคร",
  "tour_requests.error": "ไม่สามารถโหลดคำขอเยี่ยมชมได้",
  "tour_requests.empty": "ไม่พบคำขอเยี่ยมชม",
  "tour_requests.name": "ชื่อ",
  "tour_requests.email": "อีเมล",
  "tour_requests.children_column": "จำนวนบุตร",
  "tour_requests.received": "วันที่ได้รับ",
  "tour_requests.child": "คน",
  "tour_requests.children_word": "คน",
  "contact_inquiries.title": "ข้อความติดต่อสอบถาม",
  "contact_inquiries.subtitle": "ข้อความที่ส่งผ่านแบบฟอร์มติดต่อ",
  "contact_inquiries.error": "ไม่สามารถโหลดข้อความติดต่อสอบถามได้",
  "contact_inquiries.empty": "ไม่พบข้อความติดต่อสอบถาม",
  "contact_inquiries.name": "ชื่อ",
  "contact_inquiries.email": "อีเมล",
  "contact_inquiries.subject": "หัวข้อเรื่อง",
  "contact_inquiries.received": "วันที่ได้รับ",
  "image.default_label": "รูปภาพ",
  "image.replace": "แทนที่",
  "image.remove": "ลบออก",
  "image.upload": "อัปโหลด{{label}}",
  "image.formats_hint": "PNG, JPG หรือ WebP — ขนาดไม่เกิน 10 MB",
  "image.aspect_hint": "อัตราส่วนที่แนะนำ {{ratio}}",
  "image.crop_title": "ครอบตัดรูปภาพ",
  "image.zoom": "ซูม",
  "image.uploading": "กำลังอัปโหลด…",
  "image.crop_and_upload": "ครอบตัดและอัปโหลด",
  "image.crop_apply": "ใช้รูปนี้",
  "image.crop_failed": "การครอบตัดล้มเหลว",
  "image.upload_failed": "การอัปโหลดล้มเหลว",
  "student_combobox.all_students": "นักเรียนทั้งหมด",
  "student_combobox.search_placeholder": "ค้นหานักเรียน…",
  "student_combobox.no_students_found": "ไม่พบนักเรียน",
  "student_combobox.clear_student": "ล้างนักเรียนที่เลือก",
  "staff_combobox.search_placeholder": "ค้นหาเจ้าหน้าที่…",
  "staff_combobox.no_staff_found": "ไม่พบเจ้าหน้าที่",
  "email_list.invalid_email": "กรุณากรอกอีเมลที่ถูกต้อง",
  "email_list.already_in_list": "ที่อยู่อีเมลนี้มีอยู่ในรายการแล้ว",
  "email_list.no_recipients": "ยังไม่มีผู้รับ",
  "email_list.remove_email": "ลบ {{email}} ออก",
  "editor.content_placeholder": "เขียนเนื้อหาบทความของคุณ...",
  "editor.quote_placeholder": "คำคม",
  "editor.author_placeholder": "ผู้เขียน",
  "editor.loading": "กำลังโหลดตัวแก้ไข…",
  "enum.incident_type.biting_ey": "กัด (เด็กเล็ก)",
  "enum.incident_type.hitting_ey": "ตี (เด็กเล็ก)",
  "enum.incident_type.pushing_ey": "ผลัก (เด็กเล็ก)",
  "enum.incident_type.throwing_objects": "ขว้างปาสิ่งของ",
  "enum.incident_type.verbal_aggression": "การใช้คำพูดก้าวร้าว",
  "enum.incident_type.targeted_harm": "พฤติกรรมทำร้ายผู้อื่นโดยเจตนา",
  "enum.incident_type.inappropriate_language": "การใช้คำพูด ท่าทาง หรือข้อความที่ไม่เหมาะสม",
  "enum.incident_type.property_damage": "ความเสียหายต่อทรัพย์สิน",
  "enum.incident_type.leaving_supervised_areas": "ออกจากพื้นที่ที่มีการดูแล",
  "enum.incident_type.emotional_dysregulation": "ภาวะควบคุมอารมณ์ไม่ได้",
  "enum.incident_type.accident": "อุบัติเหตุ",
  "enum.incident_type.peer_conflict": "ความขัดแย้งระหว่างเพื่อน",
  "enum.incident_type.other": "อื่นๆ",
  "enum.incident_severity.low": "ต่ำ",
  "enum.incident_severity.medium": "ปานกลาง",
  "enum.incident_severity.high": "สูง",
  "enum.incident_status.open": "เปิด",
  "enum.incident_status.investigating": "กำลังตรวจสอบ",
  "enum.incident_status.closed": "ปิดแล้ว",
  "enum.incident_student_role.initiated": "ก่อเหตุ / เป็นฝ่ายกระทำ",
  "enum.incident_student_role.affected": "ได้รับผลกระทบ / เป็นฝ่ายถูกกระทำ",
  "enum.incident_student_role.witness": "พยาน",
  "enum.incident_student_role.unclear": "เกี่ยวข้อง — ไม่ชัดเจน",
  "enum.support_note_visibility.staff": "แชร์กับครู",
  "enum.support_note_visibility.sst_only": "SST เท่านั้น",
  "enum.incident_outcome.no_further_action": "ไม่ต้องดำเนินการเพิ่มเติม",
  "enum.incident_outcome.monitoring": "การเฝ้าติดตาม",
  "enum.incident_outcome.parents_informed": "แจ้งผู้ปกครองแล้ว",
  "enum.incident_outcome.behaviour_support_plan": "แผนสนับสนุนพฤติกรรม",
  "enum.incident_outcome.referred_to_counsellor": "ส่งต่อพบที่ปรึกษา",
  "enum.incident_outcome.disciplinary_action": "มาตรการทางวินัย",
  "enum.incident_outcome.other": "อื่นๆ",
  "enum.checkout_unavailable_reason.absent": "ขาดเรียนวันนี้",
  "enum.checkout_unavailable_reason.excused": "ลาวันนี้",
  "enum.checkout_unavailable_reason.early_dismissal": "มีการขอกลับก่อนเวลาแล้ววันนี้",
  "enum.checkout_unavailable_reason.collected": "รับกลับแล้ววันนี้",
  "enum.checkout_unavailable_reason.edp": "อยู่ในโครงการ EDP",
  "enum.checkout_unavailable_reason.suspended": "พักการเรียนวันนี้",
  "checkout.subtitle": "เรียกนักเรียนมาที่จุดรับ-ส่งและส่งมอบให้ครอบครัว",
  "checkout.tab_door": "จุดรับ-ส่ง",
  "checkout.tab_room": "ห้องรอ",
  "checkout.tab_all": "ทั้งหมด",
  "checkout.tab_switch_label": "มุมมองการรับกลับ",
  "checkout.door_is_office_only": "หน้าจอนี้เป็นของสำนักงานหน้าโรงเรียน คุณดูได้ แต่การเรียกและบันทึกการรับนักเรียนทำได้ที่จุดรับ-ส่งเท่านั้น",
  "checkout.edp_until": "อยู่ EDP จนถึง {{time}}",
  "checkout.edp_back": "กลับจาก EDP แล้ว",
  "checkout.edp_skip_action": "วันนี้ไม่ไป EDP",
  "checkout.edp_skipped": "วันนี้ไม่ไป EDP: {{reason}}",
  "checkout.edp_skipped_by": "บันทึกโดย {{name}}",
  "checkout.edp_skip_undo": "ไป EDP ตามเดิม",
  "checkout.edp_skip_title": "วันนี้ไม่ไป EDP",
  "checkout.edp_skip_description": "บ่ายนี้จะถือว่า {{name}} กลับบ้าน ครูผู้สอน EDP จะเห็นเหตุผลในรายชื่อช่วงบ่าย",
  "checkout.edp_skip_reason_label": "เหตุผลจากผู้ปกครอง",
  "checkout.edp_skip_reason_required": "โปรดระบุเหตุผลจากผู้ปกครอง",
  "checkout.edp_skip_reason_max": "เหตุผลต้องไม่เกิน 200 ตัวอักษร",
  "checkout.edp_skip_confirm": "บันทึก",
  "checkout.edp_skip_recorded": "บันทึกแล้ว เรียก {{name}} ได้ทันที",
  "checkout.edp_skip_removed": "{{name}} ไป EDP ตามเดิม",
  "checkout.going_home_alone_badge": "กลับบ้านเอง",
  "checkout_door.search_title": "ค้นหาครอบครัว",
  "checkout_door.search_placeholder": "ค้นหาด้วยชื่อหรือชื่อเล่นของนักเรียน…",
  "checkout_door.search_hint": "พิมพ์ต่อเพื่อค้นหา",
  "checkout_door.search_no_results": "ไม่พบข้อมูล",
  "checkout_door.no_guardian_heading": "ไม่มีผู้ปกครองในระบบ",
  "checkout_door.already_called": "เรียกแล้ว",
  "checkout_door.call_button": "เรียก",
  "checkout_door.call_all_button": "เรียกทั้งหมด",
  "checkout_door.call_failed": "ติดต่อห้องเรียนไม่สำเร็จ การเรียกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "checkout_door.call_no_grade": "นักเรียนคนนี้ยังไม่มีระดับชั้นในระบบ จึงไม่สามารถแจ้งห้องเรียนได้ กรุณาแก้ไขข้อมูลนักเรียนก่อน",
  "checkout_door.waiting_title": "กำลังรอ",
  "checkout_door.waiting_empty": "ไม่มีใครรอรับกลับ",
  "checkout_door.status_on_way": "กำลังมา",
  "checkout_door.collected_button": "รับกลับแล้ว",
  "checkout_door.collect_failed": "บันทึกการรับกลับไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "checkout_door.cancel_button": "ยกเลิก",
  "checkout_door.cancel_failed": "ยกเลิกการเรียกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "checkout_door.collected_at": "รับกลับเมื่อ {{time}}",
  "checkout_door.undo_collected_button": "เลิกทำ",
  "checkout_door.undo_failed": "ยกเลิกการรับกลับไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "checkout_door.left_alone_button": "กลับเองแล้ว",
  "checkout_alone.title": "กลับบ้านเอง",
  "checkout_alone.send_home_button": "ให้กลับบ้าน",
  "checkout_alone.parent_coming_button": "ผู้ปกครองมารับ",
  "checkout_alone.parent_coming_heading": "วันนี้ผู้ปกครองมารับ ({{count}})",
  "checkout_alone.undo_button": "เลิกทำ",
  "checkout_alone.keep_failed": "บันทึกว่าผู้ปกครองมารับไม่สำเร็จ กรุณาลองใหม่",
  "checkout_alone.undo_failed": "เลิกทำไม่สำเร็จ กรุณาลองใหม่",
  "checkout_waiting_room.title": "กำลังรับนักเรียน",
  "checkout_waiting_room.filter_label": "ระดับชั้นที่แสดง",
  "checkout_waiting_room.filter_my_homeroom": "ห้องเรียนประจำของฉัน",
  "checkout_waiting_room.empty": "ไม่มีใครรอรับกลับ",
  "checkout_waiting_room.on_way_button": "กำลังมา",
  "checkout_waiting_room.edp_strip_title": "อยู่ต่อเพื่อ EDP",
  "checkout_waiting_room.edp_strip_count": "อยู่ต่อ {{count}} คน",
  "checkout_waiting_room.edp_strip_empty": "วันนี้ไม่มีนักเรียนจากเกรดที่เลือกอยู่ต่อเพื่อ EDP",
  "checkout_waiting_room.edp_strip_show": "แสดง",
  "checkout_waiting_room.edp_strip_hide": "ซ่อน",
  "enum.it_ticket_location.classroom": "ห้องเรียน",
  "enum.it_ticket_location.library": "ห้องสมุด",
  "enum.it_ticket_location.admin_office": "สำนักงานธุรการ",
  "enum.it_ticket_location.staff_office": "ห้องพักครู",
  "enum.it_ticket_location.meeting_room": "ห้องประชุม",
  "enum.it_ticket_location.not_applicable": "ไม่มีสถานที่ที่เกี่ยวข้อง",
  "enum.it_ticket_location.other": "อื่นๆ",
  "enum.it_ticket_device.laptop": "แล็ปท็อป",
  "enum.it_ticket_device.projector_smartboard": "โปรเจกเตอร์ / Smart Board",
  "enum.it_ticket_device.tv": "ทีวี",
  "enum.it_ticket_device.wifi_network": "WIFI / เครือข่าย",
  "enum.it_ticket_device.google_classroom": "Google Classroom",
  "enum.it_ticket_device.student_laptop": "แล็ปท็อปนักเรียน",
  "enum.it_ticket_device.student_tablet": "แท็บเล็ตนักเรียน",
  "enum.it_ticket_device.hmh": "HMH",
  "enum.it_ticket_device.mcgraw_hill": "McGraw Hill",
  "enum.it_ticket_device.risp_platform": "ระบบ RISP",
  "enum.it_ticket_device.other_software": "ซอฟต์แวร์อื่นๆ",
  "enum.it_ticket_device.other": "อื่นๆ",
  "enum.it_ticket_priority.low": "ต่ำ",
  "enum.it_ticket_priority.medium": "ปานกลาง",
  "enum.it_ticket_priority.high": "สูง",
  "enum.it_ticket_status.open": "เปิด",
  "enum.it_ticket_status.in_progress": "กำลังดำเนินการ",
  "enum.it_ticket_status.waiting_on_requester": "รอผู้แจ้งตอบกลับ",
  "enum.it_ticket_status.resolved": "แก้ไขแล้ว",
  "enum.leave_type.personal": "ลากิจ",
  "enum.leave_type.vacation": "ลาพักร้อน",
  "enum.leave_type.sick": "ลาป่วย",
  "enum.leave_type.professional_development": "การพัฒนาวิชาชีพ",
  "enum.leave_portion.full_day": "เต็มวัน",
  "enum.leave_portion.morning_half": "ครึ่งวัน (เช้า)",
  "enum.leave_portion.afternoon_half": "ครึ่งวัน (บ่าย)",
  "enum.status.pending": "รอดำเนินการ",
  "enum.status.approved": "อนุมัติแล้ว",
  "enum.status.rejected": "ปฏิเสธ",
  "enum.student_absence_type.sick": "ป่วย",
  "enum.student_absence_type.family": "ธุระครอบครัว",
  "enum.student_absence_type.travel": "เดินทาง",
  "enum.student_absence_type.medical": "การแพทย์",
  "enum.student_absence_type.other": "อื่นๆ",
  "enum.relationship.mother": "มารดา",
  "enum.relationship.father": "บิดา",
  "enum.relationship.guardian": "ผู้ปกครอง",
  "enum.relationship.grandmother": "ยาย/ย่า",
  "enum.relationship.grandfather": "ตา/ปู่",
  "enum.relationship.stepmother": "แม่เลี้ยง",
  "enum.relationship.stepfather": "พ่อเลี้ยง",
  "enum.relationship.aunt": "ป้า/น้า/อา (ฝ่ายหญิง)",
  "enum.relationship.uncle": "ลุง/น้า/อา (ฝ่ายชาย)",
  "enum.relationship.other": "อื่นๆ",
  "enum.language.en": "อังกฤษ",
  "enum.language.th": "ไทย",
  "enum.language.zh": "จีน",
  "enum.tour_status.new": "ใหม่",
  "enum.tour_status.confirmed": "ยืนยันแล้ว",
  "enum.tour_status.completed": "เสร็จสิ้น",
  "enum.tour_status.cancelled": "ยกเลิก",
  "enum.inquiry_status.new": "ใหม่",
  "enum.inquiry_status.in_progress": "กำลังดำเนินการ",
  "enum.inquiry_status.resolved": "แก้ไขแล้ว",
  "enum.sex.male": "ชาย",
  "enum.sex.female": "หญิง",
  "enum.booking_resource_type.room": "ห้อง",
  "enum.booking_resource_type.tablet": "แท็บเล็ต",
  "import.subtitle": "เพิ่มนักเรียนหรือเจ้าหน้าที่จากเทมเพลต Excel หรือนำเข้าผลสอบ MAP ที่ส่งออกจาก NWEA",
  "import.tabs_label": "สิ่งที่ต้องการนำเข้า",
  "import.tab_map": "ผลสอบ MAP",
  "import.step_template_title": "ดาวน์โหลดเทมเพลต",
  "import.step_template_body_students": "กรอกนักเรียนหนึ่งคนต่อหนึ่งแถว และห้ามแก้ไขหัวคอลัมน์",
  "import.step_template_body_staff": "กรอกเจ้าหน้าที่หนึ่งคนต่อหนึ่งแถว และห้ามแก้ไขหัวคอลัมน์",
  "import.step_upload_title": "อัปโหลดเทมเพลตที่กรอกแล้ว",
  "import.file_label": "เทมเพลตที่กรอกแล้ว (.xlsx)",
  "import.step_review_title": "ตรวจสอบและยืนยัน",
  "import.step_review_waiting": "คุณจะเห็นข้อมูลทุกแถวก่อนที่ระบบจะบันทึก รายชื่อที่มีอยู่ใน RISP แล้วจะถูกข้าม ไม่มีการเขียนทับ",
  "import.choose_another_file": "เลือกไฟล์อื่น",
  "import.students": "นักเรียน",
  "import.staff": "เจ้าหน้าที่",
  "import.download_template": "ดาวน์โหลดเทมเพลต",
  "import.download_failed": "ดาวน์โหลดไม่สำเร็จ",
  "import.analysing": "กำลังวิเคราะห์ไฟล์…",
  "import.preview_failed": "แสดงตัวอย่างไม่สำเร็จ",
  "import.preview_help_note": "<strong>ยังไม่มีการบันทึกข้อมูล</strong> ตรวจสอบแถวข้อมูล แล้วกดยืนยัน <strong>เพิ่ม</strong> = รายชื่อใหม่ที่จะถูกสร้างขึ้น <strong>ข้าม</strong> = มีอยู่ในระบบแล้ว (จับคู่ด้วยอีเมลหรือรหัส) — จะไม่ถูกแก้ไข <strong>ข้อผิดพลาด</strong> = มีบางอย่างผิดพลาดในแถวนั้น (ดูข้อความ) แก้ไขในไฟล์ของคุณแล้วอัปโหลดใหม่อีกครั้ง",
  "import.chip_add": "✅ เพิ่ม {{count}} รายการ",
  "import.chip_skip": "⏭️ ข้าม {{count}} รายการ",
  "import.chip_error": "⚠️ {{count}} ข้อผิดพลาด",
  "import.col_row": "แถว",
  "import.col_full_name": "ชื่อ-นามสกุล",
  "import.col_notes": "หมายเหตุ / เหตุผล",
  "import.no_rows": "ไม่มีแถวข้อมูลที่จะแสดง",
  "import.commit_failed": "ยืนยันการนำเข้าไม่สำเร็จ",
  "import.send_invitations": "ส่งอีเมลเชิญให้เจ้าหน้าที่ใหม่",
  "import.importing": "กำลังนำเข้า…",
  "import.confirm_import": "ยืนยันการนำเข้า",
  "import.result_help_note": "เสร็จสิ้น แถวที่ถูกข้ามหรือมีข้อผิดพลาดจะไม่ถูกสร้างขึ้น — แก้ไขข้อผิดพลาดในไฟล์ Excel ของคุณแล้วนำเข้าอีกครั้งเพื่อเพิ่มรายการเหล่านั้น",
  "import.summary": "สร้างแล้ว {{created}} รายการ · ข้าม {{skipped}} รายการ",
  "import.invited": "ส่งคำเชิญให้เจ้าหน้าที่ {{count}} คนแล้ว",
  "import.errors_count": "ข้อผิดพลาด ({{count}}):",
  "import.row_error": "แถว {{row}}: {{message}}",
  "import.import_another": "นำเข้าอีกครั้ง",
  "import.disposition_skip": "ข้าม",
  "import.disposition_error": "ข้อผิดพลาด",
  "school_years.tabs_label": "ส่วนต่าง ๆ ของปีการศึกษา",
  "school_years.tab_years": "ปีการศึกษา",
  "school_years.tab_edp_rounds": "รอบ EDP",
  "school_years.tab_school_days": "วันเปิดเรียน",
  "school_years.tab_sessions": "รอบเรียน",
  "inquiries.tabs_label": "ส่วนต่าง ๆ ของข้อความติดต่อ",
  "inquiries.tab_contact": "ข้อความติดต่อ",
  "inquiries.tab_tours": "คำขอเยี่ยมชม",
  "school_years.default_name": "ปีการศึกษา {{startYear}}-{{endYear}}",
  "school_years.subtitle": "ช่วงปีการศึกษาที่ใช้ร่วมกันสำหรับแซนด์ดอลลาร์และฟีเจอร์อื่น ๆ ของโรงเรียนในอนาคต",
  "school_years.new_school_year": "ปีการศึกษาใหม่",
  "school_years.active_year_label": "ปีการศึกษาปัจจุบัน:",
  "school_years.empty": "ยังไม่มีปีการศึกษา สร้างปีการศึกษาก่อนใช้งานฟีเจอร์ที่อ้างอิงปี",
  "school_years.col_code": "รหัส",
  "school_years.col_name": "ชื่อ",
  "school_years.col_start_date": "วันที่เริ่มต้น",
  "school_years.col_end_date": "วันที่สิ้นสุด",
  "school_years.promote_title": "เลื่อนชั้นนักเรียนทั้งหมดขึ้นหนึ่งระดับหรือไม่?",
  "school_years.promote_description": "นักเรียนที่ยังใช้งานอยู่ทุกคนจะถูกเลื่อนขึ้นหนึ่งระดับชั้นสำหรับปีนี้ นักเรียนเกรด 12 จะไม่มีการเปลี่ยนแปลง การดำเนินการนี้ทำได้เพียงครั้งเดียวต่อปี",
  "school_years.promote_label": "เลื่อนชั้น",
  "school_years.promoted_already": "นักเรียนถูกเลื่อนชั้นสำหรับปีนี้ไปแล้ว",
  "school_years.promoted_success": "เลื่อนชั้นนักเรียนแล้ว {{count}} คน",
  "school_years.promote_failed": "เลื่อนชั้นนักเรียนไม่สำเร็จ",
  "school_years.error_code_required": "กรุณากรอกรหัส",
  "school_years.error_name_required": "กรุณากรอกชื่อ",
  "school_years.error_start_date_required": "กรุณาเลือกวันที่เริ่มต้น",
  "school_years.error_end_date_required": "กรุณาเลือกวันที่สิ้นสุด",
  "school_years.status_planned": "วางแผนไว้",
  "school_years.status_active": "ใช้งานอยู่",
  "school_years.status_archived": "เก็บถาวร",
  "school_years.status_locked": "ล็อก",
  "school_years.edit_title": "แก้ไขปีการศึกษา",
  "school_years.new_title": "สร้างปีการศึกษาใหม่",
  "school_years.field_start_date": "วันที่เริ่มต้น",
  "school_years.field_end_date": "วันที่สิ้นสุด",
  "settings.subtitle": "จัดการการตั้งค่าทั่วทั้งเว็บไซต์โดยไม่ต้องสร้างบิลด์ใหม่",
  "settings.load_error": "ไม่สามารถโหลดการตั้งค่าได้",
  "settings.empty": "ไม่มีการตั้งค่าให้แสดง",
  "settings.label.mourning_mode": "โหมดไว้อาลัย",
  "settings.label.tour_request_recipients": "ผู้รับแจ้งคำขอเยี่ยมชม",
  "settings.label.contact_inquiry_recipients": "ผู้รับแจ้งข้อความติดต่อสอบถาม",
  "settings.label.leave_request_staff_recipients": "ผู้รับแจ้งคำขอลา (เจ้าหน้าที่)",
  "settings.label.leave_request_student_recipients": "ผู้รับแจ้งคำขอลา (นักเรียน)",
  "settings.label.student_absence_recipients": "ผู้รับแจ้งการลาของนักเรียน",
  "settings.label.early_dismissal_recipients": "ผู้รับแจ้งคำขอกลับก่อนเวลา",
  "settings.label.early_dismissal_reminder_recipients": "ผู้รับการแจ้งเตือนก่อนกลับก่อนเวลา",
  "settings.label.early_dismissal_reminder_lead_minutes": "เวลาแจ้งเตือนล่วงหน้าก่อนกลับก่อนเวลา",
  "settings.label.late_arrival_recipients": "ผู้รับแจ้งการมาสาย",
  "settings.label.fever_alert_recipients": "ผู้รับแจ้งเตือนไข้",
  "settings.label.allergy_change_request_recipients": "ผู้รับแจ้งคำขอเปลี่ยนแปลงการแพ้อาหารและการกินอาหารพิเศษ",
  "settings.label.immigration_compliance_recipients": "ผู้รับสรุปข้อมูลการปฏิบัติตามกฎหมายตรวจคนเข้าเมือง",
  "settings.label.it_support_recipients": "ผู้รับแจ้งปัญหา IT",
  "settings.label.it_archive_after_days": "เก็บถาวรเรื่องที่แก้ไขแล้วหลังจาก (วัน)",
  "settings.desc.mourning_mode": "ใช้ฟิลเตอร์ขาวดำกับทั้งเว็บไซต์",
  "settings.desc.tour_request_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนเมื่อมีคำขอเยี่ยมชมใหม่",
  "settings.desc.contact_inquiry_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนเมื่อมีการส่งแบบฟอร์มติดต่อใหม่",
  "settings.desc.leave_request_staff_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับสำเนาทุกครั้งที่มีการส่ง อนุมัติ หรือปฏิเสธคำขอลาของเจ้าหน้าที่",
  "settings.desc.leave_request_student_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับสำเนาทุกครั้งที่มีการส่ง อนุมัติ หรือปฏิเสธคำขอลาของนักเรียน",
  "settings.desc.student_absence_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนเมื่อผู้ปกครองแจ้งการลาของนักเรียน",
  "settings.desc.early_dismissal_recipients": "อีเมลของเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนเมื่อผู้ปกครองแจ้งการกลับก่อนเวลา",
  "settings.desc.early_dismissal_reminder_recipients": "อีเมลของเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนก่อนถึงเวลารับนักเรียน เพื่อให้มีผู้ไปรับนักเรียนมาที่ประตู",
  "settings.desc.early_dismissal_reminder_lead_minutes": "จะส่งการแจ้งเตือนล่วงหน้ากี่นาทีก่อนถึงเวลารับนักเรียน",
  "settings.desc.late_arrival_recipients": "ได้รับแจ้งเมื่อผู้ปกครองแจ้งว่านักเรียนจะมาสาย",
  "settings.desc.fever_alert_recipients": "เจ้าหน้าที่ที่จะได้รับอีเมลเมื่อบันทึกอุณหภูมิของเด็กตั้งแต่ 37.5 °C ขึ้นไป",
  "settings.desc.allergy_change_request_recipients": "ผู้ที่ได้รับอีเมลเมื่อผู้ปกครองเสนอการเปลี่ยนแปลงข้อมูลการแพ้อาหารหรือการกินอาหารพิเศษเพื่อพิจารณา",
  "settings.desc.immigration_compliance_recipients": "อีเมลฝ่ายบุคคลที่จะได้รับสรุปประจำวันเกี่ยวกับกำหนดวันหมดอายุวีซ่า ใบอนุญาตทำงาน และการรายงานตัว 90 วัน ที่ใกล้ถึงหรือเลยกำหนด",
  "settings.desc.it_support_recipients": "อีเมลฝ่ายไอทีที่จะได้รับการแจ้งเตือนเมื่อมีการแจ้งปัญหา IT ใหม่",
  "settings.desc.it_archive_after_days": "เรื่องที่แก้ไขแล้วจะถูกย้ายไปยังที่เก็บถาวรหลังจากจำนวนวันนี้ นับจากวันที่แก้ไขเสร็จ",
  "audit_log.subtitle": "ทุกการเปลี่ยนแปลงที่เกิดขึ้นผ่านระบบผู้ดูแล ใครเป็นผู้ทำ และเมื่อใด",
  "audit_log.error": "ไม่สามารถโหลดบันทึกการตรวจสอบได้",
  "audit_log.empty": "ไม่พบรายการบันทึกการตรวจสอบ",
  "audit_log.actor_email_label": "อีเมลผู้ดำเนินการ",
  "audit_log.search_email_placeholder": "ค้นหาอีเมล…",
  "audit_log.action_placeholder": "เช่น users.",
  "audit_log.from_label": "จาก",
  "audit_log.from_placeholder": "จาก…",
  "audit_log.to_label": "ถึง",
  "audit_log.to_placeholder": "ถึง…",
  "audit_log.page_summary": "หน้า {{page}} จาก {{totalPages}} ({{total}} รายการ)",
  "audit_log.col_when": "เมื่อ",
  "audit_log.col_actor": "ผู้ดำเนินการ",
  "audit_log.col_action": "การกระทำ",
  "audit_log.col_target": "เป้าหมาย",
  "audit_log.no_payload": "ไม่มีข้อมูล payload",
  "audit_log.medical_payload_restricted": "รายละเอียดทางการแพทย์ยังคงถูกเก็บไว้ ต้องมีสิทธิ์เข้าถึงข้อมูลทางการแพทย์เพื่อดูรายละเอียด",
  "calendar.subtitle": "วันสำคัญทางวิชาการ วันหยุด และเหตุการณ์สำคัญ",
  "calendar.add_entry": "เพิ่มรายการปฏิทิน",
  "calendar.error": "ไม่สามารถโหลดรายการปฏิทินได้ กรุณาลองใหม่อีกครั้ง",
  "calendar.empty_no_entries": "ยังไม่มีรายการปฏิทิน",
  "calendar.empty_filtered": "ไม่พบรายการปฏิทินที่ตรงกับตัวกรองปัจจุบัน",
  "calendar.summary": "แสดง {{filtered}} จาก {{total}} รายการ",
  "calendar.summary_with_year": "แสดง {{filtered}} จาก {{total}} รายการในปี {{code}}",
  "calendar.school_year_label": "ปีการศึกษา",
  "calendar.select_school_year_placeholder": "เลือกปีการศึกษา",
  "calendar.active_suffix": "(ใช้งานอยู่)",
  "calendar.all_categories": "หมวดหมู่ทั้งหมด",
  "calendar.col_audience": "กลุ่มเป้าหมาย",
  "calendar.all_day": "ตลอดวัน",
  "calendar.publish_tooltip": "เผยแพร่กิจกรรม",
  "calendar.delete_title": "ลบรายการปฏิทิน",
  "calendar.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการปฏิทินนี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "calendar.feed_description": "แชร์ลิงก์นี้ให้ครอบครัวเพื่อให้พวกเขาซิงค์ปีการศึกษาปัจจุบันได้โดยอัตโนมัติ",
  "calendar.copy_feed_link": "คัดลอกลิงก์ฟีด",
  "calendar.feed_link_copied": "คัดลอกลิงก์ฟีดแล้ว",
  "calendar.view_label": "มุมมอง",
  "calendar.view_list": "รายการ",
  "calendar.view_month": "เดือน",
  "calendar.month_label": "เดือน",
  "calendar.previous_month": "เดือนก่อนหน้า",
  "calendar.next_month": "เดือนถัดไป",
  "leave.list_title": "คำขอลา",
  "leave.list_subtitle": "ตรวจสอบและพิจารณาคำขอลาของบุคลากร",
  "leave.new_on_behalf": "สร้างแทนบุคลากร",
  "leave.search_placeholder": "ค้นหาด้วยชื่อหรืออีเมลผู้ขอ…",
  "leave.search_aria": "ค้นหาคำขอลาด้วยอีเมลผู้ขอ",
  "leave.type_label": "ประเภท",
  "leave.list_empty": "ไม่พบคำขอที่ตรงกับตัวกรองนี้",
  "leave.col_requester": "ผู้ขอ",
  "leave.col_dates": "วันที่",
  "leave.col_days": "จำนวนวัน",
  "leave.col_action": "การดำเนินการ",
  "leave.open": "เปิด",
  "leave.new_on_behalf_title": "สร้างคำขอลาแทนบุคลากร",
  "leave.my_title": "การลาของฉัน",
  "leave.my_subtitle": "ยื่นและติดตามคำขอลาของคุณ",
  "leave.new_request": "สร้างคำขอใหม่",
  "leave.your_entitlement": "สิทธิ์การลาของคุณ",
  "leave.history": "ประวัติ",
  "leave.no_requests": "ยังไม่มีคำขอลา",
  "leave.days_one": "{{count}} วัน",
  "leave.days_other": "{{count}} วัน",
  "leave.reviewer_message": "ข้อความจากผู้พิจารณา:",
  "leave.new_request_title": "สร้างคำขอลาใหม่",
  "leave.detail_title": "คำขอลา — {{name}}",
  "leave.loading": "กำลังโหลด…",
  "leave.detail_breadcrumb": "รายละเอียด",
  "leave.back": "กลับ",
  "leave.request_section": "คำขอ",
  "leave.days_counted": "จำนวนวันที่นับ",
  "leave.submitted": "ยื่นเมื่อ",
  "leave.reviewed": "พิจารณาเมื่อ",
  "leave.reason": "เหตุผล",
  "leave.requester_entitlement_title": "การลาของ {{name}}",
  "leave.entitlement_default_title": "สิทธิ์การลา",
  "leave.left": "คงเหลือ",
  "leave.days_used": "วันที่ใช้ไป",
  "leave.over_allowance": "เกินสิทธิ์ {{limit}} วัน",
  "leave.staff_member_label": "บุคลากร",
  "leave.staff_member_placeholder": "เลือกบุคลากรที่คำขอนี้เป็นของ",
  "leave.on_behalf_hint": "ยื่นแทนบุคลากร — บุคลากรจะได้รับอีเมลยืนยันและสามารถตรวจสอบคำขอได้จากหน้าการลาของฉัน",
  "leave.error_no_requester": "กรุณาเลือกบุคลากรที่คำขอนี้เป็นของ",
  "leave.error_type_required": "กรุณาระบุประเภท",
  "leave.error_start_date_required": "กรุณาระบุวันที่เริ่มลา",
  "leave.error_end_date_required": "กรุณาระบุวันที่สิ้นสุด",
  "leave.error_end_date_after_start": "วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มลา",
  "leave.error_reason_required": "กรุณาระบุเหตุผล",
  "leave.error_submit_failed": "ไม่สามารถส่งคำขอลาได้",
  "leave.days_remaining": "เหลือ {{remaining}} จาก {{limit}} วันในปีนี้",
  "leave.days_pending_suffix": " ({{pending}} รอดำเนินการ)",
  "leave.start_date_label": "วันที่เริ่มลา",
  "leave.end_date_label": "วันที่สิ้นสุด",
  "leave.duration_label": "ระยะเวลา",
  "leave.half_day_hint": "ตัวเลือกครึ่งวันใช้ได้เฉพาะคำขอลาแบบวันเดียวเท่านั้น",
  "leave.submit_on_behalf": "ส่งคำขอแทนบุคลากร",
  "leave.submit_request": "ส่งคำขอ",
  "leave.save_changes": "บันทึกการแก้ไข",
  "leave.edit_request": "แก้ไขคำขอ",
  "leave.edit_request_title": "แก้ไขคำขอ",
  "leave.submitting": "กำลังส่ง…",
  "leave.decision_title": "การพิจารณา",
  "leave.decided_by": "โดย {{name}} · {{date}}",
  "leave.message_to_requester": "ข้อความถึงผู้ขอ",
  "leave.message_placeholder": "ไม่บังคับ — ข้อความนี้จะรวมอยู่ในอีเมลอนุมัติ/ปฏิเสธ",
  "leave.reject": "ปฏิเสธ",
  "leave.approve": "อนุมัติ",
  "leave.error_decision_failed": "ไม่สามารถบันทึกผลการพิจารณาได้",
  "leave.internal_notes_title": "บันทึกภายใน",
  "leave.internal_notes_hint": "มองเห็นได้เฉพาะผู้ดูแลระบบเท่านั้น",
  "leave.no_notes": "ยังไม่มีบันทึก",
  "leave.unknown_author": "ไม่ทราบผู้เขียน",
  "leave.note_placeholder": "เพิ่มบันทึกสำหรับผู้พิจารณาคนอื่น…",
  "leave.add_note": "เพิ่มบันทึก",
  "leave.adding_note": "กำลังเพิ่ม…",
  "leave.error_note_empty": "บันทึกต้องไม่ว่างเปล่า",
  "leave.error_note_add_failed": "ไม่สามารถเพิ่มบันทึกได้",
  "leave.error_note_delete_failed": "ไม่สามารถลบบันทึกได้",
  "arrivals_dismissals.title": "มาสายและกลับก่อนเวลา",
  "arrivals_dismissals.subtitle": "รายการมาสายและกลับก่อนเวลาที่ผู้ปกครองแจ้งไว้และที่สำนักงานบันทึกไว้ ไม่มีรายการใดที่ต้องรออนุมัติ",
  "arrivals_dismissals.kind.arrival": "มาถึง",
  "arrivals_dismissals.kind.dismissal": "กลับ",
  "arrivals_dismissals.type_label": "ประเภท",
  "arrivals_dismissals.type.all": "ทั้งหมด",
  "arrivals_dismissals.empty": "ไม่พบรายการที่ตรงกับตัวกรองนี้",
  "late_arrivals.record_button": "บันทึกการมาสาย",
  "late_arrivals.dialog_title": "บันทึกการมาสาย",
  "late_arrivals.arrives_at": "เวลาที่มาถึง",
  "late_arrivals.time_window": "เลือกเวลาระหว่าง 08:00 ถึง 13:00",
  "late_arrivals.toast_recorded": "บันทึกการมาสายแล้ว",
  "late_arrivals.record_failed": "ไม่สามารถบันทึกการมาสายได้",
  "late_arrivals.not_excused": "ไม่ได้รับอนุญาต",
  "late_arrivals.excused": "ได้รับอนุญาต",
  "late_arrivals.excused_help": "ปิดสวิตช์เมื่อควรนับเป็นการมาสายตามปกติ เฉพาะผู้ดูแลระบบเท่านั้นที่เปลี่ยนได้",
  "late_arrivals.excused_failed": "ไม่สามารถเปลี่ยนสถานะการได้รับอนุญาตได้",
  "late_arrivals.term_count_one": "ปีการศึกษานี้มาสาย {{count}} ครั้ง (ไม่ได้รับอนุญาต {{notExcused}} ครั้ง)",
  "late_arrivals.term_count_other": "ปีการศึกษานี้มาสาย {{count}} ครั้ง (ไม่ได้รับอนุญาต {{notExcused}} ครั้ง)",
  "late_arrivals.detail_breadcrumb": "การมาสาย",
  "late_arrivals.detail_title": "การมาสาย — {{name}}",
  "late_arrivals.not_found": "ไม่พบรายการมาสายนี้แล้ว อาจถูกลบไปแล้ว",
  "late_arrivals.deleted": "ลบรายการมาสายแล้ว",
  "late_arrivals.delete_title": "ลบรายการมาสายนี้หรือไม่?",
  "late_arrivals.delete_description": "คาบเรียนที่ได้รับการยกเว้นจะกลับไปเป็นยังไม่ได้บันทึก",
  "early_dismissals.record_button": "บันทึกการกลับก่อนเวลา",
  "early_dismissals.dialog_title": "บันทึกการกลับก่อนเวลา",
  "early_dismissals.toast_recorded": "บันทึกการกลับก่อนเวลาแล้ว",
  "early_dismissals.record_failed": "ไม่สามารถบันทึกการกลับก่อนเวลาได้",
  "early_dismissals.deleted": "ลบการกลับก่อนเวลาแล้ว",
  "early_dismissals.delete_title": "ลบการกลับก่อนเวลานี้หรือไม่?",
  "early_dismissals.delete_description": "รายการนี้จะหายไปจากรายชื่อที่ประตูและจากตารางของครู ระบบจะไม่ส่งอีเมลแจ้ง หากผู้ปกครองเป็นผู้แจ้งไว้ กรุณาแจ้งผู้ปกครองด้วยตนเอง",
  "student_absences.delete_title": "ลบการลาน้ีหรือไม่?",
  "student_absences.delete_description": "เครื่องหมายลาที่ได้รับอนุญาตของวันเหล่านี้จะถูกลบ และวันดังกล่าวจะกลับไปไม่มีบันทึกการเข้าเรียน หากครูเคยบันทึกไว้ก่อนที่จะเพิ่มการลานี้ จะไม่สามารถกู้คืนบันทึกเดิมได้",
  "student_absences.deleted": "ลบการลาแล้ว",
  "student_absences.title": "การขาดเรียนของนักเรียน",
  "student_absences.subtitle": "การลาที่ผู้ปกครองแจ้ง และที่โรงเรียนบันทึกแทน",
  "student_absences.record_button": "บันทึกการขาดเรียน",
  "student_absences.search_aria": "ค้นหาการขาดเรียนด้วยชื่อนักเรียน",
  "student_absences.empty": "ไม่พบรายการขาดเรียนที่ตรงกับตัวกรองนี้",
  "student_absences.type_label": "ประเภท",
  "student_absences.col_dates": "วันที่",
  "student_absences.dialog_title": "บันทึกการขาดเรียน",
  "student_absences.edit_title": "แก้ไขการขาดเรียน",
  "student_absences.toast_updated": "แก้ไขการขาดเรียนแล้ว",
  "student_absences.end_before_start": "วันสุดท้ายต้องไม่อยู่ก่อนวันแรก",
  "student_absences.toast_recorded": "บันทึกการขาดเรียนแล้ว",
  "student_absences.record_failed": "ไม่สามารถบันทึกการขาดเรียนได้",
  "student_absences.start_date_label": "วันที่เริ่ม",
  "student_absences.end_date_label": "วันที่สิ้นสุด",
  "incidents.error_select_student": "กรุณาเลือกนักเรียน",
  "incidents.error_date_required": "กรุณาระบุวันที่",
  "incidents.error_time_format": "เวลาต้องอยู่ในรูปแบบ HH:MM",
  "incidents.error_location_required": "กรุณาระบุสถานที่",
  "incidents.error_type_other_required": "กรุณาระบุประเภทเหตุการณ์",
  "incidents.error_description_required": "กรุณาระบุรายละเอียด",
  "incidents.action_taken_optional": "การดำเนินการที่ทำไปแล้ว (ไม่บังคับ)",
  "incidents.prevention_suggestion_optional": "ข้อเสนอแนะเพื่อป้องกัน (ไม่บังคับ)",
  "incidents.error_form_invalid": "ยังมีข้อมูลที่ต้องแก้ไข กรุณาตรวจสอบช่องที่ไฮไลต์",
  "incidents.attachment_upload_warning": "บันทึกเหตุการณ์แล้ว แต่ไม่สามารถอัปโหลดไฟล์แนบได้: {{message}}",
  "incidents.unknown_error": "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
  "incidents.report_success": "รายงานเหตุการณ์แล้ว",
  "incidents.report_failed": "ไม่สามารถรายงานเหตุการณ์ได้",
  "incidents.report_incident": "รายงานเหตุการณ์",
  "incidents.report_description": "ยื่นรายงานเหตุการณ์เกี่ยวกับนักเรียน",
  "incidents.field_location": "สถานที่",
  "incidents.field_type": "ประเภทเหตุการณ์",
  "incidents.field_specify": "ระบุ",
  "incidents.add_student": "เพิ่มนักเรียนอีกคน",
  "incidents.add_staff": "เพิ่มเจ้าหน้าที่",
  "incidents.select_student": "เลือกนักเรียน",
  "incidents.student_note_placeholder": "หมายเหตุ (ไม่บังคับ)",
  "incidents.severity": "ความรุนแรง",
  "incidents.field_medical": "ต้องได้รับการดูแลทางการแพทย์",
  "incidents.field_description": "รายละเอียดเหตุการณ์",
  "incidents.action_taken": "การดำเนินการที่ทำไปแล้ว",
  "incidents.prevention_suggestion": "ข้อเสนอแนะเพื่อป้องกัน",
  "incidents.field_attachments": "ไฟล์แนบ (รูปภาพหรือ PDF สูงสุด 6 ไฟล์)",
  "incidents.remove": "ลบออก",
  "incidents.submit_report": "ส่งรายงาน",
  "sst.tab_switch_label": "กรองตามสถานะ",
  "sst.tab_incidents": "เหตุการณ์",
  "sst.tab_lunch_detention": "MSS",
  "sst.tab_lunch_detention_attention": "MSS ที่รอดำเนินการ",
  "sst.tab_patterns": "รูปแบบ",
  "sst.tab_tests": "แบบทดสอบ",
  "sst.patterns_subtitle": "นักเรียนที่มีรูปแบบนำหน้าที่ควรติดตามในช่วง {{days}} วันเรียนที่ผ่านมา",
  "sst.patterns_empty": "ไม่มีรูปแบบที่สำคัญในช่วง {{days}} วันเรียนที่ผ่านมา",
  "sst.patterns_filter_unsupervised": "ยังไม่ได้รับการดูแล",
  "sst.patterns_filter_supervised": "อยู่ในการดูแล",
  "sst.patterns_filter_everyone": "ทั้งหมด",
  "sst.patterns_supervised_since": "อยู่ในการดูแลของ SST ตั้งแต่ {{date}}",
  "sst.patterns_not_supervised": "ไม่ได้รับการดูแล",
  "sst.patterns_flag_late": "รูปแบบการมาสาย",
  "sst.patterns_flag_attendance": "การเข้าเรียน",
  "sst.patterns_flag_class": "การเข้าคาบเรียน",
  "sst.patterns_flag_incidents": "เหตุการณ์",
  "sst.patterns_flag_recognition": "การยอมรับ",
  "sst.patterns_strip_label": "{{days}} วันเรียน เก่าที่สุดก่อน",
  "sst.patterns_legend_title": "วิธีอ่านแถบข้อมูล",
  "sst.patterns_legend_present": "มาเรียน",
  "sst.patterns_legend_late": "สาย — ยิ่งสูงยิ่งสายมาก",
  "sst.patterns_legend_late_unmeasured": "สาย ไม่มีบันทึกเวลามาถึง",
  "sst.patterns_legend_absent": "ขาดเรียน",
  "sst.patterns_legend_excused": "ลา",
  "sst.patterns_legend_suspended": "พักการเรียน",
  "sst.patterns_legend_none": "ไม่มีบันทึก",
  "sst.patterns_legend_incident": "มีเหตุการณ์ในวันนั้น",
  "sst.patterns_legend_mss": "วัน MSS",
  "sst.patterns_day_present": "มาเรียน",
  "sst.patterns_day_late": "สาย {{minutes}} นาที",
  "sst.patterns_day_late_unmeasured": "สาย ไม่มีบันทึกเวลามาถึง",
  "sst.patterns_day_absent": "ขาดเรียน",
  "sst.patterns_day_excused": "ลา",
  "sst.patterns_day_suspended": "พักการเรียน",
  "sst.patterns_day_none": "ไม่มีบันทึก",
  "sst.patterns_day_incidents_one": "{{count}} เหตุการณ์",
  "sst.patterns_day_incidents_other": "{{count}} เหตุการณ์",
  "sst.patterns_day_mss": "วัน MSS",
  "sst.patterns_attendance_line": "มาเรียน {{rate}} จาก {{days}} วันเรียนที่บันทึกไว้ในปีนี้",
  "sst.patterns_attendance_none": "ยังไม่มีบันทึกการเข้าเรียนในปีนี้",
  "sst.patterns_attendance_compare": "นักเรียน {{gradeName}} เฉลี่ย {{average}}",
  "sst.patterns_late_line": "มาถึงหลัง {{cutoff}} จำนวน {{count}} เช้า ในช่วง {{days}} วันเรียนที่ผ่านมา",
  "sst.patterns_late_figures": "สายเฉลี่ย {{minutes}} นาที รวมเวลาเรียนที่เสียไป {{lost}} นาที",
  "sst.patterns_late_partial": "มีเพียง {{measured}} เช้าที่บันทึกเวลามาถึงไว้ ตัวเลขนี้จึงคิดจาก {{measured}} เช้านั้น",
  "sst.patterns_late_unmeasured": "ไม่มีเช้าใดบันทึกเวลามาถึงไว้ จึงคำนวณค่าเฉลี่ยไม่ได้",
  "sst.patterns_class_line": "{{className}}: เข้าเรียน {{rate}} จาก {{periods}} คาบที่บันทึกไว้ในปีนี้",
  "sst.patterns_class_compare": "ค่าเฉลี่ยของเพื่อนร่วมชั้นอยู่ที่ {{average}}",
  "sst.patterns_incidents_line": "มีชื่อในเหตุการณ์ {{count}} ครั้ง ภายใน {{days}} วัน",
  "sst.patterns_recognition_line_one": "ได้รับแซนด์ดอลลาร์ {{count}} เหรียญ ในช่วง {{days}} วันเรียนที่ผ่านมา",
  "sst.patterns_recognition_line_other": "ได้รับแซนด์ดอลลาร์ {{count}} เหรียญ ในช่วง {{days}} วันเรียนที่ผ่านมา",
  "sst.patterns_recognition_compare": "นักเรียน {{gradeName}} เฉลี่ยวันละ {{average}}",
  "sst.patterns_threshold_late": "แจ้งเตือนตั้งแต่ 5 เช้าขึ้นไป",
  "sst.patterns_threshold_attendance": "แจ้งเตือนเมื่อต่ำกว่า 80%",
  "sst.patterns_threshold_class": "แจ้งเตือนเมื่อต่ำกว่า 80%",
  "sst.patterns_threshold_incidents": "แจ้งเตือนตั้งแต่ 3 ครั้ง หรือ 2 ครั้งในหนึ่งสัปดาห์",
  "sst.patterns_threshold_recognition": "แจ้งเตือนเมื่อน้อยกว่า 5",
  "sst.patterns_flag_grades_low": "ผลการเรียนต่ำ",
  "sst.patterns_flag_grades_dropping": "ผลการเรียนลดลง",
  "sst.patterns_threshold_grades_low": "แจ้งเตือนเมื่อผลต่ำตั้งแต่ 3 วิชา หรือได้ F",
  "sst.patterns_threshold_grades_dropping": "แจ้งเตือนเมื่อผลลดลงตั้งแต่ 2 วิชา",
  "sst.patterns_grades_low_line": "ผลการเรียนต่ำในสมุดรายงาน {{period}}:",
  "sst.patterns_grades_dropping_line": "ผลในสมุดรายงาน {{period}} ต่ำกว่า {{previous}} ในวิชา:",
  "sst.patterns_open_student": "เปิดดูนักเรียน",
  "sst.patterns_filter_any_flag": "รูปแบบใด ๆ",
  "sst.suspensions.title": "การพักการเรียน",
  "sst.suspensions.case": "พักการเรียน",
  "sst.suspensions.badge": "พักการเรียน",
  "sst.suspensions.tab_attention": "ข้อความจากครูเรื่องการพักการเรียนที่ยังไม่ได้อ่าน",
  "sst.suspensions.subtitle_sst": "การพักการเรียนทั้งหมด สถานที่พักการเรียน และงานที่ครูส่งมา",
  "sst.suspensions.subtitle_teacher": "การพักการเรียนของนักเรียนที่คุณสอน ส่งงานถึงทีม SST ได้จากแต่ละรายการ",
  "sst.suspensions.create_action": "บันทึกการพักการเรียน",
  "sst.suspensions.search_aria": "ค้นหาการพักการเรียนตามชื่อนักเรียน",
  "sst.suspensions.filter_all": "ทั้งหมด",
  "sst.suspensions.filter_active": "กำลังพักการเรียน",
  "sst.suspensions.filter_upcoming": "กำลังจะเริ่ม",
  "sst.suspensions.filter_past": "สิ้นสุดแล้ว",
  "sst.suspensions.filter_cancelled": "ยกเลิกแล้ว",
  "sst.suspensions.empty": "ไม่มีการพักการเรียนที่จะแสดง",
  "sst.suspensions.served_at_label": "สถานที่พักการเรียน",
  "sst.suspensions.served_at_school": "พักการเรียนในโรงเรียน",
  "sst.suspensions.served_at_home": "พักการเรียนที่บ้าน",
  "sst.suspensions.supervisor_label": "ส่งงานถึง",
  "sst.suspensions.supervisor_none": "ยังไม่ได้กำหนด",
  "sst.suspensions.phase_upcoming": "กำลังจะเริ่ม",
  "sst.suspensions.phase_active": "กำลังพักการเรียน",
  "sst.suspensions.phase_ended": "สิ้นสุดแล้ว",
  "sst.suspensions.phase_cancelled": "ยกเลิกแล้ว",
  "sst.suspensions.open_action": "เปิดการพักการเรียน",
  "sst.suspensions.error_student_required": "กรุณาเลือกนักเรียน",
  "sst.suspensions.error_start_required": "กรุณาเลือกวันเริ่มต้น",
  "sst.suspensions.error_end_required": "กรุณาเลือกวันสิ้นสุด",
  "sst.suspensions.error_end_before_start": "วันสิ้นสุดต้องไม่มาก่อนวันเริ่มต้น",
  "sst.suspensions.error_location_too_long": "สถานที่ต้องยาวไม่เกิน {{max}} ตัวอักษร",
  "sst.suspensions.error_reason_required": "กรุณาระบุเหตุผล",
  "sst.suspensions.error_reason_too_long": "เหตุผลต้องยาวไม่เกิน {{max}} ตัวอักษร",
  "sst.suspensions.field_start_date": "วันแรก",
  "sst.suspensions.field_end_date": "วันสุดท้าย",
  "sst.suspensions.location_label": "สถานที่ในโรงเรียน",
  "sst.suspensions.location_placeholder": "เช่น ช่วงเช้าอยู่ฝั่ง EY หลังพักกลางวันอยู่ห้อง SST",
  "sst.suspensions.supervisor_field_label": "ส่งงานถึง (ผู้ดูแล)",
  "sst.suspensions.edp_allowed_label": "อนุญาตให้เข้าร่วม EDP",
  "sst.suspensions.edp_allowed_hint": "ปิด: นักเรียนไม่เข้าร่วม EDP ระหว่างพักการเรียน เปิด: เข้าร่วม EDP ตามปกติ",
  "sst.suspensions.incident_label": "เหตุการณ์",
  "sst.suspensions.incident_none": "ไม่มีเหตุการณ์",
  "sst.suspensions.incident_open": "เปิดเหตุการณ์",
  "sst.suspensions.create_title": "บันทึกการพักการเรียน",
  "sst.suspensions.create_description": "ทุกวันเรียนในช่วงนี้จะถูกบันทึกเป็นพักการเรียนในการเช็กชื่อ ทุกคาบเรียน และ MSS และครูของนักเรียนจะได้รับแจ้ง",
  "sst.suspensions.create_submit": "บันทึกการพักการเรียน",
  "sst.suspensions.create_success": "บันทึกการพักการเรียนแล้ว",
  "sst.suspensions.edit_title": "แก้ไขการพักการเรียน",
  "sst.suspensions.edit_description": "แก้ไขการพักการเรียนของ {{name}} วันที่ใหม่จะปรับการเช็กชื่อและ MSS ให้ตรงกัน",
  "sst.suspensions.edit_success": "อัปเดตการพักการเรียนแล้ว",
  "sst.suspensions.cancel_title": "ยกเลิกการพักการเรียน",
  "sst.suspensions.cancel_description": "ยกเลิกการพักการเรียนของ {{name}} เนื่องจากบันทึกผิดพลาดใช่หรือไม่",
  "sst.suspensions.cancel_marks_explained": "เครื่องหมายพักการเรียนทั้งหมดจะถูกลบ วันและคาบเรียนจะกลับเป็นยังไม่ได้เช็กชื่อ และการลา การมาสาย และการแตะบัตรจะมีผลอีกครั้ง เครื่องหมายเดิมของครูจะไม่ถูกคืนค่า หากต้องการสิ้นสุดก่อนกำหนด ให้แก้ไขวันสุดท้ายแทน",
  "sst.suspensions.cancel_confirm": "ยกเลิกการพักการเรียน",
  "sst.suspensions.cancel_success": "ยกเลิกการพักการเรียนแล้ว",
  "sst.suspensions.cancel_action": "ยกเลิกการพักการเรียน",
  "sst.suspensions.outcome_label": "บันทึกรายวัน",
  "sst.suspensions.outcome_pending": "ยังไม่ได้บันทึก",
  "sst.suspensions.outcome_served": "อยู่ครบ",
  "sst.suspensions.outcome_not_served": "ไม่ได้อยู่ตามกำหนด",
  "sst.suspensions.outcome_absent": "ขาดเรียน",
  "sst.suspensions.marked_by_at": "บันทึกโดย {{name}} · {{date}}",
  "sst.suspensions.day_note_label": "งานที่ทำ",
  "sst.suspensions.day_note_placeholder": "งานที่ทำเสร็จ พฤติกรรม หรือสิ่งที่ต้องติดตาม",
  "sst.suspensions.thread_file_too_big": "{{name}} มีขนาดเกิน 10 MB จึงไม่ได้แนบ",
  "sst.suspensions.thread_placeholder": "เขียนข้อความหรือแนบงาน…",
  "sst.suspensions.thread_send": "ส่ง",
  "sst.suspensions.thread_attach_label": "แนบไฟล์ (รูปภาพหรือ PDF ไม่เกิน 6 ไฟล์)",
  "sst.suspensions.thread_remove_file": "นำ {{name}} ออก",
  "sst.suspensions.thread_with": "ข้อความกับ {{name}}",
  "sst.suspensions.thread_hint_sst": "เฉพาะคุณ ทีม SST และครูท่านนี้เท่านั้นที่เห็นข้อความนี้",
  "sst.suspensions.thread_title_teacher": "ข้อความของคุณกับทีม SST",
  "sst.suspensions.thread_hint_teacher": "ส่งงานและบันทึกสำหรับนักเรียนคนนี้ เฉพาะคุณและทีม SST เท่านั้นที่เห็นข้อความนี้",
  "sst.suspensions.notes_title": "บันทึกของ SST",
  "sst.suspensions.notes_hint": "เฉพาะทีม SST ครูไม่เห็นบันทึกนี้",
  "sst.suspensions.notes_placeholder": "เพิ่มบันทึกสำหรับทีม SST…",
  "sst.suspensions.notes_send": "เพิ่มบันทึก",
  "sst.suspensions.teachers_back": "ครูทั้งหมด",
  "sst.suspensions.teachers_title": "ครู",
  "sst.suspensions.teachers_empty": "ไม่พบครูของนักเรียนคนนี้",
  "sst.suspensions.teacher_left": "ไม่ได้สอนนักเรียนคนนี้แล้ว",
  "sst.suspensions.teacher_no_messages": "ยังไม่มีข้อความ",
  "sst.suspensions.teacher_unread_one": "ข้อความที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "sst.suspensions.teacher_unread_other": "ข้อความที่ยังไม่ได้อ่าน {{count}} ข้อความ",
  "sst.suspensions.send_work_to": "ส่งงานถึง",
  "sst.suspensions.details_title": "รายละเอียด",
  "sst.suspensions.created_label": "บันทึกเมื่อ",
  "sst.suspensions.created_by": "{{name}} · {{date}}",
  "sst.suspensions.cancelled_label": "ยกเลิกเมื่อ",
  "sst.suspensions.manage_title": "จัดการ",
  "sst.suspensions.tab_overview": "ภาพรวม",
  "sst.suspensions.tab_log": "บันทึกรายวัน",
  "sst.suspensions.tab_notes": "บันทึกของ SST",
  "sst.suspensions.tab_teachers": "ครู",
  "sst.suspensions.tab_thread": "ส่งงาน",
  "sst.suspensions.attention_log_title_one": "มี {{count}} วันที่ต้องบันทึก",
  "sst.suspensions.attention_log_title_other": "มี {{count}} วันที่ต้องบันทึก",
  "sst.suspensions.attention_log_description": "บันทึกว่านักเรียนอยู่ครบในแต่ละวันที่ผ่านมาหรือไม่ และทำงานอะไร",
  "sst.suspensions.attention_log_action": "เปิดบันทึกรายวัน",
  "sst.suspensions.workspace_tabs_label": "ส่วนของการพักการเรียน",
  "sst.suspensions.log_title": "บันทึกรายวัน",
  "sst.suspensions.log_hint": "หนึ่งแถวต่อวันเรียนที่พักการเรียนในโรงเรียน วันที่ยังมาไม่ถึงยังบันทึกไม่ได้",
  "sst.suspensions.log_empty": "ไม่มีวันเรียนที่ต้องบันทึก",
  "sst.suspensions.student_empty": "ไม่มีประวัติการพักการเรียน",
  "lunch_detentions.title": "MSS (ช่วงสนับสนุนและเรียนรู้ช่วงกลางวัน)",
  "lunch_detentions.subtitle": "ตรวจสอบรอบ MSS และบันทึกการเข้าร่วมสำหรับรอบที่ท่านดูแล",
  "lunch_detentions.search_aria": "ค้นหารอบ MSS ด้วยชื่อนักเรียน",
  "lunch_detentions.empty": "ไม่มีรอบ MSS ตามตัวกรองนี้",
  "lunch_detentions.awaiting_decision_title": "รอการพิจารณา",
  "lunch_detentions.proposed_by_name": "เสนอโดย {{name}}",
  "lunch_detentions.proposed_by_sst": "สร้างโดยทีม SST โดยตรง",
  "lunch_detentions.col_supervisor": "ผู้ดูแล",
  "lunch_detentions.col_proposed_by": "ผู้เสนอ",
  "lunch_detentions.open_action": "เปิดดู",
  "lunch_detentions.supervisor_none": "ยังไม่ได้กำหนด",
  "lunch_detentions.case": "MSS",
  "lunch_detentions.decided_by": "พิจารณาโดย {{name}} เมื่อ {{date}}",
  "lunch_detentions.decision_note_label": "บันทึกการพิจารณา",
  "lunch_detentions.days_title": "รายวัน",
  "lunch_detentions.col_attendance": "การเข้าร่วม",
  "lunch_detentions.col_marked_by": "บันทึกโดย",
  "lunch_detentions.col_note": "หมายเหตุ",
  "lunch_detentions.marked_by_at": "{{name}}, {{date}}",
  "lunch_detentions.note_placeholder": "เพิ่มบันทึกเกี่ยวกับรายการนี้…",
  "lunch_detentions.mark_disabled_hint": "เฉพาะผู้ดูแลที่กำหนดไว้หรือสมาชิกทีม SST เท่านั้นที่บันทึกได้ที่นี่ และทำได้เฉพาะขณะที่รายการนี้ได้รับการอนุมัติ",
  "lunch_detentions.manage_title": "จัดการ",
  "lunch_detentions.cancel_action": "ยกเลิกรายการ",
  "lunch_detentions.details_title": "รายละเอียด",
  "attachments.remove_confirm_title": "ลบไฟล์นี้หรือไม่",
  "attachments.remove_confirm_description": "{{name}} จะถูกลบออกสำหรับทุกคนที่เห็นรายการนี้",
  "attachments.remove_action": "ลบออก",
  "attachments.removed": "ลบ {{name}} แล้ว",
  "attachments.uploading_one": "กำลังอัปโหลด {{count}} ไฟล์…",
  "attachments.uploading_other": "กำลังอัปโหลด {{count}} ไฟล์…",
  "attachments.uploaded_one": "เพิ่ม {{count}} ไฟล์แล้ว",
  "attachments.uploaded_other": "เพิ่ม {{count}} ไฟล์แล้ว",
  "lunch_detentions.documents_title": "เอกสาร",
  "lunch_detentions.documents_help": "แบบฝึกหัดหรือสื่อการเรียนสำหรับ MSS นี้",
  "lunch_detentions.documents_add": "เพิ่มเอกสาร — PDF, Word, Excel, PowerPoint หรือรูปภาพ ไม่เกินไฟล์ละ 10 MB",
  "lunch_detentions.documents_empty": "ยังไม่มีเอกสาร",
  "lunch_detentions.documents_added_by": "เพิ่มโดย {{name}} · {{date}}",
  "lunch_detentions.documents_added_on": "เพิ่มเมื่อ {{date}}",
  "lunch_detentions.documents_read_only_hint": "ผู้ที่มีชื่ออยู่ใน MSS นี้ ครูประจำชั้นของนักเรียน และทีม SST สามารถเพิ่มเอกสารได้",
  "lunch_detentions.documents_count_one": "เอกสาร {{count}} ฉบับ",
  "lunch_detentions.documents_count_other": "เอกสาร {{count}} ฉบับ",
  "lunch_detentions.created_at_label": "สร้างเมื่อ",
  "lunch_detentions.proposed_by_label": "ผู้เสนอ",
  "lunch_detentions.supervisor_label": "ผู้ดูแล",
  "lunch_detentions.withdraw_action": "ถอนคำเสนอ",
  "lunch_detentions.withdraw_confirm_title": "ถอนคำเสนอนี้หรือไม่?",
  "lunch_detentions.withdraw_confirm_description": "ทีม SST จะไม่เห็นรายการนี้ในรายการที่รอการพิจารณาอีกต่อไป",
  "lunch_detentions.withdraw_success": "ถอนคำเสนอเรียบร้อยแล้ว",
  "lunch_detentions.confirm_no_show_title": "บันทึกว่าไม่มาตามนัดหรือไม่?",
  "lunch_detentions.confirm_no_show_description": "{{name}} อยู่ในโรงเรียนเมื่อวันที่ {{date}} แต่ไม่ได้มาตามนัด การบันทึกนี้จะถือเป็นการไม่มาตามนัด",
  "lunch_detentions.confirm_no_show_action": "บันทึกว่าไม่มาตามนัด",
  "lunch_detentions.room.folded_in": "รวมอีก {{count}} รายการ",
  "lunch_detentions.room.days_left": "เหลือ {{count}} วัน",
  "lunch_detentions.room.until": "ถึง {{date}}",
  "lunch_detentions.room.note_placeholder": "เพิ่มบันทึก…",
  "lunch_detentions.room.not_marked_title": "ยังไม่ได้บันทึกการเข้า",
  "lunch_detentions.room.left_to_mark": "เหลืออีก {{count}} คนที่ต้องบันทึก",
  "lunch_detentions.room.session_title": "ห้อง MSS",
  "lunch_detentions.room.open_room": "เปิดห้องวันนี้",
  "lunch_detentions.room.load_error": "โหลดห้อง MSS ไม่สำเร็จ",
  "lunch_detentions.decide_approve_title": "อนุมัติรอบ MSS",
  "lunch_detentions.decide_reject_title": "ไม่อนุมัติรอบ MSS",
  "lunch_detentions.decide_description": "{{name}}, {{dates}}",
  "lunch_detentions.decide_approve_success": "อนุมัติรอบ MSS แล้ว",
  "lunch_detentions.decide_reject_success": "ไม่อนุมัติรอบ MSS แล้ว",
  "lunch_detentions.decision_note_hint": "ครูผู้เสนอจะเห็นข้อความนี้",
  "lunch_detentions.supervisor_field_label": "ผู้ดูแล",
  "lunch_detentions.supervisor_none_option": "ยังไม่มีผู้ดูแล",
  "lunch_detentions.edit_title": "แก้ไขรอบ MSS",
  "lunch_detentions.edit_description": "วันที่บันทึกไปแล้วจะยังคงอยู่ มีเพียงวันที่ยังไม่ได้บันทึกเท่านั้นที่จะปรับตามช่วงวันที่ใหม่",
  "lunch_detentions.field_start_date": "วันที่เริ่มต้น",
  "lunch_detentions.field_end_date": "วันที่สิ้นสุด",
  "lunch_detentions.error_start_required": "กรุณาระบุวันที่เริ่มต้น",
  "lunch_detentions.error_end_required": "กรุณาระบุวันที่สิ้นสุด",
  "lunch_detentions.error_end_before_start": "วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น",
  "lunch_detentions.edit_success": "แก้ไขรอบ MSS แล้ว",
  "lunch_detentions.cancel_title": "ยกเลิกรอบ MSS นี้หรือไม่",
  "lunch_detentions.cancel_description": "วันที่บันทึกไปแล้วของ {{name}} จะยังคงอยู่ในประวัติ ส่วนวันที่ยังค้างอยู่จะไม่ถูกติดตามอีกต่อไป",
  "lunch_detentions.cancel_confirm": "ยกเลิกรายการ",
  "lunch_detentions.cancel_success": "ยกเลิกรอบ MSS แล้ว",
  "lunch_detentions.propose_action": "สร้างรอบ MSS ใหม่",
  "lunch_detentions.propose_dialog_title": "สร้างรอบ MSS ใหม่",
  "lunch_detentions.propose_dialog_description_teacher": "รายการนี้จะถูกส่งให้ทีม SST พิจารณาอนุมัติ",
  "lunch_detentions.propose_dialog_description_sst": "รายการนี้จะถูกสร้างและอนุมัติทันที",
  "lunch_detentions.field_students": "นักเรียน",
  "lunch_detentions.error_select_student": "กรุณาเลือกนักเรียนอย่างน้อยหนึ่งคน",
  "lunch_detentions.error_too_many_students": "เลือกนักเรียนได้ไม่เกิน {{max}} คนต่อครั้ง",
  "lunch_detentions.clash_notice": "อยู่ระหว่างงดพักกลางวันจนถึงวันที่ {{date}}",
  "lunch_detentions.clash_notice_proposer_hint": "ส่งคำขอได้ตามปกติ — ทีม SST จะเพิ่มวันเหล่านี้เข้ากับช่วงที่กำลังดำเนินอยู่ หรือจัดให้อยู่หลังจากช่วงนั้นสิ้นสุดลง",
  "lunch_detentions.clash_remove_student": "ไม่รวมนักเรียนคนนี้ในคำขอนี้",
  "lunch_detentions.clash_create_must_resolve": "รายการนี้จะถูกอนุมัติทันที จึงไม่สามารถตัดสินใจภายหลังได้ สำหรับนักเรียนแต่ละคนข้างต้น ให้เลือกเพิ่มวันเข้ากับช่วงที่กำลังดำเนินอยู่ — นักเรียนจะอยู่ในช่วงเดียว เข้าห้องพักกลางวันวันละครั้ง และถูกบันทึกครั้งเดียว — หรือไม่รวมไว้ในคำขอนี้แล้วจัดการแยกต่างหาก",
  "lunch_detentions.clash_must_resolve": "เลือกหนึ่งตัวเลือก หรือแก้ไขวันที่ไม่ให้ทับซ้อนกัน — สองช่วงที่คลุมวันเดียวกันจะทำให้นักเรียนถูกเรียกเข้าห้องพักกลางวันสองครั้ง",
  "lunch_detentions.request_count": "คำขอครั้งที่ {{ordinal}} ของปีการศึกษานี้",
  "lunch_detentions.reschedule_after_clash_action": "เริ่มหลังจากงดพักกลางวันรอบเดิมสิ้นสุด",
  "lunch_detentions.reschedule_after_clash_hint": "สองช่วงต่อเนื่องกัน คำขอนี้จะกลายเป็นอีกช่วงหนึ่งที่เริ่มในวันถัดจากวันสุดท้ายของช่วงปัจจุบัน โดยมีวัน ผู้ดูแล และการบันทึกของตัวเอง เป็นสองรายการในประวัติแทนที่จะเป็นรายการเดียว",
  "lunch_detentions.extend_existing_action": "เพิ่มเข้าในรอบที่กำลังดำเนินอยู่",
  "lunch_detentions.clash_same_days": "จำนวนวันที่ต้องรับโทษเท่ากันทั้งสองแบบ สิ่งที่เลือกคือจะให้เป็นช่วงเดียวหรือสองช่วง",
  "lunch_detentions.extend_existing_hint": "ช่วงเดียวที่ยาวขึ้น วันที่คำขอนี้ระบุจะถูกเพิ่มต่อท้ายช่วงที่กำลังดำเนินอยู่ นักเรียนจึงอยู่ในช่วงเดียว เข้าห้องพักกลางวันวันละครั้ง และถูกบันทึกครั้งเดียว คำขอนี้ยังคงเหตุผลของตัวเองและเชื่อมโยงกับช่วงนั้น",
  "lunch_detentions.extends_days_hint": "คำขอนี้ไม่มีวันของตนเอง แต่ขยายเวลารอบด้านล่าง และนักเรียนจะถูกบันทึกการเข้าร่วมที่รอบนั้น",
  "lunch_detentions.extends_link": "{{reason}} ({{dates}})",
  "lunch_detentions.extended_by_label": "ขยายเวลาโดย",
  "lunch_detentions.error_reason_required": "กรุณาระบุเหตุผล",
  "lunch_detentions.propose_submit": "เสนอ",
  "lunch_detentions.create_submit": "สร้าง",
  "lunch_detentions.propose_success": "เสนอรอบ MSS แล้ว",
  "lunch_detentions.create_success": "สร้างรอบ MSS แล้ว",
  "lunch_detentions.mode_label": "อนุมัติทันทีหรือส่งให้ตรวจสอบ",
  "lunch_detentions.mode_approve": "อนุมัติทันที",
  "lunch_detentions.mode_review": "ส่งให้ตรวจสอบ",
  "lunch_detentions.review_success": "ส่งรอบ MSS ให้ตรวจสอบแล้ว",
  "lunch_detentions.from_incident_title": "สร้างรอบ MSS หรือไม่",
  "lunch_detentions.from_incident_description": "กรณีนี้ปิดโดยมีการดำเนินการทางวินัย ต้องการสร้างรอบ MSS ให้นักเรียนที่เกี่ยวข้องตอนนี้หรือไม่",
  "lunch_detentions.from_incident_confirm": "สร้างรอบ MSS",
  "lunch_detentions.from_incident_skip": "ไม่ใช่ตอนนี้",
  "enum.lunch_detention_status.proposed": "เสนอแล้ว",
  "enum.lunch_detention_status.approved": "อนุมัติแล้ว",
  "enum.lunch_detention_status.rejected": "ปฏิเสธแล้ว",
  "enum.lunch_detention_status.withdrawn": "ถอนคำเสนอแล้ว",
  "enum.lunch_detention_status.cancelled": "ยกเลิกแล้ว",
  "enum.lunch_detention_phase.proposed": "เสนอแล้ว",
  "enum.lunch_detention_phase.upcoming": "ยังไม่ถึงกำหนด",
  "enum.lunch_detention_phase.running": "กำลังดำเนินการ",
  "enum.lunch_detention_phase.completed": "เสร็จสิ้นแล้ว",
  "enum.lunch_detention_phase.extension": "เพิ่มเข้ากับรอบอื่น",
  "enum.lunch_detention_phase.rejected": "ปฏิเสธแล้ว",
  "enum.lunch_detention_phase.withdrawn": "ถอนคำเสนอแล้ว",
  "enum.lunch_detention_phase.cancelled": "ยกเลิกแล้ว",
  "enum.lunch_detention_attendance.pending": "ยังไม่บันทึก",
  "enum.lunch_detention_attendance.attended": "เข้าร่วม",
  "enum.lunch_detention_attendance.absent": "ขาดเรียน",
  "enum.lunch_detention_attendance.no_show": "ไม่มาตามนัด",
  "enum.lunch_detention_attendance.excused": "ได้รับการยกเว้น",
  "enum.lunch_detention_attendance.suspended": "พักการเรียน",
  "incidents.title": "เหตุการณ์",
  "incidents.subtitle_all": "ตรวจสอบรายงานเหตุการณ์ที่เจ้าหน้าที่ยื่นเข้ามา",
  "incidents.subtitle_mine": "รายงานเหตุการณ์ที่คุณมีส่วนเกี่ยวข้องหรือดูแลในฐานะครูประจำชั้น",
  "incidents.search_aria": "ค้นหาเหตุการณ์ด้วยชื่อนักเรียนที่เกี่ยวข้องทุกคน",
  "incidents.empty": "ไม่พบเหตุการณ์ที่ตรงกับตัวกรองนี้",
  "incidents.col_medical": "การแพทย์",
  "incidents.col_reporter": "ผู้รายงาน",
  "incidents.type_label": "ประเภท",
  "incidents.open_action": "เปิด",
  "incidents.unread_badge": "{{count}} การอัปเดตที่ยังไม่ได้อ่าน",
  "incidents.new_badge": "ใหม่",
  "incidents.students_involved": "นักเรียนที่เกี่ยวข้อง",
  "incidents.what_happened": "เหตุการณ์ที่เกิดขึ้น",
  "incidents.schedule_students_count": "ตรงกับตารางของนักเรียน {{count}} คน",
  "incidents.estimated_lesson": "คาบเรียนโดยประมาณ",
  "incidents.initial_response_title": "การตอบสนองเบื้องต้น",
  "incidents.staff_involved": "เจ้าหน้าที่ที่เกี่ยวข้อง",
  "incidents.description_label": "รายละเอียด",
  "incidents.attachments_label": "ไฟล์แนบ",
  "incidents.close": "ปิด",
  "incidents.severity_prefix": "ความรุนแรง: {{severity}}",
  "incidents.medical_attention_badge": "ต้องดูแลทางการแพทย์",
  "incidents.infirmary_title": "ห้องพยาบาล",
  "incidents.infirmary_link_action": "เชื่อมโยงการเข้าพบ",
  "incidents.infirmary_unlink_action": "ยกเลิกการเชื่อมโยง",
  "incidents.infirmary_open_requires_access": "การเปิดระเบียนฉบับเต็มต้องมีสิทธิ์เข้าถึงการแพทย์ / ห้องพยาบาล",
  "incidents.infirmary_none": "ยังไม่มีการเข้าห้องพยาบาลที่เชื่อมโยงกับเหตุการณ์นี้",
  "incidents.infirmary_none_but_flagged": "เหตุการณ์นี้ถูกระบุว่าต้องได้รับการดูแลทางการแพทย์ แต่ยังไม่มีการเข้าห้องพยาบาลที่เชื่อมโยงไว้",
  "incidents.infirmary_pick_hint": "การเข้าห้องพยาบาลของนักเรียนในเหตุการณ์นี้เมื่อวันที่ {{date}}",
  "incidents.infirmary_pick_empty": "ไม่พบการเข้าห้องพยาบาลที่ยังไม่ได้เชื่อมโยงของนักเรียนเหล่านี้ในวันนั้น",
  "incidents.no_attachments": "ไม่มีไฟล์แนบ",
  "incidents.download_failed": "ไม่สามารถดาวน์โหลดได้",
  "incidents.case": "กรณี",
  "incidents.the_report": "รายงาน",
  "incidents.filed_by": "ยื่นโดย {{name}}",
  "incidents.legacy_note": "นำเข้าจากระบบเดิม",
  "incidents.conversation": "บทสนทนา",
  "incidents.message_placeholder": "เขียนข้อความ…",
  "incidents.send_message": "ส่งข้อความ",
  "incidents.decision": "การตัดสินใจ",
  "incidents.outcome": "ผลลัพธ์",
  "incidents.closed_by": "ปิดโดย {{name}} เมื่อ {{date}}",
  "incidents.no_decision_yet": "ยังไม่มีการบันทึกการตัดสินใจ",
  "incidents.reopen": "เปิดใหม่",
  "incidents.start_investigation": "เริ่มการสอบสวน",
  "incidents.close_case": "ปิดกรณี",
  "incidents.propose_lunch_detention": "เสนอ MSS",
  "incidents.no_lunch_detentions": "กรณีนี้ยังไม่มีรอบ MSS",
  "incidents.lunch_detentions_title": "รอบ MSS จากกรณีนี้",
  "incidents.close_case_description": "บันทึกผลลัพธ์และข้อความปิดกรณีที่จะส่งอีเมลถึงเจ้าหน้าที่ที่เกี่ยวข้อง",
  "incidents.closing_message": "ข้อความปิดกรณี",
  "incidents.closing_message_hint": "ข้อความนี้จะถูกส่งอีเมลถึงเจ้าหน้าที่ที่เกี่ยวข้องกับกรณีนี้",
  "incidents.sst_only_note": "บันทึกสำหรับทีม SST เท่านั้น",
  "incidents.sst_only_note_hint": "มองเห็นได้เฉพาะทีมสนับสนุนนักเรียน (SST) เท่านั้น จะไม่ถูกส่งอีเมลและจะไม่แสดงต่อเจ้าหน้าที่ที่เกี่ยวข้อง",
  "incidents.sst_thread_title": "บันทึก SST",
  "incidents.sst_thread_description": "การสนทนาส่วนตัวสำหรับการทำงานของทีมสนับสนุนนักเรียน",
  "incidents.sst_thread_empty": "ยังไม่มีข้อความ เฉพาะเจ้าหน้าที่ที่มีสิทธิ์เข้าถึงทีม SST เท่านั้นที่จะเห็นบทสนทนานี้",
  "incidents.close_success": "ปิดกรณีแล้ว",
  "incidents.error_outcome_required": "กรุณาเลือกผลลัพธ์",
  "incidents.error_decision_required": "ต้องระบุข้อความปิดกรณี",
  "incidents.status_moved": "เปลี่ยนสถานะจาก {{from}} เป็น {{to}}",
  "incidents.reporter": "ผู้รายงาน",
  "incidents.edit_report": "แก้ไขรายงาน",
  "incidents.edit_report_description": "แก้ไขรายละเอียดของรายงานนี้ นักเรียน บุคลากร และไฟล์แนบแก้ไขได้ที่หน้าเคส",
  "incidents.update_success": "อัปเดตรายงานแล้ว",
  "incidents.update_failed": "อัปเดตรายงานไม่สำเร็จ",
  "incidents.workspace_tabs_label": "พื้นที่ทำงานเหตุการณ์",
  "case_management.next_action": "การดำเนินการถัดไป",
  "case_management.items_needing_attention": "รายการที่ต้องดำเนินการ",
  "case_management.needs_attention": "ต้องดำเนินการ",
  "incidents.tab_overview": "ภาพรวม",
  "incidents.tab_risai": "RisAI",
  "incidents.tab_activity": "กิจกรรม",
  "incidents.tab_staff_conversation": "การสนทนาของเจ้าหน้าที่",
  "incidents.tab_sst": "บันทึก SST",
  "incidents.tab_outcome": "ผลลัพธ์",
  "incidents.tab_family": "การสื่อสารกับครอบครัว",
  "incidents.attention_clarify_roles_title": "ระบุบทบาทของนักเรียนให้ชัดเจน",
  "incidents.attention_clarify_roles_description": "ยังมีนักเรียนอย่างน้อยหนึ่งคนที่ระบุบทบาทว่าไม่ชัดเจน โปรดยืนยันบทบาทก่อนดำเนินการต่อ",
  "incidents.attention_start_investigation_title": "ตรวจสอบรายงานนี้",
  "incidents.attention_start_investigation_description": "ตรวจสอบรายงานและผู้เกี่ยวข้อง แล้วเริ่มการสอบสวน",
  "incidents.attention_record_outcome_title": "บันทึกผลลัพธ์",
  "incidents.attention_record_outcome_description": "กรณีอยู่ระหว่างการสอบสวนและรอการตัดสินใจจาก SST",
  "incidents.attention_waiting_for_sst_title": "รอ SST ตรวจสอบ",
  "incidents.attention_waiting_for_sst_description": "คุณสามารถติดตามกรณีและเพิ่มบันทึกสำหรับเจ้าหน้าที่ได้ โดย SST เป็นผู้ตัดสินใจขั้นถัดไป",
  "incidents.attention_complete_title": "กรณีเสร็จสิ้น",
  "incidents.attention_complete_description": "บันทึกผลลัพธ์แล้ว โดยประวัติและบทสนทนายังคงเปิดดูได้",
  "incidents.attention_action_clarify_roles": "ตรวจสอบผู้เกี่ยวข้อง",
  "incidents.attention_action_record_outcome": "บันทึกผลลัพธ์",
  "incidents.attention_warning_unclear_roles_title": "บทบาทของนักเรียนยังไม่ชัดเจน",
  "incidents.attention_warning_unclear_roles_description": "ยืนยันว่าใครเป็นผู้เริ่ม ผู้ได้รับผลกระทบ หรือพยาน",
  "incidents.attention_warning_awaiting_outcome_title": "กรณีนี้กำลังรอผลลัพธ์",
  "incidents.attention_warning_awaiting_outcome_description": "ดำเนินการตรวจสอบของ SST ให้เสร็จก่อนปิดกรณี",
  "incidents.attention_warning_sst_follow_up_due_title": "อาจถึงเวลาติดตามโดย SST",
  "incidents.attention_warning_sst_follow_up_due_description": "นักเรียนที่อยู่ภายใต้การดูแลไม่มีข้อความเฉพาะ SST ในกรณีนี้ตลอดเจ็ดวันที่ผ่านมา",
  "incidents.schedule_estimate_title": "บริบทตารางเรียนโดยประมาณ",
  "incidents.schedule_estimate_description": "ประเมินจากวันที่ เวลา และตารางเรียนที่บันทึกไว้ของนักเรียนแต่ละคน โดยรายงานเหตุการณ์ยังคงเป็นข้อมูลหลัก",
  "incidents.schedule_estimate_unavailable": "ไม่พบคาบเรียนที่ตรงกับวันที่และเวลาที่บันทึกไว้",
  "incidents.staff_conversation_title": "การสนทนาของเจ้าหน้าที่",
  "incidents.staff_conversation_description": "มองเห็นได้โดยเจ้าหน้าที่ที่เกี่ยวข้อง ครูประจำชั้นที่เกี่ยวข้อง และทีม SST",
  "incidents.case_activity_title": "กิจกรรมของกรณี",
  "incidents.case_activity_description": "การเปลี่ยนแปลงสถานะ ผู้เกี่ยวข้อง และการตัดสินใจเรียงตามเวลา โดยการสนทนาอยู่ในแท็บแยกต่างหาก",
  "incidents.activity_report_created": "สร้างรายงานเหตุการณ์แล้ว",
  "incidents.related_history_title": "ประวัติเหตุการณ์ที่เกี่ยวข้อง",
  "incidents.related_history_description": "เหตุการณ์ก่อนหน้าที่เกี่ยวข้องกับนักเรียนเหล่านี้และคุณมีสิทธิ์ดู เลือกนักเรียนเพื่อเปิดรายการที่กรองทั้งหมด",
  "incidents.related_history_empty": "ไม่พบเหตุการณ์ก่อนหน้าที่คุณมีสิทธิ์ดูสำหรับนักเรียนเหล่านี้",
  "incidents.related_same_students_title_one": "มีเหตุการณ์ก่อนหน้า {{count}} รายการที่เกี่ยวข้องกับนักเรียนกลุ่มเดียวกัน",
  "incidents.related_same_students_title_other": "มีเหตุการณ์ก่อนหน้า {{count}} รายการที่เกี่ยวข้องกับนักเรียนกลุ่มเดียวกัน",
  "incidents.related_same_students_description": "นักเรียนตั้งแต่สองคนขึ้นไปจากกรณีนี้เคยปรากฏร่วมกัน ซึ่งอาจช่วยระบุรูปแบบของกลุ่มที่เกิดซ้ำ",
  "incidents.related_same_students_badge": "นักเรียนกลุ่มเดียวกัน",
  "incidents.related_history_more_one": "มีเหตุการณ์ที่เกี่ยวข้องอีก {{count}} รายการ ดูได้จากตัวกรองนักเรียนด้านบน",
  "incidents.related_history_more_other": "มีเหตุการณ์ที่เกี่ยวข้องอีก {{count}} รายการ ดูได้จากตัวกรองนักเรียนด้านบน",
  "incidents.infraction_tags_title": "แท็กพฤติกรรมผิดระเบียบ",
  "incidents.infraction_tags_description": "ติดตามรูปแบบที่เกิดซ้ำโดยแยกแท็กเดิมของนักเรียนออกจากแท็กที่เพิ่มจากเหตุการณ์นี้อย่างชัดเจน",
  "incidents.infraction_tags_existing": "แท็กที่นักเรียนมีอยู่แล้ว",
  "incidents.infraction_tags_added": "แท็กที่เพิ่มจากเหตุการณ์นี้",
  "incidents.risai_title": "ความช่วยเหลือจาก RisAI",
  "incidents.risai_description": "ผู้ช่วยที่ต้องผ่านการตรวจทานสำหรับสรุปข้อมูลกรณีและเตรียมข้อความที่ชัดเจนและเหมาะสมสำหรับครอบครัว",
  "incidents.risai_summary": "สรุปลำดับเหตุการณ์ของกรณี",
  "incidents.risai_draft": "เตรียมข้อความสำหรับตรวจทาน",
  "incidents.risai_case_assistant": "ผู้ช่วยจัดการเคส RisAI",
  "incidents.risai_callout_description": "เปลี่ยนรายงานนี้ให้เป็นสรุปเคสที่ชัดเจน ระบุสิ่งที่ควรติดตาม และเตรียมข้อความที่เหมาะสมสำหรับครอบครัว",
  "incidents.risai_suggestions_title": "คำแนะนำจาก RisAI",
  "incidents.risai_suggestions_description": "ตัวอย่างคำถามเชิงปฏิบัติที่ RisAI สามารถเสนอจากข้อมูลในกรณีนี้",
  "incidents.risai_suggestion_roles": "ยืนยันบทบาทของนักเรียนแต่ละคนโดยใช้คำบอกเล่าแยกกันหากเป็นไปได้",
  "incidents.risai_suggestion_outcome": "เปรียบเทียบข้อมูลและระบุสิ่งที่ยังขาดก่อนบันทึกผลลัพธ์",
  "incidents.risai_suggestion_medical": "ยืนยันว่ามีการติดตามจากห้องพยาบาลหรือไม่และควรเชื่อมโยงกับกรณีนี้หรือไม่",
  "incidents.risai_suggestion_support_plan": "ตรวจสอบว่าเหตุการณ์นี้ส่งผลต่อแผนสนับสนุน SST ที่มีอยู่ของนักเรียนหรือไม่",
  "incidents.risai_suggestion_facts": "แยกข้อเท็จจริงที่สังเกตเห็นโดยตรงออกจากข้อสันนิษฐานหรือคำบอกเล่า",
  "incidents.risai_suggestion_family": "เตรียมสรุปที่เป็นกลางสำหรับครอบครัวโดยไม่เปิดเผยข้อมูลภายในหรือข้อมูลเฉพาะ SST",
  "incidents.risai_open_preview": "ดูตัวอย่าง RisAI",
  "incidents.risai_workspace_description": "RisAI จะช่วยเจ้าหน้าที่ตรวจทานข้อมูลที่มีอยู่ในเคสนี้ โดยเสนอเนื้อหา แต่เจ้าหน้าที่ยังคงเป็นผู้รับผิดชอบทุกการตัดสินใจและข้อความ",
  "incidents.risai_brief_title": "สรุปเคส",
  "incidents.risai_brief_description": "รวมรายงาน ลำดับเหตุการณ์ และผลลัพธ์ที่บันทึกไว้เป็นสรุปสั้น ๆ",
  "incidents.risai_brief_action": "สร้างสรุปเคส",
  "incidents.risai_follow_up_title": "ข้อเสนอแนะในการติดตาม",
  "incidents.risai_follow_up_description": "ชี้ให้เห็นข้อมูลที่ขาดหายและคำถามที่อาจช่วยให้เจ้าหน้าที่ตรวจทานเคสได้ครบถ้วน",
  "incidents.risai_follow_up_action": "เสนอสิ่งที่ควรติดตาม",
  "incidents.risai_family_draft_title": "ร่างข้อความสำหรับครอบครัว",
  "incidents.risai_family_draft_description": "เตรียมร่างข้อความที่ชัดเจนโดยไม่เปิดเผยข้อมูลภายในหรือข้อมูลเฉพาะ SST",
  "incidents.risai_family_draft_action": "เตรียมร่างข้อความ",
  "incidents.risai_human_control_title": "ออกแบบโดยคำนึงถึงความเป็นส่วนตัว และตรวจทานโดยเจ้าหน้าที่",
  "incidents.risai_human_control_description": "RisAI จะเคารพสิทธิ์การเข้าถึงของเคส ไม่ส่งข้อความ เปลี่ยนผลลัพธ์ หรือเปิดเผยเนื้อหาเฉพาะ SST และข้อเสนอแนะทั้งหมดต้องได้รับการตรวจทานโดยเจ้าหน้าที่ที่ได้รับอนุญาต",
  "incidents.family_communication_title": "การสื่อสารกับครอบครัวอย่างปลอดภัย",
  "incidents.family_communication_description": "นักเรียนแต่ละคนจะมีบทสนทนาส่วนตัวแยกกันกับผู้ปกครองที่เชื่อมโยงไว้ โดยข้อมูลภายในของเหตุการณ์และ SST จะยังคงแยกจากกัน",
  "incidents.family_owner_sst": "SST เป็นผู้เตรียมและส่งข้อความถึงครอบครัวของนักเรียนคนนี้ โดยครูประจำชั้นสามารถติดตามบทสนทนาได้",
  "incidents.family_owner_homeroom": "SST เป็นผู้เตรียมและรับผิดชอบข้อความ โดยครูประจำชั้นเป็นผู้ส่งให้ครอบครัว",
  "incidents.family_prepared_by": "จัดเตรียมโดย",
  "incidents.family_sent_by": "ส่งโดย",
  "incidents.family_sst_team": "ทีม SST",
  "incidents.family_homeroom_teacher": "ครูประจำชั้น",
  "incidents.family_flow_supervised": "SST รับผิดชอบข้อความและเป็นผู้ส่งเนื่องจากนักเรียนอยู่ภายใต้การดูแลของ SST โดยครูประจำชั้นสามารถติดตามบทสนทนาได้",
  "incidents.family_flow_not_supervised": "SST ยังคงเป็นผู้รับผิดชอบและจัดเตรียมข้อความ จากนั้นครูประจำชั้นจะเป็นผู้ส่งให้ครอบครัวผ่านแพลตฟอร์ม",
  "incidents.family_future_status_label": "สถานะบทสนทนา",
  "incidents.family_future_status_not_started": "ยังไม่เริ่ม",
  "incidents.family_future_attention_hint": "เมื่อเลือกติดต่อครอบครัว แท็บนี้จะแสดงว่าต้องดำเนินการจนกว่าจะส่งข้อความที่ผ่านการตรวจทานแล้ว",
  "incidents.close_prefilled_hint": "เคสนี้เคยถูกปิดมาก่อน ผลการดำเนินการ ข้อความปิดเคส และบันทึกเฉพาะ SST เดิมถูกกรอกไว้ด้านล่างแล้ว จะคงไว้หรือแก้ไขก็ได้",
  "support_notes.title": "บันทึกการดูแลนักเรียน",
  "support_notes.add": "เพิ่มบันทึก",
  "support_notes.placeholder": "เขียนบันทึกการดูแลนักเรียน…",
  "support_notes.visibility": "การมองเห็น",
  "support_notes.none": "ยังไม่มีบันทึกการดูแลสำหรับนักเรียนคนนี้",
  "support_notes.error_body_required": "กรุณากรอกบันทึก",
  "support_notes.banner_title": "ข้อสังเกตจาก SST: โปรดอ่านก่อนสอน",
  "support_notes.read_more": "อ่านบันทึกทั้งหมด",
  "support_notes.show_less": "แสดงน้อยลง",
  "support_notes.view_all": "ข้อสังเกตจาก SST ทั้งหมด ({{count}})",
  "support_notes.tag": "บันทึก SST",
  "support_notes.tag_aria": "เปิดข้อสังเกตจาก SST ของ {{name}}",
  "support_notes.class_button_one": "ข้อสังเกตจาก SST ({{count}} คน)",
  "support_notes.class_button_other": "ข้อสังเกตจาก SST ({{count}} คน)",
  "support_notes.class_page_title": "ข้อสังเกตจาก SST",
  "support_notes.class_page_subtitle": "สิ่งที่ทีมดูแลนักเรียน (SST) แบ่งปันเกี่ยวกับนักเรียนในชั้นนี้",
  "support_notes.class_page_none": "ยังไม่มีนักเรียนในชั้นนี้ที่มีข้อสังเกตจาก SST ที่แบ่งปันไว้",
  "support_notes.earlier_notes": "ข้อสังเกตก่อนหน้า ({{count}})",
  "support_notes.open_student": "เปิดหน้านักเรียน",
  "support_notes.back_to_register": "กลับไปที่ใบเช็กชื่อ",
  "it_tickets.new_title": "แจ้งปัญหา IT ใหม่",
  "it_tickets.created": "ส่งเรื่องแจ้งปัญหาแล้ว",
  "it_tickets.submit": "ส่งเรื่อง",
  "it_tickets.error_create_failed": "ไม่สามารถส่งเรื่องได้",
  "it_tickets.field_location": "สถานที่",
  "it_tickets.field_location_other": "ระบุสถานที่",
  "it_tickets.field_device": "ประเภทอุปกรณ์ / ซอฟต์แวร์",
  "it_tickets.field_device_other": "ระบุอุปกรณ์หรือซอฟต์แวร์",
  "it_tickets.field_description": "รายละเอียด",
  "it_tickets.field_priority": "ระดับความสำคัญ",
  "it_tickets.field_needed_by": "วันที่ต้องการให้เสร็จ",
  "it_tickets.needed_by_hint": "ไม่บังคับ — เว้นว่างไว้หากไม่มีกำหนดเวลา",
  "it_tickets.field_attachments": "ไฟล์แนบ (รูปภาพหรือ PDF สูงสุด 6 ไฟล์)",
  "it_tickets.priority_hint_low": "ปัญหาเล็กน้อย รอได้",
  "it_tickets.priority_hint_medium": "กระทบงานประจำวัน แต่ยังพอมีวิธีแก้ไขเฉพาะหน้า",
  "it_tickets.priority_hint_high": "เร่งด่วน — ทำให้ไม่สามารถสอนหรือทำงานที่จำเป็นได้",
  "it_tickets.error_location_required": "โปรดระบุสถานที่ เพื่อให้ฝ่ายไอทีทราบว่าต้องไปที่ใด",
  "it_tickets.location_answered_hint": "เว็บไซต์ไม่ได้อยู่ในห้องใด จึงไม่ต้องระบุสถานที่",
  "it_tickets.error_location_other_required": "กรุณาระบุสถานที่",
  "it_tickets.error_device_required": "กรุณาเลือกอุปกรณ์หรือซอฟต์แวร์อย่างน้อยหนึ่งรายการ",
  "it_tickets.error_device_other_required": "กรุณาระบุอุปกรณ์หรือซอฟต์แวร์",
  "it_tickets.error_description_required": "กรุณาระบุรายละเอียด",
  "it_tickets.attachment_upload_warning": "ส่งเรื่องแจ้งปัญหาแล้ว แต่ไม่สามารถอัปโหลดไฟล์แนบได้: {{message}}",
  "it_tickets.my_title": "แจ้งปัญหา IT ของฉัน",
  "it_tickets.my_subtitle": "ติดตามปัญหา IT ที่คุณแจ้ง และตอบกลับฝ่าย IT",
  "it_tickets.report_button": "แจ้งปัญหา IT",
  "it_tickets.empty": "คุณยังไม่ได้แจ้งปัญหา IT",
  "it_tickets.filter_status": "กรองตามสถานะ",
  "it_tickets.empty_for_status": "ไม่มีเรื่องแจ้งในสถานะนี้",
  "it_tickets.detail_title": "เรื่องแจ้งปัญหา IT · {{requester}}",
  "it_tickets.details_section": "รายละเอียดเรื่องแจ้งปัญหา",
  "it_tickets.col_requester": "ผู้แจ้ง",
  "it_tickets.col_created": "แจ้งเมื่อ",
  "it_tickets.col_resolved": "แก้ไขเมื่อ",
  "it_tickets.conversation_title": "การสนทนา",
  "it_tickets.comment_placeholder": "เขียนข้อความตอบกลับ…",
  "it_tickets.comment_send": "ส่ง",
  "it_tickets.error_comment_failed": "ไม่สามารถส่งข้อความตอบกลับได้",
  "it_tickets.status_moved": "เปลี่ยนสถานะจาก {{from}} เป็น {{to}}",
  "it_tickets.change_status": "เปลี่ยนสถานะ",
  "it_tickets.status_note": "หมายเหตุ (ไม่บังคับ)",
  "it_tickets.error_status_failed": "ไม่สามารถเปลี่ยนสถานะได้",
  "it_tickets.attachments": "ไฟล์แนบ",
  "it_tickets.add_attachment": "เพิ่มไฟล์แนบ",
  "it_tickets.new_reply": "มีข้อความตอบกลับใหม่",
  "it_tickets.board_title": "บอร์ด IT",
  "it_tickets.board_subtitle": "ลากเรื่องแจ้งปัญหาไปยังคอลัมน์เพื่อเปลี่ยนสถานะ",
  "it_tickets.age_days_one": "อายุ {{count}} วัน",
  "it_tickets.age_days_other": "อายุ {{count}} วัน",
  "it_tickets.age_hours_one": "อายุ {{count}} ชั่วโมง",
  "it_tickets.age_hours_other": "อายุ {{count}} ชั่วโมง",
  "it_tickets.age_minutes_one": "อายุ {{count}} นาที",
  "it_tickets.age_minutes_other": "อายุ {{count}} นาที",
  "it_tickets.due_on": "ครบกำหนด {{date}}",
  "it_tickets.overdue": "เกินกำหนด",
  "it_tickets.status_update_failed": "ไม่สามารถเปลี่ยนสถานะเรื่องแจ้งปัญหาได้",
  "it_tickets.view_archive": "ดูที่เก็บถาวร",
  "it_tickets.filter_priority": "ระดับความสำคัญ",
  "it_tickets.filter_device": "อุปกรณ์",
  "it_tickets.assignee": "ผู้รับผิดชอบ",
  "it_tickets.assigned_to": "มอบหมายให้",
  "it_tickets.assigned_to_name": "มอบหมายให้ {{name}}",
  "it_tickets.assignment_cleared": "ยกเลิกการมอบหมาย",
  "it_tickets.unassigned": "ยังไม่มีผู้รับผิดชอบ",
  "it_tickets.assignee_hint": "มอบหมายได้เฉพาะผู้ดูแลระบบที่มีสิทธิ์ IT support และระบบจะส่งอีเมลแจ้ง ยกเว้นเมื่อคุณมอบหมายให้ตัวเอง",
  "it_tickets.error_assign_failed": "ไม่สามารถเปลี่ยนผู้รับผิดชอบได้",
  "it_tickets.filter_search": "ค้นหา",
  "it_tickets.filter_from": "ตั้งแต่",
  "it_tickets.filter_to": "ถึง",
  "it_tickets.filter_location": "สถานที่",
  "it_tickets.archive_title": "ที่เก็บถาวรเรื่องแจ้งปัญหา IT",
  "it_tickets.archive_subtitle": "เรื่องแจ้งปัญหาที่แก้ไขแล้วและแนวโน้มของอุปกรณ์/ห้องในช่วงเวลาที่เลือก",
  "it_tickets.archive_empty": "ไม่มีเรื่องแจ้งปัญหาที่ตรงกับช่วงเวลาและตัวกรองนี้",
  "it_tickets.stats_opened": "แจ้งเข้ามา",
  "it_tickets.stats_resolved": "แก้ไขแล้ว",
  "it_tickets.stats_still_open": "ยังไม่ปิด",
  "it_tickets.stats_overdue": "เกินกำหนด",
  "it_tickets.stats_avg_resolution": "เวลาแก้ไขเฉลี่ย",
  "it_tickets.stats_median_resolution": "เวลาแก้ไขค่ามัธยฐาน",
  "it_tickets.stats_hours": "{{value}} ชั่วโมง",
  "it_tickets.stats_by_month": "ปริมาณตามช่วงเวลา",
  "it_tickets.stats_by_device": "แยกตามประเภทอุปกรณ์",
  "it_tickets.stats_by_location": "แยกตามสถานที่",
  "it_tickets.stats_by_priority": "แยกตามระดับความสำคัญ",
  "it_tickets.stats_top_requesters": "ผู้แจ้งปัญหาสูงสุด",
  "it_tickets.stats_no_resolutions": "ยังไม่มีเรื่องที่แก้ไขแล้ว",
  "it_tickets.stats_opened_legend": "แจ้งเข้ามา",
  "it_tickets.stats_resolved_legend": "แก้ไขแล้ว",
  "it_tickets.archive_page_summary": "หน้า {{page}} จาก {{totalPages}} ({{total}} เรื่อง)",
  "it_assets.title": "ทรัพย์สิน IT",
  "it_assets.subtitle": "อุปกรณ์ทุกชิ้นของโรงเรียน: ใครถืออยู่ อยู่ที่ไหน และอยู่ในสภาพใด",
  "it_assets.empty": "ไม่มีทรัพย์สินที่ตรงกับตัวกรองนี้",
  "it_assets.items": "รายการ",
  "it_assets.unassigned": "ยังไม่ได้มอบหมาย",
  "it_assets.unknown_person": "ไม่ทราบชื่อบุคคล",
  "it_assets.needs_matching": "ต้องจับคู่",
  "it_assets.scan_button": "สแกน",
  "it_assets.print_labels": "พิมพ์ฉลาก ({{count}})",
  "it_assets.print_all_labels": "พิมพ์ฉลากทั้งหมด ({{count}})",
  "it_assets.bulk.button": "อัปโหลดรูปภาพจำนวนมาก",
  "it_assets.bulk.title": "อัปโหลดรูปภาพจำนวนมาก",
  "it_assets.bulk.help": "ตั้งชื่อรูปตามรหัสทรัพย์สินเดิมหรือแท็กทรัพย์สิน เช่น TAG-001.jpg รองรับเฉพาะ JPEG, PNG หรือ WebP (บน iPhone ให้เลือก \"เข้ากันได้มากที่สุด\") ไฟล์ละไม่เกิน 25 MB",
  "it_assets.bulk.files_label": "รูปภาพ",
  "it_assets.bulk.selected": "เลือกแล้ว {{count}} ไฟล์",
  "it_assets.bulk.upload": "อัปโหลด",
  "it_assets.bulk.uploading": "กำลังอัปโหลด…",
  "it_assets.bulk.summary": "จับคู่ได้ {{matched}} ไม่พบทรัพย์สิน {{unmatched}} กำกวม {{ambiguous}} ล้มเหลว {{failed}}",
  "it_assets.bulk.matched": "จับคู่ได้",
  "it_assets.bulk.unmatched": "ไม่พบทรัพย์สินที่ตรงกัน",
  "it_assets.bulk.ambiguous": "กำกวม (ตรงกับทรัพย์สินมากกว่าหนึ่งรายการ จึงไม่มีการเปลี่ยนแปลง)",
  "it_assets.bulk.ambiguous_row": "{{file}}: {{tags}}",
  "it_assets.bulk.failed": "ล้มเหลว",
  "it_assets.bulk.failed_row": "{{file}}: {{reason}}",
  "it_assets.bulk.failed_reason.not_image": "ไม่ใช่ไฟล์รูปภาพ",
  "it_assets.bulk.failed_reason.too_large": "ไฟล์ใหญ่กว่า 25 MB",
  "it_assets.bulk.failed_reason.request_failed": "อัปโหลดไม่สำเร็จ กรุณาลองอีกครั้ง",
  "it_assets.bulk.failed_reason.unsupported_format": "ไม่รองรับรูปแบบไฟล์นี้ ใช้ JPEG, PNG หรือ WebP",
  "it_assets.bulk.failed_reason.invalid_image": "ไฟล์นี้ไม่ใช่รูปภาพที่อ่านได้",
  "it_assets.bulk.failed_reason.save_failed": "บันทึกรูปภาพนี้ไม่สำเร็จ",
  "it_assets.labels.title": "ฉลากทรัพย์สิน",
  "it_assets.labels.subtitle": "กระดาษ A4 3 คอลัมน์ ฉลากขนาด 63.5 × 38.1 มม. พิมพ์ที่ขนาด 100%",
  "it_assets.labels.school": "Ruamrudee International School Phuket — IT",
  "it_assets.labels.none": "ยังไม่ได้เลือกทรัพย์สิน เลือกจากรายการแล้วกดพิมพ์ฉลาก",
  "it_assets.labels.none_matching": "ไม่มีทรัพย์สินที่ตรงกับตัวกรองนี้",
  "it_assets.labels.load_failed": "โหลดทรัพย์สินบางรายการไม่สำเร็จ จึงไม่อยู่ในแผ่นฉลาก: {{ids}}",
  "it_assets.labels.load_all_failed": "โหลดรายการทรัพย์สินไม่สำเร็จ กลับไปที่รายการแล้วลองอีกครั้ง",
  "it_assets.bulk.progress": "กำลังอัปโหลด… {{sent}}/{{total}}",
  "it_assets.select_all": "เลือกทรัพย์สินทั้งหมดในหน้านี้",
  "it_assets.select_asset": "เลือก {{tag}}",
  "it_assets.device_type.laptop": "แล็ปท็อป",
  "it_assets.device_type.desktop": "คอมพิวเตอร์ตั้งโต๊ะ",
  "it_assets.device_type.macbook": "แมคบุ๊ก",
  "it_assets.device_type.mac_mini": "แมคมินิ",
  "it_assets.device_type.imac": "ไอแมค",
  "it_assets.device_type.tablet": "แท็บเล็ต",
  "it_assets.device_type.ipad": "ไอแพด",
  "it_assets.device_type.monitor": "จอภาพ",
  "it_assets.device_type.printer": "เครื่องพิมพ์",
  "it_assets.device_type.projector": "โปรเจกเตอร์",
  "it_assets.device_type.network": "อุปกรณ์เครือข่าย",
  "it_assets.device_type.server": "เซิร์ฟเวอร์",
  "it_assets.device_type.phone": "โทรศัพท์",
  "it_assets.device_type.other": "อื่น ๆ",
  "it_assets.status.in_use": "ใช้งานอยู่",
  "it_assets.status.available": "ว่าง",
  "it_assets.status.repair": "ต้องซ่อม",
  "it_assets.status.storage": "เก็บในคลัง",
  "it_assets.status.retired": "ปลดระวาง",
  "it_assets.status.lost": "สูญหาย",
  "it_assets.department.it": "ฝ่าย IT",
  "it_assets.department.staff": "บุคลากร",
  "it_assets.department.teacher": "ครู",
  "it_assets.department.student": "นักเรียน",
  "it_assets.department.ia_specialist": "ผู้ช่วยสอน / ผู้เชี่ยวชาญ",
  "it_assets.department.shared": "อุปกรณ์ส่วนกลาง / ใช้ร่วมกัน",
  "it_assets.department.other": "อื่น ๆ",
  "it_assets.credential_kind.product_key": "คีย์ผลิตภัณฑ์",
  "it_assets.credential_kind.local": "บัญชีในเครื่อง",
  "it_assets.credential_kind.admin": "บัญชีผู้ดูแลระบบ",
  "it_assets.credential_kind.microsoft": "บัญชี Microsoft",
  "it_assets.credential_kind.email": "บัญชีอีเมล",
  "it_assets.credential_kind.icloud": "บัญชี iCloud",
  "it_assets.credential_kind.other": "อื่น ๆ",
  "it_assets.stats.total": "ทั้งหมด",
  "it_assets.stats.in_use": "ใช้งานอยู่",
  "it_assets.stats.repair": "ต้องซ่อม",
  "it_assets.stats.unassigned": "ยังไม่ได้มอบหมาย",
  "it_assets.stats.needs_matching": "ต้องจับคู่",
  "it_assets.stats.value": "มูลค่ารวม",
  "it_assets.filters.device_type": "ประเภทอุปกรณ์",
  "it_assets.filters.status": "สถานะ",
  "it_assets.filters.department": "แผนก",
  "it_assets.filters.needs_matching": "เฉพาะที่ต้องจับคู่",
  "it_assets.filters.all_types": "ทุกประเภท",
  "it_assets.filters.all_statuses": "ทุกสถานะ",
  "it_assets.filters.all_departments": "ทุกแผนก",
  "it_assets.filters.search": "ค้นหาทรัพย์สิน",
  "it_assets.filters.search_placeholder": "แท็ก หมายเลขซีเรียล ยี่ห้อ รุ่น หรือชื่อบุคคล",
  "it_assets.columns.select": "เลือก",
  "it_assets.columns.photo": "รูปภาพ",
  "it_assets.columns.tag": "แท็ก",
  "it_assets.columns.type": "ประเภท",
  "it_assets.columns.brand_model": "ยี่ห้อและรุ่น",
  "it_assets.columns.serial": "หมายเลขซีเรียล",
  "it_assets.columns.assigned": "มอบหมายให้",
  "it_assets.columns.status": "สถานะ",
  "it_assets.columns.updated": "อัปเดตล่าสุด",
  "it_assets.scan.title": "สแกนทรัพย์สิน",
  "it_assets.scan.description": "หันกล้องไปที่ฉลาก QR ของทรัพย์สิน หรือพิมพ์แท็ก",
  "it_assets.scan.start": "สแกนฉลาก QR",
  "it_assets.scan.stop": "หยุดสแกน",
  "it_assets.scan.unsupported": "เบราว์เซอร์นี้สแกนคิวอาร์โค้ดไม่ได้ กรุณาพิมพ์แท็กแทน",
  "it_assets.scan.camera_error": "ไม่สามารถเข้าถึงกล้องได้",
  "it_assets.scan.manual_label": "แท็กทรัพย์สิน",
  "it_assets.scan.manual_placeholder": "เช่น RISP-0001",
  "it_assets.scan.lookup": "ค้นหา",
  "it_assets.scan.not_found": "ไม่มีทรัพย์สินที่มีแท็ก {{code}}",
  "it_assets.scan.label_not_found": "ทรัพย์สินของป้ายนี้ไม่มีอยู่ในระบบแล้ว ({{code}})",
  "it_assets.scan.create_with_tag": "สร้างทรัพย์สินด้วยแท็ก {{code}}",
  "it_assets.add_button": "เพิ่มอุปกรณ์",
  "it_assets.print_label": "พิมพ์ฉลาก",
  "it_assets.tabs.label": "ส่วนข้อมูลอุปกรณ์",
  "it_assets.tabs.details": "รายละเอียด",
  "it_assets.tabs.credentials": "ข้อมูลเข้าสู่ระบบ",
  "it_assets.tabs.history": "ประวัติ",
  "it_assets.details.title": "รายละเอียดอุปกรณ์",
  "it_assets.details.legacy_id": "รหัสอุปกรณ์เดิม",
  "it_assets.photo.title": "รูปภาพ",
  "it_assets.photo.upload": "อัปโหลดรูปภาพ",
  "it_assets.photo.replace": "เปลี่ยนรูปภาพ",
  "it_assets.photo.uploaded": "บันทึกรูปภาพแล้ว",
  "it_assets.photo.remove_title": "ลบรูปภาพนี้หรือไม่?",
  "it_assets.models.button": "รูปภาพรุ่น",
  "it_assets.models.title": "รูปภาพรุ่น",
  "it_assets.models.help": "หนึ่งรูปต่อยี่ห้อและรุ่น อุปกรณ์ทุกเครื่องของรุ่นนั้นที่ไม่มีรูปของตัวเองจะแสดงรูปนี้",
  "it_assets.models.search_placeholder": "ค้นหารุ่น",
  "it_assets.models.empty": "ไม่พบรุ่นที่ตรงกัน",
  "it_assets.models.devices_one": "{{count}} เครื่อง มีรูปของตัวเอง {{own}} เครื่อง",
  "it_assets.models.devices_other": "{{count}} เครื่อง มีรูปของตัวเอง {{own}} เครื่อง",
  "it_assets.models.unused": "ไม่มีอุปกรณ์ที่ใช้รุ่นนี้แล้ว",
  "it_assets.models.upload_for": "อัปโหลดรูปภาพของ {{model}}",
  "it_assets.models.saved": "บันทึกรูปภาพรุ่นแล้ว",
  "it_assets.models.remove_title": "ลบรูปภาพของ {{model}} หรือไม่?",
  "it_assets.photo.model_photo": "รูปภาพรุ่น — อัปโหลดรูปเพื่อแสดงรูปของเครื่องนี้แทน",
  "it_assets.delete.title": "ลบ {{tag}} หรือไม่?",
  "it_assets.delete.description": "อุปกรณ์ ข้อมูลเข้าสู่ระบบ และประวัติทั้งหมดจะถูกลบถาวร หากต้องการเก็บบันทึกไว้ ให้เปลี่ยนสถานะเป็น \"ปลดระวาง\" แทน",
  "it_assets.delete.done": "ลบอุปกรณ์แล้ว",
  "it_assets.form.create_title": "เพิ่มอุปกรณ์",
  "it_assets.form.edit_title": "แก้ไขอุปกรณ์",
  "it_assets.form.asset_tag": "รหัสอุปกรณ์",
  "it_assets.form.device_type": "ประเภทอุปกรณ์",
  "it_assets.form.device_type_other": "อุปกรณ์ประเภทใด?",
  "it_assets.form.brand": "ยี่ห้อ",
  "it_assets.form.model": "รุ่น",
  "it_assets.form.serial_number": "หมายเลขซีเรียล",
  "it_assets.form.service_tag": "Service tag (รหัสบริการ)",
  "it_assets.form.libib_code": "รหัส Libib",
  "it_assets.form.color": "สี",
  "it_assets.form.department": "แผนก",
  "it_assets.form.no_department": "ไม่ระบุแผนก",
  "it_assets.form.department_other": "แผนกใด?",
  "it_assets.form.purchase_date": "วันที่ซื้อ",
  "it_assets.form.warranty_until": "รับประกันถึง",
  "it_assets.form.cost_baht": "ราคา (บาท)",
  "it_assets.form.notes": "หมายเหตุ",
  "it_assets.form.status": "สถานะ",
  "it_assets.form.tag_required": "กรุณากรอกรหัสอุปกรณ์",
  "it_assets.form.tag_taken": "มีอุปกรณ์อื่นใช้รหัสนี้แล้ว",
  "it_assets.form.device_type_other_required": "กรุณาระบุประเภทของอุปกรณ์",
  "it_assets.form.department_other_required": "กรุณาระบุแผนก",
  "it_assets.form.cost_invalid": "กรุณากรอกราคาตั้งแต่ 0 ขึ้นไป",
  "it_assets.form.cost_too_large": "กรุณากรอกราคาไม่เกิน 9,999,999,999.99 บาท",
  "it_assets.form.too_long": "ไม่เกิน {{max}} ตัวอักษร",
  "it_assets.form.created": "เพิ่มอุปกรณ์แล้ว",
  "it_assets.form.updated": "บันทึกอุปกรณ์แล้ว",
  "it_assets.assign.button": "มอบหมาย",
  "it_assets.assign.title": "มอบหมายอุปกรณ์",
  "it_assets.assign.description": "เลือกผู้ใช้งาน สถานที่เก็บ หรือทั้งสองอย่าง",
  "it_assets.assign.person": "บุคคล",
  "it_assets.assign.person_search": "ค้นหาบุคลากรหรือนักเรียน",
  "it_assets.assign.no_person": "ไม่ระบุบุคคล",
  "it_assets.assign.room": "ห้อง",
  "it_assets.assign.room_search": "ค้นหาห้อง",
  "it_assets.assign.no_room": "ไม่ระบุห้อง",
  "it_assets.assign.no_match": "ไม่พบรายการที่ตรงกัน",
  "it_assets.assign.note": "หมายเหตุ",
  "it_assets.assign.return": "คืนให้ฝ่ายไอที",
  "it_assets.assign.saved": "บันทึกการมอบหมายแล้ว",
  "it_assets.assign.returned": "คืนอุปกรณ์ให้ฝ่ายไอทีแล้ว",
  "it_assets.status_dialog.button": "เปลี่ยนสถานะ",
  "it_assets.status_dialog.title": "เปลี่ยนสถานะ",
  "it_assets.status_dialog.note": "หมายเหตุ",
  "it_assets.status_dialog.unchanged": "กรุณาเลือกสถานะอื่น",
  "it_assets.status_dialog.saved": "เปลี่ยนสถานะแล้ว",
  "it_assets.credentials.title": "ข้อมูลเข้าสู่ระบบ",
  "it_assets.credentials.add": "เพิ่มข้อมูลเข้าสู่ระบบ",
  "it_assets.credentials.add_title": "เพิ่มข้อมูลเข้าสู่ระบบ",
  "it_assets.credentials.edit_title": "แก้ไขข้อมูลเข้าสู่ระบบ",
  "it_assets.credentials.form_description": "รหัสลับจะถูกเข้ารหัสเก็บไว้ และแสดงเฉพาะเมื่อกดเปิดดู",
  "it_assets.credentials.empty": "ยังไม่มีข้อมูลเข้าสู่ระบบสำหรับอุปกรณ์นี้",
  "it_assets.credentials.kind": "ประเภท",
  "it_assets.credentials.label": "ชื่อกำกับ",
  "it_assets.credentials.username": "ชื่อผู้ใช้",
  "it_assets.credentials.hint": "คำใบ้",
  "it_assets.credentials.secret": "รหัสผ่านหรือคีย์",
  "it_assets.credentials.secret_keep": "เว้นว่างไว้เพื่อใช้ค่าเดิม",
  "it_assets.credentials.clear_secret": "ลบรหัสลับ",
  "it_assets.credentials.actions": "การดำเนินการ",
  "it_assets.credentials.reveal": "แสดงเป็นเวลา 30 วินาที",
  "it_assets.credentials.hide": "ซ่อน",
  "it_assets.credentials.copy": "คัดลอก",
  "it_assets.credentials.copied": "คัดลอกไปยังคลิปบอร์ดแล้ว",
  "it_assets.credentials.copy_failed": "คัดลอกไม่สำเร็จ",
  "it_assets.credentials.reveal_failed": "ไม่สามารถแสดงรหัสลับได้",
  "it_assets.credentials.saved": "บันทึกข้อมูลเข้าสู่ระบบแล้ว",
  "it_assets.credentials.deleted": "ลบข้อมูลเข้าสู่ระบบแล้ว",
  "it_assets.credentials.delete_title": "ลบข้อมูลเข้าสู่ระบบนี้หรือไม่?",
  "it_assets.credentials.delete_description": "รายการ {{kind}} และรหัสลับจะถูกลบถาวร",
  "it_assets.history.title": "ประวัติ",
  "it_assets.history.empty": "ยังไม่มีบันทึก",
  "it_assets.history.created": "เพิ่มอุปกรณ์",
  "it_assets.history.assigned": "มอบหมายให้ {{to}}",
  "it_assets.history.returned": "คืนให้ฝ่ายไอที",
  "it_assets.history.status_changed": "{{from}} → {{to}}",
  "it_assets.history.by": "โดย {{name}}",
  "bookings.my_title": "การจองของฉัน",
  "bookings.my_subtitle": "จองห้องคอมพิวเตอร์หรือแท็บเล็ตส่วนกลางสำหรับคาบเรียน",
  "bookings.today_heading": "วันนี้",
  "bookings.today_none": "ไม่มีการจองวันนี้",
  "bookings.all_title": "การจองทั้งหมด",
  "bookings.all_subtitle": "รายการจองห้องคอมพิวเตอร์และแท็บเล็ตทั้งหมด สำหรับการจัดส่งและติดตามการใช้งาน",
  "bookings.tablet_pool_title": "จำนวนแท็บเล็ต",
  "bookings.tablet_pool_subtitle": "กำหนดจำนวนแท็บเล็ตที่สามารถจองได้ต่อคาบเรียน",
  "bookings.tablet_pool_saved": "อัปเดตจำนวนแท็บเล็ตแล้ว",
  "bookings.new_button": "จองใหม่",
  "bookings.new_title": "การจองใหม่",
  "bookings.empty": "ยังไม่มีการจอง",
  "bookings.filter_when": "กรองตามวันที่",
  "bookings.filter_upcoming": "ที่กำลังจะถึง",
  "bookings.filter_past": "ที่ผ่านมา",
  "bookings.empty_for_filter": "ไม่มีการจองในช่วงนี้",
  "bookings.submit": "จอง",
  "bookings.created": "สร้างการจองแล้ว",
  "bookings.cancel_button": "ยกเลิก",
  "bookings.cancel_title": "ยกเลิกการจองนี้หรือไม่?",
  "bookings.cancel_description": "การดำเนินการนี้จะเปิดห้องหรือแท็บเล็ตในคาบนี้ให้ผู้อื่นจองได้",
  "bookings.cancelled": "ยกเลิกการจองแล้ว",
  "bookings.field_resource_type": "ทรัพยากร",
  "bookings.field_date": "วันที่",
  "bookings.field_period": "คาบเรียน",
  "bookings.field_time": "เวลา",
  "bookings.field_room": "ห้อง",
  "bookings.field_delivery_room": "ห้องจัดส่ง",
  "bookings.field_class": "ชั้นเรียน",
  "bookings.field_quantity": "จำนวน",
  "bookings.field_note": "หมายเหตุ",
  "bookings.field_tablet_total": "จำนวนแท็บเล็ตทั้งหมด",
  "bookings.booked_by": "จองโดย",
  "bookings.period_placeholder": "เลือกคาบเรียน",
  "bookings.room_placeholder": "เลือกห้อง",
  "bookings.class_placeholder": "เลือกชั้นเรียน",
  "bookings.class_none": "ไม่ระบุชั้นเรียน",
  "bookings.summary_room": "{{room}}",
  "bookings.summary_tablet": "แท็บเล็ต {{quantity}} เครื่อง ไปที่ {{room}}",
  "bookings.error_date_required": "กรุณาระบุวันที่",
  "bookings.error_period_required": "กรุณาเลือกคาบเรียน",
  "bookings.error_room_required": "กรุณาเลือกห้อง",
  "bookings.error_quantity_number": "จำนวนต้องเป็นตัวเลข",
  "bookings.error_quantity_min": "จำนวนต้องมีอย่างน้อย 1",
  "bookings.error_quantity_required": "กรุณาระบุจำนวน",
  "bookings.error_create_failed": "ไม่สามารถสร้างการจองได้",
  "bookings.error_tablet_total_number": "ต้องเป็นตัวเลข",
  "bookings.status_free": "ว่าง",
  "bookings.status_busy": "ไม่ว่าง",
  "bookings.reason_scheduled": "มีคาบเรียนอยู่แล้ว",
  "bookings.reason_booked": "ถูกจองแล้ว",
  "bookings.tablets_remaining": "เหลือแท็บเล็ต {{remaining}} จาก {{total}} เครื่อง",
  "bookings.filter_from": "ตั้งแต่",
  "bookings.filter_to": "ถึง",
  "parents.error_full_name_required": "กรุณากรอกชื่อ-นามสกุล",
  "parents.error_email_invalid": "กรุณากรอกอีเมลที่ถูกต้อง",
  "parents.error_email_required": "กรุณากรอกอีเมล",
  "parents.error_students_required": "กรุณาเชื่อมโยงนักเรียนอย่างน้อยหนึ่งคน",
  "parents.toast_updated": "อัปเดตข้อมูลผู้ปกครองแล้ว",
  "parents.toast_created": "สร้างผู้ปกครองแล้ว — ส่งอีเมลเชิญแล้ว",
  "parents.error_save_failed": "ไม่สามารถบันทึกข้อมูลผู้ปกครองได้",
  "parents.edit_title": "แก้ไขผู้ปกครอง",
  "parents.add_title": "เพิ่มผู้ปกครอง",
  "parents.full_name": "ชื่อ-นามสกุล",
  "parents.email": "อีเมล",
  "parents.email_placeholder": "parent@example.com",
  "parents.email_change_hint": "อีเมลนี้ใช้สำหรับเข้าสู่ระบบ การเปลี่ยนอีเมลจะทำให้ผู้ปกครองออกจากระบบทุกอุปกรณ์",
  "parents.field_phone": "เบอร์โทรศัพท์ (ไม่บังคับ)",
  "parents.field_address": "ที่อยู่ (ไม่บังคับ)",
  "parents.field_relationship": "ความสัมพันธ์ (ไม่บังคับ)",
  "parents.field_occupation": "อาชีพ (ไม่บังคับ)",
  "parents.field_date_of_birth": "วันเกิด (ไม่บังคับ)",
  "parents.field_nationalities": "สัญชาติ (ไม่บังคับ)",
  "parents.field_preferred_language": "ภาษาที่ใช้ติดต่อสื่อสาร",
  "parents.field_person_id": "รหัสประจำตัว (ไม่บังคับ)",
  "parents.linked_students": "นักเรียนที่เชื่อมโยง",
  "parents.person_id_placeholder": "P-001",
  "parents.select_placeholder": "เลือก…",
  "parents.invite_resent": "ส่งคำเชิญอีกครั้งแล้ว",
  "parents.error_resend_invite": "ไม่สามารถส่งคำเชิญอีกครั้งได้",
  "parents.error_resend": "ไม่สามารถส่งใหม่ได้",
  "parents.toast_deactivated": "ปิดใช้งานผู้ปกครองแล้ว",
  "parents.toast_activated": "เปิดใช้งานผู้ปกครองแล้ว",
  "parents.title": "ผู้ปกครอง",
  "parents.subtitle": "จัดการบัญชีผู้ปกครองและบุตรที่เชื่อมโยง",
  "parents.empty": "ยังไม่มีผู้ปกครอง",
  "parents.search_placeholder": "ค้นหาจากผู้ปกครอง บุตรหลาน หรืออีเมล…",
  "parents.search_aria": "ค้นหาผู้ปกครอง",
  "parents.filter_account_all": "บัญชีทั้งหมด",
  "parents.filter_grade_all": "ทุกระดับชั้น",
  "parents.item_label": "ผู้ปกครอง",
  "parents.empty_filtered": "ไม่พบผู้ปกครองที่ตรงกับการค้นหานี้",
  "parents.confirm_deactivate_title": "ปิดใช้งานผู้ปกครองรายนี้?",
  "parents.confirm_deactivate_description": "{{name}} จะไม่สามารถเข้าสู่ระบบพอร์ทัลผู้ปกครองได้จนกว่าคุณจะเปิดใช้งานอีกครั้ง",
  "parents.confirm_resend_title": "ส่งคำเชิญอีกครั้ง?",
  "parents.confirm_resend_description": "{{name}} จะได้รับอีเมลตั้งค่าใหม่ที่ {{email}} และลิงก์เดิมจะใช้งานไม่ได้อีกต่อไป",
  "parents.col_name": "ชื่อ",
  "parents.col_phone": "โทรศัพท์",
  "parents.col_children": "บุตร",
  "parents.col_account": "บัญชี",
  "parents.col_active": "ใช้งานอยู่",
  "parents.col_language": "ภาษา",
  "parents.deactivate": "ปิดใช้งาน",
  "parents.activate": "เปิดใช้งาน",
  "parents.account_active": "ใช้งานแล้ว",
  "parents.account_invited": "เชิญแล้ว",
  "parents.resend_invite": "ส่งคำเชิญอีกครั้ง",
  "parents.status_active": "ใช้งานอยู่",
  "parents.status_inactive": "ปิดใช้งาน",
  "parents.details_section": "รายละเอียด",
  "parents.phone": "เบอร์โทรศัพท์",
  "parents.relationship": "ความสัมพันธ์",
  "parents.address": "ที่อยู่",
  "parents.created_label": "สร้างเมื่อ",
  "parents.no_students_linked": "ไม่มีนักเรียนที่เชื่อมโยง",
  "parents.search_students_placeholder": "ค้นหานักเรียน…",
  "parents.no_students_found": "ไม่พบนักเรียน",
  "parents.tab_list": "ผู้ปกครอง",
  "parents.tab_changes": "การเปลี่ยนแปลงล่าสุด",
  "parents.changes_empty": "ยังไม่มีการเปลี่ยนแปลงให้ตรวจสอบ",
  "parents.mark_all_reviewed": "ทำเครื่องหมายว่าตรวจสอบแล้วทั้งหมด",
  "parents.mark_reviewed": "ตรวจสอบแล้ว",
  "parents.reviewed_by": "ตรวจสอบแล้วโดย {{name}}",
  "parents.reviewed": "ตรวจสอบแล้ว",
  "parents.show_reviewed": "แสดงรายการที่ตรวจสอบแล้ว",
  "parents.change_field_fullName": "ชื่อ-นามสกุล",
  "parents.change_field_phone": "เบอร์โทรศัพท์",
  "parents.change_field_address": "ที่อยู่",
  "parents.change_field_occupation": "อาชีพ",
  "parents.change_field_dateOfBirth": "วันเกิด",
  "parents.change_field_nationalities": "สัญชาติ",
  "parents.change_field_email": "อีเมล",
  "parents.occupation": "อาชีพ",
  "parents.date_of_birth": "วันเกิด",
  "parents.nationalities": "สัญชาติ",
  "nationalities.label": "สัญชาติ",
  "nationalities.search_placeholder": "ค้นหาสัญชาติ…",
  "nationalities.none_found": "ไม่พบสัญชาติ",
  "nationalities.represented": "สัญชาติที่มีอยู่",
  "nationalities.top_chart_title": "สัญชาติยอดนิยม",
  "nationalities.by_grade_title": "จำนวนสัญชาติที่แตกต่างกันตามระดับชั้น",
  "nationalities.footnote_count_each": "ผู้ที่มีสองสัญชาติจะถูกนับรวมในแต่ละสัญชาติ",
  "teachers.reorder_aria": "จัดลำดับ {{name}}",
  "teachers.reorder_hint": "ลากรายชื่อครูขึ้นหรือลงเพื่อเปลี่ยนลำดับการแสดงผล การเปลี่ยนแปลงจะถูกบันทึกโดยอัตโนมัติ",
  "teachers.col_teacher": "ครู",
  "teachers.col_leadership": "ตำแหน่งผู้บริหาร",
  "teachers.uncategorised": "ไม่มีหมวดหมู่",
  "teachers.senior": "ผู้บริหารระดับสูง",
  "teachers.divisional": "ผู้บริหารระดับฝ่าย",
  "teachers.publish_tooltip": "เผยแพร่ข้อมูลครู",
  "teachers.title": "ครู",
  "teachers.subtitle": "ทั้งหมด {{total}} คน · เผยแพร่แล้ว {{published}} คน",
  "teachers.done_reordering": "เสร็จสิ้นการจัดลำดับ",
  "teachers.reorder": "จัดลำดับ",
  "teachers.add": "เพิ่มครู",
  "teachers.empty": "ยังไม่มีข้อมูลครู สร้างรายการแรกได้เลย!",
  "teachers.delete_title": "ลบข้อมูลครู",
  "teachers.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลครูนี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "teachers.tab_list": "ครู",
  "teachers.tab_review": "ตรวจสอบโปรไฟล์",
  "teachers.review_empty": "ไม่มีโปรไฟล์รอการตรวจสอบ",
  "teachers.review_new": "โปรไฟล์ใหม่",
  "teachers.review_edit": "แก้ไข",
  "teachers.review_submitted": "ส่งเมื่อ {{date}}",
  "teachers.review_current_value": "ปัจจุบัน: {{value}}",
  "teachers.review_preview": "ตัวอย่างบนเว็บไซต์",
  "teachers.review_approve": "อนุมัติ",
  "teachers.review_reject": "ไม่อนุมัติ",
  "teachers.review_reject_note": "แจ้งสิ่งที่ต้องแก้ไข",
  "teachers.review_reject_note_required": "กรุณาระบุเหตุผลสั้น ๆ เพื่อให้ผู้ส่งทราบว่าต้องแก้ไขอะไร",
  "teachers.review_approved_hint": "อนุมัติแล้ว เผยแพร่ได้จากแท็บครูหลังจากตั้งค่าหมวดหมู่และลำดับ",
  "teachers.pending_badge": "รอการตรวจสอบ",
  "teachers.col_title": "ตำแหน่งงาน",
  "teachers.col_bio": "ประวัติ",
  "teachers.col_qualifications": "วุฒิการศึกษา",
  "teachers.col_certifications": "ประกาศนียบัตร",
  "staff.status_active": "ใช้งานอยู่",
  "staff.status_inactive": "ปิดใช้งาน",
  "staff.public_profile": "โปรไฟล์สาธารณะบนเว็บไซต์",
  "staff.no_profile": "ไม่มีโปรไฟล์สาธารณะที่เชื่อมโยงกับบัญชีนี้",
  "staff.no_profile_hint": "สร้างได้จากหน้า <link>ครู</link> แล้วเชื่อมโยงผู้ใช้นี้ผ่านช่อง \"บัญชีสำหรับเข้าสู่ระบบที่เชื่อมโยง\"",
  "staff.leave_history": "ประวัติการลา",
  "staff.no_leave_requests": "ยังไม่มีการยื่นคำขอลา",
  "staff.leaves_section": "การลา",
  "staff.my_leaves_hint": "จัดการและตรวจสอบคำขอลาของคุณได้ที่หน้า <link>การลาของฉัน</link>",
  "staff.immigration_compliance_section": "การปฏิบัติตามกฎหมายตรวจคนเข้าเมือง",
  "staff.immigration_compliance_empty": "ยังไม่อยู่ระหว่างการติดตามในขณะนี้",
  "staff.it_assets": "อุปกรณ์ที่ได้รับมอบหมาย",
  "staff.it_no_assets": "ไม่มีอุปกรณ์ที่ได้รับมอบหมาย",
  "staff.it_tickets": "คำขอไอทีที่แจ้ง",
  "staff.it_no_tickets": "ยังไม่มีคำขอไอที",
  "staff.personal_details": "ข้อมูลส่วนตัว",
  "staff.date_of_birth": "วันเกิด",
  "staff.phone": "โทรศัพท์",
  "staff.address": "ที่อยู่",
  "staff.door_id": "รหัสประตู",
  "staff.out_today": "ไม่อยู่วันนี้",
  "staff.last_login": "เข้าสู่ระบบล่าสุด",
  "staff.work_title": "งาน",
  "staff.work_homeroom": "ครูประจำชั้น",
  "staff.work_assisting": "ผู้ช่วยสอนในห้อง",
  "staff.work_default_room": "ห้องประจำ",
  "staff.work_aide_for": "ผู้ช่วยดูแลเฉพาะของ",
  "staff.timetable_title": "ตารางสอนรายสัปดาห์",
  "staff.detail_tabs_label": "ส่วนข้อมูลบุคลากร",
  "staff.tab_overview": "ภาพรวม",
  "staff.tab_timetable": "ตารางสอน",
  "staff.tab_hr": "ฝ่ายบุคคล",
  "staff.tab_attendance": "การเข้างาน",
  "staff.tab_it": "ไอที",
  "staff.tab_wallet": "กระเป๋าเงิน",
  "staff.profile_show_bio": "แสดงประวัติ",
  "staff.profile_hide_bio": "ซ่อนประวัติ",
  "profile.title": "โปรไฟล์ของฉัน",
  "profile.subtitle": "รายละเอียดของคุณและข้อมูลที่โรงเรียนแสดง",
  "profile.identity_section": "ข้อมูลระบุตัวตน",
  "profile.identity_managed_hint": "ชื่อ-นามสกุลและอีเมลของคุณจัดการโดยโรงเรียน ติดต่อผู้ดูแลระบบเพื่อแก้ไข",
  "profile.basic_section": "ข้อมูลพื้นฐาน",
  "profile.photo_label": "รูปโปรไฟล์ (สี่เหลี่ยมจัตุรัส)",
  "profile.photo_hint": "ใช้เป็นรูปประจำตัวของคุณทั่วทั้งระบบ",
  "profile.nickname_placeholder": "ชื่อที่เพื่อนร่วมงานเรียก",
  "profile.saved": "บันทึกแล้ว",
  "profile.save_failed": "ไม่สามารถบันทึกโปรไฟล์ของคุณได้",
  "profile.immigration_section": "การตรวจคนเข้าเมือง",
  "profile.immigration_empty": "ยังไม่มีการติดตาม",
  "profile.public_section": "โปรไฟล์บนเว็บไซต์",
  "profile.public_hint": "นี่คือสิ่งที่ผู้เข้าชมเห็นบนเว็บไซต์โรงเรียน การเปลี่ยนแปลงต้องผ่านการตรวจสอบจากผู้ดูแลระบบก่อนเผยแพร่",
  "profile.public_status_pending": "รอการตรวจสอบตั้งแต่ {{date}}",
  "profile.public_status_rejected": "ไม่อนุมัติการเปลี่ยนแปลง: {{note}}",
  "profile.public_status_live": "เผยแพร่บนเว็บไซต์แล้ว",
  "profile.public_status_draft": "ยังไม่ได้เผยแพร่",
  "profile.public_photo_label": "รูปสำหรับเว็บไซต์ (สี่เหลี่ยมจัตุรัส)",
  "profile.public_role_label": "ตำแหน่งงาน",
  "profile.public_bio_label": "ประวัติ",
  "profile.public_qualifications_label": "วุฒิการศึกษา (บรรทัดละหนึ่งรายการ)",
  "profile.public_certifications_label": "ประกาศนียบัตร (บรรทัดละหนึ่งรายการ)",
  "profile.public_submit": "ส่งเพื่อตรวจสอบ",
  "profile.public_role_required": "กรุณาระบุตำแหน่งงาน",
  "statistics.title": "สถิติ",
  "statistics.subtitle": "การวิเคราะห์ผู้เข้าชมและสถิติยอดเข้าชมเนื้อหา",
  "statistics.tab_visitors": "ผู้เข้าชม",
  "statistics.tab_content": "เนื้อหา",
  "statistics.tab_diversity": "ความหลากหลาย",
  "statistics.tab_students": "นักเรียน",
  "statistics.students_total": "นักเรียนที่กำลังศึกษาอยู่",
  "statistics.students_no_parents": "นักเรียนที่ยังไม่เชื่อมโยงผู้ปกครอง",
  "statistics.students_parents_never": "นักเรียนที่ผู้ปกครองยังไม่เคยเข้าสู่ระบบ",
  "statistics.students_missing_logins": "นักเรียนที่ข้อมูลเข้าสู่ระบบไม่ครบ",
  "statistics.students_footnote": "ตั้งแต่เกรด 1 ขึ้นไป นักเรียนทุกคนต้องมีอีเมล Google รวมถึงบัญชี HMH, IXL, ล็อกเกอร์ และ Wi-Fi ส่วนเกรด 1–5 ต้องมีบัญชี McGraw Hill ด้วย คลิกที่การ์ดเพื่อดูรายชื่อนักเรียนที่เกี่ยวข้อง",
  "statistics.period_7d": "7 วัน",
  "statistics.period_30d": "30 วัน",
  "statistics.period_90d": "90 วัน",
  "statistics.tab_news": "ข่าวสาร",
  "statistics.tab_pages": "หน้าเว็บ",
  "statistics.section_news": "บทความข่าว",
  "statistics.section_pages": "หน้าเว็บไซต์",
  "statistics.no_views": "ไม่มียอดเข้าชมสำหรับ {{label}} ในช่วงเวลานี้",
  "statistics.views_over_time": "ยอดเข้าชมตามช่วงเวลา",
  "statistics.total_views": "ยอดเข้าชมทั้งหมด",
  "statistics.avg_per_day": "เฉลี่ย/วัน",
  "statistics.peak_day": "วันที่มียอดสูงสุด",
  "statistics.top_10": "10 อันดับยอดเข้าชมสูงสุด",
  "statistics.new": "ใหม่",
  "statistics.returning": "กลับมาใหม่",
  "statistics.include_internal": "รวมการเข้าชมภายในองค์กร",
  "statistics.unique_visitors": "ผู้เข้าชมที่ไม่ซ้ำ",
  "statistics.pageviews": "ยอดเข้าชมหน้าเว็บ",
  "statistics.sessions": "เซสชัน",
  "statistics.unique_visitors_over_time": "ผู้เข้าชมที่ไม่ซ้ำตามช่วงเวลา",
  "statistics.new_vs_returning": "ผู้เข้าชมใหม่เทียบกับกลับมาใหม่",
  "statistics.devices": "อุปกรณ์",
  "statistics.traffic_sources": "แหล่งที่มาของผู้เข้าชม",
  "statistics.no_data_period": "ไม่มีข้อมูลในช่วงเวลานี้",
  "statistics.admissions_funnel": "ช่องทางการรับสมัคร",
  "statistics.form_abandonment": "การละทิ้งแบบฟอร์ม",
  "statistics.no_form_activity": "ไม่มีการใช้งานแบบฟอร์มในช่วงเวลานี้",
  "statistics.submitted_ratio": "ส่งแล้ว {{submits}}/{{starts}}",
  "statistics.abandoned_pct": "ละทิ้ง {{pct}}%",
  "statistics.top_locations": "สถานที่ยอดนิยม",
  "statistics.view_countries": "ประเทศ",
  "statistics.view_cities": "เมือง",
  "statistics.unknown_country": "ไม่ทราบ",
  "statistics.n_visitors": "ผู้เข้าชม {{count}} คน",
  "statistics.map_alt": "แผนที่โลกแสดงผู้เข้าชมจาก {{count}} ประเทศ",
  "statistics.col_country": "ประเทศ",
  "statistics.col_region": "ภูมิภาค",
  "statistics.col_city": "เมือง",
  "statistics.col_visitors": "ผู้เข้าชม",
  "statistics.downloads": "การดาวน์โหลด",
  "statistics.no_downloads": "ไม่มีการดาวน์โหลดในช่วงเวลานี้",
  "statistics.col_file": "ไฟล์",
  "statistics.col_unique": "ไม่ซ้ำ",
  "statistics.col_total": "ทั้งหมด",
  "common.print": "พิมพ์",
  "common.export_csv": "ส่งออก CSV",
  "common.export_excel": "ส่งออก Excel",
  "medical.error_select_student": "กรุณาเลือกนักเรียน",
  "medical.error_date_required": "กรุณาระบุวันที่",
  "medical.error_time_format": "เวลาต้องอยู่ในรูปแบบ HH:MM",
  "medical.error_visit_type_required": "กรุณาระบุประเภทการมาพบ",
  "medical.toast_visit_updated": "อัปเดตการมาพบแล้ว",
  "medical.toast_visit_recorded": "บันทึกการมาพบแล้ว",
  "medical.photo_upload_warning": "บันทึกการมาพบแล้ว แต่อัปโหลดรูปภาพไม่สำเร็จ: {{message}}",
  "medical.unknown_error": "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
  "medical.error_save_visit": "บันทึกการมาพบไม่สำเร็จ",
  "medical.edit_visit": "แก้ไขการมาพบ",
  "medical.record_visit": "บันทึกการมาพบ",
  "medical.record_visit_description": "บันทึกการมาห้องพยาบาลของนักเรียน",
  "medical.field_visit_date": "วันที่มาพบ",
  "medical.field_visit_time": "เวลาที่มาพบ",
  "medical.field_visit_type": "ประเภทการมาพบ",
  "medical.field_place": "สถานที่ (ไม่บังคับ)",
  "medical.field_notes": "บันทึกเพิ่มเติม (ไม่บังคับ)",
  "medical.field_tags": "แท็ก (ไม่บังคับ)",
  "medical.field_existing_photos": "รูปภาพที่มีอยู่",
  "medical.field_add_photos": "เพิ่มรูปภาพ (ไม่บังคับ)",
  "medical.select_type_placeholder": "เลือกประเภท…",
  "medical.place_placeholder": "ห้องพยาบาล, ห้องเรียน…",
  "medical.photo_tag_aria": "แท็กรูปภาพ",
  "medical.photo_tag_before": "ก่อน",
  "medical.photo_tag_after": "หลัง",
  "medical.photo_tag_other": "อื่นๆ",
  "medical.retag_photo_aria": "เปลี่ยนแท็กของรูปนี้",
  "medical.share_section_title": "แชร์ให้ผู้ปกครอง",
  "medical.share_will_email": "ยังไม่ได้แชร์ การแชร์จะส่งอีเมลลิงก์พอร์ทัลให้ผู้ปกครอง โดยตัวอีเมลจะไม่มีรายละเอียด",
  "medical.shared_on": "แชร์ให้ผู้ปกครองเมื่อ {{when}} การแก้ไขจะไม่ส่งอีเมลซ้ำ",
  "medical.family_note_label": "ข้อความถึงผู้ปกครอง",
  "medical.family_note_help": "ผู้ปกครองจะเห็นข้อความนี้แทนบันทึกทางการแพทย์",
  "medical.copy_notes_to_family": "คัดลอกจากบันทึก",
  "medical.family_photos_label": "รูปภาพที่ผู้ปกครองจะเห็นได้",
  "medical.family_photos_count": "แชร์รูปภาพ {{count}} จาก {{total}} รูป",
  "medical.share_with_family": "แชร์ให้ผู้ปกครอง",
  "medical.update_share": "อัปเดตสิ่งที่แชร์",
  "medical.unshare": "หยุดแชร์",
  "medical.share_sent": "แชร์แล้ว ระบบได้ส่งอีเมลถึงผู้ปกครอง",
  "medical.share_updated": "อัปเดตสิ่งที่ผู้ปกครองเห็นแล้ว",
  "medical.share_withdrawn": "ไม่ได้แชร์ให้ผู้ปกครองแล้ว",
  "medical.files_selected_one": "เลือกไฟล์แล้ว {{count}} ไฟล์",
  "medical.files_selected_other": "เลือกไฟล์แล้ว {{count}} ไฟล์",
  "medical.delete_photo_title": "ลบรูปภาพ",
  "medical.delete_photo_description": "ลบ \"{{name}}\" หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "medical.move_visit_remove_photos_title": "ย้ายการมาพบและลบรูปภาพหรือไม่?",
  "medical.move_visit_remove_photos_description_one": "การมาพบนี้มีรูปภาพ {{count}} รูปของนักเรียนที่บันทึกไว้ การย้ายไปยังนักเรียนคนอื่นจะลบรูปภาพนั้น การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "medical.move_visit_remove_photos_description_other": "การมาพบนี้มีรูปภาพ {{count}} รูปของนักเรียนที่บันทึกไว้ การย้ายไปยังนักเรียนคนอื่นจะลบรูปภาพเหล่านั้น การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "medical.move_visit_remove_photos_confirm": "ลบรูปภาพและย้ายการมาพบ",
  "medical.delete_photo_aria": "ลบ {{name}}",
  "medical.daily_log_title": "บันทึกประจำวันห้องพยาบาล",
  "medical.daily_log_subtitle": "บันทึกและตรวจสอบการมาพบห้องพยาบาลในช่วงวันที่ที่เลือก",
  "medical.add_visit": "เพิ่มการมาพบ",
  "medical.search_student_placeholder": "ค้นหาชื่อนักเรียน…",
  "medical.search_student_aria": "ค้นหาชื่อนักเรียน",
  "medical.all_types": "ทุกประเภท",
  "medical.all_tags": "ทุกแท็ก",
  "medical.visit_count_one": "{{count}} รายการ",
  "medical.visit_count_other": "{{count}} รายการ",
  "medical.col_name": "ชื่อ",
  "medical.col_class": "ชั้นเรียน",
  "medical.col_type": "ประเภท",
  "medical.col_place": "สถานที่",
  "medical.col_notes": "บันทึก",
  "medical.col_tags": "แท็ก",
  "medical.col_parent": "ครอบครัว",
  "medical.family_sees_this": "ครอบครัวเห็นการเข้าพบครั้งนี้ — แชร์เมื่อ {{when}}",
  "medical.family_not_shared": "ยังไม่ได้แชร์กับครอบครัว",
  "medical.col_photos": "รูปภาพ",
  "medical.csv_col_parent_notified": "แชร์กับครอบครัว",
  "medical.no_visits": "ไม่มีการมาพบที่บันทึกไว้สำหรับวันนี้",
  "medical.delete_visit_title": "ลบการมาพบของ {{name}} หรือไม่?",
  "medical.delete_visit_description": "การดำเนินการนี้จะลบบันทึกการมาพบและรูปภาพที่แนบไว้อย่างถาวร",
  "medical.item_label": "รายการ",
  "medical.visit_detail_title": "การมาพบห้องพยาบาล",
  "medical.visit_section_title": "รายละเอียดการมาพบ",
  "medical.student_section_title": "นักเรียน",
  "medical.record_section_title": "ข้อมูลบันทึก",
  "medical.visit_history_title": "การมาพบครั้งอื่น ({{count}})",
  "medical.no_other_visits": "นี่เป็นการมาพบครั้งเดียวที่บันทึกไว้ของนักเรียนคนนี้",
  "medical.no_photos": "ไม่มีรูปภาพแนบกับการมาพบครั้งนี้",
  "medical.add_photos": "เพิ่มรูปภาพ",
  "medical.open_profile": "เปิดโปรไฟล์",
  "medical.open_visit": "เปิดรายการ",
  "medical.recorded_by": "บันทึกโดย",
  "medical.early_dismissal": "การกลับก่อนเวลา",
  "common.created": "สร้างเมื่อ",
  "common.updated": "แก้ไขล่าสุด",
  "medical.print_title": "บันทึกประจำวันห้องพยาบาล",
  "medical.error_label_required": "กรุณาระบุป้ายชื่อ",
  "medical.error_sort_order_number": "ลำดับการเรียงต้องเป็นตัวเลข",
  "medical.col_tag": "แท็ก",
  "medical.col_visit_type": "ประเภทการมาพบ",
  "medical.col_sort": "ลำดับ",
  "medical.active": "ใช้งาน",
  "medical.inactive": "ไม่ใช้งาน",
  "medical.tags_empty": "ยังไม่มีแท็ก เพิ่มแท็กแรกเพื่อเริ่มต้น",
  "medical.visit_types_empty": "ยังไม่มีประเภทการมาพบ เพิ่มรายการแรกเพื่อเริ่มต้น",
  "medical.edit_tag": "แก้ไขแท็ก",
  "medical.new_tag": "แท็กใหม่",
  "medical.edit_visit_type": "แก้ไขประเภทการมาพบ",
  "medical.new_visit_type": "ประเภทการมาพบใหม่",
  "medical.field_label": "ป้ายชื่อ",
  "medical.field_color": "สี",
  "medical.field_sort_order": "ลำดับการเรียง",
  "medical.tag_placeholder": "ภูมิแพ้",
  "medical.visit_type_placeholder": "มาพบเนื่องจากป่วย",
  "medical.delete_tag_title": "ลบแท็ก \"{{label}}\" หรือไม่?",
  "medical.delete_tag_description": "การดำเนินการนี้จะลบแท็กอย่างถาวร การมาพบที่ใช้แท็กนี้อยู่อาจได้รับผลกระทบ",
  "medical.delete_visit_type_title": "ลบประเภทการมาพบ \"{{label}}\" หรือไม่?",
  "medical.delete_visit_type_description": "การดำเนินการนี้จะลบประเภทการมาพบอย่างถาวร การมาพบที่ใช้ประเภทนี้อยู่อาจได้รับผลกระทบ",
  "medical.tab_visit_types": "ประเภทการมาพบ",
  "medical.tab_tags": "แท็ก",
  "medical.new_visit_type_cta": "เพิ่มประเภทการมาพบ",
  "medical.new_tag_cta": "เพิ่มแท็ก",
  "medical.settings_subtitle": "ประเภทการมาพบและแท็กสำหรับโมดูลห้องพยาบาล",
  "temperature.error_invalid": "กรุณากรอกอุณหภูมิที่ถูกต้อง",
  "temperature.toast_reading_recorded": "บันทึกอุณหภูมิของ {{name}} แล้ว",
  "temperature.error_save_failed": "บันทึกอุณหภูมิไม่สำเร็จ",
  "temperature.toast_reading_updated": "อัปเดตอุณหภูมิแล้ว",
  "temperature.error_update_failed": "อัปเดตอุณหภูมิไม่สำเร็จ",
  "temperature.error_delete_failed": "ลบอุณหภูมิไม่สำเร็จ",
  "temperature.error_export_failed": "ส่งออกข้อมูลอุณหภูมิไม่สำเร็จ",
  "temperature.add_title": "เพิ่มการบันทึกอุณหภูมิ",
  "temperature.edit_title": "แก้ไขการบันทึกอุณหภูมิ",
  "temperature.recording_for": "กำลังบันทึกให้ <bold>{{name}}</bold>",
  "temperature.field_temperature": "อุณหภูมิ (°C)",
  "temperature.field_note": "บันทึกเพิ่มเติม (ไม่บังคับ)",
  "temperature.note_placeholder": "เช่น บ่นปวดหัว",
  "temperature.export_title": "ส่งออก CSV ข้อมูลอุณหภูมิ",
  "temperature.export_description": "ส่งออกข้อมูลอุณหภูมิตามช่วงวันที่และห้องเรียนที่เลือก",
  "temperature.from_label": "จากวันที่",
  "temperature.to_label": "ถึงวันที่",
  "temperature.error_from_after_to": "วันที่ \"จากวันที่\" ต้องมาก่อนหรือเท่ากับวันที่ \"ถึงวันที่\"",
  "temperature.classes_label": "ห้องเรียน",
  "temperature.select_all": "เลือกทั้งหมด",
  "temperature.no_tracking_classes": "ไม่มีห้องเรียนที่เปิดใช้การติดตามอุณหภูมิ",
  "temperature.download_csv": "ดาวน์โหลด CSV",
  "temperature.exporting": "กำลังส่งออก…",
  "temperature.col_class": "ชั้นเรียน",
  "temperature.col_grade": "ระดับชั้น",
  "temperature.col_readings": "การบันทึกอุณหภูมิ",
  "temperature.edit_reading_aria": "แก้ไขการบันทึกอุณหภูมิ",
  "temperature.delete_reading_aria": "ลบการบันทึกอุณหภูมิ",
  "temperature.no_readings": "ไม่มีการบันทึก",
  "temperature.add_reading": "เพิ่มการบันทึก",
  "temperature.no_students_enrolled": "ไม่มีนักเรียนในชั้นเรียนนี้",
  "temperature.print_title": "แผ่นบันทึกอุณหภูมิ",
  "temperature.subtitle": "ติดตามการบันทึกอุณหภูมิรายวันตามชั้นเรียน",
  "temperature.select_year_placeholder": "เลือกปีการศึกษา…",
  "temperature.no_classes_enabled": "ไม่มีห้องเรียนที่เปิดใช้งาน",
  "temperature.select_class_placeholder": "เลือกชั้นเรียน…",
  "temperature.help_note": "บันทึกอุณหภูมิของเด็กแต่ละคนตลอดวัน การบันทึกที่ 37.5 °C ขึ้นไปจะถูกทำเครื่องหมายและแจ้งเตือนเจ้าหน้าที่",
  "temperature.select_prompt": "เลือกชั้นเรียนและวันที่เพื่อดูหรือบันทึกอุณหภูมิ",
  "temperature.loading_roster": "กำลังโหลดรายชื่อนักเรียน…",
  "temperature.load_roster_failed": "โหลดรายชื่อนักเรียนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "students.subtitle": "จัดการนักเรียน รูปภาพ และอีเมลสำหรับเข้าสู่ระบบ Google",
  "students.item_label": "นักเรียน",
  "students.new_student": "เพิ่มนักเรียนใหม่",
  "students.search_placeholder": "ค้นหาด้วยชื่อหรือชื่อเล่น…",
  "students.search_aria": "ค้นหานักเรียนด้วยชื่อหรือชื่อเล่น",
  "students.house_label": "บ้าน",
  "students.all_houses": "ทุกบ้าน",
  "students.all_grades": "ทุกระดับชั้น",
  "students.filter_active_only": "เฉพาะที่ใช้งานอยู่",
  "students.filter_inactive_only": "เฉพาะที่ไม่ได้ใช้งาน",
  "students.status.label": "สถานะ",
  "students.status.card_title": "สถานะการเรียน",
  "students.status.enrolled": "กำลังเรียน",
  "students.status.trial": "ทดลองเรียน",
  "students.status.admitted": "รับเข้าแล้ว",
  "students.status.left": "ออกแล้ว",
  "students.status.arriving": "รอเข้าเรียน",
  "students.status.trial_until": "ทดลองเรียนถึง {{date}}",
  "students.status.arriving_starts": "รอเข้าเรียน · เริ่ม {{date}}",
  "students.status.filter_enrolled": "กำลังเรียน",
  "students.status.filter_trial": "ทดลองเรียน",
  "students.status.filter_trial-ending": "ทดลองเรียนครบกำหนด",
  "students.status.filter_admitted": "รอเข้าเรียน",
  "students.status.filter_left": "ออกแล้ว",
  "students.status.create_hint_enrolled": "เข้าเรียนตั้งแต่วันนี้",
  "students.status.create_hint_trial": "เข้าเรียนในช่วงวันทดลองเรียน และผู้ปกครองเข้าสู่ระบบได้ ต้องระบุระดับชั้น",
  "students.status.create_hint_admitted": "รับเข้าแล้วและจะเริ่มเรียนภายหลัง ผู้ปกครองเข้าสู่ระบบได้ทันที ส่วนเด็กจะอยู่ในรายชื่อชั้นเรียนตั้งแต่วันเริ่มเรียน ต้องระบุระดับชั้น",
  "students.status.readonly_hint": "เปลี่ยนสถานะด้วยปุ่มขยายเวลา ลงทะเบียนเรียน หรือออก ในแถวหรือหน้าของนักเรียน",
  "students.status.explain_enrolled": "อยู่ในชั้นเรียน ในใบเช็กชื่อ และในข้อมูลทางการของโรงเรียน",
  "students.status.explain_trial": "อยู่ในชั้นเรียนและใบเช็กชื่อพร้อมป้ายทดลองเรียน แต่ไม่อยู่ในสมุดรายงานผล MAP หรือการตรวจสอบข้อมูล หากไม่มีใครดำเนินการ ระบบจะขยายการทดลองเรียนออกไปทีละหนึ่งวันเรียน",
  "students.status.explain_admitted": "ยังไม่ได้เข้าเรียน ครูจะเห็นเด็กในส่วนรอเข้าเรียน และระบบจะลงทะเบียนเรียนให้อัตโนมัติในวันเริ่มเรียน",
  "students.status.explain_left": "ไม่ได้อยู่ที่โรงเรียนแล้ว บัญชีผู้ปกครองจะยังใช้งานได้เฉพาะเมื่อยังมีพี่หรือน้องเรียนอยู่",
  "students.status.mark_left": "บันทึกว่าออกแล้ว",
  "students.status.left_confirm_title": "บันทึกว่า {{name}} ออกแล้วหรือไม่",
  "students.status.left_confirm_description": "เด็กจะไม่อยู่ในรายชื่อชั้นเรียนและใบเช็กชื่อตั้งแต่วันนี้ ข้อมูลเดิมยังคงอยู่ และใบแจ้งหนี้ฉบับร่างจะไม่ถูกแก้ไข หากจำเป็นให้ยกเลิกในหน้าค่าเล่าเรียน",
  "students.trial.extend": "ขยายเวลาทดลองเรียน",
  "students.trial.extend_title": "ขยายเวลาทดลองเรียนของ {{name}}",
  "students.trial.extend_submit": "ขยายเวลาทดลองเรียน",
  "students.trial.currently_until": "ขณะนี้การทดลองเรียนสิ้นสุดวันที่ {{date}}",
  "students.trial.start_date": "วันเริ่มทดลองเรียน",
  "students.trial.end_date": "วันสิ้นสุดทดลองเรียน",
  "students.trial.start_required": "เลือกวันเริ่มทดลองเรียน",
  "students.trial.end_required": "เลือกวันสิ้นสุดทดลองเรียน",
  "students.trial.end_before_start": "วันสิ้นสุดทดลองเรียนต้องไม่อยู่ก่อนวันเริ่ม",
  "students.enrol.action": "ลงทะเบียนเรียน",
  "students.enrol.title": "ลงทะเบียนเรียนให้ {{name}}",
  "students.enrol.description": "หากเลือกวันนี้ เด็กจะเข้าเรียนทันที หากเลือกวันที่ภายหลัง จะบันทึกเป็นรอเข้าเรียนจนถึงวันนั้น",
  "students.enrol.start_date": "วันเริ่มเรียน",
  "students.enrol.start_date_required": "เลือกวันเริ่มเรียน",
  "students.enrol.grade": "ระดับชั้น",
  "students.enrol.create_draft": "สร้างใบแจ้งหนี้ฉบับร่าง",
  "students.enrol.create_draft_hint": "ใบแจ้งหนี้ฉบับร่างของภาคเรียนสำหรับเด็กคนนี้ พร้อมส่วนลดสำหรับวันเรียนที่ผ่านไปแล้ว จะยังเป็นฉบับร่างจนกว่าคุณจะออกใบแจ้งหนี้ในหน้าค่าเล่าเรียน",
  "students.enrol.prepaid_hint": "ครอบครัวชำระล่วงหน้าแล้วหรือไม่ ให้ตั้งค่าภาคเรียนที่ชำระล่วงหน้า เพื่อไม่ให้การออกใบแจ้งหนี้รวมครั้งต่อไปเรียกเก็บซ้ำ",
  "students.enrol.prepaid_link": "เปิดการตั้งค่าชำระล่วงหน้า",
  "students.enrol.submit": "ลงทะเบียนเรียน",
  "students.enrol.done_enrolled": "ลงทะเบียนเรียนแล้ว เด็กเข้าเรียนได้ตั้งแต่วันนี้",
  "students.enrol.done_admitted": "รับเข้าแล้ว เด็กจะเข้าเรียนในวันเริ่มเรียน",
  "students.enrol.draft_created": "สร้างใบแจ้งหนี้ฉบับร่างแล้ว",
  "students.enrol.open_draft": "เปิดฉบับร่าง",
  "students.enrol.draft_skipped": "ไม่ได้สร้างฉบับร่าง เพราะวันเริ่มเรียนอยู่นอกภาคเรียนของปีนี้",
  "students.enrol.draft_failed": "บันทึกการลงทะเบียนเรียนแล้ว แต่สร้างใบแจ้งหนี้ฉบับร่างไม่ได้",
  "students.arriving.change_start": "เปลี่ยนวันเริ่มเรียน",
  "students.arriving.change_start_title": "เปลี่ยนวันเริ่มเรียนของ {{name}}",
  "students.arriving.change_start_hint": "เด็กจะอยู่ในรายชื่อชั้นเรียนตั้งแต่วันที่เลือก หากเป็นวันที่ผ่านมาแล้ว ระบบจะลงทะเบียนเรียนให้ทันที",
  "students.arriving.section_title": "รอเข้าเรียน ({{count}})",
  "students.arriving.section_hint": "เด็กที่รับเข้าแล้วและเด็กทดลองเรียนที่จะเริ่มภายหลังในปีนี้ ยังไม่อยู่ในใบเช็กชื่อ",
  "students.arriving.starts_col": "เริ่มเรียน",
  "students.empty": "ไม่พบนักเรียน",
  "students.tab_list": "นักเรียน",
  "students.tab_audit": "ตรวจสอบข้อมูล",
  "students.detail_tabs_label": "ส่วนต่าง ๆ ของระเบียนนักเรียน",
  "students.detail_tab_overview": "ภาพรวม",
  "students.detail_tab_family_logins": "ครอบครัวและการเข้าสู่ระบบ",
  "students.detail_tab_attendance": "การเข้าเรียน",
  "students.detail_tab_timetable": "ตารางเรียน",
  "students.timetable_title": "ตารางเรียนรายสัปดาห์",
  "students.timetable_empty": "ยังไม่มีการเผยแพร่ตารางเรียนของนักเรียนคนนี้",
  "students.timetable_special_dates": "ไม่มีวันประจำ",
  "students.edp_this_round_label": "EDP รอบนี้",
  "students.edp_none_this_round": "ไม่มีในรอบนี้",
  "students.detail_tab_wellbeing": "สุขภาวะ",
  "students.detail_tab_sst": "SST",
  "students.detail_tab_rewards": "รางวัล",
  "students.detail_tab_wallet": "กระเป๋าเงิน",
  "students.sst_tabs_label": "ระเบียนทีมสนับสนุนนักเรียน",
  "students.sst_tab_supervision": "การดูแลโดย SST",
  "students.sst_tab_incidents": "เหตุการณ์",
  "students.sst_tab_notes": "บันทึก SST",
  "students.sst_tab_lunch_detentions": "MSS",
  "students.sst_supervision_title": "การดูแลโดย SST",
  "students.sst_supervision_badge": "อยู่ในการดูแลของ SST",
  "students.sst_supervision_since": "อยู่ในการดูแลของ SST ตั้งแต่ {{date}}",
  "students.sst_supervision_active": "อยู่ในการดูแลของ SST",
  "students.sst_supervision_inactive": "ขณะนี้นักเรียนคนนี้ไม่ได้อยู่ในการดูแลของ SST",
  "students.sst_supervision_history": "ประวัติการดูแล",
  "students.sst_supervision_no_history": "ยังไม่มีประวัติการดูแลโดย SST สำหรับนักเรียนคนนี้",
  "students.sst_supervision_active_period": "ช่วงการดูแลปัจจุบัน",
  "students.sst_supervision_closed_period": "ช่วงการดูแลก่อนหน้า",
  "students.sst_supervision_started_by": "เริ่มโดย {{name}} เมื่อ {{date}}",
  "students.sst_supervision_ended_by": "สิ้นสุดโดย {{name}} เมื่อ {{date}}",
  "students.sst_supervision_start_action": "เริ่มการดูแลโดย SST",
  "students.sst_supervision_end_action": "สิ้นสุดการดูแล",
  "students.sst_supervision_reason_label": "เหตุผลที่เริ่มการดูแล",
  "students.sst_supervision_reason_placeholder": "อธิบายเหตุผลที่เริ่มการดูแลโดย SST…",
  "students.sst_supervision_end_note_label": "บันทึกเมื่อสิ้นสุด (ไม่บังคับ)",
  "students.sst_supervision_end_note_placeholder": "บันทึกเหตุผลที่สิ้นสุดการดูแลหรือการติดตามผล…",
  "students.sst_supervision_history_hint": "การดำเนินการนี้จะถูกเก็บไว้อย่างถาวรในประวัติการดูแล",
  "students.sst_supervision_start_confirm": "เริ่มการดูแล",
  "students.sst_supervision_end_confirm": "สิ้นสุดการดูแล",
  "students.sst_supervision_started": "เริ่มการดูแลโดย SST แล้ว",
  "students.sst_supervision_ended": "สิ้นสุดการดูแลโดย SST แล้ว",
  "students.audit_title": "ตรวจสอบข้อมูลนักเรียน",
  "students.audit_subtitle": "นักเรียนที่ขาดผู้ปกครองหรือข้อมูลเข้าสู่ระบบ และผู้ปกครองที่ยังไม่เคยเข้าสู่ระบบ",
  "students.audit_filter_any_issue": "มีปัญหา",
  "students.audit_filter_no_parents": "ไม่มีผู้ปกครอง",
  "students.audit_filter_parents_never": "ผู้ปกครองไม่เคยเข้าสู่ระบบ",
  "students.audit_filter_missing_logins": "ข้อมูลเข้าสู่ระบบไม่ครบ",
  "students.audit_filter_all": "นักเรียนทั้งหมด",
  "students.audit_col_parents": "ผู้ปกครอง",
  "students.audit_col_parent_login": "การเข้าสู่ระบบของผู้ปกครอง",
  "students.audit_no_parents_badge": "ยังไม่เชื่อมโยง",
  "students.audit_parent_logged_in": "เคยเข้าสู่ระบบ",
  "students.audit_parent_never_logged_in": "ไม่เคยเข้าสู่ระบบ",
  "students.audit_col_google": "Google",
  "students.audit_col_hmh": "HMH",
  "students.audit_col_mcgrawhill": "McGraw Hill",
  "students.audit_col_boddle": "Boddle",
  "students.audit_col_wifi": "Wi-Fi",
  "students.audit_col_ixl": "IXL",
  "students.audit_col_locker": "ล็อกเกอร์",
  "students.audit_not_required": "ยังไม่จำเป็นก่อนเกรด 1",
  "students.audit_empty": "ไม่พบนักเรียนตามเงื่อนไขนี้",
  "students.help_note": "เพิ่มนักเรียนทีละคนด้วย <strong>เพิ่มนักเรียน</strong> หรือนำเข้าจำนวนมากจาก Excel ผ่าน <strong>นำเข้าข้อมูล</strong>",
  "students.google_email_label": "อีเมล Google",
  "students.link_button": "เชื่อมโยง",
  "students.google_email_dialog_title": "อีเมลสำหรับเข้าสู่ระบบ Google — {{name}}",
  "students.school_google_email_label": "อีเมล Google ของโรงเรียน",
  "students.google_email_placeholder": "firstname.lastname@risphuket.ac.th",
  "students.error_invalid_email": "กรุณากรอกอีเมลที่ถูกต้อง",
  "students.google_email_hint": "นักเรียนจะสามารถเข้าสู่ระบบเว็บไซต์สาธารณะด้วยอีเมลนี้ได้",
  "students.unlink": "ยกเลิกการเชื่อมโยง",
  "students.delete_title": "เก็บนักเรียน \"{{name}}\" เข้าคลังหรือไม่?",
  "students.delete_description": "นักเรียนจะถูกตั้งค่าเป็นไม่ใช้งานและหายจากรายชื่อปัจจุบัน โดยประวัติทั้งหมดจะยังคงอยู่",
  "students.back_to_students": "กลับไปหน้านักเรียน",
  "students.details_title": "รายละเอียดนักเรียน",
  "students.nickname_label": "ชื่อเล่น",
  "students.date_of_birth_label": "วันเกิด",
  "students.sex_label": "เพศ",
  "students.personal_id_label": "รหัสประจำตัว",
  "students.no_house": "ไม่มีบ้าน",
  "students.no_google_email": "ยังไม่ได้เชื่อมโยงอีเมล Google",
  "students.photo_download": "ดาวน์โหลดรูป",
  "students.photo_downloading": "กำลังดาวน์โหลด…",
  "students.award_button": "มอบรางวัลให้นักเรียนคนนี้",
  "students.stat_total": "แซนด์ดอลลาร์ทั้งหมด",
  "students.stat_this_month": "เดือนนี้",
  "students.stat_top_value": "มูลค่าสูงสุด",
  "students.stat_top_awarder": "ผู้มอบรางวัลสูงสุด",
  "students.award_count_one": "{{count}} รางวัล",
  "students.award_count_other": "{{count}} รางวัล",
  "students.monthly_history": "ประวัติรายเดือน",
  "students.by_value": "แยกตามมูลค่า",
  "students.no_awards_yet": "ยังไม่มีรางวัล",
  "students.unknown": "ไม่ทราบ",
  "students.growth_title": "การเจริญเติบโต",
  "students.add_measurement": "เพิ่มการวัดร่างกาย",
  "students.who_info_p1": "เปอร์เซ็นไทล์ใช้ตาม <strong>WHO Child Growth Standards</strong> (ปี 2006 สำหรับอายุ 0–5 ปี) และ <strong>WHO Growth Reference</strong> (ปี 2007 สำหรับอายุ 5–19 ปี)",
  "students.who_info_p2": "<strong>ส่วนสูงตามอายุ</strong> และ <strong>BMI ตามอายุ</strong> แสดงผลสำหรับทุกช่วงอายุ ส่วน <strong>น้ำหนักตามอายุ</strong> แสดงเฉพาะจนถึงอายุ 10 ปี (WHO ไม่ได้กำหนดค่าเกินอายุ 10 ปี — BMI ตามอายุเป็นตัวชี้วัดที่แนะนำสำหรับเด็กโต)",
  "students.who_info_p3": "เปอร์เซ็นไทล์คำนวณจากอายุและเพศของเด็กด้วยวิธี WHO LMS (z-score → เปอร์เซ็นไทล์) แสดงให้เห็นว่าเด็กเปรียบเทียบกับกลุ่มอ้างอิงของ WHO อย่างไร เช่น เปอร์เซ็นไทล์ที่ 75 หมายถึงสูงกว่า/หนักกว่าเด็ก 75% ในวัยเดียวกัน",
  "students.who_info_p4": "ต้องมี <strong>วันเกิด</strong> และ <strong>เพศ</strong> ของนักเรียน มิฉะนั้นเปอร์เซ็นไทล์จะแสดงเป็น '—'",
  "students.col_weight": "น้ำหนัก",
  "students.col_height": "ส่วนสูง",
  "students.col_weight_kg": "น้ำหนัก (กก.)",
  "students.col_height_cm": "ส่วนสูง (ซม.)",
  "students.growth_print_title": "ประวัติการเจริญเติบโต",
  "students.delete_measurement_title": "ลบการวัดร่างกาย",
  "students.delete_measurement_description": "ลบการวัดร่างกายจากวันที่ {{date}} หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "students.recent_awards_title": "รางวัลล่าสุด",
  "students.total_suffix": "ทั้งหมด {{count}} รายการ",
  "students.awarded_by": "โดย {{name}}",
  "students.staff_fallback": "เจ้าหน้าที่",
  "students.view_all_awards": "ดูรางวัลทั้งหมดของนักเรียนคนนี้",
  "students.edit_title": "แก้ไขนักเรียน",
  "students.new_title": "เพิ่มนักเรียนใหม่",
  "students.google_email_invalid": "อีเมล Google ไม่ถูกต้อง",
  "students.fullname_placeholder": "สมชาย ใจดี",
  "students.nickname_placeholder": "น้องดี",
  "students.nickname_hint": "หากระบุไว้ ชื่อเล่นจะถูกแสดงแทนชื่อเต็มทั่วทั้งระบบ",
  "students.date_of_birth_field": "วันเกิด (ไม่บังคับ)",
  "students.sex_field": "เพศ (ไม่บังคับ)",
  "students.not_specified": "ไม่ระบุ",
  "students.person_id_placeholder": "S-001",
  "students.door_id_field": "รหัสประตู (ไม่บังคับ)",
  "students.door_id_field_hint": "หมายเลขสั้นสำหรับแผงประตูเมื่อรหัสประจำตัวมีหลักมากเกินไป บัตรที่ลงทะเบียนด้วยหมายเลขนี้จะเปิดประตูในชื่อนักเรียนคนนี้",
  "students.door_id_invalid": "รหัสประตูต้องเป็นตัวเลขเท่านั้น",
  "students.google_email_field": "อีเมล Google (ไม่บังคับ)",
  "students.google_email_field_hint": "หากระบุไว้ นักเรียนจะสามารถเข้าสู่ระบบเว็บไซต์สาธารณะด้วยบัญชี Google นี้ได้",
  "students.grade_level_field": "ระดับชั้น",
  "students.edp_free_places_field": "ที่นั่ง EDP ฟรี",
  "students.edp_free_places_hint": "จำนวนวิชา EDP ที่นักเรียนคนนี้ไม่ต้องจ่าย แต่ละที่มีมูลค่าเท่ากับราคาวิชามาตรฐานของรอบนั้น นักเรียนส่วนใหญ่ไม่มี",
  "students.edp_free_places_invalid": "กรอกจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
  "students.house_field": "บ้าน (ไม่บังคับ)",
  "students.photo_alt": "รูปนักเรียน",
  "students.infirmary_title": "การมาห้องพยาบาล",
  "students.no_infirmary_visits": "ยังไม่มีการมาห้องพยาบาล",
  "students.delete_visit_title": "ลบการมาพบ",
  "students.delete_visit_description": "ลบการมาห้องพยาบาลจากวันที่ {{date}} หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "students.parents_title": "ผู้ปกครอง",
  "students.new_parent": "เพิ่มผู้ปกครองใหม่",
  "students.no_parents_linked": "ยังไม่มีผู้ปกครองที่เชื่อมโยง",
  "students.parent_search_placeholder": "เชื่อมโยงผู้ปกครองที่มีอยู่ — ค้นหาชื่อหรืออีเมล…",
  "students.no_matching_parents": "ไม่พบผู้ปกครองที่ยังไม่ได้เชื่อมโยง",
  "students.toast_parent_linked": "เชื่อมโยงผู้ปกครองแล้ว",
  "students.error_link_failed": "ไม่สามารถเชื่อมโยงได้",
  "students.unlink_parent_title": "ยกเลิกการเชื่อมโยงผู้ปกครอง?",
  "students.unlink_parent_description": "{{name}} จะไม่เชื่อมโยงกับนักเรียนคนนี้อีกต่อไป คุณสามารถเชื่อมโยงใหม่ได้ทุกเมื่อ",
  "students.toast_parent_unlinked": "ยกเลิกการเชื่อมโยงผู้ปกครองแล้ว",
  "students.error_unlink_failed": "ไม่สามารถยกเลิกการเชื่อมโยงได้",
  "students.no_temp_readings": "ไม่มีการบันทึกอุณหภูมิ",
  "students.temp_col_temp_c": "อุณหภูมิ (°C)",
  "students.temp_col_temp": "อุณหภูมิ",
  "students.temp_col_taken_by": "ผู้บันทึก",
  "students.temp_col_note": "บันทึก",
  "students.temperature_print_title": "ประวัติอุณหภูมิ",
  "students.edit_measurement_title": "แก้ไขการวัดร่างกาย",
  "students.measurement_save_failed": "บันทึกไม่สำเร็จ",
  "students.no_incidents": "ไม่มีเหตุการณ์ที่บันทึกไว้สำหรับนักเรียนคนนี้",
  "students.incidents_visible_title": "เหตุการณ์ที่คุณสามารถดูได้",
  "students.no_visible_incidents": "ไม่มีเหตุการณ์ของนักเรียนคนนี้ที่คุณมีสิทธิ์ดู",
  "students.no_lunch_detentions": "ยังไม่มีบันทึกรอบ MSS ของนักเรียนคนนี้",
  "students.no_measurements_yet": "ยังไม่มีข้อมูลการวัดร่างกาย",
  "students.error_date_required": "กรุณาระบุวันที่",
  "students.error_weight_number": "น้ำหนักต้องเป็นตัวเลข",
  "students.error_height_number": "ส่วนสูงต้องเป็นตัวเลข",
  "students.allergies_section": "ภูมิแพ้และอาหาร",
  "students.allergy_badge": "แพ้รุนแรง",
  "students.allergy_card.print": "พิมพ์บัตรภูมิแพ้",
  "students.allergy_card.severe_banner": "ภูมิแพ้รุนแรง",
  "students.allergy_card.allergens_heading": "สารก่อภูมิแพ้",
  "students.allergy_card.dietary_heading": "หมายเหตุด้านอาหาร",
  "students.allergy_card.no_allergens": "ไม่มีข้อมูลสารก่อภูมิแพ้",
  "students.allergy_severe_suffix": "รุนแรง",
  "students.no_dietary_info": "ไม่มีข้อมูลภูมิแพ้หรือหมายเหตุด้านอาหาร",
  "students.dietary_note": "หมายเหตุด้านอาหาร",
  "students.allergies_label": "รายการแพ้",
  "students.aides.badge": "ผู้ช่วยดูแลเฉพาะตัว: {{name}}",
  "students.aides.label": "1:1",
  "students.aides.off.full_day": "ลาวันนี้",
  "students.aides.off.morning_half": "ลาช่วงเช้า",
  "students.aides.off.afternoon_half": "ลาช่วงบ่าย",
  "students.aides.role": "ผู้ช่วยดูแลเฉพาะตัว",
  "students.aides.section_title": "ผู้ช่วยดูแลเฉพาะตัว",
  "students.aides.none": "ยังไม่มีผู้ช่วยดูแลเฉพาะตัว",
  "students.aides.edit_title": "ผู้ช่วยดูแลเฉพาะตัว",
  "students.aides.edit_description": "บุคลากรที่ดูแลนักเรียนคนนี้แบบตัวต่อตัว จะเห็นข้อมูลทั้งหมด รายงานเหตุการณ์ และข้อมูลการเข้าสู่ระบบของนักเรียนคนนี้",
  "students.aides.saved": "บันทึกผู้ช่วยดูแลเฉพาะตัวแล้ว",
  "students.add_allergy": "เพิ่มรายการแพ้",
  "students.allergy_item_placeholder": "เช่น ถั่วลิสง",
  "students.severe": "รุนแรง",
  "students.media_consent_section": "การยินยอมให้เผยแพร่สื่อ",
  "students.social_consent_label": "การยินยอมให้เผยแพร่สื่อ",
  "students.social_note": "หมายเหตุ",
  "students.may_leave_alone_badge": "กลับเองได้",
  "students.leave_alone_section": "การกลับบ้านเอง",
  "students.leave_alone_label": "อนุญาตให้กลับเอง",
  "students.leave_alone_hint": "ต้องมีแบบฟอร์มที่ผู้ปกครองลงนามแล้วเท่านั้น",
  "students.leave_alone_note": "หมายเหตุ",
  "students.social_ok": "เผยแพร่ได้",
  "students.social_no": "ห้ามเผยแพร่",
  "students.credentials_section_title": "ข้อมูลเข้าสู่ระบบดิจิทัล",
  "students.credential_add_button": "เพิ่มข้อมูลเข้าสู่ระบบ",
  "students.credential_empty": "ยังไม่มีข้อมูลเข้าสู่ระบบ",
  "students.credential_col_platform": "แพลตฟอร์ม",
  "students.credential_col_username": "ชื่อผู้ใช้",
  "students.credential_col_password": "รหัสผ่าน",
  "students.credential_col_login_url": "ลิงก์เข้าสู่ระบบ",
  "students.credential_col_notes": "หมายเหตุ",
  "students.credential_open_login": "เปิดหน้าเข้าสู่ระบบ",
  "students.credential_toggle_reveal": "แสดง/ซ่อนรหัสผ่าน",
  "students.credential_copy_password": "คัดลอกรหัสผ่าน",
  "common.password_large_type": "แสดงรหัสผ่านตัวใหญ่",
  "common.password_large_type_hint": "ตัวเลขเป็นสีน้ำเงิน และสัญลักษณ์เป็นสีแดง ตัวเลขเล็กใต้แต่ละตัวอักษรบอกลำดับของตัวอักษรนั้น",
  "students.credential_toast_copied": "คัดลอกรหัสผ่านแล้ว",
  "students.credential_error_copy": "คัดลอกไม่สำเร็จ",
  "students.credential_error_reveal": "ไม่สามารถแสดงรหัสผ่านได้",
  "students.credential_delete_title": "ลบข้อมูลเข้าสู่ระบบ",
  "students.credential_delete_description": "ลบข้อมูลเข้าสู่ระบบ \"{{name}}\" ของนักเรียนคนนี้ใช่หรือไม่? ไม่สามารถย้อนกลับได้",
  "students.credential_print_title": "ข้อมูลเข้าสู่ระบบดิจิทัล",
  "students.credential_add_title": "เพิ่มข้อมูลเข้าสู่ระบบ",
  "students.credential_edit_title": "แก้ไขข้อมูลเข้าสู่ระบบ",
  "students.credential_field_platform": "แพลตฟอร์ม",
  "students.credential_field_custom_label": "ชื่อแพลตฟอร์ม",
  "students.credential_error_custom_label_required": "กรุณาระบุชื่อแพลตฟอร์ม",
  "students.credential_field_username": "ชื่อผู้ใช้ / อีเมล",
  "students.credential_field_password": "รหัสผ่าน",
  "students.credential_field_notes": "หมายเหตุ (ผู้ปกครองมองเห็น)",
  "students.credential_platform_other": "อื่นๆ",
  "students.credential_toast_added": "เพิ่มข้อมูลเข้าสู่ระบบแล้ว",
  "students.credential_toast_updated": "อัปเดตข้อมูลเข้าสู่ระบบแล้ว",
  "students.credential_error_save": "ไม่สามารถบันทึกข้อมูลนี้ได้",
  "credential_export.title": "ส่งออกข้อมูลนักเรียน",
  "credential_export.subtitle": "สร้างเอกสารพิมพ์หรือไฟล์ CSV ของข้อมูลนักเรียน ข้อมูลเข้าสู่ระบบเป็นเพียงส่วนเสริมหนึ่งในหลายส่วน",
  "credential_export.label_grade": "ระดับชั้น",
  "credential_export.layout_heading": "รูปแบบชีต",
  "credential_export.split_by_grade": "แยกชีตตามระดับชั้น",
  "credential_export.split_by_grade_hint": "แยกเป็นชีตละระดับชั้นในไฟล์ Excel และขึ้นหน้าใหม่สำหรับแต่ละระดับชั้นเมื่อพิมพ์",
  "credential_export.as_cards": "พิมพ์เป็นบัตรข้อมูลเข้าสู่ระบบ",
  "credential_export.as_cards_hint": "บัตรละหนึ่งนักเรียน สองใบต่อแถวบนกระดาษ A4 สำหรับตัดแจก ช่องข้อมูลนักเรียนช่องแรกจะเป็นหัวบัตร",
  "credential_export.card_username": "ชื่อผู้ใช้",
  "credential_export.card_password": "รหัสผ่าน",
  "credential_export.no_grade": "ไม่มีระดับชั้น",
  "credential_export.reorder_column_aria": "ย้ายคอลัมน์ {{column}}",
  "credential_export.fields_heading": "ข้อมูลนักเรียน",
  "credential_export.platforms_heading": "แพลตฟอร์มบัญชีเข้าสู่ระบบ",
  "credential_export.field.fullName": "ชื่อ-นามสกุล",
  "credential_export.field.firstName": "ชื่อ",
  "credential_export.field.lastName": "นามสกุล",
  "credential_export.field.nickname": "ชื่อเล่น",
  "credential_export.field.personId": "รหัสนักเรียน",
  "credential_export.field.risPersonId": "รหัส RIS Phuket",
  "credential_export.field.gradeLevel": "ระดับชั้น",
  "credential_export.field.sex": "เพศ",
  "credential_export.field.dateOfBirth": "วันเกิด",
  "credential_export.field.house": "บ้าน (House)",
  "credential_export.field.passportOrThaiId": "หนังสือเดินทาง / เลขบัตรประชาชน",
  "credential_export.field.email": "อีเมล",
  "credential_export.field.parents": "ข้อมูลติดต่อผู้ปกครอง",
  "credential_export.platform.google": "Gmail / Google",
  "credential_export.platform.ixl": "IXL",
  "credential_export.platform.locker": "ล็อกเกอร์",
  "credential_export.platform.hmh": "HMH",
  "credential_export.platform.mcgrawhill": "McGraw Hill",
  "credential_export.platform.boddle": "Boddle",
  "credential_export.platform.kidsaz": "Kids A-Z",
  "credential_export.platform.epic": "Epic",
  "credential_export.platform.wifi": "ไวไฟโรงเรียน",
  "credential_export.platform.other": "อื่นๆ",
  "credential_export.password_warning": "เอกสารนี้มีรหัสผ่านอยู่ — โปรดเก็บรักษาและทำลายอย่างระมัดระวัง",
  "credential_export.generate": "สร้างรายงาน",
  "credential_export.generating": "กำลังสร้าง…",
  "credential_export.empty": "ไม่พบนักเรียนสำหรับตัวเลือกนี้",
  "credential_export.empty_hint": "เลือกระดับชั้นและข้อมูลหรือแพลตฟอร์มอย่างน้อยหนึ่งรายการ แล้วกดสร้างรายงาน",
  "sand_dollars.award_title": "มอบแซนด์ดอลลาร์",
  "sand_dollars.award_subtitle": "เลือกนักเรียน กำหนดมูลค่า แล้วส่ง",
  "sand_dollars.no_house_yet": "{{name}} — ยังไม่มีบ้าน",
  "sand_dollars.remove_student_aria": "ลบ {{name}}",
  "sand_dollars.search_placeholder": "ค้นหาด้วยชื่อหรือชื่อเล่น…",
  "sand_dollars.reset_filters": "ล้างตัวกรอง",
  "sand_dollars.select_all_count": "เลือกทั้งหมด {{count}} คน",
  "sand_dollars.deselect_all": "ยกเลิกการเลือกทั้งหมด",
  "sand_dollars.select_all_grade": "เลือกทั้งหมด {{grade}}",
  "sand_dollars.student_count_one": "{{count}} คน",
  "sand_dollars.student_count_other": "{{count}} คน",
  "sand_dollars.selected_count": "เลือกแล้ว {{count}} คน",
  "sand_dollars.no_students_match": "ไม่พบนักเรียนที่ตรงกับตัวกรองนี้",
  "sand_dollars.value_label": "มูลค่า",
  "sand_dollars.no_categories_prompt": "กรุณาสร้างหมวดหมู่รางวัลก่อน",
  "sand_dollars.awarding": "กำลังมอบรางวัล…",
  "sand_dollars.award_count_one": "มอบแซนด์ดอลลาร์ {{count}} เหรียญ",
  "sand_dollars.award_count_other": "มอบแซนด์ดอลลาร์ {{count}} เหรียญ",
  "sand_dollars.note_placeholder": "บันทึกส่วนตัว (ไม่บังคับ เห็นเฉพาะคุณ)",
  "sand_dollars.toast_awarded_count_one": "มอบแซนด์ดอลลาร์ {{count}} เหรียญแล้ว",
  "sand_dollars.toast_awarded_count_other": "มอบแซนด์ดอลลาร์ {{count}} เหรียญแล้ว",
  "sand_dollars.toast_value_label": "มูลค่า: {{name}}",
  "sand_dollars.toast_award_failed": "มอบแซนด์ดอลลาร์ไม่สำเร็จ",
  "sand_dollars.all_awards_title": "รางวัลแซนด์ดอลลาร์ทั้งหมด",
  "sand_dollars.all_awards_subtitle": "เรียกดู กรอง และลบรางวัล (เฉพาะผู้ดูแลระบบ)",
  "sand_dollars.no_awards_match": "ไม่พบรางวัลที่ตรงกับตัวกรองนี้",
  "sand_dollars.from_placeholder": "จาก",
  "sand_dollars.to_placeholder": "ถึง",
  "sand_dollars.my_awards_only": "เฉพาะรางวัลของฉัน",
  "sand_dollars.item_label": "รางวัล",
  "sand_dollars.teacher_col": "ครู",
  "sand_dollars.auto_award.attendance_weekly": "จากการมาโรงเรียนครบสัปดาห์และตรงเวลา ({{period}})",
  "sand_dollars.auto_award.attendance_monthly": "จากการมาโรงเรียนครบเดือนและตรงเวลา ({{period}})",
  "sand_dollars.auto_award.attendance_weekly_name": "มาเรียนครบสัปดาห์ตรงเวลา",
  "sand_dollars.auto_award.attendance_monthly_name": "มาเรียนครบเดือนตรงเวลา",
  "sand_dollars.auto_award.filter_automatic": "อัตโนมัติ",
  "sand_dollars.auto_award.attendance_weekly_hint": "มอบเหรียญแซนด์ดอลลาร์ 1 เหรียญให้เด็กที่มาโรงเรียน ตรงเวลา และแตะบัตรที่ประตูครบทุกวันเรียนในสัปดาห์นั้น มอบให้ทุกเช้าวันศุกร์",
  "sand_dollars.auto_award.attendance_monthly_hint": "มอบเหรียญแซนด์ดอลลาร์ 1 เหรียญให้เด็กที่มาเรียนครบทั้งเดือนโดยไม่ขาดหรือมาสายแม้แต่ครั้งเดียว มอบให้ในวันที่ 1 ของเดือนถัดไป นอกเหนือจากรางวัลรายสัปดาห์ของเดือนนั้น",
  "sand_dollars.auto_award.min_school_days": "จำนวนวันเรียนขั้นต่ำในช่วงเวลานี้",
  "sand_dollars.auto_award.min_school_days_hint": "ช่วงเวลาที่สั้นกว่านี้ เช่น สัปดาห์ที่มีวันหยุดคั่นอยู่ จะถูกข้ามสำหรับทุกคน",
  "sand_dollars.auto_award.error_category_required": "เลือกหมวดหมู่ก่อนเปิดใช้งานรางวัลนี้",
  "sand_dollars.auto_award.error_min_days_number": "กรอกจำนวนวันเป็นจำนวนเต็ม",
  "sand_dollars.auto_award.run_label": "รันซ้ำสำหรับวันที่ในช่วงเวลานี้",
  "sand_dollars.auto_award.run_cta": "รัน",
  "sand_dollars.auto_award.run_result": "มอบเหรียญแซนด์ดอลลาร์ {{awarded}} เหรียญสำหรับ {{periodKey}}",
  "sand_dollars.auto_award.run_skipped": "ไม่ได้มอบรางวัล: {{reason}}",
  "sand_dollars.auto_award.skip_reason_disabled": "กฎนี้ถูกปิดใช้งานอยู่",
  "sand_dollars.auto_award.skip_reason_no_category": "ยังไม่ได้เลือกหมวดหมู่",
  "sand_dollars.auto_award.skip_reason_too_few_school_days": "ช่วงเวลานี้มีวันเรียนน้อยกว่าที่กำหนด",
  "sand_dollars.auto_award.skip_reason_year_not_writable": "ปีการศึกษานี้ถูกล็อกไม่ให้แก้ไข",
  "sand_dollars.select_category": "เลือกหมวดหมู่",
  "sand_dollars.private_note_col": "บันทึกส่วนตัว",
  "sand_dollars.delete_award_title": "ลบรางวัลนี้หรือไม่?",
  "sand_dollars.delete_award_description": "ยอดรวมของนักเรียนจะลดลง 1 การกระทำนี้ไม่สามารถย้อนกลับได้",
  "sand_dollars.stats_title": "สถิติแซนด์ดอลลาร์",
  "sand_dollars.stats_subtitle": "ภาพรวมโครงการ อัตราต่อระดับชั้น บ้าน กระดานผู้นำ และการให้รางวัลของบุคลากร",
  "sand_dollars.celebration_label": "การเฉลิมฉลอง",
  "sand_dollars.no_celebration_option": "ไม่มีการเฉลิมฉลอง (ใช้ช่วงเวลา)",
  "sand_dollars.scoped_to_celebration": "สถิติทั้งหมดอ้างอิงตามช่วงเวลาของการเฉลิมฉลองนี้",
  "sand_dollars.houses_totals_for": "บ้าน — ยอดรวมสำหรับ {{title}}",
  "sand_dollars.houses_totals_year": "บ้าน — ยอดรวมปีการศึกษานี้",
  "sand_dollars.unknown_house": "ไม่ทราบ",
  "sand_dollars.no_awards_yet": "ยังไม่มีรางวัล",
  "sand_dollars.house_race_title": "การแข่งขันระหว่างบ้านตามช่วงเวลา (รายเดือน)",
  "sand_dollars.not_enough_data": "ข้อมูลยังไม่เพียงพอ",
  "sand_dollars.leaderboard_title": "กระดานผู้นำ",
  "sand_dollars.period_today": "วันนี้",
  "sand_dollars.period_week": "สัปดาห์นี้",
  "sand_dollars.period_month": "เดือนนี้",
  "sand_dollars.period_year": "ปีการศึกษานี้",
  "sand_dollars.period_all": "ตลอดกาล",
  "sand_dollars.scope_overall": "โดยรวม",
  "sand_dollars.scope_house": "ตามบ้าน",
  "sand_dollars.scope_grade": "ตามระดับชั้น",
  "sand_dollars.no_awards_scope": "ยังไม่มีรางวัลในขอบเขตนี้",
  "sand_dollars.tab_celebrations": "การเฉลิมฉลอง",
  "sand_dollars.tab_attendance_awards": "รางวัลจากการเข้าเรียน",
  "sand_dollars.standings_fallback": "อันดับ",
  "sand_dollars.overall_top3": "อันดับสูงสุด 3 อันดับโดยรวม",
  "sand_dollars.by_house": "ตามบ้าน",
  "sand_dollars.by_grade": "ตามระดับชั้น",
  "sand_dollars.schoolwide_top_scorers": "ผู้ทำคะแนนสูงสุดของทั้งโรงเรียน",
  "sand_dollars.no_awards_period": "ไม่มีรางวัลในช่วงเวลานี้",
  "sand_dollars.tab_houses": "บ้าน",
  "houses.tab": "บ้าน",
  "houses.search_placeholder": "ค้นหานักเรียนหรือบุคลากร…",
  "houses.student_count_one": "นักเรียน {{count}} คน",
  "houses.student_count_other": "นักเรียน {{count}} คน",
  "houses.leaders": "ผู้นำบ้าน",
  "houses.captains": "กัปตันบ้าน · เกรด 5",
  "houses.council": "สภาบ้าน · เกรด 6–9",
  "houses.members": "สมาชิก · เกรด 1–4",
  "houses.none_yet": "ยังไม่มี",
  "houses.no_houses": "ยังไม่ได้ตั้งค่าบ้าน",
  "houses.edit_leaders": "แก้ไขผู้นำบ้าน",
  "houses.edit_leaders_for": "แก้ไขผู้นำบ้าน {{house}}",
  "houses.edit_leaders_title": "ผู้นำบ้าน {{house}}",
  "houses.leaders_label": "ผู้นำบ้าน",
  "houses.move_to": "ย้าย {{name}} ไปบ้านอื่น",
  "houses.no_house": "ไม่มีบ้าน",
  "houses.unplaced_title": "ยังไม่ได้อยู่บ้านใด",
  "houses.grade_not_set": "ยังไม่ได้ระบุระดับชั้น",
  "houses.everyone_placed": "นักเรียนทุกคนมีบ้านแล้ว",
  "houses.currently_in": "ปัจจุบันอยู่บ้าน {{house}}",
  "houses.move_failed": "เปลี่ยนบ้านไม่สำเร็จ",
  "sand_dollars.tab_categories": "หมวดหมู่",
  "sand_dollars.new_house_cta": "เพิ่มบ้านใหม่",
  "sand_dollars.new_category_cta": "เพิ่มหมวดหมู่ใหม่",
  "sand_dollars.new_celebration_cta": "เพิ่มการเฉลิมฉลองใหม่",
  "sand_dollars.config_subtitle": "บ้าน หมวดหมู่รางวัล และช่วงเวลาการเฉลิมฉลอง",
  "sand_dollars.error_title_required": "กรุณากรอกหัวข้อ",
  "sand_dollars.error_period_start_required": "กรุณาเลือกวันที่เริ่มต้น",
  "sand_dollars.error_period_end_required": "กรุณาเลือกวันที่สิ้นสุด",
  "sand_dollars.period_col": "ช่วงเวลา",
  "sand_dollars.status_archived": "เก็บถาวร",
  "sand_dollars.no_celebrations_yet": "ยังไม่มีการเฉลิมฉลอง สร้างรายการสำหรับเดือนนี้",
  "sand_dollars.edit_celebration": "แก้ไขการเฉลิมฉลอง",
  "sand_dollars.new_celebration": "การเฉลิมฉลองใหม่",
  "sand_dollars.field_period_start": "วันที่เริ่มต้นช่วงเวลา",
  "sand_dollars.field_period_end": "วันที่สิ้นสุดช่วงเวลา",
  "sand_dollars.field_notes": "หมายเหตุ (ไม่บังคับ)",
  "sand_dollars.field_end_time": "เวลาสิ้นสุดในวันสุดท้าย (ไม่บังคับ)",
  "sand_dollars.field_end_time_hint": "Sand Dollars ที่บันทึกหลังเวลานี้จะไม่นับ เพื่อให้ผลพร้อมสำหรับการเฉลิมฉลอง",
  "sand_dollars.field_minimum_dollars": "จำนวน Sand Dollars ขั้นต่ำ (ไม่บังคับ)",
  "sand_dollars.field_minimum_dollars_hint": "นักเรียนที่ได้รับอย่างน้อยจำนวนนี้ในช่วงเวลาดังกล่าวจะได้รับรางวัล",
  "sand_dollars.error_minimum_dollars": "กรอกจำนวนเต็มตั้งแต่ 1 ถึง 999 หรือเว้นว่างไว้",
  "sand_dollars.minimum_heading_one": "ขั้นต่ำ {{count}} Sand Dollars",
  "sand_dollars.minimum_heading_other": "ขั้นต่ำ {{count}} Sand Dollars",
  "sand_dollars.minimum_reached_one": "ถึงเกณฑ์ขั้นต่ำ ({{count}} คน)",
  "sand_dollars.minimum_reached_other": "ถึงเกณฑ์ขั้นต่ำ ({{count}} คน)",
  "sand_dollars.minimum_not_reached_one": "ยังไม่ถึงเกณฑ์ ({{count}} คน)",
  "sand_dollars.minimum_not_reached_other": "ยังไม่ถึงเกณฑ์ ({{count}} คน)",
  "sand_dollars.minimum_reached_status": "ถึงเกณฑ์",
  "sand_dollars.minimum_not_reached_status": "ยังไม่ถึงเกณฑ์",
  "sand_dollars.celebration_col_house": "บ้าน",
  "sand_dollars.celebration_col_dollars": "Sand Dollars",
  "sand_dollars.delete_celebration_title": "ลบการเฉลิมฉลอง \"{{title}}\" หรือไม่?",
  "sand_dollars.delete_celebration_description": "อันดับคำนวณจากรางวัลตามคำขอ การลบจะลบเฉพาะข้อมูลการเฉลิมฉลองเท่านั้น",
  "sand_dollars.error_name_required": "กรุณากรอกชื่อ",
  "sand_dollars.error_sort_order_number": "ลำดับการเรียงต้องเป็นตัวเลข",
  "sand_dollars.icon_col": "ไอคอน",
  "sand_dollars.sort_col": "ลำดับ",
  "sand_dollars.categories_empty": "ยังไม่มีหมวดหมู่ เพิ่มคุณค่าที่ต้องการเชิดชู",
  "sand_dollars.edit_category": "แก้ไขหมวดหมู่",
  "sand_dollars.new_category": "หมวดหมู่ใหม่",
  "sand_dollars.field_name": "ชื่อ",
  "sand_dollars.name_placeholder_category": "ความรับผิดชอบ",
  "sand_dollars.field_icon": "ไอคอน (ไม่บังคับ)",
  "sand_dollars.delete_category_title": "ลบหมวดหมู่ \"{{name}}\" หรือไม่?",
  "sand_dollars.delete_category_description": "รางวัลที่เชื่อมโยงกับหมวดหมู่นี้จะทำให้ไม่สามารถลบได้",
  "sand_dollars.houses_empty": "ยังไม่มีบ้าน สร้างบ้านทั้งสี่เพื่อเริ่มต้น",
  "sand_dollars.edit_house": "แก้ไขบ้าน",
  "sand_dollars.new_house": "บ้านใหม่",
  "sand_dollars.house_name_placeholder": "โลมา",
  "sand_dollars.delete_house_title": "ลบบ้าน \"{{name}}\" หรือไม่?",
  "sand_dollars.delete_house_description": "นักเรียนที่อยู่ในบ้านนี้จะทำให้ไม่สามารถลบได้ กรุณาย้ายนักเรียนออกก่อน",
  "house_points.title": "คะแนนบ้าน",
  "house_points.subtitle": "การปรับคะแนนด้วยตนเองสำหรับแต่ละบ้าน",
  "house_points.empty": "ยังไม่มีการปรับคะแนน",
  "house_points.item_label": "รายการปรับคะแนน",
  "house_points.adjust": "ปรับคะแนน {{house}}",
  "house_points.new_title": "ปรับคะแนน {{house}}",
  "house_points.edit_title": "แก้ไขการปรับคะแนน",
  "house_points.amount": "จำนวน (+ หรือ −)",
  "house_points.category": "หมวดหมู่",
  "house_points.category_placeholder": "เลือกหมวดหมู่",
  "house_points.note": "หมายเหตุ",
  "house_points.house": "บ้าน",
  "house_points.admin": "โดย",
  "house_points.delete_title": "ลบการปรับคะแนนนี้หรือไม่?",
  "house_points.delete_description": "การดำเนินการนี้จะลบรายการปรับคะแนนและอัปเดตยอดรวมของบ้าน",
  "house_points.error_amount_number": "จำนวนต้องเป็นตัวเลข",
  "house_points.error_amount_integer": "จำนวนต้องเป็นจำนวนเต็ม",
  "house_points.error_amount_nonzero": "จำนวนต้องไม่เป็นศูนย์",
  "house_points.error_amount_required": "กรุณากรอกจำนวน",
  "house_points.error_category_required": "กรุณาเลือกหมวดหมู่",
  "house_points.error_date_required": "กรุณาเลือกวันที่",
  "house_points.breakdown": "{{students}} คะแนนจากนักเรียน, {{adjustments}} จากการปรับคะแนน",
  "common.name": "ชื่อ",
  "common.code": "รหัส",
  "common.sort": "ลำดับ",
  "common.error_name_required": "กรุณากรอกชื่อ",
  "common.weekday_short.mon": "จ.",
  "common.weekday_short.tue": "อ.",
  "common.weekday_short.wed": "พ.",
  "common.weekday_short.thu": "พฤ.",
  "common.weekday_short.fri": "ศ.",
  "common.weekday_short.sat": "ส.",
  "timetable.edp_tile_label": "EDP",
  "common.weekday_full.mon": "วันจันทร์",
  "common.weekday_full.tue": "วันอังคาร",
  "common.weekday_full.wed": "วันพุธ",
  "common.weekday_full.thu": "วันพฤหัสบดี",
  "common.weekday_full.fri": "วันศุกร์",
  "common.kind_lesson": "คาบเรียน",
  "common.kind_break": "พัก",
  "common.kind_activity": "กิจกรรม",
  "common.close": "ปิด",
  "common.dismiss_note": "ซ่อนคำแนะนำนี้",
  "common.navigation_menu": "เมนูนำทาง",
  "icon_picker.no_icon": "ไม่มีไอคอน",
  "icon_picker.none": "ไม่มี",
  "color_picker.use_color": "ใช้สี {{color}}",
  "color_picker.custom_color": "สีกำหนดเอง",
  "timetable.col_slots": "ช่วงเวลา",
  "timetable.slot_count_one": "{{count}} ช่วงเวลา",
  "timetable.slot_count_other": "{{count}} ช่วงเวลา",
  "timetable.special_schedules_empty": "ยังไม่มีตารางพิเศษ เพิ่มรายการแรกเพื่อเริ่มต้น",
  "timetable.new_special_schedule": "ตารางพิเศษใหม่",
  "timetable.short_day_placeholder": "วันเรียนสั้น",
  "timetable.start_from_normal_schedule_label": "เริ่มจากตารางเรียนปกติ",
  "timetable.start_from_normal_schedule_desc": "สร้างช่วงเวลาให้หนึ่งช่วงต่อหนึ่งคาบที่ใช้งานอยู่จากแท็บตารางเวลาเรียน คุณเพียงปรับเวลาเท่านั้น",
  "timetable.edit_special_schedule_named": "แก้ไข \"{{name}}\"",
  "timetable.edit_special_schedule": "แก้ไขตารางพิเศษ",
  "timetable.duplicate_default_schedule_button": "ทำซ้ำตารางเรียนปกติ",
  "timetable.col_start": "เริ่ม",
  "timetable.col_end": "สิ้นสุด",
  "timetable.col_kind": "ประเภท",
  "timetable.midday_swap_role": "บทบาทการสลับช่วงกลางวัน",
  "timetable.period_weekdays": "มีในวัน",
  "timetable.period_weekdays_hint": "วันในสัปดาห์ที่มีคาบนี้ หากไม่เลือกวันใด คาบนี้จะหายไปจากตารางเรียนและจากเสียงออดของวันนั้น",
  "timetable.error_weekdays_required": "เลือกอย่างน้อยหนึ่งวัน",
  "timetable.midday_lunch": "มื้อกลางวัน",
  "timetable.midday_lesson": "คาบเรียน",
  "timetable.col_linked_period": "คาบที่เชื่อมโยง",
  "timetable.col_remove": "ลบ",
  "timetable.no_linked_period": "— ไม่มี (อิสระ/กิจกรรม) —",
  "timetable.period_placeholder": "คาบที่ 1",
  "timetable.remove_slot_aria": "ลบช่วงเวลา",
  "timetable.slots_empty": "ยังไม่มีช่วงเวลา เพิ่มช่วงเวลาหรือทำซ้ำตารางเรียนปกติ",
  "timetable.add_slot_button": "เพิ่มช่วงเวลา",
  "timetable.duplicate_confirm_title": "ทำซ้ำตารางเรียนปกติหรือไม่?",
  "timetable.duplicate_confirm_description": "การดำเนินการนี้จะแทนที่รายการช่วงเวลาด้านล่างด้วยหนึ่งช่วงเวลาต่อหนึ่งคาบที่ใช้งานอยู่ กดบันทึกเพื่อเก็บการเปลี่ยนแปลง",
  "timetable.duplicate_confirm_label": "ทำซ้ำ",
  "timetable.delete_special_schedule_title": "ลบตารางพิเศษ \"{{name}}\" หรือไม่?",
  "timetable.delete_special_schedule_description": "การดำเนินการนี้จะลบตารางและช่วงเวลาทั้งหมดอย่างถาวร",
  "timetable.error_start_time_required": "กรุณาระบุเวลาเริ่ม",
  "timetable.error_end_time_required": "กรุณาระบุเวลาสิ้นสุด",
  "timetable.col_period": "คาบ",
  "timetable.field_start_time": "เวลาเริ่ม",
  "timetable.field_end_time": "เวลาสิ้นสุด",
  "timetable.edit_period": "แก้ไขคาบเรียน",
  "timetable.new_period": "คาบเรียนใหม่",
  "timetable.delete_period_title": "ลบคาบเรียน \"{{name}}\" หรือไม่?",
  "timetable.delete_period_description": "การดำเนินการนี้จะลบคาบเรียนอย่างถาวร",
  "timetable.periods_empty": "ยังไม่มีคาบเรียน เพิ่มคาบเรียนเพื่อเริ่มต้น",
  "timetable.col_grade": "ระดับชั้น",
  "timetable.col_homeroom_teacher": "ครูประจำชั้น",
  "timetable.badge_per_period": "รายคาบ",
  "timetable.badge_temperature": "อุณหภูมิ",
  "timetable.ensure_one_class_per_grade_button": "สร้างชั้นเรียนให้ครบทุกระดับ",
  "timetable.ensure_one_class_per_grade_tooltip": "สร้างชั้นเรียนหนึ่งห้องต่อหนึ่งระดับชั้นที่มีนักเรียนที่ใช้งานอยู่ สำหรับปีการศึกษาที่เลือก สามารถเรียกใช้ซ้ำได้อย่างปลอดภัย ระบบจะไม่สร้างซ้ำ",
  "timetable.select_school_year_placeholder": "เลือกปีการศึกษา",
  "timetable.class_name_placeholder": "ป.6/1",
  "timetable.field_grade_level": "ระดับชั้น",
  "timetable.select_grade_placeholder": "เลือกระดับชั้น",
  "timetable.field_homeroom_teacher": "ครูประจำชั้น",
  "timetable.field_assistant_teachers": "ครูผู้ช่วย",
  "timetable.assistant_teachers_hint": "ครูผู้ช่วยดูสมุดพกของห้องนี้ได้ (ทั้งระดับปฐมวัยและประถมศึกษาปีที่ 1 ขึ้นไป) แต่แก้ไขไม่ได้",
  "timetable.assistant_teachers_placeholder": "ค้นหาเจ้าหน้าที่…",
  "timetable.assistant_teachers_empty": "ไม่พบเจ้าหน้าที่",
  "timetable.field_homeroom_room": "ห้องประจำชั้น",
  "timetable.none_placeholder": "— ไม่มี —",
  "timetable.field_per_period_attendance": "การเช็คชื่อรายคาบ",
  "timetable.per_period_attendance_tooltip": "เมื่อเปิดใช้งาน ครูจะเช็คชื่อชั้นเรียนนี้ทุกคาบ (ใน 'ชั้นเรียนของฉันวันนี้') ไม่ใช่แค่วันละครั้ง เปิดใช้สำหรับชั้นเรียนที่นักเรียนย้ายระหว่างครูผู้สอน (โดยปกติคือมัธยม) ปิดไว้สำหรับชั้นเล็ก",
  "timetable.lunch_group": "กลุ่มมื้อกลางวัน",
  "timetable.lunch_none": "ไม่มี",
  "timetable.lunch_first": "มื้อแรก (11:35)",
  "timetable.lunch_second": "มื้อสอง (12:25)",
  "timetable.field_temperature_tracking": "การบันทึกอุณหภูมิ",
  "timetable.temperature_tracking_tooltip": "เมื่อเปิดใช้งาน ชั้นเรียนนี้จะปรากฏในขั้นตอนการตรวจวัดอุณหภูมิ เพื่อให้เจ้าหน้าที่บันทึกอุณหภูมิของนักเรียนได้",
  "timetable.edit_class": "แก้ไขชั้นเรียน",
  "timetable.new_class": "ชั้นเรียนใหม่",
  "timetable.delete_class_title": "ลบชั้นเรียน \"{{name}}\" หรือไม่?",
  "timetable.delete_class_description": "การดำเนินการนี้จะลบชั้นเรียนอย่างถาวร ชั้นเรียนที่มีการเช็กชื่อหรือบันทึกอื่นแล้วจะลบไม่ได้ ให้ปิดการใช้งานแทน",
  "timetable.classes_empty_with_year": "ยังไม่มีชั้นเรียน เพิ่มชั้นเรียนหรือกด \"สร้างชั้นเรียนให้ครบทุกระดับ\"",
  "timetable.classes_empty_no_year": "เลือกปีการศึกษาเพื่อดูชั้นเรียน",
  "timetable.error_grade_level_required": "กรุณาเลือกระดับชั้น",
  "timetable.col_subject": "วิชา",
  "timetable.subject_name_placeholder": "คณิตศาสตร์",
  "timetable.subject_code_placeholder": "MATH",
  "timetable.edit_subject": "แก้ไขวิชา",
  "timetable.new_subject": "วิชาใหม่",
  "timetable.delete_subject_title": "ลบวิชา \"{{name}}\" หรือไม่?",
  "timetable.delete_subject_description": "การดำเนินการนี้จะลบวิชาอย่างถาวร",
  "timetable.subjects_empty": "ยังไม่มีวิชา เพิ่มวิชาเพื่อเริ่มต้น",
  "timetable.room_name_placeholder": "ห้องวิทยาศาสตร์",
  "timetable.room_code_placeholder": "R-SCI",
  "timetable.edit_room": "แก้ไขห้อง",
  "timetable.new_room": "ห้องใหม่",
  "timetable.delete_room_title": "ลบห้อง \"{{name}}\" หรือไม่?",
  "timetable.delete_room_description": "การดำเนินการนี้จะลบห้องอย่างถาวร",
  "timetable.rooms_empty": "ยังไม่มีห้อง เพิ่มห้องเพื่อเริ่มต้น",
  "timetable.label_class": "ชั้นเรียน",
  "timetable.label_teacher": "ครู",
  "timetable.label_room": "ห้อง",
  "timetable.label_bookable": "จองได้",
  "timetable.entity_word_class": "ชั้นเรียน",
  "timetable.entity_word_teacher": "ครู",
  "timetable.entity_word_room": "ห้อง",
  "timetable.entity_word_classes": "ชั้นเรียน",
  "timetable.entity_word_teachers": "ครู",
  "timetable.entity_word_rooms": "ห้อง",
  "timetable.entity_fallback": "รายการ",
  "timetable.field_assistants": "ผู้ช่วยสอน",
  "timetable.assistants_hint": "(โดยปกติ 1–2 คน)",
  "timetable.add_assistant_placeholder": "เพิ่มผู้ช่วยสอน…",
  "timetable.remove_assistant_aria": "ลบ {{name}}",
  "timetable.conflict_teacher": "ครูท่านนี้ถูกมอบหมายให้ชั้น {{className}} ในเวลาเดียวกันด้วย",
  "timetable.conflict_room": "ห้องนี้ถูกจองโดยชั้น {{className}} ในเวลาเดียวกันด้วย",
  "timetable.tab_classes": "ชั้นเรียน",
  "timetable.tab_rooms": "ห้องเรียน",
  "timetable.tab_subjects": "วิชา",
  "timetable.tab_bell_schedule": "ตารางเวลาเรียน",
  "timetable.tab_special_schedules": "ตารางพิเศษ",
  "timetable.tab_teacher_rooms": "ห้องประจำครู",
  "timetable.new_class_button": "เพิ่มชั้นเรียน",
  "timetable.new_room_button": "เพิ่มห้องเรียน",
  "timetable.new_subject_button": "เพิ่มวิชา",
  "timetable.new_period_button": "เพิ่มคาบเรียน",
  "timetable.new_special_schedule_button": "เพิ่มตารางพิเศษ",
  "timetable.breadcrumb_setup": "ตั้งค่า",
  "timetable.col_role": "บทบาท",
  "timetable.col_default_room": "ห้องประจำ",
  "timetable.teacher_rooms_empty": "ยังไม่มีบุคลากรที่เป็นครู",
  "timetable.setup_subtitle": "ห้องเรียน วิชา และการตั้งค่าตารางเรียนอื่น ๆ",
  "timetable.setup_help_note": "ตั้งค่าองค์ประกอบพื้นฐานของตารางเรียน: <strong>ชั้นเรียน</strong> (หนึ่งห้องต่อระดับชั้น — ใช้ \"สร้างชั้นเรียนให้ครบทุกระดับ\"), <strong>วิชา</strong>, <strong>ห้องเรียน</strong>, และ <strong>ตารางเวลาเรียน</strong> (เวลาแต่ละคาบ ใช้ร่วมกันทุกชั้นเรียน)",
  "timetable.grid_subtitle_default": "เลือกชั้นเรียนเพื่อดูและแก้ไขตารางเรียนประจำสัปดาห์",
  "timetable.grid_help_note": "สร้างตารางเรียนประจำสัปดาห์ของแต่ละชั้น: เลือกชั้นเรียน แล้วคลิกช่องคาบเรียนเพื่อกำหนด <strong>วิชา ครูผู้สอน และห้องเรียน</strong> แถวพัก อาหารกลางวัน และโฮมรูมจะครอบคลุมทั้งสัปดาห์ สำหรับชั้นเรียนที่มี <strong>การเช็คชื่อรายคาบ</strong> ตารางนี้จะเป็นตัวกำหนดคาบเรียนและรายชื่อของครูแต่ละคน",
  "timetable.col_time": "เวลา",
  "timetable.lessons_per_week": "จำนวนคาบต่อสัปดาห์",
  "timetable.lessons_total": "รวม {{count}} คาบ",
  "timetable.no_periods_configured": "ยังไม่มีการตั้งค่าคาบเรียน เพิ่มคาบเรียนได้ที่ตั้งค่าตารางเรียน → ตารางเวลาเรียน",
  "timetable.no_lessons_scheduled": "ไม่มีคาบเรียนที่กำหนดไว้",
  "timetable.add_cell_label": "+ เพิ่ม",
  "timetable.tbn": "TBN",
  "timetable.assistant_plus_name": "+ {{name}}",
  "timetable.assistant_plus_count": "+ ผู้ช่วยสอน {{count}} คน",
  "timetable.field_school_year": "ปีการศึกษา",
  "timetable.select_year_placeholder": "เลือกปี…",
  "timetable.field_view_by": "ดูตาม",
  "timetable.select_class_placeholder": "เลือกชั้นเรียน…",
  "timetable.select_teacher_placeholder": "เลือกครู…",
  "timetable.select_room_placeholder": "เลือกห้อง…",
  "timetable.view_subtitle_default": "เลือกปีการศึกษาและรายการที่ต้องการดูตาราง",
  "timetable.view_select_prompt": "เลือกปีการศึกษาและ{{entity}}เพื่อดูตาราง",
  "timetable.print_all_button": "พิมพ์ทั้งหมด {{entity}}",
  "timetable.view_help_note": "ตารางเดียวกันแสดงได้สามแบบ — สลับ <strong>ดูตาม</strong> ห้องเรียน ครู หรือห้อง กด <strong>พิมพ์</strong> เพื่อพิมพ์สิ่งที่กำลังดู หรือ <strong>พิมพ์ทั้งหมด</strong> เพื่อพิมพ์ทุกห้องเรียน ครู หรือห้องในครั้งเดียว หากมีสิทธิ์จัดการตารางสอน สามารถคลิกช่องในมุมมองห้องเรียนเพื่อแก้ไขได้",
  "attendance.status.present": "มา",
  "attendance.status.absent": "ขาด",
  "attendance.status.late": "สาย",
  "attendance.status.late_excused": "มาสาย (ได้รับอนุญาต)",
  "attendance.status.excused": "ได้รับอนุญาต",
  "attendance.status.suspended": "พักการเรียน",
  "attendance.col_day_status": "วันนี้",
  "attendance.status_unmarked": "ยังไม่ได้เช็คชื่อ",
  "attendance.status_not_marked": "ยังไม่บันทึก",
  "attendance.col_id": "รหัส",
  "attendance.col_grade_role": "เกรด / บทบาท",
  "attendance.col_mark": "ทำเครื่องหมาย",
  "attendance.col_check_in": "เวลาเข้า",
  "attendance.col_check_out": "เวลาออก",
  "attendance.col_note": "หมายเหตุ",
  "attendance.auto_from_door": "อัตโนมัติ (ประตู)",
  "attendance.last_seen": "พบล่าสุดเวลา {{time}}",
  "attendance.check_in_tooltip": "เวลาเข้าจะกรอกให้อัตโนมัติจากข้อมูลแตะบัตรที่ประตู โดยมีป้าย “อัตโนมัติ (ประตู)” กำกับ หากพิมพ์เวลาเองระบบจะแทนที่ค่าเดิมและถือเป็นการบันทึกด้วยตนเอง",
  "attendance.check_out_tooltip": "เวลาออกก็กรอกให้อัตโนมัติเช่นกัน แต่จะทำเฉพาะช่วงบ่าย และหลังจากไม่มีการแตะบัตรอีกประมาณ 1 ชั่วโมง เพื่อไม่ให้การออกไปช่วงสั้น ๆ ถูกเข้าใจผิดว่าออกจากโรงเรียนแล้ว ก่อนหน้านั้น “พบล่าสุดเวลา” จะแสดงเวลาที่แตะบัตรครั้งล่าสุด ซึ่งยังไม่ใช่การยืนยันว่าออกจากโรงเรียน หากพิมพ์เวลาเองระบบจะแทนที่ค่าเดิมและถือเป็นการบันทึกด้วยตนเอง",
  "attendance.subtitle": "บันทึกการเข้าเรียนประจำวันสำหรับนักเรียนและเจ้าหน้าที่",
  "attendance.non_school_day_banner": "<strong>{{date}}</strong> ไม่ใช่วันเรียน ไม่สามารถบันทึกการเข้าเรียนได้",
  "attendance.unmarked_count": "ยังไม่บันทึก {{count}} คน",
  "common.view_all": "ดูทั้งหมด",
  "students.attendance_title": "การเข้าเรียน",
  "students.attendance_summary": "มา {{present}} · ขาด {{absent}} · สาย {{late}} จาก {{days}} วันเรียน",
  "students.attendance_empty": "ไม่มีบันทึกการเข้าเรียนในช่วงนี้",
  "students.attendance_load_more": "ดูสัปดาห์ก่อนหน้า",
  "attendance.all_periods": "ทุกคาบ",
  "attendance.no_lesson": "ไม่มีคาบเรียน",
  "attendance.marked_label": "เช็คแล้ว",
  "attendance.unmarked_tooltip_title": "ยังไม่ได้เช็คชื่อ",
  "common.and_n_more": "และอีก {{count}} คน",
  "attendance.label_role": "บทบาท",
  "attendance.role_students": "นักเรียน",
  "attendance.label_grade": "เกรด",
  "attendance.search_by_name_placeholder": "ค้นหาด้วยชื่อ…",
  "attendance.daily_help_note": "บันทึกการเข้าเรียนประจำวัน ในวัน<strong>“เฉพาะเจ้าหน้าที่”</strong>นักเรียนจะไม่ปรากฏ ส่วนวันที่อยู่ใน<strong>รอบเรียนฤดูหนาว/ฤดูร้อน</strong>จะแสดงเฉพาะผู้ที่ลงทะเบียนไว้เท่านั้น",
  "attendance.error_mark_failed": "บันทึกการเข้าเรียนไม่สำเร็จ",
  "attendance.toast_marked_as": "บันทึก {{name}} เป็น {{status}} แล้ว",
  "attendance.toast_saved_for": "บันทึกข้อมูลของ {{name}} แล้ว",
  "attendance.error_save_failed": "บันทึกไม่สำเร็จ",
  "attendance.error_temp_failed": "บันทึกอุณหภูมิไม่สำเร็จ",
  "attendance.note_placeholder": "เพิ่มหมายเหตุ…",
  "attendance.marked_by": "โดย {{name}}",
  "attendance.temp_placeholder": "°C",
  "attendance.empty_no_roster": "ไม่พบรายชื่อ",
  "attendance.empty_select_date": "เลือกวันที่เพื่อโหลดข้อมูลการเข้าเรียน",
  "attendance.sessions_title": "รอบเรียนการเข้าเรียน",
  "attendance.sessions_subtitle": "จัดการรอบเรียนฤดูหนาวและฤดูร้อน การสร้างรอบเรียนจะเปิดวันธรรมดาของรอบเรียนนั้นในปฏิทินการเข้าเรียนโดยอัตโนมัติ",
  "attendance.error_school_year_required": "กรุณาเลือกปีการศึกษา",
  "attendance.error_kind_required": "กรุณาเลือกประเภท",
  "attendance.kind_summer": "ฤดูร้อน",
  "attendance.kind_winter": "ฤดูหนาว",
  "attendance.session_edit_title": "แก้ไขรอบเรียน",
  "attendance.new_session": "รอบเรียนใหม่",
  "attendance.toast_session_updated": "อัปเดตรอบเรียนแล้ว",
  "attendance.toast_session_created": "สร้างรอบเรียนแล้ว",
  "attendance.error_session_save_failed": "บันทึกรอบเรียนไม่สำเร็จ",
  "attendance.label_school_year": "ปีการศึกษา",
  "attendance.label_kind": "ประเภท",
  "attendance.select_kind_placeholder": "เลือกประเภท",
  "attendance.session_name_placeholder": "เช่น โรงเรียนภาคฤดูร้อน 2027",
  "attendance.col_start_date": "วันที่เริ่มต้น",
  "attendance.col_end_date": "วันที่สิ้นสุด",
  "attendance.status_active": "ใช้งานอยู่",
  "attendance.status_inactive": "ไม่ใช้งาน",
  "attendance.save_changes": "บันทึกการเปลี่ยนแปลง",
  "attendance.create_session": "สร้างรอบเรียน",
  "attendance.sessions_help_note": "<strong>รอบเรียน</strong>ใช้สำหรับโปรแกรมพิเศษที่จัดนอกปีการศึกษาปกติ — โรงเรียนภาคฤดูหนาวและภาคฤดูร้อน ในช่วงวันที่ของรอบเรียน ระบบจะบันทึกการเข้าเรียน<strong>เฉพาะนักเรียนและเจ้าหน้าที่ที่ลงทะเบียนไว้</strong>เท่านั้น ปีการศึกษาปกติไม่จำเป็นต้องมีรอบเรียน",
  "attendance.tooltip_manage_enrollments": "จัดการการลงทะเบียน",
  "attendance.tooltip_edit_session": "แก้ไขรอบเรียน",
  "attendance.tooltip_delete_session": "ลบรอบเรียน",
  "attendance.empty_sessions": "ไม่พบรอบเรียนสำหรับปีการศึกษานี้",
  "attendance.delete_session_title": "ลบรอบเรียน",
  "attendance.delete_session_description": "คุณแน่ใจหรือไม่ว่าต้องการลบ \"{{name}}\"? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "attendance.toast_session_deleted": "ลบรอบเรียนแล้ว",
  "attendance.error_delete_session_failed": "ลบรอบเรียนไม่สำเร็จ",
  "attendance.toast_exception_saved": "บันทึกข้อยกเว้นแล้ว",
  "attendance.error_exception_save_failed": "บันทึกข้อยกเว้นไม่สำเร็จ",
  "attendance.add_exception_heading": "เพิ่ม / แก้ไขข้อยกเว้น",
  "attendance.add_exception": "เพิ่มวันยกเว้น",
  "attendance.calendar_kind_open": "เปิด",
  "attendance.calendar_kind_closed": "ปิด",
  "attendance.label_audience": "กลุ่มเป้าหมาย",
  "attendance.audience_tooltip": "ใครเข้าร่วมในวันนี้: ทั้งหมด = นักเรียนและเจ้าหน้าที่; เฉพาะเจ้าหน้าที่ = เจ้าหน้าที่เท่านั้น (ไม่มีนักเรียน); เฉพาะนักเรียน = นักเรียนเท่านั้น",
  "attendance.select_audience_placeholder": "เลือกกลุ่มเป้าหมาย",
  "attendance.audience_staff_only": "เฉพาะเจ้าหน้าที่",
  "attendance.audience_students_only": "เฉพาะนักเรียน",
  "attendance.label_special_schedule": "ตารางเวลาพิเศษ",
  "attendance.special_schedule_tooltip": "กำหนดตารางเวลากระดิ่งรูปแบบพิเศษให้กับวันที่นี้ เช่น ตารางเวลาย่อสำหรับวันสอบหรือวันประชุม",
  "attendance.select_schedule_placeholder": "เลือกตารางเวลา",
  "attendance.none_option": "— ไม่มี —",
  "attendance.label_optional": "ป้ายกำกับ (ไม่บังคับ)",
  "attendance.label_placeholder_example": "เช่น วันหยุดราชการ, วันกีฬาสี",
  "attendance.save_exception": "บันทึกข้อยกเว้น",
  "attendance.toast_exception_removed": "ลบข้อยกเว้นแล้ว",
  "attendance.error_exception_remove_failed": "ลบข้อยกเว้นไม่สำเร็จ",
  "attendance.col_date_iso": "วันที่ (ISO)",
  "attendance.col_scope": "ขอบเขต",
  "attendance.col_label": "ป้ายกำกับ",
  "attendance.tooltip_remove_exception": "ลบข้อยกเว้น",
  "attendance.confirm_remove_exception_description": "ลบข้อยกเว้นปฏิทินของวันที่ {{date}} หรือไม่ วันดังกล่าวจะกลับไปใช้ตารางปกติ",
  "attendance.school_calendar_subtitle": "แก้ไขพฤติกรรมปกติของวันธรรมดา/วันหยุดสุดสัปดาห์ เพิ่มข้อยกเว้น<strong>เปิด</strong>เพื่อกำหนดให้วันหยุดสุดสัปดาห์เป็นวันเรียน หรือข้อยกเว้น<strong>ปิด</strong>เพื่อกำหนดให้วันธรรมดาเป็นวันที่ไม่มีการเรียน (เช่น วันหยุดราชการ)",
  "attendance.school_calendar_help_note": "กำหนดข้อยกเว้นให้กับตารางปกติวันจันทร์–ศุกร์ <strong>ปิด</strong> = วันหยุด (ไม่มีการบันทึกการเข้าเรียนสำหรับทุกคน) <strong>เปิด + “เฉพาะเจ้าหน้าที่”</strong> = วันเตรียมการของครู/เจ้าหน้าที่: เจ้าหน้าที่เช็คอินแต่นักเรียนจะไม่ปรากฏ (เช่น สัปดาห์ก่อนนักเรียนเปิดเทอม) <strong>เปิด + “ทั้งหมด”</strong> คือวันเรียนปกติ",
  "attendance.label_from": "จาก",
  "attendance.label_to": "ถึง",
  "attendance.empty_calendar_exceptions": "ไม่มีข้อยกเว้นปฏิทินในช่วงวันที่นี้",
  "attendance.report_subtitle": "ดูตารางการเข้าเรียนสำหรับช่วงวันที่ที่กำหนด",
  "attendance.export_xlsx": "ส่งออก .xlsx",
  "attendance.no_record": "ไม่มีข้อมูล",
  "attendance.empty_no_report_data": "ไม่มีข้อมูลการเข้าเรียนสำหรับช่วงเวลานี้",
  "attendance.empty_select_range_report": "เลือกช่วงวันที่เพื่อโหลดรายงาน",
  "attendance.daily_total": "รวมรายวัน",
  "attendance.search_student_placeholder": "ค้นหานักเรียนด้วยชื่อหรือชื่อเล่น…",
  "attendance.no_matching_students": "ไม่พบนักเรียนที่ตรงกัน",
  "attendance.all_students_enrolled": "นักเรียนที่ยังเรียนอยู่ทั้งหมดลงทะเบียนแล้ว",
  "attendance.toast_enrolled": "ลงทะเบียน {{name}} แล้ว",
  "attendance.error_already_enrolled": "ลงทะเบียนไว้แล้ว",
  "attendance.error_enroll_failed": "ลงทะเบียนไม่สำเร็จ",
  "attendance.search_staff_placeholder": "ค้นหาเจ้าหน้าที่ด้วยชื่อหรืออีเมล…",
  "attendance.no_matching_staff": "ไม่พบเจ้าหน้าที่ที่ตรงกัน",
  "attendance.all_staff_enrolled": "เจ้าหน้าที่ทั้งหมดลงทะเบียนแล้ว",
  "attendance.tooltip_remove_from_session": "นำออกจากรอบเรียน",
  "attendance.enrollments_title": "การลงทะเบียน — {{name}}",
  "attendance.enrollment_help_note": "เพิ่ม<strong>นักเรียนและเจ้าหน้าที่</strong>ที่เข้าร่วมรอบเรียนนี้ ใช้ตัวสลับ<strong>นักเรียน / เจ้าหน้าที่</strong>เพื่อค้นหาในแต่ละรายชื่อ ระบบจะติดตามการเข้าเรียนเฉพาะผู้ที่ลงทะเบียนไว้ในช่วงวันที่ของรอบเรียนนี้เท่านั้น",
  "attendance.enrolled_count": "ลงทะเบียนแล้ว ({{count}})",
  "attendance.no_one_enrolled": "ยังไม่มีผู้ลงทะเบียน",
  "attendance.toast_person_removed": "นำบุคคลออกจากรอบเรียนแล้ว",
  "attendance.error_remove_failed": "นำออกไม่สำเร็จ",
  "attendance.toast_all_marked_present": "บันทึกนักเรียนทั้งหมดเป็นมาเรียนแล้ว",
  "attendance.confirm_register": "ยืนยันการเช็คชื่อวันนี้ ({{count}})",
  "attendance.toast_register_confirmed": "ทำเครื่องหมาย {{count}} คนจากการเช็คชื่อวันนี้",
  "attendance.mark_all_present": "บันทึกมาเรียนทั้งหมด",
  "attendance.marked_footer": "บันทึกแล้ว {{marked}} / {{total}} คน",
  "attendance.missed.lessons_one": "{{count}} คาบ",
  "attendance.missed.lessons_other": "{{count}} คาบ",
  "attendance.missed.teacher_one": "ขาดเรียน {{count}} คาบ",
  "attendance.missed.teacher_other": "ขาดเรียน {{count}} คาบ",
  "attendance.missed.reported_absence_one": "ผู้ปกครองแจ้งลา {{count}} คาบ",
  "attendance.missed.reported_absence_other": "ผู้ปกครองแจ้งลา {{count}} คาบ",
  "attendance.missed.late_arrival_one": "มาสาย {{count}} คาบ",
  "attendance.missed.late_arrival_other": "มาสาย {{count}} คาบ",
  "attendance.missed.lesson_excusal_one": "ได้รับยกเว้นคาบเรียน {{count}} คาบ",
  "attendance.missed.lesson_excusal_other": "ได้รับยกเว้นคาบเรียน {{count}} คาบ",
  "attendance.missed.suspension_one": "พักการเรียน {{count}} คาบ",
  "attendance.missed.suspension_other": "พักการเรียน {{count}} คาบ",
  "attendance.missed.early_dismissal_one": "กลับก่อนเวลา {{count}} คาบ",
  "attendance.missed.early_dismissal_other": "กลับก่อนเวลา {{count}} คาบ",
  "attendance.mark_source.absence": "แจ้งลา",
  "attendance.mark_source.lateArrival": "มาสาย",
  "attendance.mark_source.earlyDismissal": "กลับก่อนเวลา",
  "attendance.mark_source.lessonExcusal": "ยกเว้นคาบเรียน",
  "attendance.mark_source.suspension": "พักการเรียน",
  "attendance.history_title": "ประวัติการเข้าเรียน",
  "attendance.history_subtitle": "ประวัติการเข้าเรียนรายบุคคลสำหรับช่วงเวลาที่เลือก",
  "attendance.rate_label": "อัตรา ({{days}} วัน)",
  "attendance.empty_no_records": "ไม่มีข้อมูลสำหรับช่วงเวลานี้",
  "attendance.empty_select_range_history": "เลือกช่วงวันที่เพื่อโหลดประวัติ",
  "attendance.marked_ratio": "บันทึกแล้ว {{marked}}/{{total}}",
  "attendance.my_classes_help_note": "คาบเรียนที่คุณมีตารางสอนในวันนี้ บันทึกการเข้าเรียนทีละคาบ แตะสถานะซ้ำเพื่อเปลี่ยนค่า ห้องเรียนที่เช็กชื่อวันละครั้งจะแสดงไว้เพื่อดูข้อมูลเท่านั้น",
  "attendance.no_marking_needed": "ไม่ต้องเช็กชื่อ",
  "attendance.lesson_assistants_one": "ผู้ช่วยครู:",
  "attendance.lesson_assistants_other": "ผู้ช่วยครู:",
  "attendance.no_classes_title": "ไม่มีคาบเรียนในวันนี้",
  "attendance.no_classes_description": "{{date}} ไม่มีคาบเรียนที่กำหนดไว้สำหรับบัญชีของคุณ หรือไม่ใช่วันเรียน",
  "attendance.my_classes_subtitle": "บันทึกการเข้าเรียนรายคาบสำหรับชั้นเรียนของคุณ",
  "attendance.period_admin_subtitle": "ดูหรือแก้ไขการเข้าเรียนรายคาบของชั้นเรียนใด ๆ",
  "attendance.label_period": "คาบเรียน",
  "attendance.select_period_placeholder": "เลือกคาบเรียน…",
  "attendance.select_class_period_date": "เลือกชั้นเรียน คาบเรียน และวันที่เพื่อดูหรือบันทึกการเข้าเรียน",
  "directory.title": "ทำเนียบนักเรียน",
  "directory.subtitle": "ดูข้อมูลนักเรียน อาการแพ้ และบ้าน (สำหรับดูอย่างเดียว)",
  "directory.search_placeholder": "ค้นหานักเรียน",
  "directory.search_aria": "ค้นหานักเรียนตามชื่อ",
  "directory.empty": "ไม่พบนักเรียน",
  "directory.sand_dollars_col": "แซนด์ดอลลาร์",
  "directory.allergy_col": "อาการแพ้",
  "directory.restriction_badge": "ข้อจำกัดด้านอาหาร",
  "directory.back": "กลับไปที่ทำเนียบนักเรียน",
  "directory.details_title": "รายละเอียด",
  "directory.no_parents": "ไม่มีข้อมูลผู้ปกครอง",
  "directory.no_share": "ห้ามเผยแพร่ภาพลงสื่อสังคมออนไลน์",
  "cafeteria.title": "โรงอาหาร",
  "cafeteria.subtitle": "จัดการเครื่องดื่ม ขนม และราคา",
  "cafeteria.tabs.label": "ส่วนต่าง ๆ ของโรงอาหาร",
  "cafeteria.tabs.menu": "เมนู",
  "cafeteria.tabs.sales": "ยอดขาย",
  "cafeteria.tabs.wallets": "กระเป๋าเงิน",
  "cafeteria.tabs.reports": "รายงาน",
  "cafeteria.sales.title": "ยอดขายโรงอาหาร",
  "cafeteria.sales.subtitle": "รายการขายทั้งหมด ทั้งชำระด้วยกระเป๋าเงินและ Thai QR คืนเงินได้ภายในวันที่ขายเท่านั้น",
  "cafeteria.sales.empty": "ไม่มีรายการขายตามตัวกรองนี้",
  "cafeteria.sales.walk_in": "ลูกค้าทั่วไป",
  "cafeteria.sales.filter_payment": "ชำระด้วย",
  "cafeteria.sales.all_payments": "ทุกวิธีชำระ",
  "cafeteria.sales.wallet": "กระเป๋าเงิน",
  "cafeteria.sales.thai_qr": "Thai QR",
  "cafeteria.sales.filter_refunds": "การคืนเงิน",
  "cafeteria.sales.any_refund": "ทุกรายการขาย",
  "cafeteria.sales.with_refunds": "มีการคืนเงิน",
  "cafeteria.sales.search_placeholder": "ค้นหาชื่อหรือเลขที่รายการขาย",
  "cafeteria.sales.search_aria": "ค้นหารายการขาย",
  "cafeteria.sales.items_label": "รายการขาย",
  "cafeteria.sales.col_time": "เวลา",
  "cafeteria.sales.col_who": "ผู้ซื้อ",
  "cafeteria.sales.col_items": "สินค้า",
  "cafeteria.sales.col_paid_by": "ชำระด้วย",
  "cafeteria.sales.col_total": "รวม",
  "cafeteria.sales.col_cashier": "แคชเชียร์",
  "cafeteria.sales.refunded_amount": "คืนเงินแล้ว {{amount}}",
  "cafeteria.sales.refund": "คืนเงิน",
  "cafeteria.sales.detail_title": "รายการขาย",
  "cafeteria.sales.refunds_title": "การคืนเงิน",
  "cafeteria.sales.no_refunds": "ยังไม่มีการคืนเงิน",
  "cafeteria.refund.title": "คืนเงิน",
  "cafeteria.refund.col_item": "สินค้า",
  "cafeteria.refund.col_bought": "ซื้อ",
  "cafeteria.refund.col_refunded": "คืนแล้ว",
  "cafeteria.refund.col_refund_now": "คืนครั้งนี้",
  "cafeteria.refund.refund_now_aria": "จำนวนที่คืนครั้งนี้: {{name}}",
  "cafeteria.refund.of_left": "จากที่เหลือ {{count}}",
  "cafeteria.refund.comment": "หมายเหตุ",
  "cafeteria.refund.comment_placeholder": "เหตุผล และคืนเงินอย่างไร (เช่น คุณพลอยคืนเงินสด)",
  "cafeteria.refund.comment_required": "กรุณาระบุเหตุผล และวิธีคืนเงิน",
  "cafeteria.refund.too_many": "{{name}} เหลือให้คืนได้เพียง {{left}} ชิ้น",
  "cafeteria.refund.wallet_note": "{{amount}} จะคืนเข้ากระเป๋าเงินของ {{name}}",
  "cafeteria.refund.thai_qr_note": "ระบบจะไม่โอนเงินคืนให้ กรุณาระบุในหมายเหตุว่าคืนเงินอย่างไร",
  "cafeteria.refund.submit": "คืนเงิน {{amount}}",
  "cafeteria.refund.done": "คืนเงิน {{amount}} แล้ว",
  "cafeteria.refund.failed": "คืนเงินไม่สำเร็จ",
  "cafeteria.add": "เพิ่มสินค้า",
  "cafeteria.empty": "ยังไม่มีสินค้า เพิ่มหมวดหมู่แล้วจึงเพิ่มสินค้า",
  "cafeteria.col_product": "สินค้า",
  "cafeteria.col_price": "ราคา",
  "cafeteria.active": "เปิดใช้งาน",
  "cafeteria.inactive": "ปิดใช้งาน",
  "cafeteria.delete_title": "ลบสินค้า",
  "cafeteria.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบสินค้านี้ การกระทำนี้ไม่สามารถย้อนกลับได้",
  "cafeteria.edit_product": "แก้ไขสินค้า",
  "cafeteria.price_label": "ราคา (฿)",
  "cafeteria.product_image": "รูปภาพสินค้า",
  "cafeteria.select_category": "เลือกหมวดหมู่",
  "cafeteria.no_categories": "ยังไม่มีหมวดหมู่",
  "cafeteria.new_category_label": "หมวดหมู่ใหม่",
  "cafeteria.new_category_placeholder": "เช่น เครื่องดื่ม",
  "cafeteria.delete_category_failed": "ลบหมวดหมู่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "cafeteria.category_already_exists": "มีหมวดหมู่ชื่อนี้อยู่แล้ว",
  "cafeteria.wallet_title": "กระเป๋าเงินโรงอาหาร",
  "cafeteria.balance_label": "ยอดเงินคงเหลือ",
  "cafeteria.topup_form_title": "เติมเงินสด",
  "cafeteria.topup_amount_label": "จำนวนเงิน (฿)",
  "cafeteria.topup_note_label": "หมายเหตุ",
  "cafeteria.topup_bonus_label": "โบนัส / เครดิตฟรี (฿)",
  "cafeteria.topup_button": "เติมเงิน",
  "cafeteria.topup_success": "เติมเงินสำเร็จ",
  "cafeteria.topup_failed": "เติมเงินไม่สำเร็จ",
  "cafeteria.transactions_title": "ประวัติการทำรายการ",
  "cafeteria.no_transactions": "ยังไม่มีรายการ",
  "cafeteria.show_qr_button": "แสดง QR",
  "cafeteria.show_qr_no_person_id": "ไม่มีรหัสประจำตัว — ไม่สามารถสร้าง QR ได้",
  "cafeteria.qr_modal_title": "รหัส QR โรงอาหาร",
  "cafeteria.qr_modal_description": "สแกนที่จุดชำระเงิน หรือพิมพ์รหัสด้วยตนเอง",
  "cafeteria.qr_generating": "กำลังสร้างรหัส QR…",
  "cafeteria.qr_failed": "ไม่สามารถสร้างรหัส QR ได้",
  "nav.cafeteria_pos": "จุดขายโรงอาหาร",
  "cafeteria.pos.title": "จุดขายโรงอาหาร",
  "cafeteria.pos.subtitle": "แตะสินค้าเพื่อเพิ่มลงตะกร้า แล้วเรียกเก็บเงินจากกระเป๋าเงินของลูกค้า",
  "cafeteria.pos.cart_title": "ตะกร้าสินค้า",
  "cafeteria.pos.cart_empty": "ยังไม่มีสินค้าในตะกร้า แตะสินค้าเพื่อเพิ่ม",
  "cafeteria.pos.total_label": "ยอดรวม",
  "cafeteria.pos.charge_button": "เรียกเก็บเงิน",
  "cafeteria.pos.clear_cart": "ล้างตะกร้า",
  "cafeteria.pos.no_products": "ไม่มีสินค้า",
  "cafeteria.pos.checkout_success": "เรียกเก็บเงิน {{total}} สำเร็จ — ยอดคงเหลือใหม่ {{balance}}",
  "cafeteria.pos.checkout_failed": "เรียกเก็บเงินจากกระเป๋าเงินไม่สำเร็จ",
  "cafeteria.pos.identify_title": "ระบุตัวลูกค้า",
  "cafeteria.pos.identify_description": "สแกนรหัส QR หรือกรอกรหัสประจำตัว",
  "cafeteria.pos.person_id_label": "รหัสประจำตัว",
  "cafeteria.pos.person_id_placeholder": "กรอกรหัสประจำตัว",
  "cafeteria.pos.lookup_button": "ค้นหา",
  "cafeteria.pos.scan_button": "สแกน QR",
  "cafeteria.pos.stop_scan_button": "หยุดสแกน",
  "cafeteria.pos.scan_unsupported": "ไม่รองรับการสแกนด้วยกล้องในเบราว์เซอร์นี้ — กรุณากรอกรหัส",
  "cafeteria.pos.camera_error": "ไม่สามารถเข้าถึงกล้องได้",
  "cafeteria.pos.person_not_found": "ไม่พบบัญชีสำหรับรหัสนี้",
  "cafeteria.pos.balance_label": "ยอดคงเหลือ",
  "cafeteria.pos.confirm_charge_button": "ยืนยันและเรียกเก็บเงิน",
  "cafeteria.pos.charging": "กำลังเรียกเก็บเงิน…",
  "cafeteria.pos.charge_success_title": "เรียกเก็บเงินสำเร็จ",
  "cafeteria.pos.charge_success_description": "ยอดคงเหลือใหม่: {{balance}}",
  "cafeteria.pos.done_button": "เสร็จสิ้น",
  "cafeteria.pos.change_person_button": "ใช้รหัสอื่น",
  "cafeteria.pos.search_label": "ค้นหาด้วยชื่อหรือชื่อเล่น",
  "cafeteria.pos.search_placeholder": "พิมพ์ชื่อหรือชื่อเล่น",
  "cafeteria.pos.search_hint": "พิมพ์อย่างน้อย 2 ตัวอักษร",
  "cafeteria.pos.search_no_results": "ไม่พบบุคคลที่ตรงกัน",
  "cafeteria.pos.payment_method_wallet": "กระเป๋าเงิน",
  "cafeteria.pos.payment_method_thai_qr": "Thai QR (ผู้ปกครอง/ผู้มาเยือน)",
  "cafeteria.pos.attribution_search_label": "ระบุผู้ปกครอง นักเรียน หรือบุคลากร (ไม่บังคับ)",
  "cafeteria.pos.attribution_search_placeholder": "พิมพ์ชื่อหรือชื่อเล่น",
  "cafeteria.pos.attribution_anonymous_hint": "เว้นว่างไว้เพื่อบันทึกเป็นผู้มาเยือนแบบไม่ระบุตัวตน",
  "cafeteria.pos.payer_label_label": "ชื่อผู้จ่ายเงิน (ไม่บังคับ)",
  "cafeteria.pos.payer_label_placeholder": "เช่น ชื่อผู้มาเยือน",
  "cafeteria.pos.record_thai_qr_button": "บันทึกการขายผ่าน Thai QR",
  "cafeteria.pos.thai_qr_checkout_success": "บันทึกการขายผ่าน Thai QR จำนวน {{total}} สำเร็จ",
  "cafeteria.pos.thai_qr_success_title": "บันทึกการขายผ่าน Thai QR สำเร็จ",
  "cafeteria.pos.thai_qr_success_description": "ยอดรวม: {{total}} ไม่มีการหักเงินจากกระเป๋าเงิน",
  "cafeteria.wallets.title": "กระเป๋าเงินโรงอาหาร",
  "cafeteria.wallets.subtitle": "ยอดคงเหลือในกระเป๋าเงินของทุกคนในโรงเรียน และประวัติการทำรายการทั้งหมด",
  "cafeteria.wallets.total_label": "ยอดเงินคงเหลือรวมทั้งหมด",
  "cafeteria.wallets.accounts_title": "กระเป๋าเงิน",
  "cafeteria.wallets.account_count": "{{count}} กระเป๋าเงิน",
  "cafeteria.wallets.search_placeholder": "ค้นหาด้วยชื่อหรือรหัสประจำตัว",
  "cafeteria.wallets.search_aria": "ค้นหากระเป๋าเงิน",
  "cafeteria.wallets.col_name": "ชื่อ",
  "cafeteria.wallets.col_role": "บทบาท",
  "cafeteria.wallets.col_person_id": "รหัสประจำตัว",
  "cafeteria.wallets.col_balance": "ยอดคงเหลือ",
  "cafeteria.wallets.empty": "ไม่พบกระเป๋าเงิน",
  "cafeteria.wallets.transactions_title": "รายการทำธุรกรรม",
  "cafeteria.wallets.filter_all": "ทั้งหมด",
  "cafeteria.wallets.filter_topups": "การเติมเงิน",
  "cafeteria.wallets.filter_purchases": "การซื้อสินค้า",
  "cafeteria.wallets.col_user": "ผู้ใช้",
  "cafeteria.wallets.col_type": "ประเภท",
  "cafeteria.wallets.col_amount": "จำนวนเงิน",
  "cafeteria.wallets.col_note": "รายละเอียด",
  "cafeteria.wallets.col_date": "วันที่",
  "cafeteria.wallets.transactions_empty": "ไม่พบรายการทำธุรกรรม",
  "cafeteria.wallets.type_topup": "เติมเงิน",
  "cafeteria.wallets.type_purchase": "ซื้อสินค้า",
  "cafeteria.wallets.type_adjustment": "ปรับปรุงยอด",
  "cafeteria.wallets.type_refund": "คืนเงิน",
  "cafeteria.wallets.type_bonus": "โบนัส",
  "cafeteria.reports.title": "รายงานโรงอาหาร",
  "cafeteria.reports.subtitle": "ยอดขาย ลูกค้า และสินค้า สำหรับวันนี้ สัปดาห์นี้ หรือเดือนนี้ เทียบกับช่วงก่อนหน้า",
  "cafeteria.reports.card_net": "ยอดขายสุทธิ",
  "cafeteria.reports.net_breakdown": "ยอดขาย {{sales}} · คืนเงิน {{refunds}}",
  "cafeteria.reports.card_refunds": "คืนเงิน",
  "cafeteria.reports.refunds_breakdown": "กระเป๋าเงิน {{wallet}} · Thai QR {{thaiQr}}",
  "cafeteria.reports.col_refunds": "คืนเงิน",
  "cafeteria.reports.col_net": "สุทธิ",
  "cafeteria.reports.col_refunded_qty": "คืนแล้ว",
  "cafeteria.reports.col_net_revenue": "รายได้สุทธิ",
  "cafeteria.reports.card_wallet": "กระเป๋าเงิน",
  "cafeteria.reports.card_thai_qr": "ไทย QR",
  "cafeteria.reports.card_orders": "จำนวนออเดอร์",
  "cafeteria.reports.card_avg_order": "มูลค่าเฉลี่ยต่อออเดอร์",
  "cafeteria.reports.card_items_sold": "จำนวนสินค้าที่ขาย",
  "cafeteria.reports.trend_vs_prev": "เทียบกับช่วงก่อนหน้า",
  "cafeteria.reports.top_seller": "ขายดีที่สุด",
  "cafeteria.reports.split_hint": "ไทย QR คือเงินที่ได้รับจริงในช่วงเวลานี้ ส่วนกระเป๋าเงินคือเครดิตที่เติมไว้ล่วงหน้าแล้วถูกใช้จ่ายออกไป",
  "cafeteria.reports.period_day": "วัน",
  "cafeteria.reports.period_week": "สัปดาห์",
  "cafeteria.reports.period_month": "เดือน",
  "cafeteria.reports.from_label": "จาก",
  "cafeteria.reports.to_label": "ถึง",
  "cafeteria.reports.sales_title": "ยอดขายตามช่วงเวลา",
  "cafeteria.reports.sales_empty": "ไม่มียอดขายในช่วงเวลานี้",
  "cafeteria.reports.col_period": "ช่วงเวลา",
  "cafeteria.reports.col_total": "ยอดรวม",
  "cafeteria.reports.col_wallet": "กระเป๋าเงิน",
  "cafeteria.reports.col_thai_qr": "ไทย QR",
  "cafeteria.reports.col_orders": "ออเดอร์",
  "cafeteria.reports.products_title": "รายละเอียดตามสินค้า",
  "cafeteria.reports.products_empty": "ไม่มียอดขายสินค้าในช่วงเวลานี้",
  "cafeteria.reports.col_product": "สินค้า",
  "cafeteria.reports.col_qty": "จำนวน",
  "cafeteria.reports.col_revenue": "รายได้",
  "cafeteria.reports.totals_label": "ยอดรวม",
  "cafeteria.reports.preset_label": "ช่วงเวลารายงาน",
  "cafeteria.reports.preset_today": "วันนี้",
  "cafeteria.reports.preset_week": "สัปดาห์นี้",
  "cafeteria.reports.preset_month": "เดือนนี้",
  "cafeteria.reports.preset_custom": "กำหนดเอง",
  "cafeteria.reports.export_pdf": "ส่งออก PDF",
  "cafeteria.reports.compared_with": "เทียบกับ {{range}}",
  "cafeteria.reports.compare_yesterday": "เทียบกับเมื่อวาน",
  "cafeteria.reports.compare_last_week": "เทียบกับสัปดาห์ก่อน",
  "cafeteria.reports.compare_last_month": "เทียบกับเดือนก่อน",
  "cafeteria.reports.compare_previous_day": "เทียบกับวันก่อนหน้า",
  "cafeteria.reports.compare_previous_days": "เทียบกับ {{count}} วันก่อนหน้า",
  "cafeteria.reports.legend_yesterday": "เมื่อวาน",
  "cafeteria.reports.legend_last_week": "สัปดาห์ก่อน",
  "cafeteria.reports.legend_last_month": "เดือนก่อน",
  "cafeteria.reports.legend_this_period": "ช่วงนี้",
  "cafeteria.reports.legend_previous_period": "ช่วงก่อนหน้า",
  "cafeteria.reports.row_sales": "ยอดขาย",
  "cafeteria.reports.card_items_per_order": "จำนวนชิ้นต่อออเดอร์",
  "cafeteria.reports.items_sold_hint": "ขายได้ {{count}} ชิ้น",
  "cafeteria.reports.card_customers": "ลูกค้า",
  "cafeteria.reports.customers_hint": "{{count}} ออเดอร์ที่ไม่ระบุผู้ซื้อ",
  "cafeteria.reports.refund_rate_hint": "{{rate}} ของยอดขาย · {{count}} ออเดอร์",
  "cafeteria.reports.card_top_ups": "เติมเงินกระเป๋า",
  "cafeteria.reports.top_ups_hint": "บันทึกการเติมเงิน {{count}} ครั้ง",
  "cafeteria.reports.payment_mix_title": "สัดส่วนวิธีชำระเงิน",
  "cafeteria.reports.payment_mix_subtitle": "ยอดขายสุทธิแยกตามวิธีชำระเงิน",
  "cafeteria.reports.orders_count": "{{count}} ออเดอร์",
  "cafeteria.reports.customers_title": "ใครเป็นผู้ซื้อ",
  "cafeteria.reports.customers_subtitle": "ยอดขายสุทธิแยกตามประเภทเจ้าของกระเป๋าเงิน",
  "cafeteria.reports.customer_student": "นักเรียน",
  "cafeteria.reports.customer_staff": "บุคลากร",
  "cafeteria.reports.customer_parent": "ผู้ปกครอง",
  "cafeteria.reports.customer_anonymous": "ไม่ระบุผู้ซื้อ",
  "cafeteria.reports.hours_title": "ช่วงเวลาที่ขายดี",
  "cafeteria.reports.hours_subtitle": "ยอดขายสุทธิแยกตามชั่วโมง",
  "cafeteria.reports.hours_peak": "สูงสุดเวลา {{hour}} ที่ {{amount}}",
  "cafeteria.reports.weekday_title": "วันในสัปดาห์",
  "cafeteria.reports.weekday_subtitle": "ยอดขายสุทธิเฉลี่ยต่อวัน จันทร์ถึงอาทิตย์",
  "cafeteria.reports.weekday_per_day": "ต่อวัน",
  "cafeteria.reports.top_products_title": "สินค้าขายดี",
  "cafeteria.reports.top_products_subtitle": "เรียงตามรายได้สุทธิ พร้อมสัดส่วนของแต่ละสินค้าต่อยอดขายสุทธิ",
  "cafeteria.reports.product_sold": "ขายได้ {{count}} ชิ้น",
  "cafeteria.reports.grades_title": "ยอดขายตามระดับชั้น",
  "cafeteria.reports.grades_subtitle": "การซื้อผ่านกระเป๋าเงินของนักเรียน แยกตามระดับชั้นปัจจุบัน",
  "cafeteria.reports.grade_orders": "{{orders}} ออเดอร์ · นักเรียน {{students}} คน",
  "cafeteria.reports.col_share": "สัดส่วน",
  "cafeteria.reports.chart_empty": "ไม่มีข้อมูลในช่วงเวลานี้",
  "cafeteria.reports.no_data_title": "ไม่มียอดขายในช่วงเวลานี้",
  "cafeteria.reports.no_data_description": "ยอดขายจะแสดงที่นี่เมื่อเครื่องขายบันทึกรายการ ลองเลือกช่วงเวลาอื่นหรือกลับมาดูภายหลัง",
  "cafeteria.reports.print_title": "รายงานยอดขายโรงอาหาร",
  "cafeteria.reports.print_period": "ช่วงเวลา",
  "cafeteria.reports.print_compared": "เทียบกับ",
  "cafeteria.reports.print_generated": "สร้างเมื่อ {{date}}",
  "cafeteria.reports.print_orders": "{{count}} ออเดอร์",
  "cafeteria.below_zero": "ติดลบ",
  "cafeteria.pos.balance_after_label": "ยอดคงเหลือหลังการขายนี้",
  "cafeteria.pos.over_limit": "รายการนี้จะทำให้ยอดเงินในกระเป๋าต่ำกว่า {{limit}} กรุณาเติมเงินก่อน",
  "cafeteria.pos.overdraft_hint": "ชำระได้จนถึง {{limit}}",
  "cafeteria.pos.unit_price": "ชิ้นละ {{price}}",
  "cafeteria.pos.decrease_item": "ลด {{name}} หนึ่งชิ้น",
  "cafeteria.pos.increase_item": "เพิ่ม {{name}} หนึ่งชิ้น",
  "cafeteria.pos.remove_item": "นำ {{name}} ออก",
  "cafeteria.wallets.account_filter_label": "กรองบัญชี",
  "cafeteria.settings.overdraft_title": "วงเงินติดลบ",
  "cafeteria.settings.overdraft_description": "ยอดเงินในกระเป๋าติดลบได้มากที่สุดเท่าใดที่จุดขาย เมื่อยอดต่ำกว่า ฿0 ระบบจะส่งอีเมลแจ้งผู้ปกครอง (หรือบุคลากรเจ้าของกระเป๋า) ให้เติมเงิน และส่งเตือนซ้ำทุก 3 วัน",
  "cafeteria.settings.overdraft_label": "วงเงินติดลบ (บาท)",
  "cafeteria.settings.overdraft_zero_hint": "ตั้งเป็น 0 เพื่อไม่ให้ยอดเงินในกระเป๋าต่ำกว่า ฿0",
  "cafeteria.settings.overdraft_none": "ห้ามติดลบ",
  "cafeteria.settings.overdraft_edit": "เปลี่ยน",
  "cafeteria.settings.overdraft_saved": "บันทึกวงเงินติดลบแล้ว",
  "cafeteria.settings.overdraft_save_failed": "บันทึกวงเงินติดลบไม่สำเร็จ",
  "cafeteria.settings.overdraft_required": "กรุณาระบุจำนวนเงินเป็นบาท",
  "cafeteria.settings.overdraft_whole": "กรุณาระบุเป็นจำนวนเต็มบาท",
  "cafeteria.settings.overdraft_min": "วงเงินต้องไม่ติดลบ",
  "cafeteria.settings.overdraft_max": "วงเงินต้องไม่เกิน {{max}}",
  "integration.subtitle": "อุปกรณ์เข้าออกประตู กริ่งเข้าเรียน API key ของเอเจนต์ การแปลภาษา และ RisAI",
  "integration.tab_devices": "อุปกรณ์",
  "integration.tab_bell": "กริ่งและตารางเวลา",
  "integration.tab_agent": "เอเจนต์",
  "integration.tab_translation": "การแปล",
  "integration.translation_title": "การแปลอัตโนมัติ",
  "integration.translation_description": "ให้หน้าจอเขียนข้อความสื่อสารแปลข้อความจากภาษาอังกฤษเป็นภาษาไทยหรือจีนโดยใช้ Google Cloud Translate ไม่มีผู้ให้บริการอื่นให้เลือก",
  "integration.translation_status_configured": "พร้อมใช้งาน",
  "integration.translation_status_not_configured": "ยังไม่ได้ตั้งค่า",
  "integration.translation_key_stored": "มี API key จัดเก็บอยู่",
  "integration.translation_key_not_stored": "ยังไม่มี API key จัดเก็บอยู่",
  "integration.translation_last_updated": "อัปเดตล่าสุด",
  "integration.translation_api_key_label": "Google Cloud Translate API key",
  "integration.translation_key_placeholder_set": "มี key จัดเก็บอยู่แล้ว — วางค่าใหม่เพื่อแทนที่",
  "integration.translation_key_placeholder_new": "วาง API key ที่นี่",
  "integration.translation_clear_button": "ลบ key",
  "integration.translation_clear_confirm_title": "ลบ API key สำหรับการแปลหรือไม่?",
  "integration.translation_clear_confirm_description": "การดำเนินการนี้จะปิดใช้งานการแปลด้วย ยังสามารถเขียนข้อความภาษาไทยและจีนได้เองตามปกติ",
  "integration.translation_clear_confirm_label": "ลบ key",
  "integration.translation_enable_label": "เปิดใช้งานการแปลอัตโนมัติ",
  "integration.translation_toast_key_saved": "บันทึก API key แล้ว",
  "integration.translation_toast_key_cleared": "ลบ API key แล้ว",
  "integration.translation_billing_note": "Google คิดค่าบริการตามจำนวนตัวอักษรที่แปล การกดแปลข้อความยาวจะมีค่าใช้จ่ายจริงกับบัญชีที่เป็นเจ้าของ key นี้ — ระบบยังไม่มีการจำกัดวงเงินการใช้งาน",
  "integration.tab_risai": "RisAI",
  "integration.risai_title": "RisAI",
  "integration.risai_description": "ผู้ช่วย AI ของโรงเรียน ชื่อ ข้อมูลติดต่อ และเลขประจำตัวจะถูกแทนด้วยรหัสชั่วคราวก่อนส่งไปยัง OpenAI และใส่กลับในคำตอบ",
  "integration.risai_status_configured": "ตั้งค่าแล้ว",
  "integration.risai_status_not_configured": "ยังไม่ได้ตั้งค่า",
  "integration.risai_key_stored": "บันทึกคีย์แล้ว",
  "integration.risai_key_not_stored": "ยังไม่มีคีย์",
  "integration.risai_last_updated": "อัปเดตล่าสุด",
  "integration.risai_api_key_label": "OpenAI API key",
  "integration.risai_key_placeholder_set": "มีคีย์อยู่แล้ว — วางคีย์ใหม่เพื่อแทนที่",
  "integration.risai_key_placeholder_new": "วาง API key",
  "integration.risai_clear_button": "ล้างคีย์",
  "integration.risai_clear_confirm_title": "ล้าง OpenAI API key หรือไม่?",
  "integration.risai_clear_confirm_description": "การล้างคีย์จะปิด RisAI ด้วย ทุกอย่างที่ใช้ RisAI จะหยุดทำงานจนกว่าจะบันทึกคีย์ใหม่",
  "integration.risai_clear_confirm_label": "ล้างคีย์",
  "integration.risai_enable_label": "เปิดใช้ RisAI",
  "integration.risai_toast_key_saved": "บันทึก API key แล้ว",
  "integration.risai_toast_key_cleared": "ล้าง API key แล้ว",
  "integration.risai_toast_defaults_saved": "บันทึกค่าเริ่มต้นแล้ว",
  "integration.risai_defaults_title": "ค่าเริ่มต้น",
  "integration.risai_model_label": "โมเดลเริ่มต้น",
  "integration.risai_model_unpriced": "ไม่มีราคาในระบบ",
  "integration.risai_model_price": "{{input}} เข้า / {{output}} ออก ต่อ 1 ล้านโทเคน",
  "integration.risai_budget_label": "งบประมาณต่อเดือน (USD)",
  "integration.risai_budget_hint": "ประมาณ {{thb}} บาท ที่ {{rate}} บาทต่อดอลลาร์ ตั้งค่าวงเงินเดียวกันในโปรเจกต์ OpenAI ไว้เป็นชั้นที่สอง",
  "integration.risai_month_spend": "เดือนนี้: {{spend}} USD จาก {{cap}} USD ใน {{count}} คำขอ",
  "integration.risai_month_errors_one": "การเรียกใช้ล้มเหลว {{count}} ครั้งในเดือนนี้",
  "integration.risai_month_errors_other": "การเรียกใช้ล้มเหลว {{count}} ครั้งในเดือนนี้",
  "integration.risai_billing_note": "OpenAI คิดค่าใช้จ่ายตามโทเคน เมื่อถึงงบประมาณ การเรียกใช้จะหยุดจนสิ้นเดือน",
  "integration.risai_save_defaults": "บันทึกค่าเริ่มต้น",
  "integration.risai_error_budget_number": "กรอกงบประมาณเป็นตัวเลข",
  "integration.risai_inspector_title": "ตัวตรวจสอบ",
  "integration.risai_inspector_description": "วางบันทึกหรือข้อมูลใดก็ได้ 'แทนที่เท่านั้น' แสดงสิ่งที่จะออกจากเซิร์ฟเวอร์โดยไม่มีค่าใช้จ่าย 'ส่ง' จะส่งผ่านโมเดลและแสดงคำตอบดิบและคำตอบที่ใส่ชื่อกลับแล้ว",
  "integration.risai_inspector_text_label": "ข้อความ",
  "integration.risai_inspector_subjects_label": "รหัสบุคคล (ไม่บังคับ คั่นด้วยจุลภาค)",
  "integration.risai_inspector_redact_button": "แทนที่เท่านั้น",
  "integration.risai_inspector_send_button": "ส่ง",
  "integration.risai_inspector_found": "แทนที่บุคคล: {{people}} · ข้อมูลติดต่อ: {{contacts}}",
  "integration.risai_inspector_panel_redacted": "สิ่งที่ออกจากเซิร์ฟเวอร์",
  "integration.risai_inspector_panel_raw": "คำตอบดิบ",
  "integration.risai_inspector_panel_restored": "คำตอบที่ใส่ชื่อกลับ",
  "integration.risai_inspector_panel_usage": "การใช้งาน",
  "integration.risai_inspector_usage": "{{model}} · เข้า {{input}} (แคช {{cached}}) / ออก {{output}} · {{cost}} USD",
  "integration.risai_inspector_unmatched_one": "รหัสที่โมเดลสร้างขึ้นเอง {{count}} รายการถูกคงไว้ตามเดิม",
  "integration.risai_inspector_unmatched_other": "รหัสที่โมเดลสร้างขึ้นเอง {{count}} รายการถูกคงไว้ตามเดิม",
  "integration.risai_inspector_send_disabled": "บันทึกคีย์และเปิดใช้ RisAI ก่อนส่ง",
  "integration.doors_title": "ประตู",
  "integration.doors_description": "อุปกรณ์เข้าออกประตูที่เอเจนต์ในสถานที่ดึงข้อมูลเหตุการณ์เช็คอิน",
  "integration.add_device_button": "เพิ่มอุปกรณ์",
  "integration.col_ip_address": "IP Address",
  "integration.open_device_web_ui": "เปิดหน้าเว็บของอุปกรณ์",
  "integration.col_port": "พอร์ต",
  "integration.col_username": "ชื่อผู้ใช้",
  "integration.col_poll_interval": "ความถี่ในการดึงข้อมูล",
  "integration.poll_interval_minutes": "{{count}} นาที",
  "integration.doors_empty": "ยังไม่มีการตั้งค่าอุปกรณ์ประตู",
  "integration.new_device_title": "เพิ่มอุปกรณ์ประตูใหม่",
  "integration.edit_device_title": "แก้ไขอุปกรณ์ประตู",
  "integration.device_name_placeholder": "เช่น ประตูหลัก",
  "integration.field_ip_address": "IP Address",
  "integration.field_port": "พอร์ต",
  "integration.field_username": "ชื่อผู้ใช้",
  "integration.field_password": "รหัสผ่าน",
  "integration.password_placeholder_set": "•••• (ตั้งไว้แล้ว)",
  "integration.password_placeholder_new": "กรอกรหัสผ่าน",
  "integration.password_hint_edit": "เว้นว่างไว้เพื่อคงรหัสผ่านเดิม",
  "integration.field_poll_interval": "ความถี่ในการดึงข้อมูล (นาที)",
  "integration.field_enabled": "เปิดใช้งาน",
  "integration.error_ip_required": "กรุณากรอก IP address",
  "integration.error_port_invalid": "กรุณากรอกพอร์ตที่ถูกต้อง (1–65535)",
  "integration.error_username_required": "กรุณากรอกชื่อผู้ใช้",
  "integration.error_password_required": "กรุณากรอกรหัสผ่าน",
  "integration.error_poll_interval_invalid": "กรุณากรอกความถี่ในการดึงข้อมูลที่ถูกต้อง (ตั้งแต่ 1 นาทีขึ้นไป)",
  "integration.delete_device_title": "ลบ \"{{name}}\" ใช่หรือไม่?",
  "integration.delete_device_description": "เอเจนต์จะหยุดดึงข้อมูลจากอุปกรณ์นี้ ไม่สามารถย้อนกลับได้",
  "integration.toast_device_created": "เพิ่มอุปกรณ์ประตูแล้ว",
  "integration.toast_device_updated": "อัปเดตอุปกรณ์ประตูแล้ว",
  "integration.toast_device_deleted": "ลบอุปกรณ์ประตูแล้ว",
  "integration.bell_title": "กริ่ง",
  "integration.bell_description": "ควบคุมกริ่งเข้าเรียนที่เอเจนต์จะสั่งดังตามช่วงเวลาที่ตั้งไว้",
  "integration.field_bell_enabled": "ระบบกริ่ง (เปิด/ปิดหลัก)",
  "integration.field_bell_enabled_help": "สั่งให้กริ่งโรงเรียนดังตามตารางเวลา ปิดเพื่อหยุดเสียงกริ่งทั้งหมด เช่น ระหว่างมีงานกิจกรรมที่โรงเรียนเปิดแต่ไม่ต้องการเสียงกริ่ง",
  "integration.field_bell_volume": "ระดับเสียง (0–100)",
  "integration.field_bell_sound": "เสียงกริ่ง",
  "integration.bell_sound_preview": "ฟังตัวอย่าง",
  "integration.bell_sound.classic_loop": "เสียงกริ่งคลาสสิก (วนซ้ำ)",
  "integration.bell_sound.electric_ring": "กริ่งไฟฟ้า",
  "integration.bell_sound.school_1": "กริ่งโรงเรียน 1",
  "integration.bell_sound.school_2": "กริ่งโรงเรียน 2",
  "integration.bell_sound.school_3": "กริ่งโรงเรียน 3",
  "integration.bell_sound.japanese": "กริ่งโรงเรียนญี่ปุ่น",
  "integration.bell_sound.german": "กริ่งโรงเรียนมัธยมเยอรมัน",
  "integration.bell_sound.vintage": "กริ่งภายในแบบวินเทจ",
  "integration.bell_sound.buzzer": "กริ่งบัซเซอร์ไฟฟ้า",
  "integration.bell_sound.long_ring": "เสียงกริ่งยาว",
  "integration.bell_sound.chime": "เสียงระฆังไชม์",
  "integration.bell_sound.ris_nat_anthem": "เพลงชาติ RIS (สั้น)",
  "integration.bell_sound.ris_song_short": "เพลงประจำโรงเรียน RIS (สั้น)",
  "integration.bell_sound.suspense_bell": "กริ่งลุ้นระทึก",
  "integration.bell_sound.national_anthem": "เพลงชาติไทย",
  "integration.bell_sound.ris_song_full": "เพลงประจำโรงเรียน RIS (เต็ม)",
  "integration.bell_sound.ac_bell": "กริ่ง AC",
  "integration.bell_sound.clock_bell_chimes": "เสียงระฆังนาฬิกา",
  "integration.error_volume_range": "ระดับเสียงต้องอยู่ระหว่าง 0 ถึง 100",
  "integration.anthem_title": "เพลงเปิดวันเรียน",
  "integration.anthem_description": "เปิดเพลงประจำโรงเรียนหนึ่งครั้งทุกเช้าตามเวลาที่กำหนด",
  "integration.field_anthem_enabled": "เปิดใช้งานเพลงเปิดวันเรียน",
  "integration.field_anthem_time": "เวลาที่เปิด",
  "integration.field_anthem_sound": "เสียงเพลงเปิดวันเรียน",
  "integration.last_bell_title": "กริ่งเลิกเรียนพิเศษ",
  "integration.last_bell_description": "ตีกริ่งอีกครั้งด้วยเสียงเฉพาะเมื่อคาบสุดท้ายของวันสิ้นสุดลง",
  "integration.field_last_bell_enabled": "เปิดใช้งานกริ่งเลิกเรียนพิเศษ",
  "integration.field_last_bell_sound": "เสียงกริ่งเลิกเรียนพิเศษ",
  "integration.break_warning_title": "แจ้งเตือนก่อนหมดเวลาพัก",
  "integration.break_warning_description": "แจ้งเตือนก่อนช่วงพักทุกช่วงจะสิ้นสุด รวมถึงพักกลางวัน โดยจะดังก่อนกริ่งถัดไป",
  "integration.field_break_warning_enabled": "เปิดใช้งานการแจ้งเตือนก่อนหมดเวลาพัก",
  "integration.field_break_warning_offset": "แจ้งเตือนก่อนหมดเวลาพัก (นาที)",
  "integration.field_break_warning_sound": "เสียงแจ้งเตือนก่อนหมดเวลาพัก",
  "integration.error_time_invalid": "กรุณาระบุเวลาที่ถูกต้อง (HH:MM)",
  "integration.error_break_offset_invalid": "กรุณาระบุเวลาแจ้งเตือนที่ถูกต้อง (0–30 นาที)",
  "integration.campus_checkin_title": "การเข้า-ออกจากข้อมูลแตะบัตรประตู",
  "integration.campus_checkin_description": "กำหนดวิธีที่เวลาเข้าและเวลาออกในหน้าตารางการเข้าเรียนถูกกรอกให้อัตโนมัติจากข้อมูลแตะบัตรที่ประตู และเวลาที่การแตะบัตรครั้งแรกถือว่าสาย",
  "integration.field_checkout_eager_hour": "ยืนยันเวลาออกหลังจาก",
  "integration.checkout_eager_hour_hint": "ระบบจะยืนยันเวลาออกให้อัตโนมัติเฉพาะตั้งแต่เวลานี้เป็นต้นไป เพื่อไม่ให้การออกไปทำธุระช่วงเช้าถูกเข้าใจผิดว่าเป็นการออกจากโรงเรียนแล้ว",
  "integration.field_checkout_quiet_minutes": "ช่วงเวลาเงียบก่อนยืนยันเวลาออก (นาที)",
  "integration.checkout_quiet_minutes_hint": "ระยะเวลาที่ต้องไม่มีการแตะบัตรอีก ก่อนที่การแตะบัตรครั้งล่าสุดจะถูกยืนยันเป็นเวลาออก",
  "integration.field_access_granted_minor_codes": "รหัสประตูที่อนุญาตให้เข้า-ออก",
  "integration.access_granted_minor_codes_placeholder": "เช่น 1, 38, 75",
  "integration.access_granted_minor_codes_hint": "รหัสเหตุการณ์ประตู (คั่นด้วยจุลภาค) ที่นับเป็นการแตะบัตรที่ได้รับอนุญาตสำเร็จ เหตุการณ์ที่ถูกปฏิเสธหรือไม่รู้จักบัตรจะไม่ถูกนับ",
  "integration.field_late_after_staff": "บุคลากรถือว่าสายหลังเวลา",
  "integration.field_late_after_students": "นักเรียนถือว่าสายหลังเวลา",
  "integration.late_after_hint": "การแตะบัตรครั้งแรกภายในนาทีนี้หรือก่อนหน้าจะบันทึกเป็นมาเรียน หากช้ากว่านั้นจะบันทึกเป็นสาย สำนักงานแก้ไขได้ภายหลัง นับเป็นนาทีเต็ม ดังนั้น 07:30:55 ยังไม่สาย",
  "integration.late_after_students_hint": "กฎเดียวกันสำหรับนักเรียน: 08:00:55 ยังไม่สาย 08:01 ถือว่าสาย",
  "integration.error_checkout_quiet_minutes_invalid": "กรุณาระบุช่วงเวลาเงียบที่ถูกต้อง (0–1440 นาที)",
  "integration.error_access_granted_minor_codes_invalid": "กรุณาระบุรหัสประตูเป็นตัวเลขคั่นด้วยจุลภาค (เช่น 1, 38, 75)",
  "integration.toast_settings_saved": "บันทึกการตั้งค่าแล้ว",
  "integration.api_key_title": "API Key",
  "integration.api_key_description": "คีย์ที่เอเจนต์ประตู/กริ่งใช้ยืนยันตัวตนกับเซิร์ฟเวอร์นี้",
  "integration.api_key_none": "ยังไม่มีการสร้าง API key",
  "integration.reveal_button": "แสดง",
  "integration.regenerate_button": "สร้างใหม่",
  "integration.toast_key_copied": "คัดลอก API key แล้ว",
  "integration.error_copy_failed": "ไม่สามารถคัดลอก API key ได้",
  "integration.regenerate_confirm_title": "สร้าง API key ใหม่ใช่หรือไม่?",
  "integration.regenerate_confirm_description": "คีย์ปัจจุบันของเอเจนต์จะใช้งานไม่ได้ทันที ต้องอัปเดตเอเจนต์ด้วยคีย์ใหม่ก่อนจึงจะเชื่อมต่อกับเซิร์ฟเวอร์นี้ได้อีกครั้ง",
  "integration.regenerate_confirm_label": "สร้างใหม่",
  "integration.toast_key_regenerated": "สร้าง API key ใหม่แล้ว",
  "integration.agent_status_title": "สถานะเอเจนต์",
  "integration.agent_status_description": "สถานะสดจากเอเจนต์หน้างาน: การเช็คอินล่าสุด ตารางกริ่ง และกิจกรรมของอุปกรณ์",
  "integration.agent_status_no_events": "ยังไม่มีเหตุการณ์",
  "integration.agent_status_never": "ไม่เคยเลย",
  "integration.agent_status_no_devices": "ยังไม่มีการตั้งค่าอุปกรณ์ประตู",
  "integration.agent_last_seen": "พบเอเจนต์ล่าสุดเมื่อ",
  "integration.agent_last_bell": "กริ่งล่าสุด",
  "integration.agent_next_bell": "กริ่งถัดไป",
  "integration.agent_devices": "อุปกรณ์",
  "integration.agent_ip": "ไอพีเอเจนต์",
  "integration.agent_version": "เวอร์ชัน",
  "integration.agent_access_hint": "เข้าถึง Pi ผ่าน SSH ที่ IP ใด IP หนึ่งด้านบน",
  "integration.open_config_page": "เปิดหน้าตั้งค่า (:8080)",
  "integration.agent_device_never_polled": "ยังไม่เคยสำรวจ",
  "integration.agent_device_unreachable": "เชื่อมต่อไม่ได้",
  "integration.agent_device_ok": "ปกติ",
  "integration.agent_device_disabled": "ปิดใช้งาน",
  "integration.agent_audio": "อุปกรณ์เสียง",
  "integration.agent_audio_ok": "ปกติ",
  "integration.agent_audio_unavailable": "ตรวจไม่พบ",
  "integration.agent_audio_never_reported": "ยังไม่เคยรายงาน",
  "integration.refresh_button": "รีเฟรช",
  "integration.bell_kind_anthem": "เพลงเปิดวันเรียน",
  "integration.bell_kind_bell": "กริ่ง",
  "integration.bell_kind_break_warning": "แจ้งเตือนก่อนหมดเวลาพัก",
  "integration.bell_kind_last_bell": "กริ่งเลิกเรียนพิเศษ",
  "integration.filter_device": "อุปกรณ์",
  "integration.log_subtitle": "เหตุการณ์เช็คอินทั้งหมดที่รายงานโดยเอเจนต์เข้าออกประตู",
  "integration.unmatched_title": "มี {{count}} การแตะบัตรที่จับคู่กับบุคคลไม่ได้ ({{badges}} รหัส)",
  "integration.unmatched_help": "บุคคลเหล่านี้แตะบัตรเข้าแล้วแต่ระบบไม่ได้บันทึกการมาเรียน เพราะรหัสบัตรที่เครื่องส่งมาไม่ตรงกับผู้ใดในระบบ กรุณาเพิ่มข้อมูลบุคคลหรือแก้ไขรหัสที่เครื่อง",
  "integration.unmatched_row_meta": "{{count}} ครั้ง · ล่าสุด {{lastSeen}}",
  "integration.unmatched_show_all": "แสดงอีก {{count}} รายการ",
  "integration.inferred_link": "อนุมาน",
  "integration.inferred_link_help": "เครื่องอ่านบัตรส่งรหัสที่ไม่ตรงกับรหัสประจำตัวของบุคคลนี้ ระบบยืนยันตัวตนจากชื่อ แต่ควรแก้ไขรหัสที่เครื่อง",
  "integration.log_error": "โหลดบันทึกการเข้าออกประตูไม่สำเร็จ",
  "integration.log_empty": "ไม่พบเหตุการณ์การเข้าออกประตู",
  "integration.log_page_summary": "หน้า {{page}} จาก {{totalPages}} ({{total}} เหตุการณ์)",
  "integration.col_person": "บุคคล",
  "integration.col_card": "บัตร",
  "integration.col_door": "ประตู",
  "integration.col_event_type": "ประเภทเหตุการณ์",
  "integration.person_unknown": "ไม่ทราบชื่อ",
  "integration.filter_person": "บุคคล",
  "integration.person_search_placeholder": "ค้นหาชื่อ บัตร หรือรหัสประจำตัว",
  "integration.filter_linked_only": "เฉพาะผู้ใช้ที่เชื่อมโยงแล้ว",
  "integration.filter_user": "ผู้ใช้",
  "integration.user_picker_placeholder": "เลือกผู้ใช้",
  "integration.user_search_placeholder": "ค้นหาด้วยชื่อหรืออีเมล",
  "integration.user_search_hint": "พิมพ์อย่างน้อย 2 ตัวอักษร",
  "integration.user_search_no_results": "ไม่พบผู้ใช้ที่ตรงกัน",
  "integration.user_picker_clear": "ล้างผู้ใช้ที่เลือก",
  "shop.title": "ร้านค้าโรงเรียน",
  "shop.subtitle": "จัดการหมวดหมู่ สินค้า และตัวเลือกสินค้าของร้านค้า",
  "shop.add": "เพิ่มสินค้า",
  "shop.empty": "ยังไม่มีสินค้า เพิ่มหมวดหมู่ก่อน แล้วจึงเพิ่มสินค้า",
  "shop.col_product": "สินค้า",
  "shop.col_variant": "ตัวเลือกสินค้า",
  "shop.col_price": "ราคา",
  "shop.col_sku": "รหัสสินค้า",
  "shop.col_stock": "คงเหลือ",
  "shop.col_min_qty": "จำนวนขั้นต่ำ",
  "shop.col_avg_cost": "ต้นทุนเฉลี่ย",
  "shop.active": "ใช้งาน",
  "shop.inactive": "ไม่ใช้งาน",
  "shop.delete_title": "ลบสินค้า",
  "shop.delete_description": "คุณแน่ใจหรือไม่ว่าต้องการลบสินค้านี้ การกระทำนี้ไม่สามารถยกเลิกได้",
  "shop.edit_product": "แก้ไขสินค้า",
  "shop.price_label": "ราคา (฿)",
  "shop.product_image": "รูปภาพสินค้า",
  "shop.select_category": "เลือกหมวดหมู่",
  "shop.no_categories": "ยังไม่มีหมวดหมู่",
  "shop.new_category_label": "หมวดหมู่ใหม่",
  "shop.new_category_placeholder": "เช่น เครื่องเขียน",
  "shop.category_already_exists": "มีหมวดหมู่ชื่อนี้อยู่แล้ว",
  "shop.delete_category_failed": "ลบหมวดหมู่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "shop.category_name_label": "ชื่อหมวดหมู่",
  "shop.edit_category": "แก้ไขหมวดหมู่",
  "shop.delete_product_failed": "ลบสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "shop.add_variant": "เพิ่มตัวเลือกสินค้า",
  "shop.edit_variant": "แก้ไขตัวเลือกสินค้า",
  "shop.variant_label": "ชื่อตัวเลือกสินค้า",
  "shop.no_variants": "ยังไม่มีตัวเลือกสินค้า เพิ่มได้ด้านล่าง",
  "shop.delete_variant_title": "ลบตัวเลือกสินค้า",
  "shop.delete_variant_description": "คุณแน่ใจหรือไม่ว่าต้องการลบตัวเลือกสินค้านี้ การกระทำนี้ไม่สามารถยกเลิกได้",
  "shop.delete_variant_failed": "ลบตัวเลือกสินค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "shop.add_size_run": "เพิ่มชุดขนาดสินค้า",
  "shop.size_run_description": "สร้างตัวเลือกสินค้าหลายขนาดพร้อมกันในราคาเดียวกัน",
  "shop.size_labels_label": "ป้ายชื่อขนาด",
  "shop.size_labels_placeholder": "หนึ่งรายการต่อบรรทัด หรือคั่นด้วยจุลภาค เช่น S, M, L, XL",
  "shop.size_run_empty_labels": "กรุณาระบุป้ายชื่อขนาดอย่างน้อยหนึ่งรายการ",
  "shop.size_run_success": "สร้างตัวเลือกสินค้าแล้ว {{count}} รายการ",
  "shop.size_run_failed": "สร้างตัวเลือกสินค้าไม่สำเร็จ {{count}} รายการ",
  "shop.payment_status_paid": "จ่ายแล้ว",
  "shop.payment_status_credit": "ค้างจ่าย",
  "shop.pos.title": "จุดขายร้านค้า",
  "shop.pos.subtitle": "แตะสินค้าเพื่อเพิ่มลงตะกร้า แล้วบันทึกการขาย",
  "shop.pos.cart_title": "ตะกร้า",
  "shop.pos.cart_empty": "ตะกร้าว่างเปล่า แตะสินค้าเพื่อเพิ่ม",
  "shop.pos.total_label": "ยอดรวม",
  "shop.pos.charge_button": "บันทึกการขาย",
  "shop.pos.clear_cart": "ล้างตะกร้า",
  "shop.pos.no_products": "ไม่มีสินค้าให้เลือก",
  "shop.pos.checkout_success": "บันทึกการขายแล้ว — ยอดรวม {{total}}",
  "shop.pos.checkout_failed": "บันทึกการขายไม่สำเร็จ",
  "shop.pos.out_of_stock": "สินค้าหมด",
  "shop.pos.pick_variant_description": "เลือกขนาดและจำนวน",
  "shop.pos.stock_available": "มีสินค้า {{count}} ชิ้น",
  "shop.pos.add_to_cart": "เพิ่มลงตะกร้า",
  "shop.pos.buyer_type_label": "ประเภทผู้ซื้อ",
  "shop.pos.buyer_type_student": "นักเรียน",
  "shop.pos.buyer_type_staff": "บุคลากร",
  "shop.pos.buyer_type_parent": "ผู้ปกครอง",
  "shop.pos.buyer_type_visitor": "ผู้มาเยือน",
  "shop.pos.buyer_name_label": "ชื่อผู้ซื้อ",
  "shop.pos.buyer_name_placeholder": "เช่น ชื่อผู้มาเยือน",
  "shop.pos.buyer_search_label": "ค้นหาด้วยชื่อหรือชื่อเล่น",
  "shop.pos.buyer_search_placeholder": "พิมพ์ชื่อหรือชื่อเล่น",
  "shop.pos.buyer_search_hint": "พิมพ์อย่างน้อย 2 ตัวอักษร",
  "shop.pos.buyer_no_results": "ไม่พบบุคคลที่ตรงกัน",
  "shop.pos.payment_status_label": "สถานะการชำระเงิน",
  "shop.pos.confirm_title": "ยืนยันการขาย",
  "shop.pos.confirm_description": "เลือกผู้ซื้อและสถานะการชำระเงิน แล้วยืนยัน",
  "shop.pos.confirm_charge_button": "ยืนยันและบันทึกการขาย",
  "shop.pos.recording": "กำลังบันทึก…",
  "shop.pos.sale_success_title": "บันทึกการขายแล้ว",
  "shop.pos.sale_success_description": "ยอดรวม {{total}} · กำไรขั้นต้น {{grossProfit}}",
  "shop.pos.done_button": "เสร็จสิ้น",
  "shop.inventory.title": "คลังสินค้าร้านค้า",
  "shop.inventory.subtitle": "สต๊อกคงเหลือ ระดับขั้นต่ำ และมูลค่าคงคลัง",
  "shop.inventory.col_status": "สถานะ",
  "shop.inventory.col_value": "มูลค่าคงคลัง",
  "shop.inventory.status_ok": "ปกติ",
  "shop.inventory.status_low": "ใกล้หมด",
  "shop.inventory.status_out": "สินค้าหมด",
  "shop.inventory.receive_stock": "รับสินค้าเข้าสต๊อก",
  "shop.inventory.adjust_stock": "ปรับปรุงสต๊อก",
  "shop.inventory.qty_label": "จำนวน",
  "shop.inventory.unit_cost_label": "ต้นทุนต่อหน่วย (฿)",
  "shop.inventory.note_label": "หมายเหตุ",
  "shop.inventory.receive_button": "รับเข้า",
  "shop.inventory.adjust_button": "ปรับปรุง",
  "shop.inventory.receive_success": "รับสินค้าเข้าสต๊อกแล้ว",
  "shop.inventory.receive_failed": "รับสินค้าเข้าสต๊อกไม่สำเร็จ",
  "shop.inventory.adjust_success": "ปรับปรุงสต๊อกแล้ว",
  "shop.inventory.adjust_failed": "ปรับปรุงสต๊อกไม่สำเร็จ",
  "shop.inventory.movements_title": "ความเคลื่อนไหวของสต๊อก",
  "shop.inventory.movements_empty": "ยังไม่มีความเคลื่อนไหวของสต๊อก",
  "shop.inventory.summary_total_value": "มูลค่าคงคลังทั้งหมด",
  "shop.inventory.summary_out_of_stock": "สินค้าหมด",
  "shop.inventory.summary_low_stock": "สินค้าใกล้หมด",
  "shop.inventory.select_variant_label": "ตัวเลือกสินค้า",
  "shop.inventory.select_variant_placeholder": "เลือกตัวเลือกสินค้า",
  "shop.inventory.variant_required": "กรุณาเลือกตัวเลือกสินค้า",
  "shop.inventory.qty_required": "กรุณาระบุจำนวน",
  "shop.inventory.qty_positive": "จำนวนต้องมากกว่า 0",
  "shop.inventory.qty_nonzero": "จำนวนต้องไม่เป็นศูนย์",
  "shop.inventory.unit_cost_required": "กรุณาระบุต้นทุนต่อหน่วย",
  "shop.inventory.unit_cost_negative": "ต้นทุนต่อหน่วยต้องไม่ติดลบ",
  "shop.inventory.history_button": "ประวัติ",
  "shop.inventory.movements_col_type": "ประเภท",
  "shop.inventory.movements_col_qty": "จำนวน",
  "shop.inventory.movements_col_unit_cost": "ต้นทุนต่อหน่วย",
  "shop.inventory.movements_col_note": "หมายเหตุ",
  "shop.inventory.movements_col_date": "วันที่",
  "shop.inventory.movement_type_stock_in": "รับสินค้าเข้าสต๊อก",
  "shop.inventory.movement_type_sale": "การขาย",
  "shop.inventory.movement_type_adjustment": "การปรับปรุง",
  "shop.reports.title": "รายงานร้านค้า",
  "shop.reports.subtitle": "ภาพรวมยอดขาย กำไร และยอดค้างชำระ",
  "shop.reports.monthly_title": "ยอดขายรายเดือน",
  "shop.reports.yearly_title": "ยอดขายรายปี",
  "shop.reports.top_sellers_title": "สินค้าขายดี",
  "shop.reports.debtors_title": "ยอดค้างชำระ",
  "shop.reports.col_month": "เดือน",
  "shop.reports.col_year": "ปี",
  "shop.reports.col_total_amount": "ยอดขายรวม",
  "shop.reports.col_total_cost": "ต้นทุนรวม",
  "shop.reports.col_gross_profit": "กำไรขั้นต้น",
  "shop.reports.col_qty_sold": "จำนวนที่ขาย",
  "shop.reports.col_revenue": "รายได้",
  "shop.reports.col_buyer": "ผู้ซื้อ",
  "shop.reports.col_outstanding": "ยอดค้างชำระ",
  "shop.reports.target_label": "เป้าหมาย",
  "shop.reports.set_target": "ตั้งเป้าหมาย",
  "shop.reports.target_amount_label": "จำนวนเป้าหมาย (฿)",
  "shop.reports.settle_button": "เคลียร์ยอด",
  "shop.reports.settle_success": "เคลียร์ยอดแล้ว",
  "shop.reports.settle_failed": "เคลียร์ยอดไม่สำเร็จ",
  "shop.reports.debtors_empty": "ไม่มียอดค้างชำระ",
  "shop.reports.from_label": "จาก",
  "shop.reports.to_label": "ถึง",
  "shop.reports.tab_monthly": "รายเดือน",
  "shop.reports.tab_yearly": "รายปี",
  "shop.reports.tab_top_sellers": "สินค้าขายดี",
  "shop.reports.tab_debtors": "ยอดค้างชำระ",
  "shop.reports.year_label": "ปี",
  "shop.reports.legend_actual": "ยอดขายจริง",
  "shop.reports.target_updated": "อัปเดตเป้าหมายแล้ว",
  "shop.reports.target_update_failed": "อัปเดตเป้าหมายไม่สำเร็จ",
  "shop.reports.target_invalid": "กรุณาระบุจำนวนเป้าหมายที่ถูกต้อง",
  "shop.reports.col_open_sales": "รายการค้างชำระ",
  "shop.reports.total_outstanding": "ยอดค้างชำระรวม",
  "shop.reports.settle_confirm_title": "เคลียร์ยอดขาย",
  "shop.reports.settle_confirm_description": "ยืนยันการเคลียร์ยอดขายเงินเชื่อรายการนี้เป็นชำระแล้วหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "shop.reports.top_sellers_empty": "ไม่มียอดขายในช่วงเวลานี้",
  "shop.reports.yearly_empty": "ยังไม่มียอดขาย",
  "shop.reports.col_amount": "จำนวนเงิน",
  "shop.reports.col_sale_id": "รายการขาย",
  "nav.allergy_change_requests": "คำขอเปลี่ยนแปลงการแพ้อาหาร",
  "allergy_changes.title": "คำขอเปลี่ยนแปลงการแพ้อาหารและการกินอาหารพิเศษ",
  "allergy_changes.subtitle": "ตรวจสอบการเปลี่ยนแปลงข้อมูลการแพ้อาหารและการกินอาหารพิเศษที่ผู้ปกครองเสนอ ก่อนนำไปบันทึกในประวัตินักเรียน",
  "allergy_changes.search_aria": "ค้นหาคำขอเปลี่ยนแปลงการแพ้อาหารด้วยชื่อนักเรียน",
  "allergy_changes.empty": "ไม่พบคำขอเปลี่ยนแปลงที่ตรงกับตัวกรองนี้",
  "allergy_changes.col_submitted_at": "วันที่ส่งคำขอ",
  "allergy_changes.col_document": "เอกสาร",
  "allergy_changes.document_attached_badge": "แนบเอกสารแล้ว",
  "allergy_changes.document_required_badge": "ต้องแนบเอกสาร",
  "allergy_changes.review_action": "ตรวจสอบ",
  "allergy_changes.no_allergies": "ไม่มีข้อมูลการแพ้อาหาร",
  "allergy_changes.no_dietary_note": "ไม่มีข้อมูลการกินอาหารพิเศษ",
  "allergy_changes.review_title": "ตรวจสอบคำขอเปลี่ยนแปลงการแพ้อาหาร",
  "allergy_changes.review_description": "เปรียบเทียบข้อมูลปัจจุบันกับการเปลี่ยนแปลงที่เสนอสำหรับ {{name}} คุณสามารถแก้ไขข้อมูลก่อนอนุมัติได้",
  "allergy_changes.current_label": "ข้อมูลปัจจุบัน",
  "allergy_changes.view_document": "ดูเอกสารประกอบ",
  "allergy_changes.proposed_label": "การเปลี่ยนแปลงที่เสนอ",
  "allergy_changes.toast_approved": "อนุมัติการเปลี่ยนแปลงการแพ้อาหารแล้ว",
  "allergy_changes.toast_rejected": "ปฏิเสธการเปลี่ยนแปลงการแพ้อาหารแล้ว",
  "presence.help_note": "แสดงรายชื่อผู้ที่เปิดแอปแอดมินอยู่ในขณะนี้ แท็บที่เปิดค้างไว้โดยไม่ได้ใช้งานก็ยังนับว่าออนไลน์ ข้อมูลนี้จึงไม่ใช่บันทึกการเข้างานหรือลงเวลา เป็นเพียงการบอกว่ามีใครอยู่ตอนนี้บ้าง",
  "presence.title": "ออนไลน์ตอนนี้",
  "presence.empty": "ขณะนี้ไม่มีผู้ใช้เชื่อมต่อ",
  "presence.connected_since": "เชื่อมต่อ {{duration}}",
  "presence.count_label": "ออนไลน์",
  "presence.online": "ออนไลน์",
  "presence.offline": "ออฟไลน์",
  "nav.my_profile": "โปรไฟล์ของฉัน",
  "dashboard.widget.bell_remaining": "เหลืออีก {{count}} ครั้งวันนี้ ครั้งสุดท้าย {{last}}",
  "nav.bell_schedule": "ตารางกริ่ง",
  "bell_schedule.subtitle": "กริ่งทั้งหมดที่โรงเรียนจะตีในวันที่เลือก",
  "bell_schedule.help_note": "รายการนี้คือสิ่งที่ตัวควบคุมกริ่งจะเล่นจริง โดยอ่านจากตารางเดียวกัน เลื่อนดูวันอื่นเพื่อตรวจสอบตารางพิเศษหรือวันคาบสั้นล่วงหน้าได้",
  "bell_schedule.previous_day": "วันก่อนหน้า",
  "bell_schedule.next_day": "วันถัดไป",
  "bell_schedule.today": "วันนี้",
  "bell_schedule.next": "ถัดไป",
  "bell_schedule.regular_schedule": "ตารางปกติ",
  "bell_schedule.ring_count": "กริ่ง {{count}} ครั้ง",
  "bell_schedule.starts_group": "{{first}} · {{second}} (กลุ่มพักกลางวันที่สอง)",
  "bell_schedule.kind_bell": "กริ่งเข้าคาบ",
  "bell_schedule.kind_anthem": "เพลงชาติ",
  "bell_schedule.kind_break_warning": "สัญญาณเตือนหมดเวลาพัก",
  "bell_schedule.kind_last_bell": "กริ่งเลิกเรียน",
  "bell_schedule.bells_off_warning": "กริ่งถูกปิดอยู่ในการตั้งค่ากริ่ง จึงจะไม่มีเสียงดังจริงในวันนี้",
  "bell_schedule.empty_title": "ไม่มีกริ่งในวันที่ {{date}}",
  "bell_schedule.empty_disabled": "กริ่งถูกปิดอยู่ในการตั้งค่ากริ่ง",
  "bell_schedule.empty_no_active_year": "วันที่นี้อยู่นอกปีการศึกษาที่ใช้งานอยู่",
  "bell_schedule.empty_not_school_day": "วันนี้ไม่ใช่วันเปิดเรียน",
  "bell_schedule.empty_no_schedule": "ไม่มีคาบเรียนในวันนี้",
  "bookings.grid_title": "เลือกคาบและห้อง",
  "bookings.grid_legend": "ช่องสีเขียวคือว่าง คลิกเพื่อเลือกคาบและห้องนั้น ช่องสีเทาแสดงชั้นเรียนหรือผู้ที่ใช้ห้องอยู่แล้ว",
  "bookings.grid_pick_date": "เลือกวันที่เพื่อดูห้องที่ว่าง",
  "bookings.grid_load_error": "ไม่สามารถโหลดข้อมูลห้องว่างของวันที่นี้ได้",
  "bookings.grid_empty": "ไม่มีห้องหรือคาบที่จองได้ในวันที่นี้",
  "bookings.error_grid_pick_required": "กรุณาเลือกคาบและห้องที่ว่างจากตาราง",
  "bookings.horizon_hint": "จองล่วงหน้าได้ไม่เกิน {{days}} วัน",
  "settings.label.bookings_max_advance_days": "ช่วงเวลาที่จองล่วงหน้าได้ (วัน)",
  "settings.desc.bookings_max_advance_days": "บุคลากรจองห้องหรือแท็บเล็ตล่วงหน้าได้กี่วัน ใส่ 0 หากไม่จำกัด",
  "settings.label.newsletter_batch_size": "ขนาดชุดการส่งจดหมายข่าว",
  "settings.desc.newsletter_batch_size": "จำนวนผู้รับต่อหนึ่งอีเมล สูงสุดไม่เกิน 100 เสมอ (ข้อจำกัดของ Gmail SMTP)",
  "settings.label.newsletter_batch_delay_ms": "ระยะหน่วงระหว่างชุดการส่ง (มิลลิวินาที)",
  "settings.desc.newsletter_batch_delay_ms": "ระยะเวลาหยุดพักระหว่างแต่ละชุดขณะส่งจดหมายข่าว",
  "settings.label.newsletter_daily_allowance": "จำนวนผู้รับสูงสุดต่อวันสำหรับจดหมายข่าว",
  "settings.desc.newsletter_daily_allowance": "ระบบจะปฏิเสธการส่งก่อนเริ่มส่งจริง หากจำนวนผู้รับเกินจำนวนนี้",
  "bookings.tablets_free_of_total": "ว่าง {{remaining}} จาก {{total}} เครื่อง",
  "bookings.tablets_all_out": "ไม่เหลือแล้ว",
  "bookings.tablets_none_in_pool": "ยังไม่มีแท็บเล็ตในคลัง",
  "bookings.tablets_legend": "แสดงคาบที่มีแท็บเล็ตว่างอย่างน้อย {{wanted}} เครื่อง เปลี่ยนจำนวนเพื่อดูคาบอื่น",
  "dashboard.widget.bookings_today_count_label": "วันนี้",
  "dashboard.widget.bookings_none_today": "ไม่มีการจองวันนี้",
  "dashboard.widget.bookings_next_up": "ถัดไป",
  "dashboard.widget.upcoming_bookings": "การจองห้องและแท็บเล็ต",
  "dashboard.widget.upcoming_bookings_empty": "ยังไม่มีการจอง",
  "dashboard.widget.bookings_tablets": "แท็บเล็ต {{count}} เครื่อง",
  "dashboard.widget.bookings_room": "ห้อง",
  "settings.label.booking_recipients": "การแจ้งเตือนการจอง",
  "settings.desc.booking_recipients": "ผู้ที่จะได้รับอีเมลทุกครั้งที่มีการจองห้องหรือแท็บเล็ต",
  "realtime.live": "เรียลไทม์",
  "realtime.reconnecting": "กำลังเชื่อมต่อใหม่",
  "realtime.live_hint": "เชื่อมต่ออยู่ ข้อมูลจะอัปเดตอัตโนมัติเมื่อมีการเปลี่ยนแปลง",
  "realtime.offline_hint": "ยังไม่ได้เชื่อมต่อ ข้อมูลจะอัปเดตอีกครั้งเมื่อเชื่อมต่อสำเร็จ",
  "signature.title": "ลายเซ็นอีเมล",
  "signature.help_note": "กรอกข้อมูลของคุณ คัดลอกลายเซ็น แล้ววางใน Gmail ที่ การตั้งค่า → ทั่วไป → ลายเซ็น ระบบไม่บันทึกข้อมูลนี้ ลายเซ็นถูกสร้างที่นี่และคัดลอกไปยังคลิปบอร์ดโดยตรง",
  "signature.field_prefix": "คำนำหน้า",
  "signature.prefix_placeholder": "ดร.",
  "signature.field_name": "ชื่อ",
  "signature.name_hint": "โรงเรียนเป็นผู้ดูแลชื่อนี้ หากต้องการแก้ไขโปรดติดต่อผู้ดูแลระบบ หากคุณใช้คำนำหน้า เช่น ดร. สามารถเพิ่มได้ที่ช่องคำนำหน้า",
  "signature.field_title": "ตำแหน่ง",
  "signature.field_title_extra": "ตำแหน่ง (บรรทัดที่ {{n}})",
  "signature.title_placeholder": "หัวหน้ากลุ่มสาระคณิตศาสตร์",
  "signature.field_phone": "โทรศัพท์",
  "signature.phone_hint": "ไม่บังคับ เว้นว่างไว้หากไม่ต้องการแสดงบรรทัดนี้",
  "signature.preview": "ตัวอย่าง",
  "signature.copy": "คัดลอกลายเซ็น",
  "signature.copied": "คัดลอกลายเซ็นแล้ว นำไปวางใน Gmail ได้เลย",
  "signature.copied_html": "คัดลอกโค้ด HTML ของลายเซ็นแล้ว",
  "signature.copy_failed": "คัดลอกไม่สำเร็จ กรุณาเลือกตัวอย่างแล้วคัดลอกด้วยตนเอง",
  "signature.field_title_line": "ตำแหน่ง บรรทัดที่ {{n}}",
  "signature.title_placeholder_extra": "ตำแหน่งเพิ่มเติม เช่น ผู้อำนวยการฝ่ายกีฬา",
  "signature.title_hint": "หนึ่งบรรทัดต่อหนึ่งตำแหน่ง เพิ่มบรรทัดสำหรับแต่ละตำแหน่งที่คุณดำรงอยู่ บรรทัดที่เว้นว่างจะไม่ถูกแสดง",
  "signature.add_title": "เพิ่มตำแหน่ง",
  "signature.remove_title": "ลบตำแหน่งนี้",
  "signature.howto_title": "วิธีตั้งค่าใน Gmail",
  "signature.subtitle": "สร้างลายเซ็นอีเมลของโรงเรียนและนำไปวางใน Gmail",
  "signature.client_gmail": "Gmail",
  "signature.client_outlook": "Outlook",
  "signature.client_apple": "Apple Mail",
  "signature.howto_gmail_1": "กดปุ่ม คัดลอกลายเซ็น ด้านบน",
  "signature.howto_gmail_2": "ใน Gmail เปิด การตั้งค่า (ไอคอนรูปเฟือง) → ดูการตั้งค่าทั้งหมด → ทั่วไป",
  "signature.howto_gmail_3": "เลื่อนไปที่ ลายเซ็น แล้วกด สร้างใหม่ และตั้งชื่อ หรือเลือกลายเซ็นที่ใช้อยู่",
  "signature.howto_gmail_4": "คลิกในกล่องลายเซ็นแล้ววาง (Ctrl+V หรือ Cmd+V บนเครื่อง Mac) ตราโรงเรียนและรูปแบบจะติดไปด้วย",
  "signature.howto_gmail_5": "ในส่วน ค่าเริ่มต้นของลายเซ็น ให้เลือกใช้กับอีเมลใหม่และการตอบกลับ แล้วกด บันทึกการเปลี่ยนแปลง",
  "signature.howto_gmail_note": "ควรวางบนคอมพิวเตอร์ เพราะแอป Gmail บนมือถือวางลายเซ็นแบบมีรูปแบบไม่ได้ แต่จะใช้ลายเซ็นที่บันทึกไว้นี้",
  "signature.howto_outlook_1": "กดปุ่ม คัดลอกลายเซ็น ด้านบน",
  "signature.howto_outlook_2": "ใน Outlook บนเว็บหรือ Outlook รุ่นใหม่ เปิด การตั้งค่า (ไอคอนรูปเฟือง) → จดหมาย → เขียนและตอบกลับ",
  "signature.howto_outlook_3": "ในส่วน ลายเซ็นอีเมล กด ลายเซ็นใหม่ และตั้งชื่อ",
  "signature.howto_outlook_4": "คลิกในกล่องแล้ววาง (Ctrl+V หรือ Cmd+V บนเครื่อง Mac)",
  "signature.howto_outlook_5": "เลือกให้ใช้กับข้อความใหม่ และการตอบกลับ/ส่งต่อ แล้วกด บันทึก",
  "signature.howto_outlook_note": "สำหรับ Outlook รุ่นคลาสสิกบน Windows ให้ไปที่ ไฟล์ → ตัวเลือก → จดหมาย → ลายเซ็น แล้ววางในกล่องแก้ไขลายเซ็น",
  "signature.howto_apple_1": "กดปุ่ม คัดลอกลายเซ็น ด้านบน",
  "signature.howto_apple_2": "ในแอป Mail เปิด Mail → การตั้งค่า (Preferences ใน macOS รุ่นเก่า) → ลายเซ็น",
  "signature.howto_apple_3": "เลือกบัญชีของโรงเรียนในคอลัมน์ซ้าย กด + แล้วตั้งชื่อลายเซ็น",
  "signature.howto_apple_4": "เอาเครื่องหมายถูกออกจาก “ใช้แบบอักษรเริ่มต้นของข้อความเสมอ” คลิกในช่องด้านขวาแล้ววาง (Cmd+V)",
  "signature.howto_apple_5": "ปิดหน้าต่างการตั้งค่า แล้วเลือกลายเซ็นนี้ในช่อง เลือกลายเซ็น ของบัญชีนั้น",
  "signature.howto_apple_note": "ควรตั้งค่าบนเครื่อง Mac เพราะแอป Mail บน iPhone และ iPad รองรับเฉพาะลายเซ็นแบบข้อความล้วน",
  "profile.tab_profile": "โปรไฟล์",
  "profile.tab_public": "โปรไฟล์บนเว็บไซต์",
  "profile.tab_signature": "ลายเซ็นอีเมล",
  "profile.wallet_section": "กระเป๋าเงินโรงอาหาร",
  "profile.wallet_balance_label": "ยอดคงเหลือปัจจุบัน",
  "profile.wallet_empty": "ยังไม่มีรายการ",
  "profile.notification_emails_title": "การแจ้งเตือน",
  "profile.notification_emails_label": "ส่งการแจ้งเตือนทางอีเมลถึงฉัน",
  "profile.notification_emails_hint": "ทุกอย่างยังคงแสดงที่กระดิ่งเช่นเดิม — การปิดสวิตช์นี้หยุดเฉพาะอีเมลเท่านั้น อีเมลเกี่ยวกับบัญชี เช่น การรีเซ็ตรหัสผ่าน จะไม่ได้รับผลกระทบ",
  "nav.section.my_work": "งานของฉัน",
  "nav.my_work.classes_today": "คาบเรียนและบันทึกการสอน",
  "nav.my_work.newsletter": "จดหมายข่าว",
  "nav.my_work.bookings": "การจอง",
  "nav.my_work.leaves": "การลา",
  "nav.my_work.it_tickets": "แจ้งปัญหาไอที",
  "nav.my_work.sst": "SST",
  "nav.section.attendance": "การเข้าเรียน",
  "nav.section.people": "บุคคล",
  "dashboard.updated_ago": "อัปเดต{{ago}}",
  "attendance.per_period_off_notice": "{{class}} เช็กชื่อวันละครั้ง จึงไม่มีข้อมูลรายคาบให้บันทึก หากต้องการใช้หน้านี้ ให้เปิด “เช็กชื่อรายคาบ” สำหรับห้องนี้ที่ ตารางสอน → ตั้งค่า → ห้องเรียน",
  "enum.tour_status.replied": "ตอบกลับแล้ว",
  "credential_export.preparing": "กำลังเตรียม…",
  "lesson_excusals.title": "คำขอลาคาบเรียน",
  "lesson_excusals.dialog_title": "บันทึกการลาเรียนรายคาบ",
  "lesson_excusals.record_button": "บันทึกการลา",
  "lesson_excusals.day_label": "วัน",
  "lesson_excusals.choose_lesson": "เลือกคาบเรียน",
  "lesson_excusals.no_lessons": "ไม่มีคาบเรียนที่ลาได้ในวันนั้น",
  "lesson_excusals.lesson_required": "กรุณาเลือกคาบเรียน",
  "lesson_excusals.below_threshold": "ต่ำกว่าเกณฑ์การเข้าเรียนในวิชา {{subject}} แล้ว",
  "lesson_excusals.current_attendance": "การเข้าเรียนในวิชา {{subject}}",
  "lesson_excusals.toast_recorded": "บันทึกการลาเรียนรายคาบแล้ว",
  "lesson_excusals.record_failed": "บันทึกการลาเรียนรายคาบไม่สำเร็จ",
  "dashboard.widget.out_today_label": "ไม่อยู่วันนี้",
  "dashboard.widget.movements_today_label": "วันนี้",
  "attendance.leaves_at": "กลับ {{time}}",
  "teacher_day.nobody_out": "ไม่มีผู้ที่ไม่อยู่หรือกลับก่อนเวลาในวันที่เลือก",
  "teacher_day.students_out": "นักเรียนที่ไม่อยู่",
  "teacher_day.leaves_at": "กลับเวลา {{time}}",
  "teacher_day.misses_lesson": "ขาด {{subject}} · {{period}}",
  "teacher_day.your_homeroom": "โฮมรูมของคุณ",
  "teacher_day.staff_out": "เจ้าหน้าที่ไม่อยู่",
  "lesson_excusals.subtitle": "คาบเรียนที่ครอบครัวแจ้งลา และที่โรงเรียนบันทึกแทน",
  "lesson_excusals.tab_full_day": "ลาเต็มวัน",
  "lesson_excusals.tab_lessons": "รายคาบเรียน",
  "lesson_excusals.delete_title": "ลบการลารายคาบนี้หรือไม่?",
  "lesson_excusals.delete_description": "คาบเรียนนี้จะกลับไปเป็นไม่มีการบันทึกการเข้าเรียน และจะไม่มีการแจ้งผู้ปกครอง หากครูเคยบันทึกการเข้าเรียนไว้ก่อนที่จะมีการลานี้ จะไม่สามารถกู้คืนได้",
  "lesson_excusals.tab_switch": "ประเภทการลา",
  "lesson_excusals.col_lesson": "คาบเรียน",
  "lesson_excusals.col_attendance": "การเข้าเรียน",
  "lesson_excusals.rate_at_request": "{{percent}}% เมื่อแจ้ง",
  "lesson_excusals.type.injury": "บาดเจ็บ",
  "lesson_excusals.type.illness": "ป่วย",
  "lesson_excusals.type.medical": "การแพทย์",
  "lesson_excusals.type.religious": "ศาสนกิจ",
  "lesson_excusals.type.other": "อื่นๆ",
  "subjects.parent_excusable": "ผู้ปกครองสามารถขอลาคาบเรียนนี้ได้",
  "attendance.col_subject_rate": "การเข้าเรียนวิชา{{subject}}",
  "attendance.col_subject_rate_short": "การเข้าเรียน",
  "attendance.tab_daily": "รายวัน",
  "attendance.tab_classes": "ตามชั้นเรียน",
  "attendance.no_grade": "ไม่มีระดับชั้น",
  "attendance.tab_subjects": "ตามวิชา",
  "attendance.tab_audit": "ตรวจสอบ",
  "attendance.audit_title": "ตรวจสอบการเช็คชื่อ",
  "attendance.audit_subtitle": "การเช็คชื่อที่ยังไม่ครบ: นักเรียนที่ยังไม่มีการเช็คชื่อประจำวัน และคาบเรียนที่ยังไม่ได้เช็คชื่อหรือเช็คชื่อไม่ครบ",
  "attendance.audit_view_daily": "เช็คชื่อประจำวัน",
  "attendance.audit_view_lessons": "เช็คชื่อรายคาบ",
  "attendance.audit_daily_empty": "นักเรียนทุกคนได้รับการเช็คชื่อครบทุกวันเรียนในช่วงนี้",
  "attendance.audit_lessons_empty": "ทุกคาบเรียนในช่วงนี้เช็คชื่อครบแล้ว",
  "attendance.audit_col_period": "คาบ",
  "attendance.audit_col_class": "ห้องเรียน",
  "attendance.audit_col_subject": "วิชา",
  "attendance.audit_col_teacher": "ครู",
  "attendance.audit_col_register": "การเช็คชื่อ",
  "attendance.audit_state_missing": "ยังไม่ได้เช็คชื่อ",
  "attendance.audit_state_partial": "เช็คแล้ว {{marked}} จาก {{expected}} คน",
  "attendance.audit_skipped": "ยังไม่ได้เช็ค: {{names}}",
  "attendance.audit_all_teachers": "ครูทุกคน",
  "attendance.audit_select": "เลือก",
  "attendance.audit_select_all": "เลือกทะเบียนทั้งหมดที่แสดง",
  "attendance.audit_select_register": "เลือก {{subject}} {{period}} วันที่ {{date}}",
  "attendance.audit_fill_button": "กรอกจากการเข้าเรียนรายวัน",
  "attendance.audit_fill_selected_one": "เลือกแล้ว {{count}} ทะเบียน",
  "attendance.audit_fill_selected_other": "เลือกแล้ว {{count}} ทะเบียน",
  "attendance.audit_fill_title": "กรอกทะเบียนจากการเข้าเรียนรายวัน",
  "attendance.audit_fill_description": "กรอกเฉพาะนักเรียนที่ยังไม่มีการบันทึก โดยใช้การเข้าเรียนรายวัน การบันทึกที่มีอยู่แล้วจะไม่ถูกเปลี่ยนแปลง",
  "attendance.audit_fill_loading": "กำลังตรวจสอบทะเบียน…",
  "attendance.audit_fill_registers_one": "{{count}} ทะเบียน",
  "attendance.audit_fill_registers_other": "{{count}} ทะเบียน",
  "attendance.audit_fill_present_one": "มาเรียน {{count}} คน",
  "attendance.audit_fill_present_other": "มาเรียน {{count}} คน",
  "attendance.audit_fill_late_one": "มาสาย {{count}} คน (มาถึงระหว่างคาบ)",
  "attendance.audit_fill_late_other": "มาสาย {{count}} คน (มาถึงระหว่างคาบ)",
  "attendance.audit_fill_absent_one": "ขาดเรียน {{count}} คน (มาถึงหลังจบคาบ)",
  "attendance.audit_fill_absent_other": "ขาดเรียน {{count}} คน (มาถึงหลังจบคาบ)",
  "attendance.audit_fill_excused_one": "ลา {{count}} คน (กลับก่อนเวลา)",
  "attendance.audit_fill_excused_other": "ลา {{count}} คน (กลับก่อนเวลา)",
  "attendance.audit_fill_nothing": "ไม่มีอะไรต้องกรอก: นักเรียนทุกคนมีการบันทึกแล้ว หรือยังไม่มีการเข้าเรียนรายวัน",
  "attendance.audit_fill_skipped_title": "ไม่มีการเข้าเรียนรายวัน — เว้นว่างไว้",
  "attendance.audit_fill_skipped_hint": "บันทึกนักเรียนเหล่านี้ในทะเบียนรายวันก่อน แล้วกรอกอีกครั้ง",
  "attendance.audit_fill_confirm": "กรอกทะเบียน",
  "attendance.audit_fill_done_one": "กรอกแล้ว {{count}} ทะเบียน",
  "attendance.audit_fill_done_other": "กรอกแล้ว {{count}} ทะเบียน",
  "attendance.audit_fill_failed": "ไม่สามารถกรอกทะเบียนได้",
  "attendance.subject_rates_title": "การเข้าเรียนตามวิชา",
  "attendance.subject_rates_empty": "ยังไม่มีการบันทึกคาบเรียนในชั้นเรียนของคุณ",
  "attendance.subject_rates_filter_grade": "เกรด",
  "attendance.subject_rates_filter_subject": "วิชา",
  "settings.label.lesson_excusal_recipients": "ผู้รับแจ้งคำขอลาคาบเรียน",
  "settings.desc.lesson_excusal_recipients": "อีเมลเจ้าหน้าที่ที่จะได้รับการแจ้งเตือนเมื่อผู้ปกครองส่งคำขอลาคาบเรียน",
  "edp.approve.grade_levels_required": "เลือกอย่างน้อยหนึ่งระดับชั้น",
  "edp.approve.block_required": "กรุณาเลือกคาบ",
  "edp.approve.category_required": "กรุณาเลือกหมวดหมู่",
  "edp.approve.day_required": "กรุณาเลือกวัน",
  "edp.approve.groups_share_a_teacher_slot": "สองกลุ่มที่มีครูคนเดียวกันใช้คาบเดิมในวันเดิมไม่ได้",
  "edp.approve.description": "ยืนยันรายละเอียดสุดท้ายของวิชานี้ หากมีการเปลี่ยนแปลงจากข้อเสนอ ระบบจะบันทึกเป็นการแก้ไข",
  "edp.approve.eligible_for_free_places": "ใช้สิทธิ์เรียนฟรีได้",
  "edp.approve.eligible_for_free_places_hint": "มีเพียงบางวิชาที่ใช้สิทธิ์เรียนฟรีได้ สิทธิ์ของครอบครัวมีมูลค่าเท่ากับค่าเรียนพื้นฐานหนึ่งหน่วยต่อสิทธิ์ ใช้ได้เฉพาะกับวิชาที่เลือกไว้ที่นี่ ส่วนที่เหลือจะไม่ถูกนำไปใช้ต่อ",
  "edp.config.registration_closed": "ปิดรับคำขอใหม่",
  "edp.config.registration_closed_hint": "ใช้เมื่อมีผู้สมัครเกินจำนวนที่รับได้ วิชานี้จะยังแสดงในตารางของผู้ปกครองโดยระบุว่าเต็มแล้วและเลือกไม่ได้ ครอบครัวที่ยื่นคำขอไว้แล้วจะยังคงคำขอและลำดับคิวเดิม การตั้งค่านี้หยุดเฉพาะคำขอใหม่เท่านั้น",
  "edp.schedule_tags.more": "อีก {{count}} รายการ",
  "edp.approve.external_instructor": "ไม่ใช่บุคลากรของโรงเรียน",
  "edp.approve.external_instructor_hint": "ชื่อที่ผู้ปกครองจะเห็น วิชาที่สอนแบบนี้จะไม่จองช่วงบ่ายของใคร",
  "edp.approve.external_instructor_label": "ชื่อผู้สอน",
  "edp.approve.external_instructor_required": "กรุณาระบุชื่อผู้สอน",
  "edp.approve.instructor_required": "กรุณาเลือกผู้สอน",
  "edp.approve.max_below_min": "จำนวนนักเรียนสูงสุดต้องไม่น้อยกว่าจำนวนขั้นต่ำ",
  "edp.approve.min_floor": "จำนวนนักเรียนขั้นต่ำต้องมีอย่างน้อย 4 คน ยกเว้นวิชาแบบตัวต่อตัว",
  "edp.approve.min_required": "กรุณาระบุจำนวนนักเรียนขั้นต่ำ",
  "edp.approve.number_required": "กรุณาระบุตัวเลข",
  "edp.approve.preview_none": "ไม่มีการเปลี่ยนแปลงจากข้อเสนอ",
  "edp.approve.preview_title": "สิ่งที่จะเปลี่ยนแปลง",
  "edp.approve.recorded": "อนุมัติข้อเสนอแล้ว",
  "edp.approve.submit": "อนุมัติ",
  "edp.approve.title": "อนุมัติข้อเสนอ",
  "edp.approve.title_required": "กรุณาระบุชื่อวิชา",
  "edp.decision.admin_notes": "บันทึกภายใน",
  "edp.decision.admin_notes_hint": "เห็นได้เฉพาะฝ่ายบริหาร — จะไม่แสดงให้ผู้เสนอเห็น",
  "edp.decision.comment": "ความคิดเห็น",
  "edp.decision.comment_hint": "ความคิดเห็นนี้จะถูกส่งถึงผู้เสนอ",
  "edp.decision.comment_required": "กรุณาระบุความคิดเห็น",
  "edp.decision.recorded": "บันทึกการตัดสินใจแล้ว",
  "edp.decision.request_changes_title": "ขอให้แก้ไข",
  "edp.decision.waitlist_title": "ขึ้นบัญชีรอ",
  "edp.decision.reject_title": "ไม่อนุมัติข้อเสนอ",
  "edp.detail.action_approve": "อนุมัติ",
  "edp.detail.action_reject": "ไม่อนุมัติ",
  "edp.detail.action_request_changes": "ขอให้แก้ไข",
  "edp.detail.action_waitlist": "ขึ้นบัญชีรอ",
  "edp.detail.actions_title": "การตัดสินใจ",
  "edp.detail.admin_notes": "บันทึกจากฝ่ายบริหาร",
  "edp.detail.approved_as_proposed": "อนุมัติตามที่เสนอ",
  "edp.detail.approved_with_modification": "อนุมัติพร้อมการแก้ไข",
  "edp.detail.as_submitted": "ตามที่ส่งเข้ามา",
  "edp.detail.capacity_warning_title": "จำนวนสูงสุด {{max}} คน เกินมาตรฐานของช่วงชั้นนี้",
  "edp.detail.comment_error": "ไม่สามารถส่งความคิดเห็นได้ กรุณาลองใหม่",
  "edp.detail.comment_placeholder": "เขียนความคิดเห็น…",
  "edp.detail.comment_send": "ส่ง",
  "edp.detail.conversation": "การสนทนา",
  "edp.detail.edit_and_resubmit": "แก้ไขและส่งใหม่",
  "edp.detail.field_additional_info": "ข้อมูลเพิ่มเติม",
  "edp.detail.field_additional_students_with_support": "รับนักเรียนที่ต้องการการช่วยเหลือเพิ่มเติมได้หรือไม่",
  "edp.detail.field_available_for_two_classes": "พร้อมสอนสองคาบ",
  "edp.detail.field_block": "คาบ",
  "edp.detail.field_capacity": "จำนวนที่รับ",
  "edp.detail.field_category": "หมวดหมู่",
  "edp.detail.field_day": "วัน",
  "edp.detail.field_days_per_week": "จำนวนวันต่อสัปดาห์",
  "edp.detail.field_description": "รายละเอียด",
  "edp.detail.field_facility_other": "สถานที่ (อื่นๆ)",
  "edp.detail.field_grade_levels": "ระดับชั้น",
  "edp.detail.field_instructor": "ผู้สอน",
  "edp.detail.field_materials": "วัสดุและอุปกรณ์",
  "edp.detail.field_max_students": "จำนวนนักเรียนสูงสุด",
  "edp.detail.field_min_students": "จำนวนนักเรียนขั้นต่ำ",
  "edp.detail.field_objectives": "วัตถุประสงค์",
  "edp.detail.field_outcome": "ผลลัพธ์ของวิชา",
  "edp.detail.field_preferred_facilities": "สถานที่ที่ต้องการ",
  "edp.detail.field_purchase_details": "รายละเอียดการจัดซื้อ",
  "edp.detail.field_purchase_required": "ต้องมีการจัดซื้อ",
  "edp.detail.field_room": "ห้อง",
  "edp.detail.field_safety_details": "รายละเอียดด้านความปลอดภัย",
  "edp.detail.field_safety_required": "ข้อกำหนดด้านความปลอดภัย",
  "edp.detail.field_sessions": "วันและช่วงเวลา",
  "edp.detail.field_title": "ชื่อวิชา",
  "edp.detail.no_max": "ไม่กำหนดจำนวนสูงสุด",
  "edp.detail.resubmit_button": "ส่งใหม่",
  "edp.detail.resubmitted": "ส่งข้อเสนอใหม่แล้ว",
  "edp.detail.revision_history": "ประวัติการแก้ไข",
  "edp.detail.revision_history_toggle": "{{count}} เวอร์ชัน",
  "edp.detail.revision_version": "เวอร์ชัน {{version}}",
  "edp.detail.room_unassigned": "ยังไม่กำหนดห้อง",
  "edp.detail.withdraw_button": "ถอนข้อเสนอ",
  "edp.detail.withdraw_confirm_action": "ถอนข้อเสนอ",
  "edp.detail.withdraw_confirm_body": "ข้อเสนอนี้จะถูกถอน และจะไม่สามารถอนุมัติได้อีก การกระทำนี้ไม่สามารถย้อนกลับได้",
  "edp.detail.withdraw_confirm_title": "ถอนข้อเสนอนี้หรือไม่",
  "edp.detail.withdrawn": "ถอนข้อเสนอแล้ว",
  "edp.detail.tri_yes": "ใช่",
  "edp.detail.tri_no": "ไม่",
  "edp.detail.tri_maybe": "อาจจะ",
  "edp.detail.support_yes": "ใช่",
  "edp.detail.support_no": "ไม่",
  "edp.detail.support_na": "ไม่เกี่ยวข้อง",
  "edp.detail.support_possibly": "อาจจะ",
  "edp.detail.purchase_no": "ไม่",
  "edp.detail.purchase_yes": "ใช่",
  "edp.detail.purchase_possibly": "อาจจะ",
  "edp.detail.course_config_title": "ราคาและการเปิดลงทะเบียน",
  "edp.detail.course_config_hint": "ผู้ปกครองจะเห็นเฉพาะวิชาที่มีสถานะ \"เปิดรับลงทะเบียน\" เท่านั้น",
  "edp.detail.course_price": "ราคา (บาท ตลอดรอบ)",
  "edp.detail.course_price_hint": "จำนวนที่ผู้ปกครองจ่ายสำหรับทุกคาบของวิชานี้ ไม่ใช่ราคาต่อคาบ",
  "edp.detail.course_price_invalid": "กรอกจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
  "edp.detail.course_status": "สถานะการลงทะเบียน",
  "edp.detail.course_status_locked": "ถูกกำหนดโดยอัตโนมัติเมื่อมีการจัดสรรที่นั่งแล้ว",
  "edp.detail.course_config_saved": "บันทึกการตั้งค่าวิชาแล้ว",
  "edp.detail.families_will_see_heading": "ผู้ปกครองจะเห็นข้อมูลนี้",
  "edp.detail.families_will_see_hint": "ผู้ปกครองที่กำลังเลือกวิชาให้บุตรหลานจะอ่านข้อมูลนี้",
  "edp.detail.office_only_heading": "สำหรับสำนักงาน",
  "edp.detail.course_title": "ชื่อวิชา",
  "edp.detail.course_title_required": "กรุณากรอกชื่อวิชา",
  "edp.detail.course_description": "รายละเอียด",
  "edp.detail.course_description_required": "กรุณากรอกรายละเอียด",
  "edp.detail.course_objectives": "วัตถุประสงค์",
  "edp.mine.empty": "คุณยังไม่ได้เสนอวิชา EDP",
  "edp.mine.empty_for_status": "ไม่มีข้อเสนอที่ตรงกับตัวกรองนี้",
  "edp.mine.filter_status": "สถานะ",
  "edp.mine.guide_link": "คู่มือและนโยบาย EDP",
  "edp.mine.heading": "ข้อเสนอ EDP ของฉัน",
  "edp.mine.propose": "เสนอวิชาใหม่",
  "edp.mine.subtitle": "ข้อเสนอวิชา EDP ของคุณ ทั้งที่ส่งแล้ว กำลังพิจารณา และตัดสินใจแล้ว",
  "edp.propose.add_another": "เพิ่มวิชาอีกรายการ",
  "edp.propose.additional_info": "ข้อมูลเพิ่มเติม",
  "edp.propose.additional_students_with_support": "รับนักเรียนที่ต้องการการช่วยเหลือเพิ่มเติมได้หรือไม่",
  "edp.propose.category": "หมวดหมู่",
  "edp.propose.confirm_accept": "ฉันได้อ่านและยอมรับข้อความข้างต้นทั้งหมด",
  "edp.propose.confirmation": "การยืนยัน",
  "edp.propose.course_n": "วิชาที่ {{n}}",
  "edp.propose.description": "รายละเอียด",
  "edp.propose.facility_other": "ระบุสถานที่",
  "edp.propose.grade_levels": "ระดับชั้น",
  "edp.propose.grade_levels_hint": "เลือกทุกระดับชั้นที่วิชานี้เปิดรับ ไม่จำเป็นต้องเป็นชั้นที่ติดกัน",
  "edp.propose.one_on_one": "วิชาแบบตัวต่อตัวหรือแบบส่วนตัว",
  "edp.propose.one_on_one_hint": "สอนแบบรายบุคคลไม่ใช่แบบกลุ่ม จึงไม่ใช้เกณฑ์ขั้นต่ำ 4 คน แต่ยังต้องเลือกระดับชั้นที่เปิดรับ",
  "edp.propose.heading": "เสนอวิชา EDP",
  "edp.propose.back_to_guide": "← คู่มือและนโยบาย EDP",
  "edp.propose.identity_from_account": "ชื่อและบทบาทของคุณถูกดึงมาจากบัญชีของคุณ — ไม่ต้องกรอกใหม่",
  "edp.propose.materials": "วัสดุและอุปกรณ์",
  "edp.propose.max_hint": "เว้นว่างไว้หากไม่กำหนดจำนวนสูงสุด",
  "edp.propose.max_students": "จำนวนนักเรียนสูงสุด",
  "edp.propose.maybe": "อาจจะ",
  "edp.propose.min_students": "จำนวนนักเรียนขั้นต่ำ",
  "edp.propose.no_open_round": "ขณะนี้ยังไม่มีรอบที่เปิดรับข้อเสนอ กรุณากลับมาตรวจสอบอีกครั้งเมื่อฝ่ายบริหารเปิดรอบใหม่",
  "edp.propose.not_applicable": "ไม่เกี่ยวข้อง",
  "edp.propose.objectives": "วัตถุประสงค์",
  "edp.propose.outcome": "ผลลัพธ์ของวิชา",
  "edp.propose.position_department": "ตำแหน่ง / แผนก",
  "edp.propose.possibly": "อาจจะ",
  "edp.propose.preferred_facilities": "สถานที่ที่ต้องการ",
  "edp.propose.purchase_details": "รายละเอียดการจัดซื้อ",
  "edp.propose.purchase_required": "วิชานี้ต้องมีการจัดซื้อหรือไม่",
  "edp.propose.round_window": "{{round}} · ปิดรับข้อเสนอ {{closes}}",
  "edp.propose.safety_details": "รายละเอียดด้านความปลอดภัย",
  "edp.propose.safety_required": "วิชานี้มีข้อกำหนดด้านความปลอดภัยเฉพาะหรือไม่",
  "edp.propose.submit": "ส่งข้อเสนอ",
  "edp.propose.submitted": "ส่งข้อเสนอ {{count}} วิชาเรียบร้อยแล้ว",
  "edp.guide.eyebrow": "โปรแกรมเสริมหลักสูตรและกิจกรรมหลังเลิกเรียน",
  "edp.guide.heading": "ทุกอย่างเกี่ยวกับ EDP รวมไว้ที่เดียว",
  "edp.guide.intro": "EDP มีคาบเรียนหลังเลิกเรียน 2 คาบ คาบละ 50 นาที แบ่งเป็น 5 ช่วงชั้น และมีทั้งวิชาการและกิจกรรม โดยบุคลากรของเราเป็นผู้เสนอทั้งหมด หน้านี้อธิบายวิธีเสนอคอร์ส สิ่งที่โรงเรียนคาดหวัง และขั้นตอนหลังจากที่ท่านส่งข้อเสนอ",
  "edp.guide.chip_block1": "15:40–16:30 · คาบที่ 1",
  "edp.guide.chip_transition": "16:30–16:40 · ช่วงเปลี่ยนคาบ",
  "edp.guide.chip_block2": "16:40–17:30 · คาบที่ 2",
  "edp.guide.chip_minimum": "ต้องมีนักเรียนอย่างน้อย 4 คน",
  "edp.guide.chip_bands": "5 ช่วงชั้น",
  "edp.guide.how_heading": "วิธีเสนอคอร์ส EDP",
  "edp.guide.step_design": "ออกแบบคอร์ส",
  "edp.guide.step_design_body": "เลือกช่วงชั้น ประเภท (เสริมหลักสูตรหรือกิจกรรม) และรูปแบบ 50 นาทีที่เหมาะกับคาบที่ 1 หรือคาบที่ 2",
  "edp.guide.step_propose": "เสนอได้ครั้งละหลายคอร์ส",
  "edp.guide.step_propose_body": "ชื่อและตำแหน่งของท่านดึงจากบัญชีผู้ใช้โดยอัตโนมัติ ท่านเพิ่มคอร์สได้หลายรายการในการส่งครั้งเดียว และแต่ละคอร์สจะได้รับการพิจารณาแยกกัน",
  "edp.guide.step_review": "ฝ่ายบริหารพิจารณา",
  "edp.guide.step_review_body": "ข้อเสนอจะพิจารณาจากความครอบคลุมของช่วงชั้น ความสมดุลของโปรแกรม บุคลากร สถานที่ ความปลอดภัย และจำนวนนักเรียนที่คาดว่าจะสมัคร",
  "edp.guide.step_decision": "ท่านจะได้รับผลการพิจารณา",
  "edp.guide.step_decision_body": "ฝ่ายบริหารอาจอนุมัติตามที่เสนอ อนุมัติโดยมีการปรับเปลี่ยน จัดไว้ในรายชื่อสำรอง หรือไม่อนุมัติในรอบนี้ ผลจะแสดงในข้อเสนอของท่าน พร้อมระบุสิ่งที่เปลี่ยนแปลงไปจากที่ท่านเสนอ",
  "edp.guide.facts_heading": "ก่อนเสนอคอร์ส",
  "edp.guide.fact_load_label": "ภาระงาน",
  "edp.guide.fact_load": "สอนได้ไม่เกิน 2 คอร์สต่อวัน",
  "edp.guide.fact_load_body": "ไม่เกินคาบละ 1 คอร์ส ขึ้นอยู่กับการจัดตาราง",
  "edp.guide.fact_minimum_label": "จำนวนขั้นต่ำ",
  "edp.guide.fact_minimum": "ต้องมีนักเรียน 4 คนจึงจะเปิดได้",
  "edp.guide.fact_minimum_body": "ยกเว้นคอร์สตัวต่อตัวหรือคอร์สส่วนตัวที่ได้รับอนุมัติ",
  "edp.guide.fact_format_label": "รูปแบบ",
  "edp.guide.fact_format": "50 นาที ภายในคาบเดียว",
  "edp.guide.fact_format_body": "คอร์สหนึ่งไม่ควรสอนต่อเนื่องคร่อมทั้งสองคาบ",
  "edp.guide.fact_compensation_label": "ค่าตอบแทน",
  "edp.guide.fact_compensation": "ฝ่ายบุคคลเป็นผู้ดูแล",
  "edp.guide.fact_compensation_body": "แยกจากข้อเสนอนี้ ตามเงื่อนไขการจ้างงานของท่าน",
  "edp.guide.band_col": "ช่วงชั้น",
  "edp.guide.band_max_col": "จำนวนสูงสุดมาตรฐาน ต่อผู้สอน 1 คน",
  "edp.guide.band_no_max": "ไม่กำหนดจำนวนสูงสุด",
  "edp.guide.band_footnote": "ระดับชั้น ป.4–ม.3 ไม่ได้กำหนดจำนวนตายตัว แต่ยังคงจำกัดด้วยลักษณะกิจกรรม ห้องเรียน อุปกรณ์ ความปลอดภัย และการดูแลนักเรียน ฝ่ายบริหารอาจกำหนดจำนวนสูงสุดที่น้อยกว่านี้ หรืออนุมัติให้รับเพิ่มได้หากมีบุคลากรเพิ่ม",
  "edp.guide.submit_heading": "ส่งข้อเสนอคอร์ส",
  "edp.guide.submit_body": "ท่านเสนอได้หลายคอร์สในครั้งเดียว การส่งข้อเสนอไม่ได้รับประกันว่าคอร์สจะเปิด ฝ่ายบริหารจะจัดตารางสุดท้ายโดยพิจารณาความครอบคลุมของช่วงชั้น ความหลากหลาย บุคลากร และความปลอดภัย",
  "edp.guide.submit_cta": "เสนอคอร์ส",
  "edp.guide.submit_window": "{{round}} · ปิดรับข้อเสนอ {{closes}}",
  "edp.guide.submit_closed": "ขณะนี้ยังไม่เปิดรับข้อเสนอ ฝ่ายบริหารจะเปิดรอบถัดไปก่อนการจัดตารางประจำภาคเรียน",
  "edp.guide.faq_heading": "คำถามที่พบบ่อย",
  "edp.guide.faq_multiple_courses": "เสนอได้มากกว่าหนึ่งคอร์สหรือไม่",
  "edp.guide.faq_multiple_courses_a": "ได้ — ท่านเพิ่มคอร์สได้หลายรายการในการส่งครั้งเดียว โดยกรอกข้อมูลบุคลากรเพียงครั้งเดียว แต่ละคอร์สจะถูกบันทึกและพิจารณาแยกกัน ฝ่ายบริหารจึงอาจอนุมัติคอร์สหนึ่ง ปรับอีกคอร์สหนึ่ง และไม่อนุมัติอีกคอร์สหนึ่งได้",
  "edp.guide.faq_two_classes": "สอน EDP สองคอร์สในวันเดียวกันได้หรือไม่",
  "edp.guide.faq_two_classes_a": "ได้ ไม่เกินสองคอร์ส — คาบที่ 1 หนึ่งคอร์ส และคาบที่ 2 หนึ่งคอร์ส ขึ้นอยู่กับการจัดตารางและการอนุมัติ โดยถือเป็นสองคอร์สแยกกัน ไม่ใช่คอร์สเดียวที่ต่อเนื่องกัน",
  "edp.guide.faq_who_decides": "ใครเป็นผู้กำหนดห้อง วัน และคาบสุดท้าย",
  "edp.guide.faq_who_decides_a": "ท่านระบุความต้องการ ส่วนฝ่ายบริหารเป็นผู้ยืนยันวัน คาบ ห้อง และช่วงชั้นสุดท้าย ตามความจำเป็นของตารางโดยรวม สิ่งที่เปลี่ยนไปจากข้อเสนอของท่านจะแสดงไว้ในข้อเสนอนั้น",
  "edp.guide.faq_equipment": "หากคอร์สต้องจัดซื้ออุปกรณ์เพิ่มต้องทำอย่างไร",
  "edp.guide.faq_equipment_a": "ระบุไว้ในข้อเสนอพร้อมประมาณการค่าใช้จ่าย การจัดซื้อทุกรายการต้องได้รับอนุมัติจากโรงเรียนก่อนดำเนินการผูกพัน",
  "edp.guide.faq_safety": "คอร์สของฉันมีว่ายน้ำ ทำอาหาร หรือใช้เครื่องมือ ต้องแจ้งอะไรบ้าง",
  "edp.guide.faq_safety_a": "โปรดอธิบายความต้องการด้านความปลอดภัยหรือการดูแลเพิ่มเติมไว้ในข้อเสนอ เช่น ความปลอดภัยทางน้ำ การเตรียมอาหาร เครื่องมือเฉพาะทาง หรือกิจกรรมกลางแจ้ง เพื่อให้ฝ่ายบริหารจัดบุคลากรได้เหมาะสม",
  "edp.guide.policy_heading": "นโยบายฉบับเต็ม",
  "edp.guide.policy_english_only": "นโยบายและแนวปฏิบัติ EDP สำหรับบุคลากร จัดทำและดูแลโดยโรงเรียนเป็นภาษาอังกฤษ และนำมาแสดงไว้ที่นี่ทั้งฉบับ",
  "edp.propose.title": "ชื่อวิชา",
  "edp.propose.families_will_see_heading": "ผู้ปกครองจะเห็นข้อมูลนี้",
  "edp.propose.families_will_see_hint": "ผู้ปกครองที่กำลังเลือกวิชาให้บุตรหลานจะอ่านข้อมูลนี้",
  "edp.propose.office_only_heading": "สำหรับสำนักงาน",
  "edp.propose.days_per_week_d1": "1 วัน",
  "edp.propose.days_per_week_d2": "2 วัน",
  "edp.propose.days_per_week_d3": "3 วัน",
  "edp.propose.days_per_week_d4": "4 วัน",
  "edp.propose.days_per_week_d5": "5 วัน",
  "edp.propose.days_per_week_flexible": "ยืดหยุ่น",
  "edp.queue.col_band": "ช่วงชั้น",
  "edp.queue.col_capacity": "จำนวนที่รับ",
  "edp.queue.col_category": "หมวดหมู่",
  "edp.queue.col_proposer": "ผู้เสนอ",
  "edp.queue.col_reference": "รหัสอ้างอิง",
  "edp.queue.col_status": "สถานะ",
  "edp.queue.col_title": "ชื่อวิชา",
  "edp.queue.empty": "ไม่มีข้อเสนอที่ตรงกับตัวกรองเหล่านี้",
  "edp.queue.filter_grade": "ระดับชั้น",
  "edp.queue.filter_block": "คาบ",
  "edp.queue.filter_category": "หมวดหมู่",
  "edp.queue.filter_day": "วัน",
  "edp.queue.filter_round": "รอบ",
  "edp.queue.filter_search": "ค้นหา",
  "edp.queue.filter_status": "สถานะ",
  "edp.queue.heading": "คิวพิจารณาข้อเสนอ EDP",
  "edp.queue.subtitle": "ตรวจสอบและตัดสินใจข้อเสนอวิชา EDP ที่ส่งเข้ามา",
  "edp.tabs_label": "ส่วนต่าง ๆ ของ EDP",
  "edp.tab_schedule": "ตารางหลัก",
  "edp.tab_proposals": "ข้อเสนอ",
  "edp.tab_registrations": "การลงทะเบียน",
  "edp.schedule.heading": "ตารางหลัก EDP",
  "edp.schedule.subtitle": "ทั้งสัปดาห์ของรอบนี้ แต่ละวิชาแสดงเป็นแถบเดียวครอบคลุมระดับชั้นที่เปิดรับ",
  "edp.schedule.filter_round": "รอบ",
  "edp.schedule.filter_grade": "ระดับชั้น",
  "edp.schedule.filter_grade_all": "ทุกระดับชั้น",
  "edp.schedule.filter_day": "วัน",
  "edp.schedule.filter_day_all": "ทุกวัน",
  "edp.schedule.filter_block": "ช่วงเวลา",
  "edp.schedule.filter_block_all": "ทุกช่วงเวลา",
  "edp.schedule.filter_category": "ประเภท",
  "edp.schedule.filter_teacher": "ครูผู้สอน",
  "edp.schedule.filter_teacher_all": "ครูทุกคน",
  "edp.schedule.count": "{{shown}} จาก {{total}} วิชา",
  "edp.schedule.gap_grade": "{{grade}} ไม่มีวิชาในวัน {{days}}",
  "edp.schedule.gaps_none_grade": "{{grade}} มีวิชาครบทุกวันที่แสดง",
  "edp.schedule.empty_no_round": "ยังไม่มีรอบ EDP ที่จะแสดงตาราง",
  "edp.schedule.col_slot": "ช่วงเวลา",
  "edp.schedule.col_grades": "ระดับชั้น",
  "edp.schedule.slot_empty": "ไม่มีวิชา",
  "edp.schedule.seats": "{{enrolled}} จาก {{max}}",
  "edp.schedule.seats_no_max": "ลงทะเบียนแล้ว {{enrolled}} คน",
  "edp.schedule.gaps_title": "วันที่ยังไม่มีวิชา",
  "edp.schedule.gap": "{{band}} ไม่มีวิชาในวัน {{days}}",
  "edp.schedule.gaps_none": "ทุกระดับชั้นมีวิชาครบทุกวันธรรมดา",
  "edp.schedule.balance_title": "สัดส่วน Co-Curricular และ Extra-Curricular",
  "edp.schedule.balance": "{{band}}: Co-Curricular {{co}} วิชา, Extra-Curricular {{extra}} วิชา",
  "edp.schedule.over_max_title": "เกินจำนวนมาตรฐาน",
  "edp.schedule.over_max": "{{title}} รับได้ถึง {{max}} คน ซึ่งเกินมาตรฐาน {{standard}} คนสำหรับระดับชั้นที่เล็กที่สุด",
  "edp.schedule.over_max_none": "ไม่มีวิชาใดเกินจำนวนมาตรฐานสำหรับระดับชั้นของตน",
  "edp.schedule.special_dates_title": "ไม่ได้อยู่ในวันคงที่",
  "edp.schedule.special_dates_hint": "วิชาเหล่านี้เรียนตามวันที่กำหนดไว้เป็นรายวัน ไม่ได้ครองช่วงเวลาประจำสัปดาห์",
  "edp.schedule.special_date_closed_mark": "โรงเรียนปิด",
  "edp.schedule.special_date_closed": "{{title}} มีเรียนวันที่ {{date}} ซึ่งไม่ใช่วันเปิดเรียน",
  "edp.schedule.print.heading": "ตารางรายสัปดาห์ EDP — {{round}}",
  "edp.schedule.print.heading_grade": "ตารางรายสัปดาห์ EDP — {{round}} · {{grade}}",
  "edp.schedule.print.caption": "ตัวกรอง: {{filters}} · พิมพ์เมื่อ {{date}}",
  "edp.schedule.print.filters_none": "ไม่มี",
  "edp.schedule.print.free_place_yes": "ใช้สิทธิ์เรียนฟรีกับวิชานี้ได้",
  "edp.schedule.print.free_place_no": "ราคาเต็ม ใช้สิทธิ์เรียนฟรีไม่ได้",
  "edp.schedule.print.free_place_legend": "● ใช้สิทธิ์เรียนฟรีได้ · ○ ราคาเต็ม",
  "edp.schedule.print.free_places_none_here": "ไม่มีสิทธิ์เรียนฟรีที่ใช้ได้กับชั้นเรียนนี้ จึงไม่มีเครื่องหมายกำกับ",
  "edp.schedule.print.meta": "{{courses}} วิชา · ราคาพื้นฐาน {{price}} · {{dates}} · {{sessions}} คาบต่อสัปดาห์",
  "edp.schedule.print.category_legend": "{{co}} เสริมหลักสูตร · {{extra}} นอกหลักสูตร",
  "edp.timeline.system": "ระบบ",
  "edp.timeline.submitted": "ส่งข้อเสนอ",
  "edp.timeline.resubmitted": "ส่งข้อเสนอใหม่",
  "edp.detail.office_edit": "แก้ไขข้อเสนอนี้",
  "edp.detail.office_edit_hint": "บันทึกการแก้ไขลงในข้อเสนอโดยตรง และเก็บฉบับเดิมของครูไว้ในประวัติ หากครูต้องเป็นผู้ตัดสินใจ ให้ใช้ \"ขอให้แก้ไข\" แทน",
  "edp.detail.office_edited": "แก้ไขข้อเสนอแล้ว",
  "edp.timeline.edited_by_office": "แก้ไขโดยสำนักงาน",
  "edp.timeline.changes_requested": "ขอให้แก้ไข",
  "edp.timeline.approved": "อนุมัติข้อเสนอ",
  "edp.timeline.waitlisted": "ขึ้นบัญชีรอข้อเสนอ",
  "edp.timeline.rejected": "ไม่อนุมัติข้อเสนอ",
  "edp.timeline.withdrawn": "ถอนข้อเสนอ",
  "edp.timeline.comment": "แสดงความคิดเห็น",
  "edp.timeline.concern_raised": "แจ้งข้อกังวล",
  "edp.timeline.email_sent": "ส่งอีเมลแล้ว",
  "edp.rounds.edit_title": "แก้ไขรอบ",
  "edp.rounds.empty": "ยังไม่มีรอบ EDP",
  "edp.rounds.error_first_lesson_required": "กรุณาระบุวันเรียนวันแรก",
  "edp.rounds.error_last_lesson_required": "กรุณาระบุวันเรียนวันสุดท้าย",
  "edp.rounds.error_lesson_date_order": "วันเรียนวันสุดท้ายต้องอยู่ในหรือหลังวันเรียนวันแรก",
  "edp.rounds.error_name_required": "กรุณาระบุชื่อ",
  "edp.rounds.error_proposal_closes_required": "กรุณาระบุวันปิดรับข้อเสนอ",
  "edp.rounds.error_proposal_opens_required": "กรุณาระบุวันเปิดรับข้อเสนอ",
  "edp.rounds.error_proposal_window_order": "วันปิดรับข้อเสนอต้องอยู่ในหรือหลังวันเปิดรับ",
  "edp.rounds.error_registration_window_order": "วันปิดรับลงทะเบียนต้องอยู่ในหรือหลังวันเปิดรับ",
  "edp.rounds.error_school_year_required": "กรุณาเลือกปีการศึกษา",
  "edp.rounds.field_first_lesson": "วันเรียนวันแรก",
  "edp.rounds.field_last_lesson": "วันเรียนวันสุดท้าย",
  "edp.rounds.field_proposal_closes": "วันปิดรับข้อเสนอ",
  "edp.rounds.field_proposal_opens": "วันเปิดรับข้อเสนอ",
  "edp.rounds.field_registration_closes": "วันปิดรับลงทะเบียน",
  "edp.rounds.field_registration_opens": "วันเปิดรับลงทะเบียน",
  "edp.rounds.heading": "รอบ EDP",
  "edp.rounds.lesson_dates": "ช่วงวันเรียน",
  "edp.rounds.name": "ชื่อ",
  "edp.rounds.new_round": "รอบใหม่",
  "edp.rounds.new_title": "รอบใหม่",
  "edp.rounds.proposal_count": "จำนวนข้อเสนอ",
  "edp.rounds.proposal_window": "ช่วงรับข้อเสนอ",
  "edp.rounds.registration_window": "ช่วงรับลงทะเบียน",
  "edp.rounds.school_year": "ปีการศึกษา",
  "edp.rounds.subtitle": "เปิดรอบเพื่อให้เจ้าหน้าที่ส่งข้อเสนอวิชา EDP ได้",
  "edp.rounds.status_draft": "ฉบับร่าง",
  "edp.rounds.status_proposals_open": "เปิดรับข้อเสนอ",
  "edp.rounds.status_in_review": "กำลังพิจารณา",
  "edp.rounds.status_closed": "ปิดแล้ว",
  "edp.rounds.field_base_price": "ราคาวิชามาตรฐาน (บาท ตลอดรอบ)",
  "edp.rounds.hint_base_price": "ราคารวมตลอดทุกคาบของวิชาทั่วไป ไม่ใช่ราคาต่อคาบ และเป็นมูลค่าของที่นั่งฟรีหนึ่งที่ของนักเรียน",
  "edp.rounds.field_payments_enabled": "เปิดให้ผู้ปกครองชำระเงินสำหรับรอบนี้",
  "edp.rounds.hint_payments_enabled": "ปิดไว้จนกว่าจะพร้อม ระหว่างที่ปิดอยู่จะไม่มีหน้าชำระเงินและไม่มีข้อมูลบัญชีธนาคารปรากฏในพอร์ทัลผู้ปกครอง ให้เปิดเมื่อจัดที่นั่งเรียบร้อยและทราบยอดที่จะเรียกเก็บแล้ว",
  "edp.rounds.error_base_price_invalid": "กรอกจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
  "nav.section.edp": "โครงการกิจกรรมหลังเลิกเรียน",
  "nav.my_work.edp_proposals": "ข้อเสนอ EDP",
  "nav.edp": "EDP",
  "nav.edp_queue": "คิว EDP",
  "notifications.title": "การแจ้งเตือน",
  "notifications.empty": "ไม่มีรายการค้าง",
  "notifications.pending_items": "รายการที่รอดำเนินการ",
  "notifications.mark_all_read": "ทำเครื่องหมายว่าอ่านแล้วทั้งหมด",
  "notifications.clear_all": "ล้างทั้งหมด",
  "notifications.clear_all_confirm": "ลบการแจ้งเตือนทั้งหมดหรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "notifications.mark_unread": "ทำเครื่องหมายว่ายังไม่อ่าน",
  "notifications.load_more": "แสดงรายการเก่ากว่านี้",
  "notifications.view": "ดู",
  "notifications.item.it-tickets.created": "มีเรื่องแจ้งปัญหา IT ใหม่จาก {{name}}",
  "notifications.item.it-tickets.replied": "{{name}} ตอบกลับเรื่องแจ้งปัญหา IT ของคุณ",
  "notifications.item.it-tickets.status-changed": "สถานะเรื่องแจ้งปัญหา IT ของคุณเปลี่ยนแปลง",
  "notifications.item.it-tickets.commented": "{{name}} แสดงความคิดเห็นในเรื่องแจ้งปัญหา IT",
  "notifications.item.it-tickets.assigned": "เรื่องแจ้งปัญหา IT ถูกมอบหมายให้คุณ",
  "notifications.item.bookings.created": "มีการจองใหม่โดย {{name}}",
  "notifications.item.contact-inquiries.created": "มีข้อความติดต่อสอบถามใหม่จาก {{name}}",
  "notifications.item.tour-requests.created": "มีคำขอเยี่ยมชมใหม่จาก {{name}}",
  "notifications.item.tour-requests.scheduled": "นัดหมายการเยี่ยมชมสำหรับ {{name}} แล้ว",
  "notifications.item.tour-requests.cancelled": "การเยี่ยมชมสำหรับ {{name}} ถูกยกเลิก",
  "notifications.item.leave-requests.submitted": "{{name}} ยื่นคำขอลา",
  "notifications.item.leave-requests.approved": "คำขอลาของคุณได้รับการอนุมัติแล้ว",
  "notifications.item.leave-requests.rejected": "คำขอลาของคุณถูกปฏิเสธ",
  "notifications.item.leave-requests.edited": "{{name}} แก้ไขคำขอลาของคุณ",
  "notifications.item.student-absences.filed": "มีการแจ้งว่า {{student}} ขาดเรียน",
  "notifications.item.student-absences.edited": "การขาดเรียนของ {{student}} ถูกแก้ไข",
  "notifications.item.lesson-excusals.submitted": "มีการยื่นคำขอลาคาบเรียนสำหรับ {{student}}",
  "notifications.item.allergy-changes.submitted": "มีคำขอเปลี่ยนแปลงการแพ้อาหารสำหรับ {{student}}",
  "notifications.item.early-dismissals.filed": "มีการบันทึกการขอกลับก่อนเวลาสำหรับ {{student}}",
  "notifications.item.early-dismissals.teacher-digest": "นักเรียนของคุณ {{count}} คนขอกลับก่อนเวลาในวันนี้",
  "notifications.item.late-arrivals.filed": "{{student}} จะมาสาย",
  "notifications.item.late-arrivals.teacher-digest": "วันนี้มีนักเรียน {{count}} คนมาสายในคาบของคุณ",
  "notifications.item.fever.alert": "{{name}} มีไข้สูง: {{tempC}}°C",
  "notifications.item.sst-incidents.opened": "{{name}} เปิดเหตุการณ์ SST",
  "notifications.item.sst-incidents.message": "{{name}} โพสต์ข้อความในเหตุการณ์ SST",
  "notifications.item.sst-incidents.private-message": "มีข้อความใหม่ในกระทู้เฉพาะ SST",
  "notifications.item.sst-incidents.closed": "{{name}} ปิดเหตุการณ์ SST",
  "notifications.item.lunch-detentions.proposed": "มีการเสนอ MSS สำหรับ {{student}}",
  "notifications.item.lunch-detentions.decided": "MSS ของ {{student}} มีผลตัดสินแล้ว",
  "notifications.item.lunch-detentions.assigned": "มีการมอบหมาย MSS สำหรับ {{student}}",
  "notifications.item.lunch-detentions.cancelled": "MSS ของ {{student}} ถูกยกเลิก",
  "notifications.item.suspensions.started": "มีการบันทึกการพักการเรียนสำหรับ {{student}}",
  "notifications.item.suspensions.changed": "การพักการเรียนของ {{student}} มีการเปลี่ยนแปลง",
  "notifications.item.students.trial-started": "{{name}} เริ่มทดลองเรียนที่ {{grade}} ({{from}} ถึง {{to}})",
  "notifications.item.students.trial-extended": "การทดลองเรียนของ {{name}} ที่ {{grade}} ขยายไปถึง {{to}}",
  "notifications.item.students.enrolled": "{{name}} ลงทะเบียนเรียนที่ {{grade}} เรียบร้อยแล้ว",
  "notifications.item.students.left": "{{name}} ออกจาก {{grade}} แล้ว",
  "notifications.item.students.admitted": "{{name}} จะเริ่มเรียนที่ {{grade}} ในวันที่ {{from}}",
  "notifications.item.students.arriving-soon": "{{name}} จะเริ่มเรียนที่ {{grade}} ในวันที่ {{from}}",
  "notifications.item.support-notes.shared": "{{author}} แบ่งปันข้อสังเกตจาก SST เกี่ยวกับ {{student}}",
  "notifications.item.suspensions.cancelled": "การพักการเรียนของ {{student}} ถูกยกเลิก",
  "notifications.item.suspensions.message": "มีข้อความใหม่เกี่ยวกับการพักการเรียนของ {{student}}",
  "notifications.item.edp.approved": "ข้อเสนอ EDP “{{course}}” ของคุณได้รับการอนุมัติแล้ว",
  "notifications.item.edp.rejected": "ข้อเสนอ EDP “{{course}}” ของคุณถูกปฏิเสธ",
  "edp.registrations.heading": "การลงทะเบียน EDP",
  "edp.registrations.subtitle": "ดูว่ามีครอบครัวต้องการเรียนแต่ละวิชากี่คน และจัดสรรที่นั่ง",
  "edp.registrations.empty": "ยังไม่มีการลงทะเบียน",
  "edp.registrations.empty_no_round": "ยังไม่มีรอบ EDP ที่จะจัดสรรที่นั่ง",
  "edp.registrations.col_course": "วิชา",
  "edp.registrations.col_schedule": "วันและช่วงเวลา",
  "edp.registrations.col_grade_levels": "ระดับชั้น",
  "edp.registrations.col_demand": "ความต้องการ / จำนวนที่รับ",
  "edp.registrations.col_confirmed": "ยืนยันแล้ว",
  "edp.registrations.col_status": "สถานะ",
  "edp.registrations.filter_round": "รอบ",
  "edp.registrations.send_outcomes": "ส่งอีเมลแจ้งผล",
  "edp.registrations.send_outcomes_confirm_title": "ส่งอีเมลแจ้งผลหรือไม่?",
  "edp.registrations.send_outcomes_confirm_description": "ทุกครอบครัวที่ตัดสินใจเรียบร้อยแล้วจะได้รับอีเมลแจ้งผล การดำเนินการนี้ไม่สามารถย้อนกลับได้",
  "edp.registrations.send_outcomes_confirm_action": "ส่ง",
  "edp.registrations.send_outcomes_sending": "กำลังส่ง…",
  "edp.registrations.send_outcomes_result": "กำลังส่งอีเมลถึง {{queued}} ครอบครัว ระบบจะทยอยส่งภายในไม่กี่นาที",
  "edp.registrations.send_outcomes_result_skipped": "กำลังส่งอีเมลถึง {{queued}} ครอบครัว ข้าม {{skipped}} ครอบครัว — ดูรายชื่อด้านบน",
  "edp.registrations.send_outcomes_result_none": "ทุกครอบครัวในรอบนี้ได้รับอีเมลแจ้งผลแล้ว",
  "edp.registrations.send_outcomes_result_none_skipped": "ไม่มีครอบครัวใหม่ที่ต้องส่ง ข้าม {{skipped}} ครอบครัว — ดูรายชื่อด้านบน",
  "edp.registrations.skipped_title": "ครอบครัวที่ยังไม่ได้รับอีเมล",
  "edp.registrations.skipped_unnamed": "นักเรียนที่ไม่มีชื่อในระบบ",
  "edp.registrations.skipped_reason_pending_choices": "ยังตัดสินใจเรื่องตัวเลือกไม่เสร็จ",
  "edp.registrations.skipped_reason_no_guardian": "ไม่มีผู้ปกครองอยู่ในระบบ",
  "edp.registrations.skipped_reason_no_child_name": "ไม่มีชื่อในระบบ",
  "edp.tab_students": "นักเรียน",
  "edp.students.heading": "นักเรียน EDP",
  "edp.students.subtitle": "นักเรียนทุกคนในรอบนี้: เรียนวิชาอะไรบ้าง และมีค่าใช้จ่ายเท่าไร",
  "edp.students.search_placeholder": "ค้นหาด้วยชื่อ",
  "edp.students.empty": "ยังไม่มีนักเรียนลงทะเบียนในรอบนี้",
  "edp.students.empty_no_round": "ยังไม่มีรอบ EDP ให้ดู",
  "edp.students.filter_round": "รอบ",
  "edp.students.filter_grade": "ระดับชั้น",
  "edp.students.filter_grade_all": "ทุกระดับชั้น",
  "edp.students.filter_all": "ทั้งหมด",
  "edp.students.filter_with_seat": "ได้ที่นั่งแล้ว",
  "edp.students.filter_no_seat": "ยังไม่ได้ที่นั่ง",
  "edp.students.filter_not_registered": "ยังไม่ลงทะเบียน",
  "edp.students.never_registered": "ยังไม่ลงทะเบียน",
  "edp.students.summary": "เด็ก {{children}} คน · ลงทะเบียน {{registered}} คน · ได้ที่นั่ง {{seated}} คน · ค้างชำระ {{payable}}",
  "edp.students.col_child": "นักเรียน",
  "edp.students.col_grade": "ระดับชั้น",
  "edp.students.col_doing": "วิชาที่เรียน",
  "edp.students.col_asked_for": "สิ่งที่ขอไว้",
  "edp.students.nothing_asked_for": "เพิ่มโดยฝ่ายธุรการ",
  "edp.students.no_request_sent": "ยังไม่ส่งคำขอ",
  "edp.students.slot_rank": "ลำดับที่ {{rank}} ของช่วงบ่ายนี้",
  "edp.students.col_free_places": "สิทธิ์เรียนฟรี",
  "edp.students.col_total": "ยอดรวม",
  "edp.students.col_discount": "ส่วนลด",
  "edp.students.col_payable": "ยอดที่ต้องชำระ",
  "edp.students.no_seat_yet": "ลงทะเบียนแล้ว — ยังไม่ได้ที่นั่ง",
  "edp.students.not_registered": "เพิ่มโดยสำนักงาน",
  "edp.students.free_places_used": "ใช้ไป {{used}} จาก {{granted}} สิทธิ์",
  "edp.students.export": "ดาวน์โหลด CSV",
  "edp.students.csv_free_places": "สิทธิ์เรียนฟรีที่ได้รับ",
  "edp.students.csv_free_places_used": "สิทธิ์เรียนฟรีที่ใช้ไป",
  "edp.placement.heading": "การจัดที่นั่งในวิชา",
  "edp.placement.applicants_title": "ผู้สมัคร",
  "edp.placement.empty": "ยังไม่มีใครสมัครวิชานี้",
  "edp.placement.col_name": "ชื่อ",
  "edp.placement.col_grade": "ชั้นเรียน",
  "edp.placement.col_choice": "ลำดับที่เลือก",
  "edp.placement.col_submitted": "สมัครเมื่อ",
  "edp.placement.col_status": "สถานะ",
  "edp.placement.col_actions": "การดำเนินการ",
  "edp.placement.outside_grade_levels": "ไม่อยู่ในระดับชั้นที่วิชานี้เปิดรับ",
  "edp.placement.choice_rank": "ตัวเลือกที่ {{rank}} สำหรับช่วงบ่ายนี้",
  "edp.placement.choice_no_slot": "เรียนตามวันที่กำหนด — ไม่มีช่วงบ่ายให้จัดอันดับ",
  "edp.placement.choice_seat_only": "เพิ่มโดยสำนักงาน — ไม่มีการเลือกในระบบ",
  "edp.placement.also_this_afternoon": "ยังขอวิชาอื่นในช่วงบ่ายเดียวกัน:",
  "edp.placement.action_confirm": "ยืนยัน",
  "edp.placement.action_offer": "เสนอที่นั่ง",
  "edp.placement.action_waitlist": "รอคิว",
  "edp.placement.action_withdraw": "ถอนตัว",
  "edp.placement.action_remove": "นำออก",
  "edp.placement.remove_confirm_title": "นำออกจากคอร์สนี้หรือไม่?",
  "edp.placement.remove_confirm_description": "{{name}} จะเสียที่นั่งในคอร์สนี้และคำขอที่ยื่นไว้ การกระทำนี้ไม่สามารถย้อนกลับได้",
  "edp.placement.remove_confirm_action": "นำออก",
  "edp.placement.confirm_all": "ยืนยันทั้งหมด",
  "edp.placement.confirm_all_success": "ยืนยันแล้ว {{confirmed}} คน",
  "edp.placement.confirm_all_success_with_skipped": "ยืนยันแล้ว {{confirmed}} คน ข้ามไป {{skipped}} คน — มีที่นั่งในช่วงบ่ายนี้ของวิชาอื่นอยู่แล้ว",
  "edp.placement.oversubscribed_hint": "วิชานี้มีผู้สมัครเกินจำนวนที่รับ — โปรดตัดสินใจทีละคนแทนการยืนยันทั้งหมดพร้อมกัน",
  "edp.placement.add_student": "เพิ่มนักเรียน",
  "edp.placement.seat_status_none": "ยังไม่มีที่นั่ง",
  "edp.placement.manual_enrol_title": "เพิ่มนักเรียน",
  "edp.placement.manual_enrol_description": "มอบที่นั่งที่ยืนยันแล้วให้นักเรียนโดยตรง — สำหรับการลงทะเบียนล่าช้า การโทรติดต่อ หรือครอบครัวที่ไม่มีบัญชีพอร์ทัล",
  "edp.placement.manual_enrol_student_label": "นักเรียน",
  "edp.placement.manual_enrol_student_required": "กรุณาเลือกนักเรียน",
  "edp.placement.manual_enrol_submit": "เพิ่ม",
  "edp.placement.manual_enrol_success": "เพิ่มนักเรียนเข้าวิชาแล้ว",
  "edp.propose.confirm_no_guarantee": "ฉันเข้าใจว่าการส่งข้อเสนอนี้ไม่ได้เป็นการรับประกันว่าจะได้รับการอนุมัติ",
  "edp.propose.confirm_school_may_adjust": "ฉันเข้าใจว่าโรงเรียนอาจปรับเปลี่ยนวัน คาบ ช่วงชั้น ขนาดชั้นเรียน หรือสถานที่ที่เสนอ",
  "edp.propose.confirm_minimum_four": "ฉันเข้าใจว่าวิชา EDP โดยปกติต้องมีนักเรียนอย่างน้อย 4 คนจึงจะเปิดสอนได้ ยกเว้นการจัดแบบตัวต่อตัว/ส่วนตัวที่ได้รับอนุมัติ",
  "edp.propose.confirm_fifty_minutes": "ฉันเข้าใจว่าแต่ละคาบของ EDP มีความยาว 50 นาที",
  "edp.propose.confirm_two_per_day": "ฉันเข้าใจว่าเจ้าหน้าที่สามารถสอนวิชา EDP ได้สูงสุดสองวิชาต่อวัน",
  "edp.propose.confirm_attendance": "ฉันเข้าใจว่าเจ้าหน้าที่ EDP ที่ได้รับอนุมัติมีหน้าที่รับผิดชอบการเช็คชื่อ การดูแลนักเรียน การเปลี่ยนคาบ และการส่งกลับ ตามขั้นตอนของโรงเรียน",
  "edp.propose.confirm_hr_compensation": "ฉันเข้าใจว่าการจัดการค่าตอบแทนดำเนินการแยกต่างหากโดยฝ่ายทรัพยากรบุคคล ตามข้อตกลงการจ้างงานที่เกี่ยวข้อง",
  "edp.propose.errors.title_required": "กรุณาตั้งชื่อวิชา",
  "edp.propose.errors.category_required": "กรุณาเลือกหมวดหมู่",
  "edp.propose.errors.description_required": "กรุณาอธิบายรายละเอียดวิชา",
  "edp.propose.errors.objectives_required": "กรุณาระบุวัตถุประสงค์ 2–4 ข้อ",
  "edp.propose.errors.grade_levels_required": "เลือกอย่างน้อยหนึ่งระดับชั้น",
  "edp.propose.errors.answer_required": "กรุณาตอบคำถามนี้",
  "edp.propose.errors.number_required": "กรุณากรอกตัวเลข",
  "edp.propose.errors.minimum_required": "กรุณากรอกจำนวนขั้นต่ำ",
  "edp.propose.errors.minimum_floor": "วิชา EDP แบบกลุ่มต้องมีนักเรียนอย่างน้อย 4 คน",
  "edp.propose.errors.maximum_below_minimum": "จำนวนสูงสุดต้องไม่น้อยกว่าจำนวนขั้นต่ำ",
  "edp.propose.errors.preferred_facilities_required": "กรุณาเลือกสถานที่ที่ต้องการอย่างน้อยหนึ่งแห่ง",
  "edp.propose.errors.facility_other_required": "กรุณาอธิบายสถานที่อื่น",
  "edp.propose.errors.materials_required": "กรุณาระบุอุปกรณ์และวัสดุ หรือเขียนว่า \"ไม่มี\"",
  "edp.propose.errors.purchase_details_required": "กรุณาอธิบายรายการและประมาณการค่าใช้จ่าย",
  "edp.propose.errors.safety_details_required": "กรุณาอธิบายข้อกำหนดด้านความปลอดภัยหรือการดูแล",
  "edp.propose.errors.position_department_required": "กรุณากรอกตำแหน่งหรือแผนกของท่าน",
  "edp.propose.errors.confirmation_required": "ท่านต้องยอมรับคำรับรองของเจ้าหน้าที่ก่อนส่งข้อเสนอ",
  "edp.propose.errors.courses_required": "กรุณาเพิ่มวิชาอย่างน้อยหนึ่งวิชา",
  "editor.image_too_small": "รูปนี้มีขนาดเล็กและจะแสดงผลไม่ชัด",
  "editor.image_from_url_unsupported": "ไม่สามารถเพิ่มรูปภาพจากลิงก์ได้",
  "editor.image_from_url_unsupported_hint": "บันทึกรูปภาพลงในคอมพิวเตอร์ของคุณ แล้วอัปโหลดที่นี่",
  "editor.image_too_small_hint": "ขนาดเพียง {{width}}×{{height}} พิกเซล หากคัดลอกมาจากเอกสาร กรุณาแทรกไฟล์ภาพต้นฉบับแทน เพราะไม่สามารถกู้ความคมชัดคืนได้ภายหลัง",
  "communications.title": "การสื่อสาร",
  "communications.subtitle": "เขียนข้อความถึงผู้ปกครองและส่งไปยังกลุ่มเป้าหมายที่เลือก",
  "communications.new_message": "ข้อความใหม่",
  "communications.empty": "ยังไม่มีข้อความ",
  "communications.empty_filtered": "ไม่มีข้อความที่ตรงกับตัวกรองนี้",
  "communications.col_title": "หัวข้อ",
  "communications.col_audience": "กลุ่มเป้าหมาย",
  "communications.col_translated": "แปลแล้ว",
  "communications.col_recipients": "ผู้รับ",
  "communications.col_sent": "ส่งเมื่อ",
  "communications.last_send_failed": "การส่งครั้งล่าสุดล้มเหลว: {{reason}}",
  "enum.communication_status.draft": "ฉบับร่าง",
  "enum.communication_status.scheduled": "ตั้งเวลาไว้",
  "enum.communication_status.sending": "กำลังส่ง",
  "enum.communication_status.sent": "ส่งแล้ว",
  "communications.new_title": "ข้อความใหม่",
  "communications.edit_title": "แก้ไขข้อความ",
  "communications.field_title": "หัวข้อ",
  "communications.field_body": "ข้อความ",
  "communications.field_audience": "กลุ่มเป้าหมาย",
  "communications.audience_all_parents": "ผู้ปกครองทุกคน",
  "communications.audience_grades": "เลือกระดับชั้น",
  "communications.include_arriving": "รวมครอบครัวที่กำลังจะเข้าเรียน",
  "communications.include_arriving_hint": "ส่งถึงครอบครัวที่บุตรหลานได้รับการตอบรับแล้วแต่ยังไม่เริ่มเรียนด้วย ผู้ปกครองที่บุตรหลานทุกคนออกจากโรงเรียนแล้วจะไม่ได้รับข้อความนี้",
  "communications.error_title_required": "กรุณากรอกหัวข้อ",
  "communications.error_grades_required": "กรุณาเลือกระดับชั้นอย่างน้อยหนึ่งระดับ",
  "communications.error_save_failed": "บันทึกข้อความไม่สำเร็จ",
  "communications.save_draft": "บันทึกฉบับร่าง",
  "communications.saved": "บันทึกฉบับร่างแล้ว",
  "communications.recipient_preview": "ข้อความนี้จะถูกส่งถึงผู้ปกครอง {{count}} คน",
  "communications.recipient_preview_loading": "กำลังนับจำนวนผู้รับ…",
  "communications.send_now": "ส่งทันที",
  "communications.send_confirm_title": "ส่งข้อความนี้ทันทีหรือไม่?",
  "communications.send_confirm_description": "ข้อความนี้จะถูกส่งถึงผู้ปกครอง {{count}} คน และไม่สามารถยกเลิกได้",
  "communications.send_confirm_action": "ส่งทันที ({{count}})",
  "communications.error_send_failed": "ส่งข้อความไม่สำเร็จ",
  "communications.send_success": "ส่งข้อความแล้ว",
  "communications.schedule": "ตั้งเวลาส่ง",
  "communications.scheduled_for_label": "ส่งเมื่อ",
  "communications.error_schedule_failed": "ตั้งเวลาส่งข้อความไม่สำเร็จ",
  "communications.schedule_success": "ตั้งเวลาส่งข้อความแล้ว",
  "communications.cancel_schedule": "ยกเลิกการตั้งเวลา",
  "communications.cancel_schedule_success": "ยกเลิกการตั้งเวลาแล้ว — กลับไปเป็นฉบับร่าง",
  "communications.error_cancel_schedule_failed": "ยกเลิกการตั้งเวลาไม่สำเร็จ",
  "communications.delete_draft": "ลบฉบับร่าง",
  "communications.delete_draft_confirm_title": "ลบฉบับร่างนี้หรือไม่?",
  "communications.delete_draft_confirm_description": "ข้อความนี้จะถูกลบอย่างถาวร",
  "communications.deleted": "ลบฉบับร่างแล้ว",
  "communications.error_delete_failed": "ลบฉบับร่างไม่สำเร็จ",
  "communications.sent_at_summary": "ส่งเมื่อ {{date}}",
  "communications.locked_notice": "ข้อความนี้ถูกส่งไปแล้วและไม่สามารถแก้ไขได้อีก",
  "communications.detail_funnel_title": "การมีส่วนร่วม",
  "communications.funnel_recipients": "ผู้รับ",
  "communications.funnel_sent": "ส่งแล้ว",
  "communications.funnel_failed": "ล้มเหลว",
  "communications.funnel_clicked": "คลิกแล้ว",
  "communications.funnel_read": "อ่านแล้ว",
  "communications.recipients_title": "ผู้รับ",
  "communications.col_parent": "ผู้ปกครอง",
  "communications.col_email": "อีเมล",
  "communications.col_language": "ภาษา",
  "communications.col_sent_at": "ส่งแล้ว",
  "communications.col_clicked_at": "คลิกแล้ว",
  "communications.col_read_at": "อ่านแล้ว",
  "communications.col_failure_reason": "สาเหตุที่ล้มเหลว",
  "communications.recipients_empty": "ยังไม่มีข้อมูลผู้รับ",
  "communications.field_language_versions": "ฉบับภาษาต่าง ๆ",
  "communications.tab_translated": "แปลแล้ว",
  "communications.error_english_required": "กรุณาเพิ่มฉบับภาษาอังกฤษก่อนส่ง",
  "communications.translate_from_english": "แปลจากภาษาอังกฤษ",
  "communications.translation_billing_note": "Google คิดค่าบริการตามจำนวนตัวอักษรที่แปล",
  "communications.translation_preview_title": "ตรวจสอบคำแปล",
  "communications.translation_preview_description": "แปลด้วยเครื่องเป็นภาษา{{language}} ยังไม่บันทึกจนกว่าจะกดใช้ และยังแก้ไขได้เสมอหลังจากนั้น",
  "communications.translation_preview_use": "ใช้คำแปลนี้",
  "communications.translation_loading": "กำลังแปล…",
  "communications.translation_error_rejected": "คีย์ที่ตั้งค่าไว้ถูกปฏิเสธ กรุณาตรวจสอบในการตั้งค่า Integration",
  "communications.translation_error_quota": "เกินโควตาการแปลแล้ว กรุณารอหรือเพิ่มโควตาแล้วลองใหม่",
  "communications.translation_error_unavailable": "บริการแปลภาษาไม่พร้อมใช้งานในขณะนี้ กรุณาลองใหม่ภายหลัง",
  "communications.translation_error_generic": "ไม่สามารถแปลข้อความนี้ได้ กรุณาลองใหม่",
  "communications.translation_not_configured_title": "ยังไม่ได้ตั้งค่าการแปลภาษา",
  "communications.translation_not_configured_description": "ยังไม่มีผู้ให้บริการแปลภาษาที่ตั้งค่าไว้ ผู้ดูแลระบบสามารถเพิ่มคีย์ Google Cloud Translate ได้ที่การตั้งค่า Integration — ระหว่างนี้ยังคงเขียนหรือวางฉบับภาษาไทยและจีนได้ด้วยตนเอง",
  "communications.translation_not_configured_link": "ไปที่การตั้งค่า Integration",
  "settings.label.communications_send_delay_ms": "ระยะหน่วงการส่งข้อความ (ms)",
  "settings.desc.communications_send_delay_ms": "ช่วงเวลาหยุดพักระหว่างการส่งแต่ละฉบับขณะกำลังส่งข้อความ",
  "settings.label.communications_daily_allowance": "จำนวนผู้รับสูงสุดต่อวันสำหรับการสื่อสาร",
  "settings.desc.communications_daily_allowance": "การส่งจะถูกปฏิเสธก่อนที่จะมีการส่งใด ๆ ออกไป หากจำนวนผู้รับเกินตัวเลขนี้",
  "settings.label.cafeteria_overdraft_limit": "วงเงินติดลบของโรงอาหาร (บาท)",
  "settings.desc.cafeteria_overdraft_limit": "ยอดเงินในกระเป๋าโรงอาหารติดลบได้มากที่สุดเท่าใด 0 หมายถึงห้ามติดลบ",
  "checkout_roster.tally_still_here": "ยังอยู่ที่โรงเรียน",
  "checkout_roster.tally_gone_home": "กลับบ้านแล้ว",
  "checkout_roster.tally_not_in": "ไม่ได้มาวันนี้",
  "checkout_roster.filter_label": "กรองรายชื่อนักเรียน",
  "checkout_roster.filter_all": "ทั้งหมด",
  "checkout_roster.filter_still_here": "ยังอยู่",
  "checkout_roster.filter_waiting": "กำลังรอ",
  "checkout_roster.filter_gone_home": "กลับแล้ว",
  "checkout_roster.empty": "ไม่มีนักเรียนในรายชื่อวันนี้",
  "checkout_roster.empty_filtered": "ไม่มีนักเรียนตรงกับตัวกรองนี้",
  "checkout_roster.no_grade": "ไม่มีข้อมูลระดับชั้น",
  "checkout_roster.load_failed": "ไม่สามารถโหลดรายชื่อได้ รีเฟรชเพื่อลองใหม่",
  "enum.checkout_roster_state.in_class": "อยู่ในห้องเรียน",
  "enum.checkout_roster_state.waiting": "กำลังรอ",
  "enum.checkout_roster_state.on_way": "กำลังไป",
  "enum.checkout_roster_state.collected": "กลับบ้านแล้ว",
  "enum.checkout_roster_state.absent": "ขาดเรียน",
  "enum.checkout_roster_state.excused": "ลา",
  "enum.checkout_roster_state.early_dismissal": "กลับก่อนเวลา",
  "enum.checkout_roster_state.edp": "EDP",
  "enum.checkout_roster_state.suspended": "พักการเรียน",
  "edp.detail.course_max_hint": "เว้นว่างไว้หากไม่จำกัดจำนวนสูงสุด",
  "edp.detail.course_one_on_one_places_hint": "วิชาแบบตัวต่อตัวรับนักเรียนหนึ่งคน จึงมีที่นั่งเดียว",
  "edp.sessions.add": "เพิ่มวัน",
  "edp.sessions.remove": "ลบวันนี้",
  "edp.sessions.label": "เวลาที่เรียน",
  "edp.sessions.hint": "หนึ่งแถวต่อหนึ่งคาบเรียน วิชาที่เรียนสัปดาห์ละสองครั้งจะมีสองแถว และนักเรียนกลุ่มเดิมเข้าเรียนทั้งสองครั้ง",
  "edp.schedule_kind.label": "รูปแบบการเรียนของวิชานี้",
  "edp.schedule_kind.weekly": "ทุกสัปดาห์",
  "edp.schedule_kind.special_dates": "ตามวันที่กำหนด",
  "edp.schedule_kind.special_dates_hint": "สำหรับวิชาที่โรงเรียนกำหนดวันที่เรียนไว้เฉพาะ แทนการเรียนตามวันในสัปดาห์ แต่ละครั้งมีเวลาเริ่มและเวลาจบของตนเอง จึงไม่จำเป็นต้องอยู่ในคาบใดคาบหนึ่ง หากเรียนนอกสถานที่ให้เว้นห้องเรียนไว้",
  "edp.meetings.date": "วันที่",
  "edp.meetings.starts_at": "เริ่ม",
  "edp.meetings.ends_at": "จบ",
  "edp.meetings.room": "ห้องเรียน",
  "edp.meetings.add": "เพิ่มวันที่",
  "edp.meetings.remove": "ลบวันที่นี้",
  "edp.meetings.last_one_stays": "วิชาหนึ่งต้องมีการเรียนอย่างน้อยหนึ่งครั้ง หากต้องการยกเลิกวันที่กำหนด ให้เปลี่ยนเป็นวิชาที่เรียนทุกสัปดาห์ด้านบน",
  "edp.meetings.errors.at_least_one": "กำหนดวันที่ให้วิชานี้อย่างน้อยหนึ่งวัน หรือเปลี่ยนเป็นวิชาที่เรียนทุกสัปดาห์",
  "edp.meetings.errors.date_required": "ทุกแถวต้องระบุวันที่",
  "edp.meetings.errors.times_required": "ทุกวันที่ต้องระบุเวลาเริ่มและเวลาจบ",
  "edp.meetings.errors.end_after_start": "เวลาจบต้องอยู่หลังเวลาเริ่ม",
  "edp.meetings.errors.repeated_date": "วิชานี้มีการเรียนในวันที่ดังกล่าวอยู่แล้ว",
  "edp.afternoon.heading": "ช่วงบ่าย EDP",
  "edp.afternoon.scope_label": "ขอบเขต",
  "edp.afternoon.scope_homeroom": "ห้องประจำชั้นของฉัน",
  "edp.afternoon.scope_class": "ชั้นเรียน",
  "edp.afternoon.scope_school": "ทั้งโรงเรียน",
  "edp.afternoon.class_label": "ชั้นเรียน",
  "edp.afternoon.class_placeholder": "เลือกชั้นเรียน",
  "edp.afternoon.pick_class": "เลือกชั้นเรียนเพื่อดูว่านักเรียนคนใดอยู่ทำกิจกรรม EDP",
  "edp.afternoon.no_homeroom": "คุณไม่มีห้องประจำชั้นในปีนี้ จึงไม่มีข้อมูลให้แสดงที่นี่",
  "edp.afternoon.staying_heading": "อยู่ทำกิจกรรม EDP",
  "edp.afternoon.going_home_heading": "กลับบ้าน",
  "edp.afternoon.going_home_omitted": "ในมุมมองทั้งโรงเรียน จะแสดงเฉพาะนักเรียนที่อยู่ทำกิจกรรมเท่านั้น ส่วนที่เหลือทั้งหมดกลับบ้าน",
  "edp.afternoon.going_home_empty": "ทุกคนในรายชื่อนี้อยู่ทำกิจกรรม EDP วันนี้",
  "edp.afternoon.no_one_staying": "ไม่มีนักเรียนอยู่ทำกิจกรรม EDP วันนี้",
  "edp.afternoon.room_unassigned": "ยังไม่ได้กำหนดห้อง",
  "edp.afternoon.until": "ถึง {{time}} น.",
  "edp.afternoon.excused": "วันนี้ไม่ไป: {{reason}}",
  "edp.afternoon.excused_by": "บันทึกที่ประตูโดย {{name}}",
  "edp.afternoon.tab_day": "รายวัน",
  "edp.afternoon.tab_week": "รายสัปดาห์",
  "edp.afternoon.tab_class": "รายห้องเรียน",
  "edp.afternoon.week_col_student": "นักเรียน",
  "edp.afternoon.tabs_label": "มุมมองช่วงบ่าย EDP",
  "edp.week.subtitle": "สัปดาห์ของวันที่ {{date}}",
  "edp.week.week_label": "สัปดาห์",
  "edp.week.previous_week": "สัปดาห์ก่อน",
  "edp.week.next_week": "สัปดาห์ถัดไป",
  "edp.week.empty": "สัปดาห์นี้ไม่มีคอร์ส EDP",
  "edp.week.col_student": "นักเรียน",
  "edp.week.instructor_unnamed": "ยังไม่ระบุผู้สอน",
  "edp.week.marked_footer": "บันทึกแล้ว",
  "edp.week.marked_count": "บันทึกแล้ว {{marked}} จาก {{total}}",
  "edp.week.upcoming": "ยังไม่ถึง",
  "edp.week.order_label": "เรียงตาม",
  "edp.week.order_block": "บล็อก",
  "edp.week.order_name": "ชื่อ",
  "edp.week.order_day": "วัน",
  "edp.register.take_register": "เช็กชื่อ",
  "edp.register.empty_roster": "ยังไม่มีนักเรียนที่มีที่นั่งในวิชานี้ จึงยังไม่มีใครให้เช็กชื่อ",
  "edp.register.col_note": "หมายเหตุ",
  "edp.register.col_marked_by": "ผู้บันทึก",
  "edp.register.note_placeholder": "เพิ่มหมายเหตุ",
  "edp.register.mark_all_present": "บันทึกว่ามาเรียนทุกคน",
  "edp.register.marked_footer": "บันทึกแล้ว {{marked}} จาก {{total}} คน",
  "edp.register.nothing_to_save": "กรุณาเลือกสถานะให้นักเรียนอย่างน้อยหนึ่งคนก่อนบันทึก",
  "edp.register.saved": "บันทึกการเข้าเรียนแล้ว",
  "edp.register.marked_by_at": "บันทึกโดย {{name}} · {{when}}",
  "edp.register.summary_title": "ภาพรวมของภาคเรียนนี้",
  "edp.register.summary_rate": "อัตราการเข้าเรียน (มาเรียนหรือมาสาย)",
  "edp.register.summary_no_rate": "ยังไม่มีอัตรา",
  "edp.register.summary_meetings": "คาบที่ผ่านมา จากทั้งหมด {{term}} คาบ",
  "edp.register.summary_unmarked": "ยังไม่ได้เช็กชื่อ",
  "edp.register.summary_unmarked_warning": "ยังไม่ได้เช็กชื่อ {{unmarked}} จาก {{meetings}} คาบ อัตรานี้จึงคิดจากเฉพาะส่วนที่บันทึกแล้วเท่านั้น",
  "edp.register.summary_no_marks_yet": "ยังไม่มีการเช็กชื่อนักเรียนที่มีที่นั่งในวิชานี้เลย (ยังไม่ได้เช็กชื่อ {{unmarked}} จาก {{meetings}} คาบ) จึงยังคำนวณอัตราการเข้าเรียนไม่ได้",
  "edp.register.summary_no_marks_from_roster": "ยังไม่มีการเช็กชื่อนักเรียนที่มีที่นั่งในวิชานี้เลย จึงยังคำนวณอัตราการเข้าเรียนไม่ได้",
  "edp.register.summary_all_marked": "เช็กชื่อนักเรียนครบทุกคนในทุกคาบที่ผ่านมาแล้ว",
  "edp.register.summary_partly_marked": "มี {{partly}} จาก {{meetings}} คาบที่เช็กชื่อยังไม่ครบ ยังมีนักเรียนบางคนที่ยังไม่ได้บันทึกสถานะ",
  "edp.register.summary_off_schedule": "วิชานี้มีการเปลี่ยนวันเรียน ตัวเลขเหล่านี้คำนวณจากวันที่เรียนในปัจจุบัน จึงอาจรวมวันที่ไม่เคยมีการเรียนจริง",
  "edp.register.summary_none_held": "วิชานี้ยังไม่มีการเรียน จึงยังไม่มีข้อมูลให้สรุป",
  "edp.register.summary_col_unmarked": "ยังไม่ได้เช็กชื่อ",
  "nav.edp_afternoon": "ช่วงบ่าย EDP",
  "communications.message_title": "ข้อความ",
  "communications.edit_message": "แก้ไข",
  "communications.sent_edit_warning": "ส่งอีเมลถึง {{count}} ครอบครัวแล้ว",
  "communications.sent_edit_warning_hint": "การแก้ไขจะเปลี่ยนเฉพาะข้อความในพอร์ทัลเท่านั้น อีเมลที่ส่งไปแล้วไม่สามารถเปลี่ยนได้ และผู้รับก็ไม่สามารถเปลี่ยนได้อีก",
  "edp.groups.add": "เปิดเป็นอีกกลุ่ม",
  "edp.groups.remove": "ลบกลุ่มนี้",
  "edp.groups.group_n": "กลุ่มที่ {{n}}",
  "edp.groups.title": "ชื่อกลุ่ม",
  "edp.groups.title_placeholder": "ใช้ชื่อเดียวกับวิชา",
  "edp.groups.same_teacher": "ครูคนเดิม",
  "edp.groups.same_maximum": "จำนวนสูงสุดเท่าเดิม",
  "edp.groups.hint": "กลุ่มคือนักเรียนอีกชุดหนึ่งที่มีรายชื่อของตนเอง ส่วนการเพิ่มวันภายในกลุ่มหมายถึงนักเรียนกลุ่มเดิมเรียนสัปดาห์ละสองครั้ง",
  "edp.detail.add_group": "เปิดวิชานี้เป็นอีกกลุ่ม",
  "edp.detail.add_group_hint": "ใช้เมื่อมีผู้ปกครองต้องการที่นั่งมากกว่าที่วิชานี้รับได้ กลุ่มใหม่จะมีรายชื่อแยกต่างหาก ไม่ใช่นักเรียนที่ลงทะเบียนไว้แล้ว",
  "edp.detail.group_added": "เพิ่มกลุ่มใหม่แล้ว",
  "edp.propose.groups_hint": "ระบุเวลาที่วิชานี้จะเปิดสอน เพิ่มวันหากนักเรียนกลุ่มเดิมเรียนสัปดาห์ละสองครั้ง และเพิ่มกลุ่มใหม่หากต้องการเปิดวิชาเดิมอีกครั้งให้นักเรียนอีกชุดหนึ่ง",
  "edp.propose.external_instructor": "ผู้สอนเป็นบุคคลอื่น",
  "edp.propose.external_instructor_hint": "เว้นว่างไว้หากท่านเป็นผู้สอนเอง หรือระบุชื่อครูรับเชิญหรือครูพาร์ทไทม์ที่ยังไม่มีบัญชีของโรงเรียน",
  "edp.propose.errors.preferred_groups_required": "กรุณาระบุเวลาที่วิชานี้จะเปิดสอน",
  "edp.propose.errors.group_needs_a_day": "แต่ละกลุ่มต้องมีอย่างน้อยหนึ่งวัน",
  "edp.propose.errors.repeated_slot": "กลุ่มเดียวกันเรียนคาบเดิมในวันเดิมซ้ำสองครั้งไม่ได้",
  "edp.propose.errors.groups_share_a_slot": "สองกลุ่มของวิชาเดียวกันใช้คาบเดิมในวันเดิมไม่ได้",
  "edp.propose.errors.slot_not_on_that_day": "วันดังกล่าวไม่มีคาบนี้",
  "edp.groups.grades": "ระดับชั้นของกลุ่มนี้",
  "edp.groups.grades_hint": "ไม่ต้องเลือกช่องใดเลย หากต้องการให้กลุ่มนี้เปิดรับทุกระดับชั้นของวิชา",
  "edp.queue.col_requested": "ที่ขอไว้",
  "edp.detail.field_requested_sessions": "ที่ขอไว้",
  "edp.detail.field_groups": "กลุ่ม",
  "sand_dollars.stats_tabs_label": "ส่วนต่าง ๆ ของสถิติแซนด์ดอลลาร์",
  "sand_dollars.records_tabs_label": "รางวัลและสถิติแซนด์ดอลลาร์",
  "sand_dollars.tab_overview": "ภาพรวม",
  "sand_dollars.tab_grades": "ระดับชั้น",
  "sand_dollars.tab_staff": "บุคลากร",
  "sand_dollars.unknown": "ไม่ทราบ",
  "sand_dollars.stat_awards": "รางวัล",
  "sand_dollars.stat_over_school_days_one": "จาก {{count}} วันเรียน",
  "sand_dollars.stat_over_school_days_other": "จาก {{count}} วันเรียน",
  "sand_dollars.stat_per_student_per_day": "ต่อนักเรียนต่อวัน",
  "sand_dollars.stat_per_day_hint": "{{value}} ต่อวันทั้งโรงเรียน",
  "sand_dollars.stat_coverage": "นักเรียนที่ได้รับรางวัล",
  "sand_dollars.stat_coverage_hint": "{{awarded}} จาก {{total}} คนได้รับอย่างน้อยหนึ่งรางวัล",
  "sand_dollars.stat_staff_awarding": "บุคลากรที่ให้รางวัล",
  "sand_dollars.stat_median_hint": "ค่ามัธยฐาน {{value}} ต่อนักเรียน",
  "sand_dollars.trend_title": "รางวัลตามช่วงเวลา",
  "sand_dollars.weekday_title": "วันใดของสัปดาห์",
  "sand_dollars.spread_title": "การกระจายของรางวัล",
  "sand_dollars.spread_subtitle": "จัดกลุ่มนักเรียนตามจำนวนแซนด์ดอลลาร์ที่ได้รับ แถบสีแดงคือนักเรียนที่ยังไม่เคยได้รับ",
  "sand_dollars.spread_students": "นักเรียน",
  "sand_dollars.categories_title": "คุณค่าที่ได้รับการยกย่อง",
  "sand_dollars.grades_chart_title": "ต่อนักเรียนต่อวันเรียน แยกตามระดับชั้น",
  "sand_dollars.grades_chart_subtitle": "เส้นประคือค่าเฉลี่ยของโรงเรียน {{value}} ต่อนักเรียนต่อวันเรียน",
  "sand_dollars.grades_table_title": "ระดับชั้นทั้งหมด",
  "sand_dollars.col_grade": "ระดับชั้น",
  "sand_dollars.col_students": "นักเรียน",
  "sand_dollars.col_awards": "รางวัล",
  "sand_dollars.col_per_day": "ต่อนักเรียน/วัน",
  "sand_dollars.col_per_week": "ต่อนักเรียน/สัปดาห์",
  "sand_dollars.col_coverage": "ได้รับแล้ว",
  "sand_dollars.houses_not_assigned_yet": "ยังไม่มีคะแนนบ้าน — การจัดบ้านจะเกิดขึ้นราวเดือนตุลาคม",
  "sand_dollars.staff_awarding_title": "ใครเป็นผู้ให้รางวัล",
  "sand_dollars.staff_reach": "นักเรียน {{students}} คน · {{rate}} ต่อวันเรียน",
  "sand_dollars.staff_silent_title": "ยังไม่เคยให้รางวัล",
  "sand_dollars.staff_silent_subtitle": "ผู้ดูแลระบบและครูที่ยังใช้งานอยู่แต่ไม่ได้ให้รางวัลในช่วงเวลานี้",
  "sand_dollars.staff_silent_none": "ทุกคนให้รางวัลอย่างน้อยหนึ่งครั้งแล้ว",
  "sand_dollars.tab_class_list": "รายชื่อนักเรียน",
  "sand_dollars.class_list_title": "นักเรียนทุกคน พร้อมจำนวนที่ได้รับ",
  "sand_dollars.class_list_empty": "ไม่มีนักเรียนในช่วงเวลานี้",
  "sand_dollars.summary_students": "นักเรียน",
  "sand_dollars.summary_awards": "รางวัล",
  "sand_dollars.summary_median": "ค่ามัธยฐานต่อนักเรียน",
  "sand_dollars.summary_recognised": "ได้รับแล้ว",
  "sand_dollars.col_awards_total": "รางวัล",
  "sand_dollars.col_vs_grade": "เทียบกับระดับชั้น",
  "sand_dollars.col_rank_in_grade": "อันดับในระดับชั้น",
  "sand_dollars.col_awarders": "ผู้มอบ",
  "sand_dollars.col_top_value": "คุณค่าที่ได้รับบ่อยที่สุด",
  "sand_dollars.col_top_awarder": "ผู้มอบบ่อยที่สุด",
  "sand_dollars.col_last_awarded": "ได้รับล่าสุด",
  "sand_dollars.rank_of": "{{rank}} จาก {{size}}",
  "sand_dollars.school_days_ago_one": "{{count}} วันเรียนที่แล้ว",
  "sand_dollars.school_days_ago_other": "{{count}} วันเรียนที่แล้ว",
  "sand_dollars.never_awarded": "ยังไม่เคย",
  "sand_dollars.class_list_all_values": "ทุกค่านิยม",
  "sand_dollars.class_list_category_hint": "กรองตามค่านิยมที่นักเรียนแต่ละคนได้รับบ่อยที่สุด",
  "sand_dollars.class_list_below_label": "รางวัลน้อยกว่า",
  "sand_dollars.class_list_showing": "แสดง {{shown}} จาก {{total}}",
  "students.rate_per_day": "ต่อวันเรียน",
  "students.rate_per_week": "ต่อสัปดาห์เรียน",
  "students.rate_per_month": "ต่อเดือนเรียน",
  "students.rate_vs_grade": "เทียบกับระดับชั้น",
  "students.rate_window_hint": "{{awards}} รางวัลใน {{days}} วันเรียน",
  "students.rate_per_week_hint": "ห้าวันเรียน",
  "students.rate_per_month_hint": "ยี่สิบวันเรียน",
  "students.rate_vs_grade_hint": "ค่าเฉลี่ยระดับชั้น {{average}} ต่อวันเรียน · ได้รับล่าสุด {{last}}",
  "students.rate_last_never": "ยังไม่เคย",
  "students.rate_last_days_one": "{{count}} วันเรียนที่แล้ว",
  "students.rate_last_days_other": "{{count}} วันเรียนที่แล้ว",
  "lunch_detentions.thread_title": "การสนทนาของเจ้าหน้าที่",
  "lunch_detentions.private_thread_title": "บันทึกของ SST",
  "lunch_detentions.staff_thread_hint": "มองเห็นได้โดยผู้เสนอ ผู้ดูแล ครูประจำชั้นที่เกี่ยวข้อง และ SST",
  "lunch_detentions.activity_title": "กิจกรรมการกักช่วงพักกลางวัน",
  "lunch_detentions.activity_hint": "การตัดสินใจ การขยายเวลา และการเปลี่ยนแปลงการเข้าร่วม เรียงตามเวลา",
  "lunch_detentions.workspace_tabs_label": "พื้นที่ทำงาน MSS",
  "lunch_detentions.tab_overview": "ภาพรวม",
  "lunch_detentions.tab_attendance": "การเข้าร่วม",
  "lunch_detentions.tab_activity": "กิจกรรม",
  "lunch_detentions.tab_staff_conversation": "การสนทนาของเจ้าหน้าที่",
  "lunch_detentions.tab_sst": "บันทึก SST",
  "lunch_detentions.tab_family": "ต้องติดต่อครอบครัวหรือไม่?",
  "lunch_detentions.attention_review_request_title": "ตรวจสอบคำขอกักช่วงพักกลางวัน",
  "lunch_detentions.attention_review_request_description": "SST ต้องอนุมัติหรือปฏิเสธคำขอนี้",
  "lunch_detentions.attention_waiting_for_decision_title": "รอการตัดสินใจจาก SST",
  "lunch_detentions.attention_waiting_for_decision_description": "คุณสามารถติดตามคำขอนี้ได้ โดย SST เป็นผู้รับผิดชอบการอนุมัติ",
  "lunch_detentions.attention_assign_supervisor_title": "มอบหมายผู้ดูแล",
  "lunch_detentions.attention_assign_supervisor_description": "รอบที่อนุมัตินี้ยังไม่มีผู้รับผิดชอบดูแลและบันทึกการเข้าร่วม",
  "lunch_detentions.attention_record_attendance_title": "บันทึกการเข้าร่วมให้ครบ",
  "lunch_detentions.attention_record_attendance_description": "ยังมีวันกักอย่างน้อยหนึ่งวันที่ต้องบันทึกผลการเข้าร่วม",
  "lunch_detentions.attention_view_main_run_title": "ดำเนินการต่อในรอบหลัก",
  "lunch_detentions.attention_view_main_run_description": "คำขอนี้ถูกรวมเข้ากับรอบอื่น ซึ่งเป็นที่บันทึกการเข้าร่วมและความคืบหน้า",
  "lunch_detentions.attention_upcoming_title": "รอบพร้อมแล้ว",
  "lunch_detentions.attention_upcoming_description": "การกักยังไม่เริ่ม โดยจะบันทึกการเข้าร่วมในวันที่กำหนด",
  "lunch_detentions.attention_complete_title": "ไม่มีงานค้าง",
  "lunch_detentions.attention_complete_description": "รอบนี้เสร็จสิ้นหรือไม่ใช้งานแล้ว โดยยังสามารถดูประวัติได้",
  "lunch_detentions.attention_action_review": "ตรวจสอบคำขอ",
  "lunch_detentions.attention_action_assign": "มอบหมายผู้ดูแล",
  "lunch_detentions.attention_action_attendance": "เปิดการเข้าร่วม",
  "lunch_detentions.attention_action_view_main": "ดูรอบหลัก",
  "lunch_detentions.attention_warning_overdue_attendance_title_one": "มีวันกักเกินกำหนด {{count}} วัน",
  "lunch_detentions.attention_warning_overdue_attendance_title_other": "มีวันกักเกินกำหนด {{count}} วัน",
  "lunch_detentions.attention_warning_overdue_attendance_description": "วันที่กำหนดผ่านไปแล้วแต่ยังไม่มีการบันทึกผลการเข้าร่วม",
  "lunch_detentions.attention_warning_missing_supervisor_title": "ยังไม่ได้มอบหมายผู้ดูแล",
  "lunch_detentions.attention_warning_missing_supervisor_description": "มอบหมายผู้รับผิดชอบเพื่อให้ชัดเจนว่าใครต้องบันทึกการเข้าร่วม",
  "lunch_detentions.request_count_label": "จำนวนคำขอในปีการศึกษานี้",
  "lunch_detentions.family_communication_description": "บทสนทนาที่ปลอดภัยกับครอบครัวสำหรับการกักครั้งนี้จะแสดงที่นี่ โดยแยกจากบันทึกของเจ้าหน้าที่และ SST",
  "lunch_detentions.family_question_title": "จำเป็นต้องติดต่อครอบครัวหรือไม่?",
  "lunch_detentions.family_question_description": "การสื่อสารกับผู้ปกครองเป็นทางเลือกสำหรับแต่ละรอบ MSS กรุณาบันทึกการตัดสินใจก่อนเริ่มการสนทนา",
  "lunch_detentions.family_decision_label": "การตัดสินใจปัจจุบัน",
  "lunch_detentions.family_decision_pending": "ยังไม่ได้ตัดสินใจ",
  "lunch_detentions.family_yes_title": "ติดต่อครอบครัว",
  "lunch_detentions.family_yes_description": "เปิดบทสนทนาที่ปลอดภัยซึ่งเชื่อมกับการกักครั้งนี้",
  "lunch_detentions.family_no_title": "ไม่จำเป็นต้องส่งข้อความ",
  "lunch_detentions.family_no_description": "บันทึกว่าการกักครั้งนี้ไม่จำเป็นต้องติดต่อครอบครัว",
  "lunch_detentions.family_question_hint": "การตัดสินใจนี้และบทสนทนาในอนาคตจะแยกจากบันทึกของเจ้าหน้าที่และ SST",
  "lunch_detentions.family_future_attention_hint": "เมื่อฟีเจอร์เสร็จสมบูรณ์ การเลือกติดต่อครอบครัวจะทำเครื่องหมายแท็บนี้จนกว่าจะส่งข้อความแล้ว",
  "lunch_detentions.progress_label": "ความคืบหน้า",
  "lunch_detentions.progress_recorded": "บันทึกแล้ว {{recorded}} จาก {{total}} วัน",
  "lunch_detentions.progress_remaining_one": "เหลืออีก {{count}} วัน",
  "lunch_detentions.progress_remaining_other": "เหลืออีก {{count}} วัน",
  "lunch_detentions.progress_aria": "บันทึกแล้ว {{recorded}} จาก {{total}} วันของ MSS",
  "lunch_detentions.private_thread_hint": "เฉพาะผู้ที่มีสิทธิ์โมดูล SST เท่านั้นที่อ่านได้ ครูผู้เสนอและผู้ดูแลไม่เห็นส่วนนี้",
  "lunch_detentions.private_note_placeholder": "เพิ่มบันทึกที่เฉพาะ SST อ่านได้…",
  "lunch_detentions.note_send": "เพิ่มบันทึก",
  "lunch_detentions.timeline_decision": "ผลการพิจารณา: {{detail}}",
  "lunch_detentions.timeline_extension": "ขยายเวลาจากคำขอภายหลัง ({{detail}})",
  "lunch_detentions.timeline_attendance": "บันทึกเป็น {{detail}}",
  "edp.tab_payments": "การชำระเงิน",
  "edp.tab_cancellations": "การยกเลิก",
  "edp.cancellations.heading": "คาบเรียนที่ยกเลิก",
  "edp.cancellations.subtitle": "ช่วงบ่ายที่คอร์สไม่ได้เรียน และสิ่งที่โรงเรียนดำเนินการ: ชดเชยวันอื่นหรือคืนเงิน",
  "edp.cancellations.empty": "รอบนี้ยังไม่มีคาบเรียนที่ถูกยกเลิก",
  "edp.cancellations.cancel_action": "ยกเลิกคาบเรียน",
  "edp.cancellations.cancel_title": "ยกเลิกคาบเรียน",
  "edp.cancellations.cancel_description": "คอร์สจะไม่เรียนในช่วงบ่ายนั้น: รายชื่อประจำชั้นจะส่งนักเรียนกลับบ้าน และไม่มีการเช็คชื่อ",
  "edp.cancellations.cancel_submit": "ยืนยันการยกเลิก",
  "edp.cancellations.col_course": "คอร์ส",
  "edp.cancellations.col_afternoon": "ช่วงบ่าย",
  "edp.cancellations.col_reason": "เหตุผล",
  "edp.cancellations.col_settlement": "การดำเนินการ",
  "edp.cancellations.course_label": "คอร์ส",
  "edp.cancellations.course_placeholder": "เลือกคอร์ส",
  "edp.cancellations.course_required": "กรุณาเลือกคอร์ส",
  "edp.cancellations.block_label": "บล็อก",
  "edp.cancellations.reason_label": "เหตุผล",
  "edp.cancellations.reason_placeholder": "เช่น โค้ชป่วย",
  "edp.cancellations.reason_required": "กรุณาระบุเหตุผลที่ยกเลิก",
  "edp.cancellations.cancelled": "ยกเลิกคาบเรียนแล้ว",
  "edp.cancellations.settle_action": "ดำเนินการ",
  "edp.cancellations.settle_title": "ดำเนินการกับคาบเรียนที่ยกเลิก",
  "edp.cancellations.settle_description": "{{course}} {{afternoon}}: ชดเชยวันอื่น หรือคืนเงิน",
  "edp.cancellations.settlement_label": "การดำเนินการ",
  "edp.cancellations.settlement_to_decide": "ยังไม่ตัดสินใจ",
  "edp.cancellations.settlement_make_up": "ชดเชยวันอื่น",
  "edp.cancellations.settlement_refund": "คืนเงิน",
  "edp.cancellations.make_up_date_label": "วันชดเชย",
  "edp.cancellations.make_up_date_required": "กรุณาเลือกวันชดเชย",
  "edp.cancellations.make_up_block_label": "บล็อกชดเชย",
  "edp.cancellations.make_up_block_same": "บล็อกเดียวกับคาบที่ยกเลิก",
  "edp.cancellations.made_up_on": "ชดเชยวันที่ {{date}}",
  "edp.cancellations.note_label": "หมายเหตุ",
  "edp.cancellations.note_placeholder": "เช่น คืนเงิน ฿5,000 โดยโอนเมื่อ 20 ก.ย.",
  "edp.cancellations.settled": "อัปเดตการยกเลิกแล้ว",
  "edp.cancellations.remove_action": "ลบ",
  "edp.cancellations.remove_title": "นำคาบเรียนกลับมา?",
  "edp.cancellations.remove_description": "จะลบการยกเลิกของ {{course}} วันที่ {{afternoon}} เสมือนไม่เคยยกเลิก",
  "edp.cancellations.removed": "ลบการยกเลิกแล้ว",
  "edp.register.cancelled_notice": "ยกเลิก: {{reason}}",
  "edp.register.cancelled_make_up": "ชดเชยวันที่ {{date}}",
  "edp.register.cancelled_refund": "จะคืนเงิน",
  "edp.register.cancelled_to_decide": "ยังไม่ตัดสินใจว่าจะชดเชยหรือคืนเงิน",
  "edp.payments.heading": "การชำระเงิน EDP",
  "edp.payments.subtitle": "ตรวจสอบการชำระเงินและยอดคงเหลือของแต่ละครอบครัวในแต่ละรอบ",
  "edp.payments.search_placeholder": "ค้นหาตามครอบครัวหรือชื่อนักเรียน…",
  "edp.payments.round_label": "รอบ",
  "edp.payments.empty": "ไม่มีรายการชำระเงินที่จะแสดง",
  "edp.payments.round_closed_notice": "รอบนี้ปิดการชำระเงินอยู่ ผู้ปกครองจึงไม่เห็นหน้าชำระเงินและไม่สามารถแจ้งการโอนได้ เปิดใช้งานได้ในการตั้งค่ารอบ",
  "edp.payments.col_family": "ครอบครัว",
  "edp.payments.col_amount": "ยอดที่แจ้ง",
  "edp.payments.col_reported": "แจ้งเมื่อ",
  "edp.payments.col_slip": "สลิป",
  "edp.payments.col_status": "สถานะ",
  "edp.payments.col_actions": "การดำเนินการ",
  "edp.payments.view_slip": "เปิดสลิป",
  "edp.payments.no_slip": "ไม่ได้แนบ",
  "edp.payments.status_declared": "แจ้งแล้ว",
  "edp.payments.status_confirmed": "ยืนยันแล้ว",
  "edp.payments.status_rejected": "ปฏิเสธ",
  "edp.payments.action_confirm": "ยืนยัน",
  "edp.payments.action_reject": "ปฏิเสธ",
  "edp.payments.note_placeholder": "หมายเหตุถึงผู้ปกครอง (ต้องระบุเมื่อปฏิเสธ)",
  "edp.payments.confirm_title": "ยืนยันการชำระเงินนี้หรือไม่",
  "edp.payments.confirm_description": "ระบบจะแจ้ง {{name}} ว่าการชำระเงินจำนวน {{amount}} ตรงกับรายการของธนาคารแล้ว และผู้ปกครองจะไม่สามารถแก้ไขได้อีก",
  "edp.payments.confirmed": "ยืนยันการชำระเงินแล้ว",
  "edp.payments.rejected": "ปฏิเสธการชำระเงินแล้ว ผู้ปกครองสามารถแจ้งใหม่ได้",
  "edp.payments.notices_action": "ส่งแจ้งเตือนการชำระเงิน",
  "edp.payments.notices_title": "ส่งอีเมลถึงทุกครอบครัวที่ยังค้างชำระหรือไม่",
  "edp.payments.notices_description": "แต่ละครอบครัวที่ยังค้างชำระจะได้รับอีเมลหนึ่งฉบับ ระบุรายชื่อบุตรหลาน ยอดรวม และลิงก์ไปยังหน้าชำระเงิน ครอบครัวที่ยืนยันการชำระเงินแล้วจะไม่ได้รับ",
  "edp.payments.balances_title": "ยอดเงินที่ไม่ตรงกัน",
  "edp.payments.balances_hint": "เปรียบเทียบค่าเรียนปัจจุบันกับยอดชำระที่ยืนยันแล้ว ตรวจสอบยอดค้างชำระหรือยอดชำระเกิน และบันทึกการปรับปรุงรายการ",
  "edp.payments.col_owed": "ยอดค้างปัจจุบัน",
  "edp.payments.col_paid": "ยืนยันแล้ว",
  "edp.payments.col_balance": "ส่วนต่าง",
  "edp.payments.family_unknown": "ไม่มีข้อมูลผู้ปกครอง",
  "edp.payments.recorded_by_office": "บันทึกโดยสำนักงาน",
  "edp.my_courses.badge": "EDP",
  "timetable.edp_cell": "EDP",
  "edp.register.unpaid": "ยังไม่ชำระ",
  "edp.by_teacher.heading": "ใครสอนอะไร",
  "edp.by_teacher.subtitle": "คอร์สทั้งหมดในรอบนี้ จัดกลุ่มตามผู้สอน",
  "edp.by_teacher.col_teacher": "ครูผู้สอน",
  "edp.by_teacher.col_courses": "คอร์ส",
  "edp.by_teacher.course_count_one": "{{count}} คอร์ส",
  "edp.by_teacher.course_count_other": "{{count}} คอร์ส",
  "edp.by_teacher.confirmed_one": "{{count}} คน",
  "edp.by_teacher.confirmed_other": "{{count}} คน",
  "edp.by_teacher.visiting": "ครูภายนอก",
  "edp.by_teacher.nobody": "ยังไม่ได้กำหนดผู้สอน",
  "edp.payments.awaiting_review": "แจ้งแล้ว {{count}} รายการ ยังไม่ได้ตรวจสอบ",
  "edp.payments.balance_short": "ยังขาดอีก {{amount}}",
  "edp.payments.balance_over": "รับเกินไว้ {{amount}}",
  "edp.payments.record_action": "บันทึกการชำระเงิน",
  "edp.payments.record_title": "บันทึกการชำระเงินที่สำนักงานได้รับ",
  "edp.payments.record_description": "เงินสดที่เคาน์เตอร์ หรือการโอนที่ผู้ปกครองไม่ได้แจ้งผ่านพอร์ทัล ระบบจะบันทึกเป็นยืนยันแล้ว เนื่องจากท่านเป็นผู้เห็นการชำระเงินเอง",
  "edp.payments.record_student": "นักเรียน",
  "edp.payments.record_student_hint": "เลือกบุตรหลานคนใดก็ได้ของครอบครัวนั้น การชำระเงินจะหักยอดรวมของทั้งครอบครัว ไม่ใช่เฉพาะนักเรียนคนนี้",
  "edp.payments.record_student_required": "โปรดเลือกนักเรียนของครอบครัวที่ชำระเงิน",
  "edp.payments.record_amount": "จำนวนเงินที่ได้รับ",
  "edp.payments.record_amount_required": "โปรดระบุจำนวนเงินที่ได้รับ เป็นจำนวนเต็มบาท",
  "edp.payments.record_note": "หมายเหตุ",
  "edp.payments.record_note_placeholder": "เช่น เงินสดที่สำนักงาน ใบเสร็จเลขที่ 0412",
  "edp.payments.method_label": "ชำระโดย",
  "edp.payments.method_bank_transfer": "โอนเงิน",
  "edp.payments.method_cash": "เงินสด",
  "edp.payments.method_credit_card": "บัตรเครดิต",
  "edp.payments.method_salary_deduction": "หักจากเงินเดือน",
  "edp.payments.export": "ส่งออก CSV",
  "edp.payments.csv_recorded_by": "บันทึกโดย",
  "edp.payments.csv_children": "บุตร",
  "edp.payments.csv_courses": "คอร์ส",
  "edp.payments.csv_free_places": "ที่นั่งฟรี",
  "edp.payments.csv_free_places_used": "ใช้ {{used}} จาก {{granted}} (ลด {{discount}})",
  "edp.payments.csv_reviewed": "ตรวจสอบเมื่อ",
  "edp.payments.csv_recorded_by_office": "บันทึกโดยสำนักงาน",
  "edp.payments.csv_note": "หมายเหตุ",
  "edp.payments.csv_awaiting_review": "รอตรวจสอบ",
  "edp.payments.totals_fees": "ค่าคอร์ส",
  "edp.payments.totals_fees_hint": "นักเรียน {{count}} คนที่มีที่นั่ง",
  "edp.payments.totals_free_places": "ที่นั่งฟรีที่ใช้",
  "edp.payments.totals_free_places_hint": "ลด {{amount}} · เหลือ {{unused}} จาก {{granted}} ที่ยังไม่ใช้",
  "edp.payments.totals_payable": "ยอดที่ต้องชำระ",
  "edp.payments.totals_payable_hint": "{{count}} ครอบครัว",
  "edp.payments.totals_confirmed": "ยืนยันแล้ว",
  "edp.payments.totals_by_method": "{{amount}} โดย{{method}}",
  "edp.payments.totals_confirmed_none": "ยังไม่มียอดที่ยืนยัน",
  "edp.payments.totals_still_to_come": "ยังไม่ได้รับ",
  "edp.payments.totals_still_to_come_hint": "{{count}} ครอบครัวที่ค้างชำระ",
  "edp.payments.totals_held_over": "ชำระเกิน",
  "edp.payments.totals_held_over_hint": "{{count}} ครอบครัวที่ชำระเกิน",
  "edp.payments.totals_awaiting": "รอตรวจสอบ",
  "edp.payments.totals_awaiting_hint": "แจ้งแล้ว {{amount}} ยังไม่ได้ตรวจสอบ · ปฏิเสธ {{rejected}} รายการ",
  "edp.payments.totals_settled": "ครบถ้วนแล้ว",
  "edp.payments.totals_settled_hint": "จาก {{total}} ครอบครัว",
  "edp.payments.record_slip": "ใบเสร็จหรือสลิป (ไม่บังคับ)",
  "edp.payments.record_slip_hint": "รูปภาพหรือ PDF รวมถึงรูปจาก iPhone โดยตรง ขนาดไม่เกิน 10 MB",
  "edp.payments.record_slip_too_big": "ไฟล์มีขนาดเกิน 10 MB",
  "edp.payments.record_success": "บันทึกการชำระเงินแล้ว",
  "edp.payments.edit_title": "แก้ไขรายการชำระเงินนี้",
  "edp.payments.edit_description": "แก้ไขจำนวนเงินหรือหมายเหตุของรายการชำระเงินของ {{name}} หากต้องการย้ายไปยังครอบครัวอื่น ให้ลบแล้วบันทึกใหม่",
  "edp.payments.edit_success": "แก้ไขรายการชำระเงินแล้ว",
  "edp.payments.delete_title": "ลบรายการชำระเงินนี้หรือไม่",
  "edp.payments.delete_description": "ระบบจะลบรายการชำระเงินจำนวน {{amount}} ของ {{name}} พร้อมสลิปที่แนบไว้ และไม่สามารถย้อนกลับได้",
  "edp.payments.deleted": "ลบรายการชำระเงินแล้ว",
  "edp.payments.create_receipt": "ออกใบเสร็จ",
  "edp.payments.create_all_receipts": "ออกใบเสร็จที่ค้างอยู่ทั้งหมด",
  "edp.payments.receipt_number": "ใบเสร็จ",
  "edp.payments.create_receipt_success": "ออกใบเสร็จ {{number}} แล้ว",
  "edp.payments.create_all_receipts_success": "ออกแล้ว {{issued}} รายการ มีอยู่แล้ว {{skipped}} รายการ",
  "edp.payments.filter_not_matching": "ยอดไม่ตรง",
  "edp.payments.balances_all_settled": "ยอดของทุกครอบครัวตรงกันแล้ว",
  "edp.rounds.field_payment_due": "กำหนดชำระเงิน",
  "edp.rounds.hint_payment_due": "ไม่บังคับ ผู้ปกครองจะได้รับแจ้งให้ชำระภายในวันนี้ และจะแสดงในจดหมายและพอร์ทัล — ชำระหลังกำหนดยังรับได้",
  "edp.payments.send_reminder": "ส่งการแจ้งเตือน",
  "edp.payments.notices_sent_on": "ส่งใบแจ้งชำระเมื่อ {{when}}",
  "edp.payments.reminder_confirm_title": "ส่งการแจ้งเตือนหรือไม่?",
  "edp.payments.reminder_confirm_body": "ส่งถึงทุกครอบครัวที่ยังค้างชำระ ยกเว้นรายที่ยังไม่ได้ตรวจสลิป ส่งซ้ำได้ภายหลัง",
  "edp.payments.notices_confirm_title": "ประกาศการชำระเงินสำหรับรอบนี้หรือไม่?",
  "edp.payments.notices_confirm_body": "ส่งถึงทุกครอบครัวที่ค้างชำระ และทำได้ครั้งเดียว หลังจากนั้นให้ใช้การแจ้งเตือน",
  "edp.payments.reminder_sent": "จัดคิวการแจ้งเตือนให้ {{count}} ครอบครัวแล้ว",
  "edp.detail.field_assistants": "ผู้ช่วย",
  "edp.detail.hint_assistants": "เจ้าหน้าที่ที่ช่วยดูแลคอร์ส จะเห็นคอร์สนี้ใน Classes Today ของตนเองและเช็กชื่อได้",
  "edp.detail.assistants_empty": "ไม่พบเจ้าหน้าที่",
  "edp.detail.assistants_placeholder": "ค้นหาเจ้าหน้าที่…",
  "nav.my_work.edp": "EDP",
  "edp.mine.tabs_label": "EDP ของฉัน",
  "edp.mine.tab_proposals": "ข้อเสนอ",
  "edp.mine.tab_running": "กำลังสอน",
  "edp.mine.running_heading": "คอร์สที่ฉันดูแล",
  "edp.mine.running_subtitle": "คอร์ส EDP ของคุณในรอบนี้ และนักเรียนในคอร์ส",
  "edp.mine.running_empty": "คุณยังไม่มีคอร์ส EDP ในรอบนี้",
  "edp.mine.students_count": "นักเรียน {{count}} คน",
  "edp.mine.take_register": "เช็กชื่อ",
  "edp.mine.no_students": "ยังไม่มีนักเรียนได้ที่นั่ง",
  "edp.mine.running_error": "ไม่สามารถโหลดคอร์สของคุณได้ กรุณาลองใหม่อีกครั้ง",
  "edp.register.load_error": "ไม่สามารถโหลดรายชื่อได้ กรุณาลองใหม่อีกครั้ง",
  "edp.my_courses.open_register": "เปิดรายการเช็กชื่อแบบเต็ม",
  "edp.payments.family_emails": "อีเมลถึงครอบครัว",
  "edp.payments.review_action": "ตรวจสอบ",
  "edp.payments.review_hint": "ตรวจสอบรายการชำระเงินนี้กับรายการเดินบัญชีธนาคารก่อนยืนยัน",
  "edp.payments.review_note_label": "หมายเหตุถึงครอบครัว",
  "edp.payments.review_note_hint": "ต้องระบุเหตุผลเมื่อปฏิเสธการชำระเงิน ครอบครัวสามารถอ่านหมายเหตุนี้ได้",
  "nav.logs": "บันทึก",
  "logs.tab_activity": "กิจกรรม",
  "logs.tab_door": "การเข้าออกประตู",
  "edp.payments.void_receipt_action": "ยกเลิกใบเสร็จ",
  "edp.payments.void_receipt_title": "ยกเลิกใบเสร็จนี้หรือไม่?",
  "edp.payments.void_receipt_description": "ใบเสร็จ {{number}} จะยังคงเลขที่เดิมไว้แต่จะไม่นับว่าออกแล้ว และรายการชำระเงินที่อยู่เบื้องหลังจะแก้ไขหรือลบได้อีกครั้ง ใช้เฉพาะเมื่อใบเสร็จนั้นผิดพลาดเท่านั้น — การที่เด็กถอนตัวจากคอร์สไม่ใช่เหตุผลให้ยกเลิกใบเสร็จ",
  "edp.payments.void_reason_label": "เหตุผล",
  "edp.payments.void_reason_placeholder": "เหตุผลที่ใบเสร็จนี้ไม่ควรถูกออก",
  "edp.payments.void_receipt_success": "ยกเลิกใบเสร็จแล้ว",
  "edp.payments.generate_pdf": "สร้าง PDF",
  "edp.payments.generate_pdf_success": "สร้าง PDF แล้ว",
  "edp.payments.create_all_receipts_confirm_title": "ออกใบเสร็จที่ค้างอยู่ทั้งหมดหรือไม่?",
  "edp.payments.create_all_receipts_confirm_description": "ระบบจะออกใบเสร็จที่มีเลขที่ให้กับทุกรายการชำระเงินที่ยืนยันแล้วในรอบนี้ที่ยังไม่มีใบเสร็จ — ขณะนี้มี {{count}} รายการ เลขที่ใบเสร็จเรียงต่อเนื่องและนำกลับมาใช้ซ้ำไม่ได้ จึงควรตรวจสอบรอบนี้ก่อน",
  "growth.height.severely-short": "เตี้ยกว่าเกณฑ์มาก",
  "growth.height.short": "เตี้ยกว่าเกณฑ์",
  "growth.height.typical": "ส่วนสูงตามเกณฑ์",
  "growth.height.tall": "สูงกว่าเกณฑ์",
  "growth.bmi.severe-thinness": "ผอมมาก",
  "growth.bmi.thinness": "ผอม",
  "growth.bmi.healthy-weight": "น้ำหนักตามเกณฑ์",
  "growth.bmi.risk-of-overweight": "เสี่ยงน้ำหนักเกิน",
  "growth.bmi.overweight": "น้ำหนักเกิน",
  "growth.weight.severely-underweight": "น้ำหนักน้อยกว่าเกณฑ์มาก",
  "growth.weight.underweight": "น้ำหนักน้อยกว่าเกณฑ์",
  "growth.weight.typical": "ไม่อยู่ในเกณฑ์น้ำหนักน้อย",
  "growth.bmi.obesity": "ภาวะอ้วน",
  "students.col_ht_who": "ส่วนสูง (WHO)",
  "students.col_wt_who": "น้ำหนัก (WHO)",
  "students.col_bmi_who": "BMI (WHO)",
  "students.growth_chart_height": "ส่วนสูงตามเกณฑ์อายุ",
  "students.growth_chart_bmi": "BMI ตามเกณฑ์อายุ",
  "students.growth_chart_weight": "น้ำหนักตามเกณฑ์อายุ",
  "students.growth_chart_band_outer": "เปอร์เซ็นไทล์ที่ 3–97",
  "students.growth_chart_band_inner": "เปอร์เซ็นไทล์ที่ 15–85",
  "students.growth_chart_median": "เปอร์เซ็นไทล์ที่ 50",
  "students.growth_chart_child": "นักเรียนคนนี้",
  "students.growth_chart_age_axis": "อายุ (ปี)",
  "students.growth_chart_tooltip_age": "อายุ {{years}} ปี",
  "students.growth_chart_no_reference": "WHO ไม่ได้กำหนดเกณฑ์ในช่วงอายุนี้ กราฟจึงแสดงเฉพาะผลการวัดของนักเรียนคนนี้ สำหรับน้ำหนักของเด็กอายุเกิน 10 ปี ให้ดูค่า BMI ตามเกณฑ์อายุแทน",
  "students.growth_chart_not_comparable": "กรุณาเพิ่มวันเกิดและเพศของนักเรียน เพื่อเปรียบเทียบผลการวัดกับเกณฑ์ของ WHO",
  "nav.medical_hub": "การแพทย์",
  "medical.hub.tab_today": "วันนี้",
  "medical.hub.tab_measurements": "การวัดร่างกาย",
  "medical.hub.tab_temperature": "อุณหภูมิ",
  "medical.hub.tab_allergies": "ภูมิแพ้",
  "medical.hub.settings": "ตั้งค่าการแพทย์",
  "medical.hub.measurements_title": "ความครบถ้วนของการวัดร่างกาย",
  "medical.hub.temperature_title": "ความครบถ้วนของการวัดอุณหภูมิ",
  "medical.hub.allergies_title": "ภูมิแพ้และข้อจำกัดด้านอาหาร",
  "medical.hub.today_title": "วันนี้",
  "medical.hub.tabs_label": "แท็บศูนย์การแพทย์",
  "medical.hub.measurements_subtitle": "ใครได้รับการวัดแล้ว และปีละกี่ครั้ง",
  "medical.hub.filter_missing_year": "ยังไม่ได้วัดปีนี้",
  "medical.hub.filter_never": "ยังไม่เคยวัด",
  "medical.hub.filter_all": "ทั้งหมด",
  "medical.hub.col_last": "วัดครั้งล่าสุด",
  "medical.hub.never_measured": "ยังไม่เคย",
  "medical.hub.measurements_empty": "ไม่มีข้อมูลตามตัวกรองนี้",
  "medical.hub.temperature_subtitle": "วัดอุณหภูมิถึงระดับอนุบาล โดยปกติวันละ 3 ครั้ง",
  "medical.hub.filter_no_reading": "ยังไม่ได้วัดวันนี้",
  "medical.hub.out_today": "ไม่ได้มาโรงเรียนวันนี้",
  "medical.hub.filter_short": "น้อยกว่า {{expected}} ครั้ง",
  "medical.hub.col_class": "ชั้นเรียน",
  "medical.hub.col_readings": "จำนวนครั้งที่วัด",
  "medical.hub.date": "วันที่",
  "medical.hub.temperature_empty": "ไม่มีข้อมูลตามตัวกรองนี้",
  "medical.hub.allergies_subtitle": "ข้อมูลภูมิแพ้และข้อจำกัดด้านอาหารของนักเรียนทุกคน",
  "medical.hub.filter_any_allergy": "มีภูมิแพ้",
  "medical.hub.filter_severe": "รุนแรง",
  "medical.hub.filter_no_record": "ยังไม่มีข้อมูล",
  "medical.hub.col_allergies": "ภูมิแพ้",
  "medical.hub.col_diet": "ข้อจำกัดด้านอาหาร",
  "medical.hub.no_record_note": "ยังไม่มีการกรอกข้อมูลของนักเรียนกลุ่มนี้ ซึ่งไม่ได้แปลว่าไม่มีภูมิแพ้",
  "medical.hub.allergies_empty": "ไม่มีข้อมูลตามตัวกรองนี้",
  "medical.hub.today_subtitle": "ใครลาป่วย การวัดอุณหภูมิคืบหน้าแค่ไหน และใครเข้าห้องพยาบาลบ้าง",
  "medical.hub.total_sick": "ลาป่วย",
  "medical.hub.total_infirmary": "เข้าห้องพยาบาล",
  "medical.hub.total_no_temperature": "ยังไม่ได้วัดอุณหภูมิ",
  "medical.hub.temperature_progress": "วัดแล้ว {{complete}} / {{students}}",
  "medical.hub.class_quiet": "วันนี้ไม่มีรายการ",
  "medical.hub.today_empty": "ไม่มีชั้นเรียนที่จะแสดง",
  "medical.hub.temperature_none_count": "ยังไม่ได้วัด {{count}} คน",
  "students.attendance_missed_while_at_school_one": "ขาดเรียน 1 คาบขณะอยู่ที่โรงเรียน",
  "students.attendance_missed_while_at_school_other": "ขาดเรียน {{count}} คาบขณะอยู่ที่โรงเรียน",
  "students.attendance_missed_lessons": "ไม่ได้เข้าเรียน {{lessons}}",
  "attendance.arrives_at": "มาถึง {{time}}",
  "attendance.col_rate_marked_days": "สัดส่วนการมาเรียนจากวันที่บันทึกแล้ว",
  "attendance.subject_rates_view_rate": "อัตราการเข้าเรียน",
  "attendance.subject_rates_view_missed": "ขาดเรียนขณะอยู่ที่โรงเรียน",
  "lesson_notes.previous_title": "ครั้งที่แล้ว · {{when}}",
  "lesson_notes.editor_label": "สิ่งที่เราทำในคาบนี้",
  "lesson_notes.editor_placeholder": "ไม่บังคับ — มีเพียงคุณที่เห็นบันทึกนี้",
  "lesson_notes.saved": "บันทึกลงบันทึกการสอนแล้ว",
  "lesson_notes.cleared": "ลบบันทึกออกจากบันทึกการสอนแล้ว",
  "lesson_notes.future_hint": "คุณสามารถบันทึกสิ่งที่ทำได้หลังจบคาบเรียน",
  "medical.hub.record_temperature": "วัดอุณหภูมิ",
  "notifications.item.conferences.teacher-digest": "มีการเปลี่ยนแปลงประชุมผู้ปกครองและครู (PTC) {{count}} รายการตั้งแต่เมื่อวาน",
  "notifications.item.conferences.teacher-final-schedule": "ปิดการจองแล้ว: ตารางประชุมผู้ปกครองและครู (PTC) ของคุณมี {{count}} นัด",
  "notifications.item.early-dismissals.gate-reminder_one": "มีนักเรียนกลับก่อน {{count}} คน",
  "notifications.item.early-dismissals.gate-reminder_other": "มีนักเรียนกลับก่อน {{count}} คน",
  "notifications.item.immigration.digest_one": "สรุปงานตรวจคนเข้าเมือง: {{count}} รายการ",
  "notifications.item.immigration.digest_other": "สรุปงานตรวจคนเข้าเมือง: {{count}} รายการ",
  "notifications.item.report-cards.deadline": "ยังมีอีก {{count}} วิชาที่ต้องกรอกสมุดรายงานผลการเรียน",
  "notifications.mark_read": "ทำเครื่องหมายว่าอ่านแล้ว",
  "notifications.detail.temperature": "{{tempC}} °C",
  "notifications.urgency.urgent": "ด่วน",
  "notifications.urgency.action": "ต้องดำเนินการ",
  "notifications.open": "เปิด",
  "notifications.dismiss": "ปิด",
  "notifications.dismiss_all": "ปิดทั้งหมด",
  "notifications.more_count": "+{{count}} รายการ",
  "allergy_changes.detail_breadcrumb": "รายละเอียด",
  "allergy_changes.not_found": "ไม่พบคำขอเปลี่ยนแปลงข้อมูลภูมิแพ้นี้",
  "allergy_changes.request_section": "คำขอ",
  "contact_inquiries.detail_breadcrumb": "รายละเอียด",
  "contact_inquiries.not_found": "ไม่พบข้อความติดต่อสอบถามนี้",
  "contact_inquiries.message": "ข้อความ",
  "tours.detail_breadcrumb": "รายละเอียด",
  "tours.detail_title": "คำขอเยี่ยมชม — {{name}}",
  "tours.not_found": "ไม่พบคำขอเยี่ยมชมนี้",
  "tours.request_section": "คำขอ",
  "tours.full_name": "ชื่อ-นามสกุล",
  "tours.phone": "โทรศัพท์",
  "tours.message": "ข้อความ",
  "tours.born": "เกิดวันที่",
  "student_absences.detail_breadcrumb": "การลา",
  "student_absences.not_found": "ไม่พบข้อมูลการลานี้ อาจถูกลบไปแล้ว",
  "student_absences.detail_title": "การลา — {{name}}",
  "allergy_changes.detail_title": "การเปลี่ยนแปลงข้อมูลภูมิแพ้ — {{name}}",
  "lesson_excusals.detail_breadcrumb": "การลารายคาบ",
  "lesson_excusals.not_found": "ไม่พบการลารายคาบนี้ อาจถูกลบไปแล้ว",
  "lesson_excusals.detail_title": "การลารายคาบ — {{name}}",
  "early_dismissals.detail_breadcrumb": "การกลับก่อนเวลา",
  "early_dismissals.not_found": "ไม่พบรายการกลับก่อนเวลานี้ อาจถูกลบไปแล้ว",
  "early_dismissals.detail_title": "การกลับก่อนเวลา — {{name}}",
  "bookings.detail_breadcrumb": "การจอง",
  "bookings.not_found": "ไม่พบการจองนี้ อาจถูกยกเลิกไปแล้ว",
  "leave.not_found": "ไม่พบคำขอลานี้",
  "leave.decision_message": "ข้อความจากผู้พิจารณา",
  "contact_inquiries.request_section": "ข้อสอบถาม",
  "presence.online_count_one": "ออนไลน์ {{count}} คน",
  "presence.online_count_other": "ออนไลน์ {{count}} คน",
  "medical.hub.not_a_school_day": "ไม่ใช่วันเรียน",
  "medical.hub.tab_growth": "การเจริญเติบโต",
  "medical.hub.growth_title": "ผลการเจริญเติบโต",
  "medical.hub.growth_subtitle": "ผลวัดล่าสุดของนักเรียนแต่ละคนเทียบกับเกณฑ์ WHO",
  "medical.hub.growth_measured": "นักเรียนที่วัดแล้ว",
  "medical.hub.growth_attention": "ควรดูก่อน",
  "medical.hub.growth_attention_hint": "กลุ่มที่ WHO ระบุว่าควรให้ความสำคัญมากที่สุด",
  "medical.hub.growth_monitor": "ควรติดตาม",
  "medical.hub.growth_monitor_hint": "อยู่นอกเกณฑ์ที่คาดไว้ แต่ยังไม่ใช่กลุ่มที่ WHO ระบุว่าควรให้ความสำคัญมากที่สุด",
  "medical.hub.growth_unreadable": "อ่านค่าไม่ได้",
  "medical.hub.growth_unreadable_hint": "วันเกิดที่ขาดหายหรือผิดไม่ได้ทำให้ไม่มีผล แต่ทำให้เทียบกับเกณฑ์ผิดช่วงอายุ ซึ่งอาจอ่านดูเหมือนปกติ ควรแก้ก่อน",
  "medical.hub.growth_empty": "ยังไม่มีข้อมูล",
  "medical.hub.growth_measurement": "ผลวัด",
  "medical.hub.growth_findings": "สิ่งที่เกณฑ์บอก",
  "medical.hub.growth_issue": "ข้อมูลที่ขาด",
  "medical.hub.growth_issue_no_date_of_birth": "ไม่มีวันเกิดในระบบ",
  "medical.hub.growth_issue_no_sex": "ไม่มีข้อมูลเพศในระบบ",
  "medical.hub.growth_issue_age_implausible": "วันเกิดไม่สอดคล้องกับระดับชั้น",
  "medical.hub.growth_age_recorded": "ระบบบันทึกอายุไว้ {{years}} ปี",
  "medical.hub.growth_percentile": "เปอร์เซ็นไทล์ที่ {{value}}",
  "medical.hub.growth_wh": "{{weight}} กก. · {{height}} ซม.",
  "medical.hub.growth_bmi": "BMI {{bmi}}",
  "medical.hub.growth_indicator.height-for-age": "ส่วนสูงตามอายุ",
  "medical.hub.growth_indicator.weight-for-age": "น้ำหนักตามอายุ",
  "medical.hub.growth_indicator.bmi-for-age": "BMI ตามอายุ",
  "students.attendance_late_count_one": "มาสาย 1 ครั้ง",
  "students.attendance_late_count_other": "มาสาย {{count}} ครั้ง",
  "students.attendance_late_minutes": "รวม {{total}} นาที เฉลี่ย {{average}} นาที",
  "students.attendance_late_worst": "มากที่สุด {{minutes}} นาที เมื่อ {{date}}",
  "students.attendance_late_excused_one": "อีก {{count}} ครั้งแจ้งมาสายไว้ (ได้รับอนุญาต)",
  "students.attendance_late_excused_other": "อีก {{count}} ครั้งแจ้งมาสายไว้ (ได้รับอนุญาต)",
  "students.attendance_by_subject": "แยกตามวิชา ปีนี้",
  "report_cards.tab_entry": "รายการที่ฉันกรอก",
  "report_cards.tab_ptc": "PTC",
  "report_cards.tab_periods": "ช่วงรายงานผล",
  "report_cards.tab_completeness": "ความครบถ้วน",
  "report_cards.tabs_label": "หมวดสมุดรายงานผล",
  "report_cards.heading": "ช่วงรายงานผล",
  "report_cards.periods.subtitle": "เปิดไตรมาสเพื่อสร้างตารางรายวิชาและสมุดรายงานผลฉบับร่างของนักเรียนทุกคน แล้วแก้ไขรายละเอียดด้านล่าง",
  "report_cards.periods.new_period": "สร้างช่วงใหม่",
  "report_cards.periods.select_school_year_placeholder": "เลือกปีการศึกษา",
  "report_cards.periods.empty": "ยังไม่มีช่วงรายงานผลสำหรับปีการศึกษานี้",
  "report_cards.periods.col_sequence": "#",
  "report_cards.periods.col_name": "ชื่อ",
  "report_cards.periods.col_start_date": "วันเริ่ม",
  "report_cards.periods.col_end_date": "วันสิ้นสุด",
  "report_cards.periods.col_due_at": "กำหนดส่ง",
  "report_cards.periods.status_draft": "ร่าง",
  "report_cards.periods.status_open": "เปิดอยู่",
  "report_cards.periods.status_closed": "ปิดแล้ว",
  "report_cards.periods.status_published": "เผยแพร่แล้ว",
  "report_cards.periods.open_action": "เปิด",
  "report_cards.periods.open_confirm_title": "เปิด \"{{name}}\" หรือไม่?",
  "report_cards.periods.open_confirm_description": "การดำเนินการนี้จะสร้างตารางรายวิชาสำหรับทุกระดับชั้น — คัดลอกจากช่วงก่อนหน้า หรืออ่านจากตารางสอนหากยังไม่มีช่วงก่อนหน้า — พร้อมสมุดรายงานผลฉบับร่างของนักเรียนที่ลงทะเบียนทุกคน ย้อนกลับไม่ได้",
  "report_cards.periods.close_action": "ปิด",
  "report_cards.periods.close_confirm_title": "ปิด \"{{name}}\" หรือไม่?",
  "report_cards.periods.close_confirm_description": "ครูจะไม่สามารถแก้ไขคะแนนหรือความเห็นของช่วงนี้ได้อีก ตารางรายวิชาจะกลายเป็นอ่านอย่างเดียว",
  "report_cards.periods.matrix_action": "ตารางรายวิชา",
  "report_cards.periods.edit_title": "แก้ไขช่วงรายงานผล",
  "report_cards.periods.new_title": "สร้างช่วงรายงานผลใหม่",
  "report_cards.periods.field_number": "ลำดับที่",
  "report_cards.periods.field_entry_opens_at": "วันเปิดให้กรอก (ไม่บังคับ)",
  "report_cards.periods.field_issue_date": "วันที่ออกรายงาน (ไม่บังคับ)",
  "report_cards.periods.error_sequence_required": "กรุณาระบุลำดับของช่วง",
  "report_cards.periods.error_name_required": "กรุณาระบุชื่อ",
  "report_cards.periods.error_start_date_required": "กรุณาระบุวันเริ่ม",
  "report_cards.periods.error_end_date_required": "กรุณาระบุวันสิ้นสุด",
  "report_cards.periods.error_end_before_start": "วันสิ้นสุดต้องอยู่หลังหรือตรงกับวันเริ่ม",
  "report_cards.periods.error_entry_opens_at_out_of_span": "วันเปิดให้กรอกต้องอยู่ระหว่างวันเริ่มและวันสิ้นสุด",
  "report_cards.periods.error_due_at_required": "กรุณาระบุกำหนดส่ง",
  "report_cards.periods.error_due_at_out_of_span": "กำหนดส่งต้องไม่ก่อนวันเริ่มหรือวันเปิดให้กรอก",
  "report_cards.periods.open_success_cloned": "เปิดสำเร็จ: สร้างรายวิชา {{lines}} รายการ และสมุดรายงานผล {{cards}} ฉบับ โดยคัดลอกจากช่วงก่อนหน้า",
  "report_cards.periods.open_success_timetable": "เปิดสำเร็จ: สร้างรายวิชา {{lines}} รายการ และสมุดรายงานผล {{cards}} ฉบับ จากตารางสอน",
  "report_cards.periods.close_success": "ปิดช่วงแล้ว",
  "report_cards.matrix.title": "ตารางรายวิชา — {{name}}",
  "report_cards.matrix.read_only_notice": "ช่วงนี้ปิดแล้ว ตารางรายวิชาจึงอ่านได้อย่างเดียว",
  "report_cards.matrix.add_line": "เพิ่มรายวิชา",
  "report_cards.matrix.col_label": "รายวิชา",
  "report_cards.matrix.col_scale": "มาตราส่วน",
  "report_cards.matrix.col_kind": "ประเภท",
  "report_cards.matrix.col_teachers": "ครูผู้สอน",
  "report_cards.matrix.kind_grade": "คะแนน",
  "report_cards.matrix.kind_standards": "มาตรฐาน",
  "report_cards.matrix.kind_narrative": "คำบรรยาย",
  "report_cards.matrix.move_up": "เลื่อนขึ้น",
  "report_cards.matrix.move_down": "เลื่อนลง",
  "report_cards.matrix.empty": "ยังไม่มีรายวิชาสำหรับระดับชั้นนี้",
  "report_cards.matrix.edit_line_title": "แก้ไขรายวิชา",
  "report_cards.matrix.new_line_title": "เพิ่มรายวิชาใหม่",
  "report_cards.matrix.field_key": "รหัส",
  "report_cards.matrix.field_label": "ป้ายชื่อที่พิมพ์",
  "report_cards.matrix.field_group_label": "ป้ายกลุ่ม",
  "report_cards.matrix.field_scale": "มาตราส่วนการให้คะแนน",
  "report_cards.matrix.no_scale": "ไม่มีมาตราส่วน",
  "report_cards.matrix.field_kind": "ประเภท",
  "report_cards.matrix.field_description": "คำอธิบาย",
  "report_cards.matrix.field_comment_enabled": "เปิดให้แสดงความเห็น",
  "report_cards.matrix.error_key_required": "กรุณาระบุรหัส",
  "report_cards.matrix.error_label_required": "กรุณาระบุป้ายชื่อ",
  "report_cards.entry.heading": "กรอกคะแนน",
  "report_cards.entry.due": "กำหนดส่ง {{date}}",
  "report_cards.entry.overdue": "เลยกำหนด",
  "report_cards.entry.outstanding_badge": "เหลือ {{count}} รายการ",
  "report_cards.entry.no_open_period": "ขณะนี้ไม่มีภาคเรียนที่เปิดให้กรอกคะแนน",
  "report_cards.entry.nothing_to_submit": "ไม่มีรายวิชาที่ได้รับมอบหมายให้คุณกรอกในภาคเรียนนี้",
  "report_cards.entry.scope_label": "เลือกชั้นเรียนที่จะแสดง",
  "report_cards.entry.scope_mine": "ชั้นเรียนของฉัน · เหลือ {{count}} รายการ",
  "report_cards.entry.scope_all": "ทุกชั้นเรียน · เหลือ {{count}} รายการ",
  "report_cards.entry.mine_empty": "คุณไม่ได้สอนชั้นเรียนใดในไตรมาสนี้ — สลับไปที่ “ทุกชั้นเรียน” เพื่อกรอกแทนผู้อื่น",
  "report_cards.entry.grid_empty": "ยังไม่มีนักเรียนในวิชานี้",
  "report_cards.entry.col_grade": "เกรด",
  "report_cards.entry.col_comment": "ความคิดเห็น",
  "report_cards.entry.grade_label": "เกรดของ {{name}}",
  "report_cards.entry.comment_label": "ความคิดเห็นสำหรับ {{name}}",
  "report_cards.entry.comment_saved": "บันทึกแล้ว",
  "report_cards.entry.copy_comment": "คัดลอกความคิดเห็นจากไตรมาสก่อน",
  "report_cards.entry.comment_only": "ความคิดเห็นเท่านั้น",
  "report_cards.entry.comment_only_hint": "นักเรียนคนนี้ไม่ได้รับเกรดตัวอักษรในช่วงนี้ — ความคิดเห็นคือการประเมิน",
  "report_cards.entry.movement_up": "ดีขึ้นตั้งแต่ {{period}}",
  "report_cards.entry.movement_down": "ลดลงตั้งแต่ {{period}}",
  "report_cards.entry.movement_level": "ไม่เปลี่ยนแปลงตั้งแต่ {{period}}",
  "report_cards.completeness.col_subject": "วิชา",
  "report_cards.completeness.col_teachers": "ครูผู้สอน",
  "report_cards.completeness.col_progress": "กรอกแล้ว / ทั้งหมด",
  "report_cards.completeness.unassigned": "ยังไม่มอบหมาย",
  "report_cards.completeness.empty": "ยังไม่มีรายวิชาสำหรับภาคเรียนนี้",
  "students.detail_tab_map": "MAP",
  "students.report_card.tab": "สมุดพก",
  "students.report_card.quarter": "ไตรมาส",
  "students.report_card.empty": "คุณไม่ได้สอนนักเรียนคนนี้ จึงไม่แสดงสมุดพก",
  "students.report_card.load_error": "ไม่สามารถโหลดรายงานผลการเรียนได้ กรุณาลองใหม่อีกครั้ง",
  "students.report_card.draft": "ฉบับร่าง",
  "students.report_card.published": "เผยแพร่แล้ว",
  "students.report_card.pdf": "PDF",
  "students.report_card.specialists_only_note": "ตัวชี้วัดและความคิดเห็นของครูประจำชั้นแสดงเฉพาะทีมครูประจำชั้น",
  "students.report_card.class": "ชั้นเรียน",
  "students.report_card.homeroom_teacher": "ครูประจำชั้น",
  "students.report_card.subjects": "ผลการเรียนรายวิชา",
  "students.report_card.comment_only_note": "ในช่วงนี้ นักเรียนคนนี้ได้รับการประเมินผ่านความคิดเห็นของครูแทนเกรดตัวอักษร",
  "students.report_card.homeroom_comment": "ความคิดเห็นของครูประจำชั้น",
  "students.report_card.attendance": "การมาเรียน",
  "students.report_card.attendance_none": "ไม่มีการบันทึกการมาเรียนในช่วงการรายงานนี้",
  "students.report_card.attendance_school_days": "วันเรียน",
  "students.report_card.attendance_present": "มาเรียน",
  "students.report_card.attendance_late": "มาสาย",
  "students.report_card.attendance_absent": "ขาดเรียน",
  "students.report_card.attendance_excused": "ลา",
  "students.report_card.attendance_suspended": "พักการเรียน",
  "students.report_card.attendance_rate": "อัตราการมาเรียน",
  "students.report_card.lesson_summaries": "สรุปการเรียนรู้",
  "students.report_card.indicators": "ตัวชี้วัด",
  "students.report_card.specialists": "วิชาเฉพาะทาง",
  "students.report_card.strengths": "จุดเด่นและช่วงเวลาที่น่าชื่นชม",
  "students.report_card.growth": "ด้านที่ควรพัฒนาต่อไป",
  "students.report_card.home_support": "วิธีสนับสนุนการเรียนรู้ที่บ้าน",
  "map.title": "ผลสอบ MAP",
  "map.none_for_student": "ยังไม่มีการนำเข้าผลสอบ MAP ของนักเรียนคนนี้",
  "map.term": "ภาคเรียน",
  "map.grade": "ระดับชั้น",
  "map.rit_score": "คะแนน RIT (+/- ค่าคลาดเคลื่อน)",
  "map.growth": "การเติบโต",
  "map.projection": "ค่าคาดการณ์",
  "map.percentile": "เปอร์เซ็นไทล์",
  "map.goals_performance": "ผลตามเป้าหมาย — {{term}}",
  "map.lexile_range": "ช่วง Lexile®",
  "map.quantile_range": "ช่วง Quantile®",
  "map.import_file_label": "ไฟล์ผลสอบ MAP",
  "map.step_export_title": "ส่งออกจาก MAP Growth",
  "map.step_export_body": "ส่งออกข้อมูลแบบ Comprehensive ใน MAP Growth แล้วแตกไฟล์ zip คุณต้องใช้ไฟล์ AssessmentResults.csv ที่อยู่ข้างใน แต่ละภาคเรียนเป็นการส่งออกแยกกัน และอัปโหลดลำดับใดก็ได้",
  "map.step_upload_title": "อัปโหลด AssessmentResults.csv",
  "map.step_review_title": "ตรวจสอบและนำเข้า",
  "map.step_review_waiting": "คุณจะเห็นว่าไฟล์จับคู่กับนักเรียนคนใดบ้างก่อนที่ระบบจะบันทึก",
  "map.import_another": "นำเข้าไฟล์อื่น",
  "map.import_action": "นำเข้า",
  "map.import_preview_done": "ยังไม่ได้บันทึกข้อมูล",
  "map.import_done": "นำเข้าเรียบร้อยแล้ว",
  "map.import_counts": "อ่านได้ {{parsed}} แถว จับคู่กับนักเรียน {{matched}} แถว ใหม่ {{created}} และปรับปรุง {{updated}}",
  "map.import_terms": "ภาคเรียนในไฟล์นี้: {{terms}}",
  "map.import_unmatched": "มี {{count}} แถวที่จับคู่กับนักเรียนไม่ได้:",
  "map.import_no_id": "(ไม่มีรหัสนักเรียน)",
  "common.reset": "ล้างค่า",
  "map.download_pdf": "ดาวน์โหลด PDF",
  "map.import_roster_label": "StudentBySchool.csv (ไม่บังคับ เพิ่มระดับชั้นของนักเรียนขณะสอบ)",
  "map.import_grades": "พบระดับชั้นสำหรับ {{count}} แถว",
  "map.import_no_grades": "ไม่พบระดับชั้น หากไม่มีไฟล์ StudentBySchool.csv จะไม่สามารถแสดงเปอร์เซ็นไทล์ ค่าเฉลี่ยโรงเรียน และค่าเฉลี่ยระดับประเทศได้",
  "map.school_average": "โรงเรียน",
  "map.national_average": "ระดับประเทศ",
  "map.rit_score_help": "คะแนนที่ได้ พร้อมค่าความคลาดเคลื่อนของแบบทดสอบทั้งสองด้าน MAP รายงานเป็นช่วงเพราะการสอบครั้งเดียวไม่สามารถระบุความสามารถของเด็กเป็นตัวเลขเดียวได้",
  "map.growth_help": "คะแนนที่เพิ่มขึ้นนับจากการสอบครั้งก่อนที่ NWEA ใช้เปรียบเทียบ หากไม่มีการสอบครั้งก่อนให้เปรียบเทียบจะเว้นว่างไว้",
  "map.projection_help": "คะแนนที่ NWEA คาดว่าจะเพิ่มขึ้นในช่วงเวลาเดียวกัน สำหรับเด็กที่เริ่มต้นที่คะแนนเท่ากัน ใช้เทียบกับช่องการเติบโต",
  "map.percentile_help": "จากเด็ก 100 คนในระดับชั้นเดียวกันทั่วประเทศ มีกี่คนที่ได้คะแนนเท่ากับหรือต่ำกว่าเด็กคนนี้ แสดงเป็นช่วงตามค่าความคลาดเคลื่อน โดยมีตัวเลขของ NWEA อยู่ตรงกลาง",
  "map.school_average_help": "คะแนนเฉลี่ยของนักเรียน RIS Phuket ในระดับชั้นเดียวกันในภาคเรียนนั้น ตัวเลขในวงเล็บคือจำนวนนักเรียนที่ใช้คำนวณค่าเฉลี่ย กลุ่มที่เล็กจะเปลี่ยนแปลงมากเมื่อมีผลคะแนนเดียว",
  "map.national_average_help": "คะแนนเฉลี่ยของระดับชั้นและภาคเรียนนั้น ตามเกณฑ์มาตรฐานระดับประเทศปี 2025 ของ NWEA",
  "map.step_reports_title": "อัปโหลดรายงานจาก NWEA (ไม่บังคับ)",
  "map.step_reports_body": "ไฟล์ PDF ที่ NWEA สร้างให้นักเรียนแต่ละคน หนึ่งไฟล์ต่อหนึ่งคน ระบบจะจับคู่ไฟล์กับนักเรียนจากรหัสนักเรียนในชื่อไฟล์ และเก็บเฉพาะรายงานล่าสุดเท่านั้น การอัปโหลดใหม่จะแทนที่ไฟล์เดิม",
  "map.reports_file_label": "ไฟล์ PDF รายงานนักเรียน",
  "map.reports_counts": "{{files}} ไฟล์ จับคู่กับนักเรียนได้ {{matched}} ไฟล์",
  "map.reports_replacing": "{{count}} ไฟล์จะแทนที่รายงานที่มีอยู่แล้ว",
  "map.reports_unmatched": "{{count}} ไฟล์ไม่ได้ถูกแนบกับนักเรียนคนใด:",
  "map.reports_matched_heading": "จับคู่แล้ว:",
  "map.reports_action": "แนบรายงานเหล่านี้",
  "map.reports_done": "แนบรายงานเรียบร้อยแล้ว",
  "map.reports_preview_done": "ยังไม่ได้บันทึกข้อมูล",
  "map.reports_another": "อัปโหลดรายงานเพิ่มเติม",
  "map.download_report": "ดาวน์โหลดรายงาน NWEA",
  "map.step_notify_title": "แจ้งผู้ปกครองว่ารายงานพร้อมแล้ว",
  "map.step_notify_body": "ส่งอีเมลหนึ่งฉบับต่อนักเรียนหนึ่งคนไปยังผู้ปกครองของนักเรียนคนนั้น พร้อมลิงก์ไปยังรายงานในพอร์ทัลผู้ปกครอง ระบบจะส่งเฉพาะครอบครัวที่บุตรหลานมีรายงานเท่านั้น และจะไม่ส่งซ้ำ คุณสามารถส่งตอนนี้หรือกลับมาส่งในภายหลังได้",
  "map.notify_pending": "มีนักเรียน {{count}} คนที่ครอบครัวยังไม่ได้รับแจ้งเกี่ยวกับรายงาน",
  "map.notify_none": "แจ้งครอบครัวที่มีรายงานครบทุกรายแล้ว",
  "map.notify_action": "ส่งอีเมล",
  "map.notify_sending": "กำลังส่ง…",
  "map.notify_done": "ส่งอีเมลแล้ว {{emails}} ฉบับ สำหรับนักเรียน {{count}} คน",
  "map.notify_no_recipients": "ข้ามนักเรียน {{count}} คน เนื่องจากไม่มีอีเมลของผู้ปกครองในระบบ:",
  "map.import_needs_results": "กรุณาแนบไฟล์ AssessmentResults.csv ซึ่งเป็นไฟล์ที่มีคะแนน",
  "edp.students.col_actions": "",
  "edp.students.discount_action": "ส่วนลด",
  "edp.students.office_discount": "สำนักงาน −{{amount}}",
  "edp.adjustments.title": "ส่วนลด",
  "edp.adjustments.description": "ส่วนลดที่สำนักงานให้กับ {{name}} ในรอบนี้ และเหตุผล",
  "edp.adjustments.amount": "จำนวนที่ลด (บาท)",
  "edp.adjustments.amount_required": "กรอกจำนวนเงินเป็นจำนวนเต็มและมากกว่าศูนย์",
  "edp.adjustments.reason": "เหตุผล",
  "edp.adjustments.reason_required": "ระบุเหตุผลที่ให้ส่วนลดนี้",
  "edp.adjustments.reason_placeholder": "ย้ายจากโยคะไปทำอาหารหลังเรียนไปแล้ว 1 ครั้ง",
  "edp.adjustments.grant": "ให้ส่วนลด",
  "edp.adjustments.granted": "บันทึกส่วนลดแล้ว",
  "edp.adjustments.withdraw": "ยกเลิก",
  "edp.adjustments.withdrawn": "ยกเลิกส่วนลดแล้ว",
  "conferences.title": "PTC",
  "conferences.new": "PTC ใหม่",
  "conferences.empty": "ยังไม่มี PTC",
  "conferences.col_title": "หัวข้อ",
  "conferences.col_dates": "วันที่",
  "conferences.col_grades": "ระดับชั้น",
  "conferences.col_status": "สถานะ",
  "conferences.col_booked": "จองแล้ว",
  "conferences.col_families": "ผู้ปกครองที่จองแล้ว",
  "conferences.status.draft": "ฉบับร่าง",
  "conferences.status.open": "เปิดจอง",
  "conferences.status.closed": "ปิดจองแล้ว",
  "conferences.status.cancelled": "ยกเลิกแล้ว",
  "conferences.back": "ย้อนกลับ",
  "conferences.tab_teachers": "ครู",
  "conferences.tab_schedule": "ตารางเวลา",
  "conferences.tab_students": "นักเรียน",
  "conferences.students.search": "ค้นหาชื่อนักเรียนหรือผู้ปกครองที่จอง",
  "conferences.students.filter_label": "กรองนักเรียน",
  "conferences.students.filter_all": "ทั้งหมด",
  "conferences.students.filter_booked": "มีนัดแล้ว",
  "conferences.students.filter_none": "ยังไม่มีนัด",
  "conferences.students.no_talks": "ยังไม่ได้จองนัด",
  "conferences.students.booked_by": "จองโดย {{name}}",
  "conferences.students.booked_by_office": "จองโดยสำนักงาน",
  "conferences.students.with": "พร้อมกับ {{names}}",
  "conferences.students.empty": "ไม่พบนักเรียนที่ตรงกับการค้นหา",
  "conferences.tab_families": "ครอบครัว",
  "conferences.detail.families_booked": "ผู้ปกครองจองแล้ว {{booked}} จาก {{invited}} คน",
  "conferences.invite_title": "เชิญครอบครัว",
  "conferences.invite_body": "การส่งคำเชิญนี้จะเปิดให้จองและส่งอีเมลเชิญ PTC ไปยังผู้ปกครอง {{count}} คนในระดับชั้นเหล่านี้",
  "conferences.invite_action": "ส่งคำเชิญ",
  "conferences.invite_confirm": "ส่งคำเชิญนี้ไปยังผู้ปกครอง {{count}} คนหรือไม่",
  "conferences.invite_sent": "ส่งคำเชิญไปยังผู้ปกครอง {{count}} คนแล้ว",
  "conferences.invite_scheduled": "ระบบจะเปิดรับจองโดยอัตโนมัติในวันที่ {{date}} และผู้ปกครอง {{count}} คนจะได้รับคำเชิญในเวลานั้น คุณยังสามารถส่งคำเชิญตอนนี้ได้",
  "conferences.remind_title": "ผู้ปกครอง {{count}} คนยังไม่ได้จอง",
  "conferences.remind_all_title": "เตือนผู้ปกครองที่ได้รับเชิญทั้งหมด {{count}} คน",
  "conferences.remind_last": "เตือนครั้งล่าสุด: {{date}}",
  "conferences.remind_never": "ยังไม่เคยเตือน",
  "conferences.remind_action": "ส่งการเตือน",
  "conferences.remind_confirm": "ส่งการเตือนไปยังผู้ปกครอง {{count}} คนหรือไม่",
  "conferences.remind_sent": "ส่งการเตือนไปยังผู้ปกครอง {{count}} คนแล้ว",
  "conferences.remind_too_late": "ถึงวันสุดท้ายแล้ว จึงไม่สามารถส่งการเตือนได้",
  "conferences.cancel_action": "ยกเลิก PTC นี้",
  "conferences.cancel_confirm": "ครอบครัวที่มีการจองจะได้รับอีเมลแจ้งว่ายกเลิกแล้ว",
  "conferences.cancel_confirm_button": "ยกเลิก PTC",
  "conferences.closed_note": "ปิดรับจองเมื่อ {{date}} คุณยังสามารถเปลี่ยนการจองได้ในแท็บตารางเวลา",
  "conferences.mine_title": "ตาราง PTC ของฉัน",
  "conferences.mine_empty": "ไม่มี PTC ที่กำหนดให้คุณ",
  "conferences.mine_parents": "ผู้ปกครอง: {{names}}",
  "conferences.mine_comments": "ความคิดเห็นของฉัน ({{period}})",
  "conferences.mine_note_add": "เพิ่มบันทึก",
  "conferences.mine_note_edit": "แก้ไขบันทึก",
  "conferences.mine_note_label": "บันทึกส่วนตัว",
  "conferences.mine_note_hint": "มีเพียงคุณเท่านั้นที่เห็นบันทึกนี้",
  "conferences.mine_note_saved": "บันทึกแล้ว",
  "conferences.mine_report_card_of": "สมุดพก: {{name}}",
  "conferences.mine_free": "ว่าง",
  "conferences.mine_break": "พัก",
  "conferences.mine_print": "พิมพ์ตารางของฉัน",
  "conferences.mine_calendar": "ดาวน์โหลด PTC นี้ (.ics)",
  "conferences.mine_session": "กิจกรรมรวมทั้งโรงเรียน: {{title}}",
  "conferences.calendar_card.title": "ปฏิทิน PTC ของคุณ",
  "conferences.calendar_card.explanation": "ปฏิทินของคุณจะอัปเดตเองเมื่อผู้ปกครองจอง ย้าย หรือยกเลิกนัด คุณไม่ต้องเพิ่มใหม่อีก และจะใช้ได้กับ PTC ครั้งต่อไปด้วย Apple Calendar และ Outlook จะรีเฟรชภายในไม่กี่นาที ส่วน Google Calendar อาจใช้เวลานานถึงหนึ่งวัน การนัดหมายแต่ละครั้งจะเตือนคุณล่วงหน้า 10 นาที",
  "conferences.calendar_card.add": "เพิ่มลงในปฏิทินของฉัน",
  "conferences.calendar_card.copy": "คัดลอกลิงก์",
  "conferences.calendar_card.copied": "คัดลอกลิงก์แล้ว",
  "conferences.calendar_card.copy_error": "คัดลอกลิงก์ไม่สำเร็จ",
  "conferences.calendar_card.google_hint": "ใน Google Calendar: ปฏิทินอื่น ๆ → + → จาก URL แล้ววาง",
  "conferences.calendar_card.reset": "รีเซ็ตลิงก์",
  "conferences.calendar_card.reset_confirm_title": "รีเซ็ตลิงก์ปฏิทินของคุณ?",
  "conferences.calendar_card.reset_confirm_description": "ปฏิทินที่ใช้ลิงก์เดิมจะหยุดอัปเดต คุณจะต้องเพิ่มลิงก์ใหม่",
  "conferences.calendar_card.reset_success": "รีเซ็ตลิงก์ปฏิทินแล้ว",
  "conferences.form.new_title": "สร้าง PTC ใหม่",
  "conferences.form.edit_title": "แก้ไข PTC",
  "conferences.form.title": "หัวข้อ",
  "conferences.form.grades": "ระดับชั้น",
  "conferences.form.slot_minutes": "ความยาวช่วงเวลา (นาที)",
  "conferences.form.closes_at": "ปิดรับจองวันที่",
  "conferences.form.opens_at": "เปิดรับจองวันที่",
  "conferences.form.opens_at_time": "เวลาเปิดรับจอง",
  "conferences.form.opens_at_hint": "ไม่บังคับ เมื่อถึงเวลานี้ ระบบจะเปิดรับจองและส่งอีเมลเชิญถึงครอบครัวโดยอัตโนมัติ โดยไม่ต้องกดส่ง เว้นว่างไว้หากต้องการส่งเอง",
  "conferences.form.days": "วันที่จัด",
  "conferences.form.day_n": "วันที่ {{n}}",
  "conferences.form.add_day": "เพิ่มวัน",
  "conferences.form.add_block": "เพิ่มช่วงเวลา",
  "conferences.form.remove_day": "ลบวัน",
  "conferences.form.remove_block": "ลบช่วงเวลา",
  "conferences.form.block_start": "เริ่ม",
  "conferences.form.block_end": "สิ้นสุด",
  "conferences.form.open_only_note": "PTC นี้เปิดจองแล้ว แก้ไขได้เฉพาะหัวข้อและกำหนดปิดรับจองเท่านั้น",
  "conferences.form.error_title_required": "กรุณากรอกหัวข้อ",
  "conferences.form.error_grades_required": "เลือกระดับชั้นอย่างน้อยหนึ่งระดับ",
  "conferences.form.error_closes_required": "เลือกวันและเวลาปิดรับจอง",
  "conferences.form.error_closes": "ต้องปิดรับจองก่อนการพบครั้งแรก",
  "conferences.form.error_opens_future": "เวลาเปิดรับจองต้องเป็นเวลาในอนาคต",
  "conferences.form.error_opens_before_close": "ต้องเปิดรับจองก่อนเวลาปิดรับจอง",
  "conferences.form.error_days_required": "เพิ่มวันอย่างน้อยหนึ่งวัน",
  "conferences.form.error_day_date_required": "เลือกวันที่ให้ครบทุกวัน",
  "conferences.form.error_day_duplicate": "แต่ละวันระบุได้เพียงครั้งเดียว",
  "conferences.form.error_block_required": "แต่ละวันต้องมีอย่างน้อยหนึ่งช่วงเวลา",
  "conferences.form.error_block_time": "เวลาต้องอยู่ในรูปแบบ HH:mm",
  "conferences.form.error_block_order": "ช่วงเวลาต้องสิ้นสุดหลังจากเริ่มต้น",
  "conferences.form.error_block_overlap": "ช่วงเวลาในวันเดียวกันต้องไม่ทับซ้อนกัน",
  "conferences.form.error_slots": "แต่ละช่วงเวลาต้องหารลงตัวเป็นจำนวนรอบเต็ม",
  "conferences.form.block_kind": "ประเภทช่วงเวลา",
  "conferences.form.kind_appointments": "นัดหมาย",
  "conferences.form.kind_session": "ช่วงกิจกรรมรวม",
  "conferences.form.session_title": "หัวข้อกำหนดการ",
  "conferences.form.item_time": "เวลา",
  "conferences.form.item_title": "หัวข้อรายการ",
  "conferences.form.item_description": "รายละเอียด",
  "conferences.form.add_item": "เพิ่มรายการ",
  "conferences.form.remove_item": "ลบรายการ",
  "conferences.form.error_session_title": "กรุณาใส่หัวข้อของช่วงกิจกรรมนี้",
  "conferences.form.error_session_items": "ช่วงกิจกรรมรวมต้องมีอย่างน้อยหนึ่งรายการในกำหนดการ",
  "conferences.form.error_session_item_title": "แต่ละรายการในกำหนดการต้องมีหัวข้อ",
  "conferences.form.error_session_item_time": "เวลาของรายการต้องอยู่ในช่วงเวลาของบล็อกนั้น",
  "conferences.teachers.add": "เพิ่มครู",
  "conferences.teachers.add_title": "เพิ่มครู",
  "conferences.teachers.col_teacher": "ครู",
  "conferences.teachers.col_subject": "วิชา",
  "conferences.teachers.col_room": "ห้อง",
  "conferences.teachers.col_grades": "ระดับชั้น",
  "conferences.teachers.col_breaks": "ช่วงพัก",
  "conferences.teachers.col_bookings": "การจอง",
  "conferences.teachers.empty": "ยังไม่มีครูใน PTC นี้",
  "conferences.teachers.remove_title": "ลบครู",
  "conferences.teachers.remove_description": "ลบ {{name}} ออกจาก PTC นี้หรือไม่ ห้องและป้ายวิชาของครูจะถูกลบไปด้วย",
  "conferences.teachers.remove_blocked": "ครูคนนี้มีการจองอยู่แล้ว — ยกเลิกหรือย้ายการจองก่อน",
  "conferences.teachers.resync": "ซิงก์จากตารางสอนใหม่",
  "conferences.teachers.resync_title": "ซิงก์จากตารางสอนใหม่",
  "conferences.teachers.resync_description": "การทำเช่นนี้จะแทนที่รายชื่อครูด้วยผู้ที่ตารางสอนระบุว่าสอนระดับชั้นเหล่านี้อยู่ในขณะนี้ ห้องและป้ายวิชาที่ตั้งไว้แล้วจะยังคงอยู่สำหรับครูที่ยังอยู่ในรายชื่อ",
  "conferences.grid.col_time": "เวลา",
  "conferences.grid.jump_to_teacher": "ไปยังครู",
  "conferences.grid.free": "ว่าง",
  "conferences.grid.break": "พัก",
  "conferences.grid.book_for_family": "จองให้ครอบครัว",
  "conferences.grid.mark_as_break": "ทำเครื่องหมายเป็นช่วงพัก",
  "conferences.grid.free_aria": "ช่องว่าง {{teacher}} เวลา {{time}}",
  "conferences.grid.break_aria": "ช่วงพัก {{teacher}} เวลา {{time}} — เอาช่วงพักออก",
  "conferences.grid.block_break_on_aria": "ทำเครื่องหมายให้ {{teacher}} พักช่วง {{block}}",
  "conferences.grid.block_break_off_aria": "เอาช่วงพักของ {{teacher}} ออกสำหรับช่วง {{block}}",
  "conferences.grid.booked_aria": "{{students}} กับ {{teacher}} เวลา {{time}}",
  "conferences.grid.booked_by_office": "โดยสำนักงาน",
  "conferences.grid.booked_by_name": "โดย {{name}}",
  "conferences.grid.booked_by_family": "ครอบครัว",
  "conferences.grid.move_to": "ย้ายไปที่…",
  "conferences.grid.move": "ย้าย",
  "conferences.grid.cancel_talk": "ยกเลิกการพบ",
  "conferences.grid.cancel_talk_title": "ยกเลิกการพบครั้งนี้หรือไม่",
  "conferences.grid.cancel_talk_description": "การพบนี้จองไว้ให้ {{names}} — การยกเลิกจะทำให้ช่วงเวลานี้ว่างอีกครั้ง",
  "conferences.grid.cancel_talk_confirm": "ยกเลิกการพบ",
  "conferences.grid.nothing_to_book": "ไม่มีอะไรให้จอง — PTC นี้ไม่มีช่วงเวลานัดพบ มีเพียงกำหนดการด้านบน",
  "conferences.book.title": "จองให้ครอบครัว",
  "conferences.book.student": "นักเรียน",
  "conferences.book.students_label": "ผู้ที่จะเข้าร่วม",
  "conferences.book.teacher_does_not_teach": "ครูคนนี้ไม่ได้สอน {{name}}",
  "conferences.book.this_child": "นักเรียนคนนี้",
  "conferences.book.error_no_students": "เลือกนักเรียนอย่างน้อยหนึ่งคน",
  "conferences.print.button": "พิมพ์",
  "conferences.print.all_teachers": "ครูทุกคน",
  "conferences.print.this_teacher": "ครูคนนี้",
  "conferences.print.door_signs": "ป้ายหน้าห้องเรียน",
  "conferences.print.door_sign_this_teacher": "ป้ายหน้าห้องเรียน — ครูคนนี้",
  "conferences.print.file_door_sign": "ป้ายหน้าห้องเรียน – {{name}}",
  "conferences.print.file_teachers": "ตารางนัดของครู",
  "conferences.print.by_family": "ตามนักเรียน",
  "conferences.print.programme": "กำหนดการ",
  "conferences.print.block": "ช่วงที่ {{n}}",
  "conferences.print.col_family": "นักเรียน",
  "conferences.print.col_teacher": "ครู",
  "conferences.print.col_room": "ห้อง",
  "report_cards.early_years.heading": "{{name}} — รายงานผลการเรียนระดับปฐมวัย",
  "report_cards.early_years.level_select_label": "ระดับชั้น",
  "report_cards.early_years.banner_unset": "ฝ่ายวิชาการยังไม่ได้กำหนดหัวข้อ จุดเน้น และวัตถุประสงค์ของภาคเรียนนี้",
  "report_cards.early_years.banner_focus": "จุดเน้น",
  "report_cards.early_years.banner_purpose": "วัตถุประสงค์",
  "report_cards.early_years.tabs_label": "ส่วนต่างๆ ของรายงานปฐมวัย",
  "report_cards.early_years.tab_summaries": "สรุปการเรียนรู้",
  "report_cards.early_years.tab_indicators": "ตัวชี้วัด",
  "report_cards.early_years.tab_grades": "ผลการประเมิน",
  "report_cards.early_years.tab_comments": "ความคิดเห็น",
  "report_cards.early_years.read_only": "ภาคเรียนนี้ปิดแล้ว ข้อมูลทั้งหมดดูได้อย่างเดียว",
  "report_cards.early_years.read_only_assistant": "คุณดูรายงานนี้ได้ แต่แก้ไขได้เฉพาะครูประจำชั้น",
  "report_cards.early_years.summaries.intro": "สิ่งที่ชั้นเรียนได้เรียนรู้ในภาคเรียนนี้ จะพิมพ์ในรายงานของเด็กทุกคนในหัวข้อ “สิ่งที่ได้เรียนรู้”",
  "report_cards.early_years.summaries.add": "เพิ่มสรุป",
  "report_cards.early_years.summaries.title": "หัวข้อ",
  "report_cards.early_years.summaries.body": "สิ่งที่ชั้นเรียนได้ทำ",
  "report_cards.early_years.summaries.move_up": "เลื่อนขึ้น",
  "report_cards.early_years.summaries.move_down": "เลื่อนลง",
  "report_cards.early_years.summaries.remove": "ลบ",
  "report_cards.early_years.summaries.empty": "ยังไม่มีสรุป",
  "report_cards.early_years.summaries.saved": "บันทึกสรุปแล้ว",
  "report_cards.early_years.summaries.error_title_required": "กรุณาใส่หัวข้อ",
  "report_cards.early_years.summaries.error_body_required": "กรุณาเขียนสิ่งที่ชั้นเรียนได้ทำ",
  "report_cards.early_years.indicators.intro": "เลือกตัวชี้วัดของภาคเรียนนี้จากคลังตัวชี้วัดของ {{level}} และจัดลำดับตามที่ต้องการให้พิมพ์",
  "report_cards.early_years.indicators.add": "เพิ่มตัวชี้วัด",
  "report_cards.early_years.indicators.new": "ตัวชี้วัดใหม่",
  "report_cards.early_years.indicators.import": "นำเข้าจากสเปรดชีต",
  "report_cards.early_years.indicators.empty": "ยังไม่ได้เลือกตัวชี้วัดสำหรับภาคเรียนนี้",
  "report_cards.early_years.indicators.move_up": "เลื่อน {{code}} ขึ้น",
  "report_cards.early_years.indicators.move_down": "เลื่อน {{code}} ลง",
  "report_cards.early_years.indicators.remove": "นำ {{code}} ออก",
  "report_cards.early_years.indicators.remove_graded_title": "นำตัวชี้วัดที่ประเมินแล้วออกหรือไม่",
  "report_cards.early_years.indicators.remove_graded_body": "มีเด็กบางคนได้รับผลการประเมินใน {{codes}} แล้ว ตัวชี้วัดจะถูกซ่อนจากภาคเรียนนี้โดยเก็บผลการประเมินไว้ หากเพิ่มกลับมาผลการประเมินจะกลับมาด้วย",
  "report_cards.early_years.indicators.remove_confirm": "นำออก",
  "report_cards.early_years.indicators.picker_title": "เลือกตัวชี้วัดของภาคเรียนนี้",
  "report_cards.early_years.indicators.picker_description": "ตัวชี้วัดที่เลือกจะปรากฏในรายงานภาคเรียนนี้ “แนะนำ” มาจากแผนประจำภาคเรียนของโรงเรียน",
  "report_cards.early_years.indicators.suggested": "แนะนำสำหรับ Q{{quarter}}",
  "report_cards.early_years.indicators.select_suggested": "เลือกทั้งหมดที่แนะนำ",
  "report_cards.early_years.indicators.all_domains": "ทุกหมวด",
  "report_cards.early_years.indicators.filter_domain": "หมวด",
  "report_cards.early_years.indicators.library_empty": "คลังตัวชี้วัดของระดับนี้ว่างเปล่า นำเข้าจากสเปรดชีตของโรงเรียนหรือเพิ่มตัวชี้วัด",
  "report_cards.early_years.indicators.edit": "แก้ไข {{code}}",
  "report_cards.early_years.indicators.retire": "เลิกใช้ {{code}}",
  "report_cards.early_years.indicators.retire_title": "เลิกใช้ตัวชี้วัดนี้หรือไม่",
  "report_cards.early_years.indicators.retire_body": "{{code}} จะไม่แสดงให้เลือกในภาคเรียนใหม่ ภาคเรียนที่ใช้อยู่แล้วยังคงเก็บไว้",
  "report_cards.early_years.indicators.apply": "ใช้",
  "report_cards.early_years.indicator.new_title": "ตัวชี้วัดใหม่",
  "report_cards.early_years.indicator.edit_title": "แก้ไขตัวชี้วัด",
  "report_cards.early_years.indicator.domain": "หมวด",
  "report_cards.early_years.indicator.code": "รหัส",
  "report_cards.early_years.indicator.label": "มาตรฐาน (ข้อความสำหรับผู้ปกครอง)",
  "report_cards.early_years.indicator.description": "ความหมาย",
  "report_cards.early_years.indicator.example": "ตัวอย่างที่สังเกตได้",
  "report_cards.early_years.indicator.practice": "แนวทางการสนับสนุน",
  "report_cards.early_years.indicator.quarters": "ภาคเรียนที่แนะนำ",
  "report_cards.early_years.indicator.teacher_only": "ตัวอย่างที่สังเกตได้และแนวทางการสนับสนุนสำหรับครูเท่านั้น จะไม่พิมพ์ในรายงาน",
  "report_cards.early_years.indicator.error_required": "จำเป็นต้องกรอก",
  "report_cards.early_years.import.title": "นำเข้าตัวชี้วัดจากสเปรดชีต",
  "report_cards.early_years.import.description": "ในสเปรดชีต เลือกคอลัมน์ A ถึง F (รหัสถึงภาคเรียน) รวมแถวหัวข้อด้าน คัดลอกแล้ววางที่นี่ รหัสที่มีอยู่แล้วจะถูกปรับปรุง รหัสใหม่จะถูกเพิ่ม",
  "report_cards.early_years.import.paste_label": "แถวที่วาง",
  "report_cards.early_years.import.preview": "{{count}} ตัวชี้วัด ใน {{domains}} ด้าน",
  "report_cards.early_years.import.skipped": "{{count}} แถวมีรหัสแต่ไม่มีข้อความ จึงถูกข้าม",
  "report_cards.early_years.import.submit": "นำเข้า",
  "report_cards.early_years.import.done": "เพิ่ม {{created}} ปรับปรุง {{updated}}",
  "report_cards.early_years.grades.col_indicator": "ตัวชี้วัด",
  "report_cards.early_years.grades.teacher_notes": "ตัวอย่างและแนวทาง",
  "report_cards.early_years.grades.no_indicators": "กรุณาเลือกตัวชี้วัดของภาคเรียนนี้ก่อน",
  "report_cards.early_years.grades.choose_indicators": "เลือกตัวชี้วัด",
  "report_cards.early_years.grades.all_graded": "นักเรียนทุกคนได้รับการประเมินครบทุกตัวชี้วัดแล้ว",
  "report_cards.early_years.grades.still_to_grade_one": "ยังประเมินไม่ครบ {{count}} คน:",
  "report_cards.early_years.grades.still_to_grade_other": "ยังประเมินไม่ครบ {{count}} คน:",
  "report_cards.early_years.grades.child_missing": "{{name}} ({{count}})",
  "report_cards.early_years.grades.left_one": "เหลือ {{count}}",
  "report_cards.early_years.grades.left_other": "เหลือ {{count}}",
  "report_cards.early_years.grades.complete": "ครบแล้ว",
  "report_cards.early_years.grades.only_missing": "แสดงเฉพาะนักเรียนที่ยังประเมินไม่ครบ",
  "report_cards.early_years.reflection.strengths": "จุดเด่นและช่วงเวลาที่น่าชื่นชม",
  "report_cards.early_years.reflection.growth": "ด้านที่ควรพัฒนาต่อไป",
  "report_cards.early_years.reflection.home": "วิธีสนับสนุนการเรียนรู้ที่บ้าน",
  "report_cards.early_years.reflection.only_missing": "เฉพาะเด็กที่ยังขาดความคิดเห็น",
  "report_cards.early_years.reflection.previous": "ภาคเรียนที่แล้ว ({{period}})",
  "report_cards.early_years.reflection.copy": "ใช้ข้อความภาคเรียนที่แล้ว",
  "report_cards.early_years.reflection.all_done": "เด็กทุกคนมีความคิดเห็นครบทั้งสามส่วนแล้ว",
  "report_cards.early_years.reflection.field_label": "{{field}} — {{name}}",
  "report_cards.early_years.banner.title": "หัวข้อภาคเรียนระดับปฐมวัย",
  "report_cards.early_years.banner.hint": "พิมพ์ใต้หัวข้อภาคเรียนในรายงานของ {{level}} ทุกฉบับ",
  "report_cards.early_years.banner.field_title": "หัวข้อ",
  "report_cards.early_years.banner.field_focus": "จุดเน้น",
  "report_cards.early_years.banner.field_purpose": "วัตถุประสงค์",
  "report_cards.early_years.banner.saved": "บันทึกแล้ว",
  "report_cards.periods.publish_action": "เผยแพร่",
  "report_cards.periods.publish_confirm_title": "เผยแพร่ {{name}} หรือไม่",
  "report_cards.periods.publish_confirm_description": "รายงานผลการเรียนของเด็กทุกคนจะถูกสร้างเป็น PDF และผู้ปกครองจะเห็นได้ในพอร์ทัลผู้ปกครอง ระบบจะปิดรอบรายงานก่อน ครูจึงแก้ไขคะแนนและความเห็นไม่ได้อีก และรายงานจะลงวันที่วันนี้ เว้นแต่ได้กำหนดวันที่ออกรายงานไว้ ระบบจะยังไม่ส่งอีเมลจนกว่าคุณจะเลือก “แจ้งผู้ปกครอง”",
  "report_cards.periods.publish_incomplete_title": "ยังมีข้อมูลที่ไม่ได้กรอก",
  "report_cards.periods.publish_anyway": "เผยแพร่ต่อไป",
  "report_cards.periods.publish_success": "เผยแพร่รายงานผลการเรียนแล้ว {{count}} ฉบับ",
  "report_cards.periods.unpublish_action": "ยกเลิกการเผยแพร่",
  "report_cards.periods.unpublish_confirm_title": "ยกเลิกการเผยแพร่ {{name}} หรือไม่",
  "report_cards.periods.unpublish_confirm_description": "ผู้ปกครองจะไม่เห็นรายงานเหล่านี้จนกว่าจะเผยแพร่อีกครั้ง ผู้ปกครองที่ได้รับอีเมลแล้วจะไม่ได้รับอีเมลซ้ำเมื่อเผยแพร่ใหม่",
  "report_cards.periods.unpublish_success": "ยกเลิกการเผยแพร่รายงานแล้ว",
  "report_cards.periods.notify_action": "แจ้งผู้ปกครอง",
  "report_cards.periods.notify_title": "ส่งอีเมลถึงผู้ปกครองหรือไม่",
  "report_cards.periods.notify_description": "ผู้ปกครอง {{parents}} คน ของเด็ก {{cards}} คน จะได้รับอีเมลพร้อมลิงก์ไปยังพอร์ทัล โดยไม่มีผลการเรียนหรือไฟล์แนบ เด็ก {{withoutRecipients}} คนไม่มีอีเมลผู้ปกครองในระบบ",
  "report_cards.periods.notify_send": "ส่ง",
  "report_cards.periods.notify_success": "ส่งอีเมลแล้ว {{count}} ฉบับ",
  "report_cards.periods.notify_failed": "ส่งอีเมลไม่สำเร็จ {{count}} ฉบับ กดแจ้งอีกครั้งเพื่อลองใหม่",
  "report_cards.periods.notify_nothing": "แจ้งผู้ปกครองครบทุกฉบับที่เผยแพร่แล้ว",
  "report_cards.early_years.reflection.preview_pdf": "ดูตัวอย่าง PDF",
  "report_cards.periods.publish_progress": "กำลังเผยแพร่รายงาน… {{done}} จาก {{total}}",
  "report_cards.periods.notify_progress": "กำลังส่งอีเมลถึงผู้ปกครอง… {{done}} จาก {{total}} คน",
  "report_cards.periods.remind_action_one": "เตือน {{count}} ครอบครัวที่ยังไม่เปิดดู",
  "report_cards.periods.remind_action_other": "เตือน {{count}} ครอบครัวที่ยังไม่เปิดดู",
  "report_cards.periods.remind_title": "ส่งอีเมลเตือนครอบครัวที่ยังไม่เปิดดูหรือไม่",
  "report_cards.periods.remind_description": "ผู้ปกครอง {{parents}} คน ของเด็ก {{cards}} คนที่ยังไม่มีผู้ปกครองเปิดดูสมุดรายงานผล จะได้รับอีเมลเตือนพร้อมลิงก์ไปยังพอร์ทัล ครอบครัวที่ผู้ปกครองเปิดดูแล้วจะไม่ได้รับอีเมล เด็ก {{withoutRecipients}} คนไม่มีอีเมลผู้ปกครองในระบบ",
  "report_cards.periods.remind_send": "ส่งอีเมลเตือน",
  "report_cards.periods.remind_success": "ส่งอีเมลเตือนแล้ว {{count}} ฉบับ",
  "report_cards.periods.remind_failed": "ส่งอีเมลเตือนไม่สำเร็จ {{count}} ฉบับ กดเตือนอีกครั้งเพื่อลองใหม่",
  "report_cards.periods.remind_nothing": "ทุกครอบครัวที่ได้รับแจ้งเปิดดูสมุดรายงานผลแล้ว",
  "report_cards.periods.remind_progress": "กำลังส่งอีเมลเตือนผู้ปกครอง… {{done}} จาก {{total}} คน",
  "report_cards.periods.preview_action": "รายงานของนักเรียน",
  "report_cards.periods.preview_title": "รายงานของนักเรียน — {{name}}",
  "report_cards.periods.preview_description": "เลือกระดับชั้น แล้วเปิด PDF ของเด็กคนใดก็ได้ตามที่จะเผยแพร่ในขณะนี้ เปิด “ความคิดเห็นเท่านั้น” เพื่อไม่ให้เกรดตัวอักษรแก่เด็กคนนั้นในช่วงนี้ การตั้งค่าจะติดไปยังช่วงถัดไปจนกว่าจะปิด",
  "report_cards.periods.preview_grade": "ระดับชั้น",
  "report_cards.periods.preview_empty": "ไม่มีรายงานของระดับชั้นนี้ในช่วงนี้",
  "report_cards.periods.preview_open": "เปิด {{name}}",
  "report_cards.periods.comment_only_for": "ความคิดเห็นเท่านั้นสำหรับ {{name}}",
  "report_cards.early_years.indicators.add_to_category": "เพิ่มใน {{domain}}",
  "report_cards.early_years.indicators.add_here": "เพิ่มตัวชี้วัด",
  "report_cards.early_years.indicator.code_optional": "ไม่บังคับ — เว้นว่างได้สำหรับตัวชี้วัดของคุณเอง",
  "report_cards.early_years.indicator.rubric": "ลักษณะของแต่ละระดับ (ไม่บังคับ)",
  "report_cards.early_years.indicator.rubric_hint": "แสดงให้ครูเห็นข้างตัวเลือกผลการประเมิน E เริ่มต้น · D กำลังพัฒนา · P ทำได้ · Ex ดีเยี่ยม",
  "report_cards.early_years.indicator.retire": "เลิกใช้",
  "report_cards.early_years.indicator.restore": "นำกลับมาใช้",
  "report_cards.early_years.indicator.retire_hint": "การเลิกใช้จะนำตัวชี้วัดออกจากคลังสำหรับภาคเรียนใหม่ ภาคเรียนที่ใช้อยู่แล้วยังคงเก็บไว้",
  "report_cards.early_years.indicator.retired_hint": "ตัวชี้วัดนี้เลิกใช้แล้ว",
  "report_cards.early_years.grades.rubric": "ลักษณะของแต่ละระดับ",
  "pdf_preview.download": "ดาวน์โหลดไฟล์ PDF",
  "pdf_preview.failed": "ไม่สามารถสร้างไฟล์ PDF ได้",
  "pdf_preview.not_opened": "หากไฟล์ PDF ไม่เปิดขึ้นที่นี่:",
  "report_cards.preview_title": "ไฟล์ PDF สมุดรายงาน",
  "report_cards.preview_preparing": "กำลังเตรียมไฟล์ PDF สมุดรายงาน…",
  "my_classes.tabs_label": "มุมมองชั้นเรียนของฉัน",
  "my_classes.tab_today": "วันนี้",
  "my_classes.tab_diary": "บันทึกการสอน",
  "my_classes.tab_tests": "แบบทดสอบ",
  "diary.title": "บันทึกการสอน",
  "diary.subtitle": "บันทึกส่วนตัวเกี่ยวกับสิ่งที่คุณทำในชั้นเรียน มีเพียงคุณที่เห็น",
  "diary.new_entry": "เพิ่มบันทึก",
  "diary.edit_entry": "แก้ไขบันทึก",
  "diary.all_classes": "ทุกชั้นเรียน",
  "diary.all_subjects": "ทุกวิชา",
  "diary.my_classes_group": "ชั้นเรียนของฉัน",
  "diary.other_classes_group": "ชั้นเรียนอื่น",
  "diary.field_class": "ชั้นเรียน",
  "diary.field_subject": "วิชา",
  "diary.field_date": "วันที่",
  "diary.field_from": "ตั้งแต่",
  "diary.field_to": "ถึง",
  "diary.field_body": "สิ่งที่เราทำ",
  "diary.class_required": "กรุณาเลือกชั้นเรียน",
  "diary.subject_required": "กรุณาเลือกวิชา",
  "diary.body_required": "กรุณาเขียนบันทึกก่อน",
  "diary.date_future": "เลือกวันนี้หรือวันก่อนหน้า",
  "diary.lesson_entry_hint": "เขียนจากคาบเรียน — แก้ไขได้เฉพาะข้อความ",
  "diary.created": "เพิ่มบันทึกแล้ว",
  "diary.updated": "อัปเดตบันทึกแล้ว",
  "diary.deleted": "ลบบันทึกแล้ว",
  "diary.delete_title": "ลบบันทึกนี้หรือไม่",
  "diary.delete_description": "การลบนี้ไม่สามารถย้อนกลับได้",
  "diary.empty_title": "ยังไม่มีบันทึก",
  "diary.empty_description": "เขียนสิ่งที่คุณทำได้จากคาบเรียนในแท็บวันนี้ หรือเพิ่มบันทึกที่นี่",
  "diary.page_of": "หน้า {{page}} จาก {{pages}}",
  "diary.open_day": "เปิดวันดังกล่าวในแท็บวันนี้",
  "class_tests.title": "แบบทดสอบ",
  "class_tests.subtitle": "แบบทดสอบที่คุณกำหนดให้ชั้นเรียนของคุณ ผู้ปกครองจะเห็นในพอร์ทัลผู้ปกครอง",
  "class_tests.place_test": "กำหนดแบบทดสอบ",
  "class_tests.edit_test": "แก้ไขแบบทดสอบ",
  "class_tests.upcoming": "ที่กำลังจะมาถึง",
  "class_tests.past": "ที่ผ่านมาแล้ว",
  "class_tests.empty_title": "ยังไม่มีแบบทดสอบ",
  "class_tests.empty_description": "กำหนดแบบทดสอบเพื่อให้นักเรียนและผู้ปกครองทราบวันสอบ",
  "class_tests.mark": "ให้คะแนน",
  "class_tests.results_published": "เผยแพร่ผลแล้ว",
  "class_tests.status_to_mark": "รอตรวจ",
  "class_tests.status_marking": "กำลังตรวจ {{marked}}/{{students}}",
  "class_tests.status_ready": "พร้อมประกาศผล",
  "class_tests.out_of": "คะแนนเต็ม {{max}}",
  "class_tests.out_of_extra": "คะแนนเต็ม {{max}} + คะแนนพิเศษ {{extra}}",
  "class_tests.cancelled": "ยกเลิกแล้ว",
  "class_tests.cancel_test": "ยกเลิกแบบทดสอบ",
  "class_tests.keep_test": "เก็บแบบทดสอบไว้",
  "class_tests.cancel_title": "ยกเลิกแบบทดสอบนี้หรือไม่?",
  "class_tests.cancel_description": "ผู้ปกครองที่ได้รับแจ้งเรื่องแบบทดสอบนี้จะได้รับอีเมลแจ้งการยกเลิก",
  "class_tests.cancel_description_published": "ผู้ปกครองที่ได้รับแจ้งเรื่องแบบทดสอบนี้จะได้รับอีเมลแจ้งการยกเลิก และจะไม่เห็นผลสอบที่เผยแพร่แล้วของแบบทดสอบนี้อีกต่อไป",
  "class_tests.cancelled_toast": "ยกเลิกแบบทดสอบแล้ว",
  "class_tests.placed": "กำหนดแบบทดสอบแล้ว",
  "class_tests.updated": "อัปเดตแบบทดสอบแล้ว",
  "class_tests.field_subject": "วิชา",
  "class_tests.field_classes": "ระดับชั้น",
  "class_tests.field_date": "วันที่",
  "class_tests.field_period": "คาบเรียน",
  "class_tests.field_title": "ชื่อแบบทดสอบ",
  "class_tests.field_revise_note": "สิ่งที่ควรทบทวน",
  "class_tests.revise_note_placeholder": "เช่น บทที่ 2 และ 3 รายการคำศัพท์",
  "class_tests.field_remind": "ส่งการแจ้งเตือนล่วงหน้าหนึ่งวัน",
  "class_tests.no_period": "ไม่มีคาบเรียน",
  "class_tests.pick_subject_first": "เลือกวิชาเพื่อดูระดับชั้น",
  "class_tests.subject_required": "เลือกวิชา",
  "class_tests.classes_required": "เลือกอย่างน้อยหนึ่งระดับชั้น",
  "class_tests.date_required": "เลือกวันที่",
  "class_tests.date_weekday": "แบบทดสอบต้องอยู่ในวันเรียน (วันจันทร์ถึงวันศุกร์)",
  "class_tests.title_required": "ระบุชื่อแบบทดสอบ",
  "class_tests.past_date_hint": "ผู้ปกครองจะไม่ได้รับอีเมลเกี่ยวกับแบบทดสอบที่ผ่านไปแล้ว",
  "class_tests.emailed_hint": "ผู้ปกครองจะได้รับอีเมลเมื่อคุณบันทึก",
  "class_tests.week_label": "แบบทดสอบในสัปดาห์นั้น",
  "class_tests.week_free": "ไม่มีแบบทดสอบ",
  "class_tests.week_pick_classes": "เลือกระดับชั้นเพื่อดูแบบทดสอบอื่นในสัปดาห์นั้น",
  "class_tests.same_day_warning": "ระดับชั้นเหล่านี้มีแบบทดสอบในวันนั้นแล้ว:",
  "class_tests.marking": "การให้คะแนน",
  "class_tests.marking_locked": "เผยแพร่ผลแล้ว หากต้องการเปลี่ยนการให้คะแนน ให้ยกเลิกการเผยแพร่ในหน้าบันทึกคะแนนก่อน",
  "class_tests.mode_none": "ไม่ให้คะแนน",
  "class_tests.mode_total": "คะแนนรวม",
  "class_tests.mode_sections": "แยกตามส่วน",
  "class_tests.mode_questions": "แยกตามข้อ",
  "class_tests.field_max": "คะแนนเต็ม",
  "class_tests.field_extra_max": "คะแนนพิเศษสูงสุด (ไม่บังคับ)",
  "class_tests.max_required": "ระบุคะแนนเต็ม",
  "class_tests.max_invalid": "ใส่ตัวเลขที่มากกว่า 0",
  "class_tests.part_label": "ชื่อ",
  "class_tests.part_question": "ข้อ",
  "class_tests.part_section": "ส่วน",
  "class_tests.part_max": "คะแนนเต็ม",
  "class_tests.part_extra_credit": "คะแนนพิเศษ",
  "class_tests.part_label_required": "ระบุชื่อให้ทุกส่วน",
  "class_tests.parts_required": "เพิ่มอย่างน้อยหนึ่งส่วนหรือหนึ่งข้อ",
  "class_tests.parts_need_scored": "ต้องมีอย่างน้อยหนึ่งส่วนที่นับรวมในคะแนน",
  "class_tests.add_section": "เพิ่มส่วน",
  "class_tests.add_question": "เพิ่มข้อ",
  "class_tests.section_n": "ส่วนที่ {{n}}",
  "class_tests.question_n": "ข้อที่ {{n}}",
  "class_tests.marks.title": "ใบบันทึกคะแนน",
  "class_tests.marks.score": "คะแนน",
  "class_tests.marks.extra_credit": "คะแนนพิเศษ",
  "class_tests.marks.extra": "พิเศษ",
  "class_tests.marks.student": "นักเรียน",
  "class_tests.marks.status": "สถานะ",
  "class_tests.marks.status_marked": "ตรวจแล้ว",
  "class_tests.marks.status_absent": "ขาดสอบ",
  "class_tests.marks.status_excused": "ได้รับการยกเว้น",
  "class_tests.marks.comment": "ความคิดเห็น",
  "class_tests.marks.total": "รวม",
  "class_tests.marks.letter": "เกรด",
  "class_tests.marks.out_of": "คะแนนเต็ม {{max}}",
  "class_tests.marks.out_of_extra": "คะแนนเต็ม {{max}} + คะแนนพิเศษ {{extra}}",
  "class_tests.marks.average": "ค่าเฉลี่ยของชั้น",
  "class_tests.marks.highest": "สูงสุด",
  "class_tests.marks.lowest": "ต่ำสุด",
  "class_tests.marks.letters": "เกรด",
  "class_tests.marks.left_class": "ไม่ได้อยู่ในระดับชั้นนี้แล้ว",
  "class_tests.marks.needs_result": "ต้องกรอกคะแนน หรือระบุว่าขาดสอบหรือได้รับการยกเว้น",
  "class_tests.marks.missing": "ยังไม่มีผล",
  "class_tests.marks.missing_banner_one": "ยังมีนักเรียน {{count}} คนที่ยังไม่มีผลสอบ: กรอกคะแนน หรือระบุว่าขาดสอบหรือได้รับการยกเว้น",
  "class_tests.marks.missing_banner_other": "ยังมีนักเรียน {{count}} คนที่ยังไม่มีผลสอบ: กรอกคะแนน หรือระบุว่าขาดสอบหรือได้รับการยกเว้น",
  "class_tests.marks.comment_needs_status": "เลือกสถานะก่อนบันทึกความคิดเห็น",
  "class_tests.marks.err_number": "กรุณากรอกตัวเลข",
  "class_tests.marks.err_negative": "คะแนนติดลบไม่ได้",
  "class_tests.marks.err_over_max": "คะแนนต้องไม่เกิน {{max}}",
  "class_tests.marks.err_decimals": "ใช้ทศนิยมได้ไม่เกินหนึ่งตำแหน่ง",
  "class_tests.marks.fix_errors": "มีคะแนนบางช่องที่ต้องแก้ไขก่อนบันทึก",
  "class_tests.marks.save_draft": "บันทึกฉบับร่าง",
  "class_tests.marks.save": "บันทึก",
  "class_tests.marks.saved_toast": "บันทึกฉบับร่างแล้ว",
  "class_tests.marks.saved_published_toast": "บันทึกแล้ว ครอบครัวของนักเรียนที่ผลสอบเปลี่ยนแปลงจะได้รับอีเมล",
  "class_tests.marks.nothing_changed": "ไม่มีการเปลี่ยนแปลงตั้งแต่บันทึกครั้งล่าสุด",
  "class_tests.marks.unsaved": "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
  "class_tests.marks.publish": "ประกาศผลสอบ",
  "class_tests.marks.publish_title": "ประกาศผลสอบนี้หรือไม่?",
  "class_tests.marks.publish_description": "แต่ละครอบครัวจะได้รับอีเมลแจ้งผลสอบของบุตรหลาน และดูผลได้ในพอร์ทัลผู้ปกครอง",
  "class_tests.marks.published_toast": "ประกาศผลสอบแล้ว",
  "class_tests.marks.publish_missing_one": "ยังมีนักเรียน {{count}} คนที่ยังไม่มีผลสอบ",
  "class_tests.marks.publish_missing_other": "ยังมีนักเรียน {{count}} คนที่ยังไม่มีผลสอบ",
  "class_tests.marks.unpublish": "ยกเลิกการประกาศ",
  "class_tests.marks.unpublish_title": "ยกเลิกการประกาศผลสอบนี้หรือไม่?",
  "class_tests.marks.unpublish_description": "ครอบครัวจะไม่เห็นผลสอบนี้จนกว่าคุณจะประกาศอีกครั้ง",
  "class_tests.marks.unpublished_toast": "ยกเลิกการประกาศผลสอบแล้ว",
  "class_tests.view_label": "แบบทดสอบที่แสดง",
  "class_tests.view_mine": "แบบทดสอบของฉัน",
  "class_tests.view_history": "ประวัติตามวิชา",
  "class_tests.mode_online": "ออนไลน์",
  "class_tests.online.title": "คำถามออนไลน์",
  "class_tests.online.questions": "คำถาม",
  "class_tests.online.build_questions": "สร้างคำถาม",
  "class_tests.online.build_hint": "นักเรียนทำข้อสอบนี้บนคอมพิวเตอร์ คำถามสร้างในหน้าแยกต่างหาก",
  "class_tests.online.build_hint_new": "นักเรียนทำข้อสอบนี้บนคอมพิวเตอร์ บันทึกข้อสอบแล้วหน้าสร้างคำถามจะเปิดขึ้น",
  "class_tests.online.switch_away_title": "ลบคำถามออนไลน์หรือไม่?",
  "class_tests.online.switch_away_description": "การเปลี่ยนวิธีให้คะแนนจากออนไลน์จะลบคำถามทั้งหมดของข้อสอบนี้ และไม่สามารถย้อนกลับได้",
  "class_tests.online.switch_away_confirm": "ลบคำถาม",
  "class_tests.online.not_online": "ข้อสอบนี้ไม่ได้ให้คะแนนแบบออนไลน์ แก้ไขข้อสอบและตั้งวิธีให้คะแนนเป็นออนไลน์เพื่อสร้างคำถาม",
  "class_tests.online.locked_title": "นักเรียนเริ่มทำข้อสอบแล้ว",
  "class_tests.online.locked_description": "ไม่สามารถเพิ่ม ลบ หรือเปลี่ยนประเภทคำถามได้อีก แต่ยังแก้เฉลย ข้อความคำถามและตัวเลือก และคะแนนได้ หรือนำคำถามออกจากการคิดคะแนน ทุกการแก้ไขจะคิดคะแนนข้อนั้นใหม่ให้นักเรียนทุกคน",
  "class_tests.online.add_section": "เพิ่มตอน",
  "class_tests.online.add_question": "เพิ่มคำถาม",
  "class_tests.online.add_option": "เพิ่มตัวเลือก",
  "class_tests.online.remove_option": "ลบตัวเลือกที่ {{n}}",
  "class_tests.online.section_name": "ชื่อตอน",
  "class_tests.online.section_n": "ตอนที่ {{n}}",
  "class_tests.online.section_empty": "ตอนนี้ยังไม่มีคำถาม",
  "class_tests.online.question_n": "คำถามที่ {{n}}",
  "class_tests.online.question_type": "ประเภทคำถาม",
  "class_tests.online.question_text": "คำถาม",
  "class_tests.online.question_placeholder": "พิมพ์คำถาม บรรทัดที่เว้นวรรคนำหน้า 4 ช่อง หรืออยู่ระหว่าง ``` จะแสดงเป็นโค้ด",
  "class_tests.online.option_n": "ตัวเลือกที่ {{n}}",
  "class_tests.online.mark_correct": "ถูกต้อง: {{option}}",
  "class_tests.online.mark_eliminate": "ตัดออก: {{option}}",
  "class_tests.online.drag_option": "ลากเพื่อเรียงลำดับ: {{option}}",
  "class_tests.online.points": "คะแนน",
  "class_tests.online.extra_credit": "คะแนนพิเศษ",
  "class_tests.online.model_answer": "คำตอบตัวอย่าง (เฉพาะผู้ตรวจเห็น)",
  "class_tests.online.type_single": "เลือกตอบข้อเดียว",
  "class_tests.online.type_multiple": "เลือกตอบหลายข้อ",
  "class_tests.online.type_order": "เรียงลำดับ",
  "class_tests.online.type_subtraction": "ตัดตัวเลือก",
  "class_tests.online.type_text": "เขียนตอบ",
  "class_tests.online.hint_single": "เลือกตัวเลือกที่ถูกต้องหนึ่งข้อ",
  "class_tests.online.hint_multiple": "ทำเครื่องหมายทุกตัวเลือกที่ถูกต้อง การเลือกผิดจะถูกหักคะแนน",
  "class_tests.online.hint_order": "ใส่รายการตามลำดับที่ถูกต้อง ลากเพื่อจัดลำดับ นักเรียนแต่ละคนจะเห็นรายการสลับลำดับ",
  "class_tests.online.hint_subtraction": "ทำเครื่องหมายตัวเลือกที่ผิดซึ่งนักเรียนควรตัดออก ต้องเหลือไว้อย่างน้อยหนึ่งตัวเลือก",
  "class_tests.online.hint_text": "นักเรียนพิมพ์คำตอบ และคุณให้คะแนนเอง",
  "class_tests.online.student_hint_multiple": "เลือกทุกคำตอบที่ถูกต้อง",
  "class_tests.online.student_hint_order": "ลากรายการให้อยู่ในลำดับที่ถูกต้อง",
  "class_tests.online.student_hint_subtraction": "เลือกตัวเลือกที่ต้องการตัดออก",
  "class_tests.online.move_up": "เลื่อนคำถามขึ้น",
  "class_tests.online.move_down": "เลื่อนคำถามลง",
  "class_tests.online.move_section_up": "เลื่อนตอนขึ้น",
  "class_tests.online.move_section_down": "เลื่อนตอนลง",
  "class_tests.online.duplicate": "ทำสำเนาคำถาม",
  "class_tests.online.delete_question": "ลบคำถาม",
  "class_tests.online.delete_section": "ลบตอน",
  "class_tests.online.empty": "ยังไม่มีคำถาม เพิ่มตอน หรือนำเข้าไฟล์ CSV",
  "class_tests.online.out_of": "คะแนนเต็ม {{max}}",
  "class_tests.online.out_of_extra": "คะแนนเต็ม {{max}} + คะแนนพิเศษ {{extra}}",
  "class_tests.online.save": "บันทึกคำถาม",
  "class_tests.online.saved_toast": "บันทึกคำถามแล้ว",
  "class_tests.online.unsaved": "มีการแก้ไขที่ยังไม่บันทึก",
  "class_tests.online.save_errors": "ยังไม่ได้บันทึกคำถาม โปรดแก้ไขรายการต่อไปนี้แล้วลองอีกครั้ง:",
  "class_tests.online.reload": "โหลดคำถามใหม่",
  "class_tests.online.err_section_name": "ตั้งชื่อให้ทุกตอน",
  "class_tests.online.err_section_name_long": "ชื่อตอนยาวได้ไม่เกิน {{max}} ตัวอักษร",
  "class_tests.online.err_text_required": "พิมพ์คำถาม",
  "class_tests.online.err_points": "คะแนนต้องมากกว่า 0 และมีทศนิยมไม่เกินหนึ่งตำแหน่ง",
  "class_tests.online.err_option_text": "ตัวเลือกต้องไม่ว่าง",
  "class_tests.online.err_min_options": "ต้องมีตัวเลือกอย่างน้อย 2 ข้อ",
  "class_tests.online.err_order_min": "คำถามเรียงลำดับต้องมีอย่างน้อย 3 รายการ",
  "class_tests.online.err_single": "เลือกตัวเลือกที่ถูกต้องหนึ่งข้อเท่านั้น",
  "class_tests.online.err_multiple": "เลือกตัวเลือกที่ถูกต้องอย่างน้อยหนึ่งข้อ",
  "class_tests.online.err_subtraction_none": "เลือกตัวเลือกที่ต้องตัดออกอย่างน้อยหนึ่งข้อ",
  "class_tests.online.err_subtraction_all": "ต้องเหลือตัวเลือกไว้อย่างน้อยหนึ่งข้อ",
  "class_tests.online.unsaved_change": "คำถามนี้มีการแก้ไขที่ยังไม่บันทึก",
  "class_tests.online.undo_change": "ยกเลิกการแก้ไข",
  "class_tests.online.save_change": "บันทึกการแก้ไข",
  "class_tests.online.remark_title": "คิดคะแนนข้อนี้ใหม่หรือไม่?",
  "class_tests.online.remark_description": "คะแนนข้อนี้ของนักเรียนทุกคนจะถูกคำนวณใหม่",
  "class_tests.online.remark_confirm": "บันทึกและคิดคะแนนใหม่",
  "class_tests.online.remarked_toast": "บันทึกแล้ว และคิดคะแนนใหม่ให้ทุกคนแล้ว",
  "class_tests.online.removed": "นำออกจากการคิดคะแนนแล้ว",
  "class_tests.online.remove_from_scoring": "นำออกจากการคิดคะแนน",
  "class_tests.online.remove_title": "นำคำถามนี้ออกจากการคิดคะแนนหรือไม่?",
  "class_tests.online.remove_description": "นักเรียนยังเห็นคำถามนี้โดยมีป้ายว่านำออกแล้ว แต่จะไม่นับรวมในคะแนนหรือคะแนนเต็มอีก คะแนนของทุกคนจะถูกคำนวณใหม่",
  "class_tests.online.restore": "นำกลับมา",
  "class_tests.online.restore_title": "นับคะแนนคำถามนี้อีกครั้งหรือไม่?",
  "class_tests.online.copy_ai": "คัดลอกคำสั่งสำหรับ AI",
  "class_tests.online.copied_ai": "คัดลอกคำสั่งแล้ว วางลงใน AI ใดก็ได้พร้อมบันทึกของคุณ แล้วนำเข้าไฟล์ CSV ที่ได้",
  "class_tests.online.import_csv": "นำเข้า CSV",
  "class_tests.online.import_title": "นำเข้าคำถามจากไฟล์ CSV",
  "class_tests.online.import_description": "หนึ่งแถวต่อหนึ่งคำถาม ตามรูปแบบที่อธิบายไว้ใน \"คัดลอกคำสั่งสำหรับ AI\" จะนำเข้าก็ต่อเมื่อทุกแถวถูกต้องเท่านั้น",
  "class_tests.online.import_file": "ไฟล์ CSV",
  "class_tests.online.import_pick_file": "เลือกไฟล์ CSV",
  "class_tests.online.import_mode": "จะทำอย่างไรกับคำถามที่มีอยู่แล้ว",
  "class_tests.online.import_mode_append": "เพิ่มต่อจากคำถามที่มีอยู่",
  "class_tests.online.import_mode_replace": "แทนที่คำถามทั้งหมด",
  "class_tests.online.import_submit": "นำเข้า",
  "class_tests.online.import_replace_title": "แทนที่คำถามทั้งหมดหรือไม่?",
  "class_tests.online.import_replace_description_one": "คำถาม {{count}} ข้อในข้อสอบนี้จะถูกแทนที่ด้วยคำถามจากไฟล์",
  "class_tests.online.import_replace_description_other": "คำถาม {{count}} ข้อในข้อสอบนี้จะถูกแทนที่ด้วยคำถามจากไฟล์",
  "class_tests.online.import_unsaved_title": "นำเข้าและทิ้งการแก้ไขหรือไม่?",
  "class_tests.online.import_unsaved_description": "การแก้ไขที่ยังไม่บันทึกในหน้านี้จะหายไป",
  "class_tests.online.import_errors": "ยังไม่ได้นำเข้า โปรดแก้ไขรายการต่อไปนี้แล้วลองอีกครั้ง:",
  "class_tests.online.import_error_row": "แถว {{row}}: {{message}}",
  "class_tests.online.import_error_row_column": "แถว {{row}} · {{column}}: {{message}}",
  "class_tests.online.import_error_question": "ตอนที่ {{section}} · คำถามที่ {{question}}: {{message}}",
  "class_tests.online.import_error_section": "ตอนที่ {{section}}: {{message}}",
  "class_tests.online.imported_toast": "นำเข้าคำถามแล้ว",
  "class_tests.online.preview": "ดูตัวอย่างแบบนักเรียน",
  "class_tests.online.preview_title": "ตัวอย่างมุมมองนักเรียน",
  "class_tests.online.preview_description": "นักเรียนแต่ละคนได้ลำดับของตนเอง คำถามจะสลับลำดับภายในแต่ละตอน และตัวเลือกก็สลับด้วย",
  "class_tests.online.preview_empty": "ยังไม่มีคำถามให้ดูตัวอย่าง",
  "class_tests.online.preview_points_one": "{{count}} คะแนน",
  "class_tests.online.preview_points_other": "{{count}} คะแนน",
  "class_tests.online.shuffle_again": "สลับอีกครั้ง",
  "class_tests.online.run": "ติดตามสด",
  "class_tests.online.open_from": "เปิดแบบทดสอบได้ตั้งแต่วันก่อนวันสอบ",
  "class_tests.online.open_test": "เปิดแบบทดสอบ",
  "class_tests.online.close_test": "ปิดแบบทดสอบ",
  "class_tests.online.reopen_test": "เปิดแบบทดสอบอีกครั้ง",
  "class_tests.online.open_title": "เปิดแบบทดสอบนี้หรือไม่",
  "class_tests.online.open_description": "นักเรียนในห้องเรียนของแบบทดสอบนี้เริ่มทำได้ทันทีที่เปิด และแบบทดสอบจะปิดเองตอนเที่ยงคืนเมื่อสิ้นวันสอบ",
  "class_tests.online.close_title": "ปิดแบบทดสอบนี้หรือไม่",
  "class_tests.online.close_description": "นักเรียนที่ยังทำอยู่จะถูกหยุด และคำตอบที่ยังทำไม่เสร็จจะถูกส่งตามที่เป็นอยู่",
  "class_tests.online.reopen_title": "เปิดแบบทดสอบนี้อีกครั้งหรือไม่",
  "class_tests.online.reopen_description": "นักเรียนที่ยังไม่ได้เริ่มจะเริ่มทำได้ และก่อนประกาศผล นักเรียนที่ถูกหยุดเพราะการปิดจะทำต่อได้",
  "class_tests.online.opened_toast": "เปิดแบบทดสอบแล้ว",
  "class_tests.online.closed_toast": "ปิดแบบทดสอบแล้ว และส่งคำตอบทั้งหมดแล้ว",
  "class_tests.online.reopened_toast": "เปิดแบบทดสอบอีกครั้งแล้ว",
  "class_tests.online.status_not_open": "ยังไม่เปิด",
  "class_tests.online.status_open": "เปิดอยู่",
  "class_tests.online.status_closed": "ปิดแล้ว",
  "class_tests.online.tabs_label": "แบบทดสอบออนไลน์",
  "class_tests.online.tab_live": "ติดตามสด",
  "class_tests.online.tab_mark": "ตรวจคำตอบ",
  "class_tests.online.tab_students": "นักเรียน",
  "class_tests.online.mark_sheet": "ใบคะแนน",
  "class_tests.online.col_student": "นักเรียน",
  "class_tests.online.col_state": "สถานะ",
  "class_tests.online.col_answered": "ตอบแล้ว",
  "class_tests.online.col_left": "ออกจากแบบทดสอบ",
  "class_tests.online.col_score": "คะแนน",
  "class_tests.online.state_not_started": "ยังไม่เริ่ม",
  "class_tests.online.state_in_progress": "กำลังทำ",
  "class_tests.online.state_submitted": "ส่งแล้ว",
  "class_tests.online.state_to_mark": "ส่งแล้ว",
  "class_tests.online.state_complete": "เสร็จสมบูรณ์",
  "class_tests.online.to_mark": "รอตรวจ {{n}} ข้อ",
  "class_tests.online.left_count": "ออกจากแบบทดสอบ {{times}} ครั้ง",
  "class_tests.online.event_left": "ออก",
  "class_tests.online.event_returned": "กลับมา",
  "class_tests.online.event_fullscreen_exit": "ออกจากโหมดเต็มจอ",
  "class_tests.online.reopen_student": "เปิดให้นักเรียนคนนี้อีกครั้ง",
  "class_tests.online.reopen_student_title": "เปิดแบบทดสอบให้ {{name}} อีกครั้งหรือไม่",
  "class_tests.online.reopen_student_description": "{{name}} จะทำต่อจากคำตอบที่บันทึกไว้ และส่งอีกครั้งเมื่อทำเสร็จหรือเมื่อแบบทดสอบปิด",
  "class_tests.online.reopened_student_toast": "{{name}} ทำต่อได้แล้ว",
  "class_tests.online.live_refresh": "อัปเดตทุก 10 วินาที",
  "class_tests.online.live_not_open": "นักเรียนจะเริ่มทำได้เมื่อคุณเปิดแบบทดสอบ",
  "class_tests.online.live_empty": "ไม่มีนักเรียนในห้องเรียนของแบบทดสอบนี้",
  "class_tests.online.mark_empty": "ยังไม่มีคำตอบแบบเขียนให้ตรวจ คำตอบจะแสดงที่นี่เมื่อนักเรียนส่ง",
  "class_tests.online.mark_no_answers": "ยังไม่มีใครตอบข้อนี้",
  "class_tests.online.mark_progress": "ตรวจแล้ว {{marked}} จาก {{total}}",
  "class_tests.online.mark_hint": "คะแนนแต่ละช่องบันทึกเมื่อออกจากช่อง ให้คะแนนได้ตั้งแต่ 0 ถึงคะแนนเต็มของข้อ ทีละ 0.5",
  "class_tests.online.model_answer_label": "คำตอบตัวอย่าง",
  "class_tests.online.mark_input": "{{name}}, {{question}}",
  "class_tests.online.out_of_points": "/ {{max}}",
  "class_tests.online.saving": "กำลังบันทึก…",
  "class_tests.online.saved": "บันทึกแล้ว",
  "class_tests.online.err_mark_number": "กรอกตัวเลข",
  "class_tests.online.err_mark_negative": "คะแนนติดลบไม่ได้",
  "class_tests.online.err_mark_over": "ไม่เกิน {{max}}",
  "class_tests.online.err_mark_step": "ให้คะแนนทีละ 0.5",
  "class_tests.online.review_answers": "ดูคำตอบ",
  "class_tests.online.review_title": "คำตอบของ {{name}}",
  "class_tests.online.review_description": "เรียงตามลำดับที่นักเรียนเห็น คะแนนที่แก้จะใช้แทนคะแนนอัตโนมัติ ลบออกเพื่อกลับไปใช้คะแนนอัตโนมัติ",
  "class_tests.online.review_not_submitted": "นักเรียนคนนี้ยังไม่ได้ส่ง จะแก้คะแนนได้เมื่อส่งแล้ว",
  "class_tests.online.review_removed": "ครูนำออกจากการคิดคะแนน",
  "class_tests.online.review_auto": "คะแนนอัตโนมัติ: {{points}} / {{max}}",
  "class_tests.online.review_teacher": "คะแนนจากครู: {{points}} / {{max}}",
  "class_tests.online.review_overridden": "แก้คะแนนแล้ว",
  "class_tests.online.review_picked": "เลือก",
  "class_tests.online.review_eliminated": "ตัดออก",
  "class_tests.online.review_correct": "คำตอบที่ถูก",
  "class_tests.online.review_should_eliminate": "ควรตัดออก",
  "class_tests.online.review_in_place": "อยู่ถูกตำแหน่ง",
  "class_tests.online.review_belongs_at": "ควรอยู่ลำดับที่ {{n}}",
  "class_tests.online.review_no_answer": "ไม่ได้ตอบ",
  "class_tests.online.review_events": "การออกจากแบบทดสอบ",
  "class_tests.online.override": "แก้คะแนน",
  "class_tests.online.override_label": "แก้คะแนน ข้อ {{n}}",
  "class_tests.online.mark": "คะแนน",
  "class_tests.online.mark_label": "คะแนน ข้อ {{n}}",
  "class_tests.online.review_save": "บันทึกคะแนน",
  "class_tests.online.review_saved_toast": "บันทึกคะแนนแล้ว",
  "class_tests.online.review_nothing_changed": "ไม่มีการเปลี่ยนแปลง",
  "class_tests.online.explain_correct": "ถูก",
  "class_tests.online.explain_incorrect": "ผิด",
  "class_tests.online.explain_no_answer": "ไม่ได้ตอบ",
  "class_tests.online.explain_picks": "ถูก {{right}} ผิด {{wrong}}",
  "class_tests.online.explain_eliminations": "ถูก {{right}} ตัดผิด {{wrong}}",
  "class_tests.online.explain_order": "อยู่ถูกตำแหน่ง {{inPlace}} จาก {{total}}",
  "class_tests.online.explain_not_marked": "ยังไม่ได้ตรวจ",
  "class_tests.online.explain_teacher": "ครูเป็นผู้ให้คะแนน",
  "class_tests.history.title": "ประวัติแบบทดสอบ",
  "class_tests.history.subtitle": "แบบทดสอบที่ผ่านมาและแบบทดสอบที่เผยแพร่ผลแล้วในวิชาที่คุณสอน ไม่ว่าครูคนใดจะเป็นผู้กำหนด",
  "class_tests.history.sst_subtitle": "แบบทดสอบที่ผ่านมาและแบบทดสอบที่เผยแพร่ผลแล้วทั้งโรงเรียน พร้อมคะแนนที่เผยแพร่แล้วของนักเรียนแต่ละคน",
  "class_tests.history.school_year": "ปีการศึกษา",
  "class_tests.history.all_subjects": "ทุกวิชา",
  "class_tests.history.student": "นักเรียน",
  "class_tests.history.all_students": "นักเรียนทุกคน",
  "class_tests.history.search_student": "ค้นหานักเรียน",
  "class_tests.history.not_published": "ยังไม่เผยแพร่ผล",
  "class_tests.history.show_results": "ผลรายบุคคล",
  "class_tests.history.empty_title": "ยังไม่มีแบบทดสอบที่ผ่านมาหรือที่เผยแพร่ผลแล้ว",
  "class_tests.history.empty_description": "แบบทดสอบจะแสดงที่นี่เมื่อเลยวันสอบแล้ว หรือเมื่อเผยแพร่ผลแล้ว",
  "class_tests.history.item_label": "แบบทดสอบ",
  "students.aides.class_assistants": "ผู้ช่วยครูประจำชั้น: {{names}}",
  "timetable.class_aides": "ผู้ช่วยดูแลเฉพาะตัว: {{list}}",
  "timetable.class_aide_pair": "{{student}} ({{aide}})",
  "dashboard.widget.my_aide_students": "นักเรียนที่ฉันดูแลเฉพาะตัว",
  "nav.section.tuition": "ค่าเล่าเรียน",
  "nav.tuition": "ค่าเล่าเรียน",
  "tuition.title": "ค่าเล่าเรียน",
  "tuition.subtitle": "ค่าธรรมเนียม ส่วนลด และใบแจ้งหนี้รายภาคเรียน",
  "tuition.year": "ปีการศึกษา",
  "tuition.grade_label": "ระดับชั้น",
  "tuition.all_grades": "ทุกระดับชั้น",
  "tuition.no_year": "กรุณาสร้างปีการศึกษาก่อน",
  "tuition.tabs.label": "ส่วนของค่าเล่าเรียน",
  "tuition.tab_fees": "ค่าธรรมเนียม",
  "tuition.tab_students": "นักเรียน",
  "tuition.tab_charges": "ใบแจ้งหนี้",
  "tuition.semester_both": "ทั้งสองภาคเรียน",
  "tuition.semester_n": "ภาคเรียนที่ {{n}}",
  "tuition.component.tuition": "ค่าเล่าเรียน",
  "tuition.component.campus_development": "ค่าพัฒนาสถานศึกษา",
  "tuition.component.technology": "ค่าเทคโนโลยี",
  "tuition.component.lunch": "ค่าอาหารกลางวัน อาหารว่าง และนม",
  "tuition.component.graduation": "ค่าจบการศึกษา",
  "tuition.component.english_language_development": "ค่าพัฒนาภาษาอังกฤษ",
  "tuition.component.learning_support": "ค่าสนับสนุนการเรียนรู้",
  "tuition.component.one_to_one_support": "ค่าผู้ช่วยดูแลรายบุคคล",
  "tuition.component.custom": "อื่น ๆ",
  "tuition.fee_types.title": "ประเภทค่าธรรมเนียม",
  "tuition.fee_types.hint": "ค่าธรรมเนียมทุกรายการที่ใบแจ้งหนี้มีได้ เรียงตามลำดับที่พิมพ์ ส่วนลดของนักเรียนลดเฉพาะรายการที่ระบุไว้ด้านล่าง หากต้องการเพิ่มประเภทค่าธรรมเนียมใหม่ โปรดแจ้งให้เพิ่ม",
  "tuition.fee_types.printed_as": "ชื่อที่พิมพ์บนใบแจ้งหนี้",
  "tuition.fee_types.charged": "วิธีเรียกเก็บ",
  "tuition.fee_types.charged_by_grade": "ตามระดับชั้น จากตารางด้านบน",
  "tuition.fee_types.charged_per_student": "รายนักเรียน เพิ่มผ่านปุ่มแก้ไขในฉบับร่าง",
  "tuition.fee_types.discount": "ใช้ส่วนลดได้",
  "tuition.fee_types.discount_yes": "ได้",
  "tuition.fee_types.discount_no": "ไม่ได้ เรียกเก็บเต็มจำนวน",
  "tuition.fee_types.default_amount": "จำนวนเงินเริ่มต้น",
  "tuition.fees.empty": "ปีการศึกษานี้ยังไม่มีค่าธรรมเนียม",
  "tuition.fees.fill_published": "ใช้ค่าธรรมเนียมที่ประกาศของปี 2026–2027",
  "tuition.fees.start_empty": "เริ่มจากตารางว่าง",
  "tuition.fees.hint": "ค่าธรรมเนียมที่แต่ละช่วงชั้นต้องชำระต่อภาคเรียน แยกตามรายการ รายการที่ไม่เกี่ยวข้องกับช่วงชั้นใดจะไม่มีแถว การแก้ไขจะมีผลกับร่างที่สร้างครั้งถัดไปเท่านั้น ไม่เปลี่ยนใบแจ้งหนี้ที่ออกแล้ว",
  "tuition.fees.fee": "รายการ",
  "tuition.fees.from": "ตั้งแต่",
  "tuition.fees.to": "ถึง",
  "tuition.fees.semester": "ภาคเรียน",
  "tuition.fees.amount": "จำนวนเงิน (บาท)",
  "tuition.fees.add": "เพิ่มแถว",
  "tuition.fees.remove": "ลบแถว",
  "tuition.fees.save": "บันทึกค่าธรรมเนียม",
  "tuition.fees.saved": "บันทึกค่าธรรมเนียมแล้ว",
  "tuition.fees.grades_backwards": "ชั้นเริ่มต้นอยู่หลังชั้นสุดท้าย",
  "tuition.fees.amount_invalid": "จำนวนเต็มบาท ตั้งแต่ 0 ขึ้นไป",
  "tuition.students.filter_label": "แสดง",
  "tuition.students.filter_all": "ทั้งหมด",
  "tuition.students.filter_discount": "มีส่วนลด",
  "tuition.students.filter_none": "ไม่มีส่วนลด",
  "tuition.students.search": "ค้นหานักเรียน",
  "tuition.roster.projected": "ยังไม่มีนักเรียนลงทะเบียนใน {{year}} รายชื่อนี้คือนักเรียนของ {{source}} โดยเลื่อนขึ้นหนึ่งระดับชั้น นักเรียนใหม่จะถูกเพิ่มเมื่อมีข้อมูลในระบบแล้ว",
  "tuition.roster.empty": "ยังไม่มีนักเรียนที่ต้องออกใบแจ้งหนี้ในปีการศึกษานี้",
  "tuition.students.student": "นักเรียน",
  "tuition.students.grade": "ระดับชั้น",
  "tuition.students.discount": "ส่วนลดค่าเล่าเรียน",
  "tuition.students.note": "หมายเหตุในใบแจ้งหนี้",
  "tuition.students.note_hint": "พิมพ์ใต้หมายเหตุในใบแจ้งหนี้ทุกใบของปีนี้ เช่น Credit Salary",
  "tuition.students.save_note": "บันทึกหมายเหตุ",
  "tuition.students.note_saved": "บันทึกหมายเหตุแล้ว",
  "tuition.students.discount_title": "ส่วนลดค่าเล่าเรียน",
  "tuition.students.tuition_only": "ใช้กับค่าเล่าเรียนเท่านั้น ค่าพัฒนาสถานศึกษา ค่าเทคโนโลยี และค่าอาหารคิดเต็มจำนวนเสมอ",
  "tuition.students.percent": "เปอร์เซ็นต์ส่วนลด",
  "tuition.students.percent_invalid": "เปอร์เซ็นต์เป็นจำนวนเต็มตั้งแต่ 1 ถึง 100",
  "tuition.students.reason": "เหตุผล",
  "tuition.students.reason_required": "กรุณาระบุเหตุผลของส่วนลด",
  "tuition.students.reason_first_50": "50 ครอบครัวแรก",
  "tuition.students.reason_staff": "บุตรของบุคลากร",
  "tuition.students.grant": "ให้ส่วนลด",
  "tuition.students.granted": "ให้ส่วนลดแล้ว",
  "tuition.students.withdraw": "ยกเลิก",
  "tuition.students.withdrawn": "ยกเลิกส่วนลดแล้ว",
  "tuition.students.granted_by": "ให้โดย {{name}} เมื่อ {{date}}",
  "tuition.students.next_generation": "การเปลี่ยนแปลงจะมีผลเมื่อสร้างร่างครั้งถัดไป ร่างที่มีผู้แก้ไขแล้วจะคงรายการของตัวเองไว้จนกว่าจะรีเซ็ต และใบแจ้งหนี้ที่ออกแล้วจะไม่เปลี่ยน",
  "tuition.students.copy_discounts": "คัดลอกส่วนลด {{count}} รายการจาก {{year}}",
  "tuition.students.copy_discounts_confirm": "คัดลอกส่วนลดของปีที่แล้วมายังปีนี้หรือไม่ แต่ละรายการคงเปอร์เซ็นต์และเหตุผลเดิม หมายเหตุจะไม่ถูกคัดลอก",
  "tuition.students.discounts_copied": "คัดลอกส่วนลดแล้ว {{count}} รายการ",
  "tuition.students.discounts_not_copied": "\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e04\u0e31\u0e14\u0e25\u0e2d\u0e01 \u0e40\u0e1e\u0e23\u0e32\u0e30\u0e44\u0e21\u0e48\u0e2d\u0e22\u0e39\u0e48\u0e43\u0e19\u0e23\u0e32\u0e22\u0e0a\u0e37\u0e48\u0e2d\u0e41\u0e25\u0e49\u0e27: {{names}}",
  "tuition.students.filter_prepaid": "ชำระล่วงหน้า",
  "tuition.students.prepaid_badge": "\u0e0a\u0e33\u0e23\u0e30\u0e25\u0e48\u0e27\u0e07\u0e2b\u0e19\u0e49\u0e32 \u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e17\u0e35\u0e48 {{fromSemester}} \u0e1b\u0e35\u0e01\u0e32\u0e23\u0e28\u0e36\u0e01\u0e29\u0e32 {{fromYears}} \u2013 \u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e17\u0e35\u0e48 {{untilSemester}} \u0e1b\u0e35\u0e01\u0e32\u0e23\u0e28\u0e36\u0e01\u0e29\u0e32 {{untilYears}}",
  "tuition.students.prepaid_title": "ชำระล่วงหน้า",
  "tuition.students.prepaid_hint": "\u0e43\u0e1a\u0e41\u0e08\u0e49\u0e07\u0e2b\u0e19\u0e35\u0e49\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e15\u0e31\u0e49\u0e07\u0e41\u0e15\u0e48\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e41\u0e23\u0e01\u0e16\u0e36\u0e07\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e2a\u0e38\u0e14\u0e17\u0e49\u0e32\u0e22\u0e17\u0e35\u0e48\u0e40\u0e25\u0e37\u0e2d\u0e01 (\u0e23\u0e27\u0e21\u0e17\u0e31\u0e49\u0e07\u0e2a\u0e2d\u0e07\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19) \u0e08\u0e30\u0e41\u0e2a\u0e14\u0e07\u0e04\u0e48\u0e32\u0e18\u0e23\u0e23\u0e21\u0e40\u0e19\u0e35\u0e22\u0e21\u0e15\u0e32\u0e21\u0e1b\u0e01\u0e15\u0e34 \u0e41\u0e25\u0e30\u0e22\u0e2d\u0e14\u0e17\u0e35\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e0a\u0e33\u0e23\u0e30\u0e40\u0e1b\u0e47\u0e19 \u0e3f0 \u0e2a\u0e48\u0e27\u0e19\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21\u0e08\u0e30\u0e2d\u0e2d\u0e01\u0e43\u0e1a\u0e41\u0e08\u0e49\u0e07\u0e2b\u0e19\u0e35\u0e49\u0e41\u0e22\u0e01\u0e15\u0e48\u0e32\u0e07\u0e2b\u0e32\u0e01 \u0e23\u0e48\u0e32\u0e07\u0e17\u0e35\u0e48\u0e2a\u0e23\u0e49\u0e32\u0e07\u0e44\u0e27\u0e49\u0e41\u0e25\u0e49\u0e27\u0e08\u0e30\u0e44\u0e21\u0e48\u0e40\u0e1b\u0e25\u0e35\u0e48\u0e22\u0e19\u0e08\u0e19\u0e01\u0e27\u0e48\u0e32\u0e08\u0e30\u0e2a\u0e23\u0e49\u0e32\u0e07\u0e2b\u0e23\u0e37\u0e2d\u0e23\u0e35\u0e40\u0e0b\u0e47\u0e15\u0e43\u0e2b\u0e21\u0e48",
  "tuition.students.prepaid_from_year": "\u0e0a\u0e33\u0e23\u0e30\u0e25\u0e48\u0e27\u0e07\u0e2b\u0e19\u0e49\u0e32\u0e15\u0e31\u0e49\u0e07\u0e41\u0e15\u0e48\u0e15\u0e49\u0e19\u0e1b\u0e35\u0e01\u0e32\u0e23\u0e28\u0e36\u0e01\u0e29\u0e32",
  "tuition.students.prepaid_from_semester": "\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e41\u0e23\u0e01",
  "tuition.students.prepaid_year": "ชำระล่วงหน้าถึงสิ้นปีการศึกษา",
  "tuition.students.prepaid_semester": "\u0e20\u0e32\u0e04\u0e40\u0e23\u0e35\u0e22\u0e19\u0e2a\u0e38\u0e14\u0e17\u0e49\u0e32\u0e22",
  "tuition.students.prepaid_semester_option": "ภาคเรียนที่ {{semester}}",
  "tuition.students.prepaid_note": "ช่องทางการชำระเงิน",
  "tuition.students.prepaid_note_hint": "เลขที่ใบเสร็จหรือวิธีชำระเงิน",
  "tuition.students.prepaid_note_required": "ระบุวิธีชำระเงิน เช่น เลขที่ใบเสร็จ",
  "tuition.students.prepaid_save": "บันทึกการชำระล่วงหน้า",
  "tuition.students.prepaid_saved": "บันทึกการชำระล่วงหน้าแล้ว",
  "tuition.students.prepaid_remove": "ลบ",
  "tuition.students.prepaid_removed": "ลบการชำระล่วงหน้าแล้ว",
  "tuition.students.prepaid_remove_confirm": "ลบการชำระล่วงหน้านี้หรือไม่ ใบแจ้งหนี้ภาคเรียนจะเรียกเก็บจากครอบครัวตามปกติ",
  "tuition.charges.prepaid": "ชำระล่วงหน้าแล้ว",
  "tuition.charges.for_semester": "สำหรับภาคเรียนที่ {{n}}",
  "tuition.charges.billing_for_1": "ใบแจ้งหนี้ในหน้านี้เป็นค่าธรรมเนียมภาคเรียนที่ 1 ปีการศึกษา {{year}} ผู้ปกครองชำระล่วงหน้า จึงส่งในช่วงภาคเรียนที่ 2 ของปีการศึกษาก่อนหน้า",
  "tuition.charges.billing_for_2": "ใบแจ้งหนี้ในหน้านี้เป็นค่าธรรมเนียมภาคเรียนที่ 2 ปีการศึกษา {{year}} ผู้ปกครองชำระล่วงหน้า จึงส่งในช่วงภาคเรียนที่ 1",
  "tuition.charges.generate": "สร้างร่างใบแจ้งหนี้",
  "tuition.charges.generated": "สร้างร่าง {{created}} รายการ · คงไว้ตามเดิม {{kept}} รายการ",
  "tuition.charges.add_draft": "เพิ่มร่างของนักเรียน",
  "tuition.charges.add_draft_hint": "สำหรับนักเรียนที่เพิ่มเข้ามาหลังสร้างร่างไปแล้ว ร่างจะคิดราคาเหมือนคนอื่น ๆ พร้อมส่วนลดและหมายเหตุของนักเรียน",
  "tuition.charges.add_draft_student": "นักเรียน",
  "tuition.charges.add_draft_choose": "เลือกนักเรียน",
  "tuition.charges.add_draft_required": "กรุณาเลือกนักเรียน",
  "tuition.charges.add_draft_none": "นักเรียนทุกคนในรายชื่อเรียกเก็บมีใบแจ้งหนี้หรือร่างในภาคเรียนนี้แล้ว",
  "tuition.charges.add_draft_confirm": "สร้างร่าง",
  "tuition.charges.draft_added": "สร้างร่างของ {{name}} แล้ว",
  "tuition.charges.issue_all": "ออกใบแจ้งหนี้ทั้งหมด",
  "tuition.charges.issue_all_hint": "ร่าง {{count}} รายการจะได้รับเลขที่ใบแจ้งหนี้และแก้ไขไม่ได้อีก",
  "tuition.charges.issue_one_hint": "ร่างนี้จะได้รับเลขที่ใบแจ้งหนี้และแก้ไขไม่ได้อีก",
  "tuition.charges.issue_hint": "พิมพ์ในใบแจ้งหนี้เป็นวันครบกำหนดชำระ",
  "tuition.charges.issue_confirm": "ออกใบแจ้งหนี้",
  "tuition.charges.issue": "ออก",
  "tuition.charges.issued_count": "ออกใบแจ้งหนี้แล้ว {{count}} ใบ",
  "tuition.charges.due_date": "วันครบกำหนดชำระ",
  "tuition.charges.make_pdfs": "สร้างไฟล์ PDF ใบแจ้งหนี้",
  "tuition.charges.pdf_progress": "ไฟล์ PDF ใบแจ้งหนี้: {{done}} จาก {{total}}",
  "tuition.charges.export": "ส่งออก CSV",
  "tuition.charges.skipped_title": "นักเรียน {{count}} คนไม่ได้รับร่าง",
  "tuition.charges.filter_label": "สถานะ",
  "tuition.charges.filter_unpaid": "ยังไม่ชำระ",
  "tuition.charges.filter_all": "ทั้งหมด",
  "tuition.charges.search": "ค้นหานักเรียนหรือเลขที่ใบแจ้งหนี้",
  "tuition.charges.kind_label": "ประเภท",
  "tuition.charges.kind_all": "ทุกประเภท",
  "tuition.charges.kind_semester": "ใบแจ้งหนี้ภาคเรียน",
  "tuition.charges.kind_extra": "ใบแจ้งหนี้พิเศษ",
  "tuition.charges.more": "อื่น ๆ",
  "tuition.charges.summary": "รวม {{total}} · ออกแล้วแต่ยังไม่มี PDF {{missing}} ใบ",
  "tuition.charges.empty": "ยังไม่มีใบแจ้งหนี้ของภาคเรียนนี้ กดสร้างร่างเพื่อเริ่ม",
  "tuition.charges.status_col": "สถานะ",
  "tuition.charges.invoice": "ใบแจ้งหนี้",
  "tuition.charges.net": "สุทธิ",
  "tuition.charges.actions": "การดำเนินการ",
  "tuition.charges.status.draft": "ร่าง",
  "tuition.charges.status.issued": "ออกแล้ว",
  "tuition.charges.status.settled": "ชำระแล้ว",
  "tuition.charges.status.cancelled": "ยกเลิก",
  "tuition.charges.edited": "แก้ไขแล้ว",
  "tuition.charges.extra": "เพิ่มเติม",
  "tuition.charges.extra_invoice": "ใบแจ้งหนี้เพิ่มเติม",
  "tuition.charges.discounted": "หลังหักส่วนลด {{amount}}",
  "tuition.charges.edit": "แก้ไข",
  "tuition.charges.pdf": "PDF",
  "tuition.charges.preview": "ดูตัวอย่าง",
  "tuition.charges.preview_title": "ตัวอย่างใบแจ้งหนี้",
  "tuition.charges.preview_preparing": "กำลังเตรียมตัวอย่างใบแจ้งหนี้…",
  "tuition.charges.cancel": "ยกเลิก",
  "tuition.charges.cancel_reason": "เหตุผล",
  "tuition.charges.cancel_reason_required": "กรุณาระบุเหตุผลในการยกเลิก",
  "tuition.charges.cancel_draft_hint": "ร่างนี้จะถูกลบ สร้างใหม่ได้โดยกดสร้างร่างอีกครั้ง",
  "tuition.charges.cancel_extra_draft_hint": "\u0e23\u0e48\u0e32\u0e07\u0e43\u0e1a\u0e41\u0e08\u0e49\u0e07\u0e2b\u0e19\u0e35\u0e49\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21\u0e19\u0e35\u0e49\u0e08\u0e30\u0e16\u0e39\u0e01\u0e25\u0e1a",
  "tuition.charges.cancel_issued_hint": "ใบแจ้งหนี้จะถูกยกเลิกและเลขที่จะไม่ถูกใช้ซ้ำ กดสร้างร่างอีกครั้งเพื่อทำร่างใหม่ให้นักเรียนคนนี้",
  "tuition.charges.cancel_confirm": "ยกเลิกใบแจ้งหนี้",
  "tuition.charges.cancelled": "ยกเลิกแล้ว",
  "tuition.editor.description": "แก้ไขร่างนี้ก่อนออกใบแจ้งหนี้",
  "tuition.editor.description_col": "รายการ",
  "tuition.editor.line_label": "รายละเอียดรายการ",
  "tuition.editor.amount": "จำนวนเงิน",
  "tuition.editor.discount_col": "ส่วนลด",
  "tuition.editor.discount": "จำนวนส่วนลด",
  "tuition.editor.discount_label": "ข้อความส่วนลด",
  "tuition.editor.discount_label_placeholder": "เช่น Discount 50% Tuition Fee",
  "tuition.editor.percent": "เปอร์เซ็นต์ส่วนลดของรายการนี้",
  "tuition.editor.apply_percent": "ใช้ %",
  "tuition.editor.remove": "ลบรายการ",
  "tuition.editor.add": "เพิ่มรายการ",
  "tuition.editor.add_one_to_one_support": "ผู้ช่วยดูแลรายบุคคล",
  "tuition.editor.add_english_language_development": "พัฒนาภาษาอังกฤษ",
  "tuition.editor.add_learning_support": "สนับสนุนการเรียนรู้",
  "tuition.editor.add_custom": "อื่น ๆ",
  "tuition.editor.note": "หมายเหตุในใบแจ้งหนี้",
  "tuition.editor.title": "หัวข้อ",
  "tuition.editor.title_placeholder": "เช่น ทัศนศึกษากรุงเทพฯ",
  "tuition.editor.title_hint": "พิมพ์เป็นหัวข้อของใบแจ้งหนี้และแสดงให้ผู้ปกครองเห็น",
  "tuition.editor.title_required": "กรุณาใส่หัวข้อใบแจ้งหนี้",
  "tuition.editor.total": "รวม",
  "tuition.editor.kept_note": "ร่างที่แก้ไขแล้วจะคงไว้เมื่อสร้างร่างใหม่ จนกว่าจะรีเซ็ต",
  "tuition.editor.reset": "รีเซ็ตตามตารางค่าธรรมเนียม",
  "tuition.editor.reset_confirm": "ยกเลิกการแก้ไขและคิดราคาร่างนี้ใหม่ตามตารางค่าธรรมเนียมหรือไม่",
  "tuition.editor.reset_done": "รีเซ็ตร่างแล้ว",
  "tuition.editor.save": "บันทึกร่าง",
  "tuition.editor.saved": "บันทึกร่างแล้ว",
  "tuition.editor.extra_description": "ใบแจ้งหนี้เพิ่มเติม แยกจากใบแจ้งหนี้ประจำภาคเรียน",
  "tuition.editor.create": "สร้างใบแจ้งหนี้เพิ่มเติม",
  "tuition.editor.created": "สร้างร่างใบแจ้งหนี้เพิ่มเติมแล้ว",
  "tuition.editor.label_required": "กรุณาระบุรายละเอียดรายการ",
  "tuition.editor.amount_invalid": "จำนวนเต็มบาท ตั้งแต่ 0 ขึ้นไป",
  "tuition.editor.discount_too_big": "ส่วนลดมากกว่าจำนวนเงิน",
  "tuition.editor.discount_label_required": "กรุณาระบุว่าเป็นส่วนลดอะไร",
  "tuition.editor.no_lines": "ใบแจ้งหนี้ต้องมีอย่างน้อยหนึ่งรายการ",
  "tuition.charges.stale_title": "ร่างที่แก้ไขแล้ว {{count}} รายการไม่ตรงกับข้อมูลปัจจุบัน — ตรวจสอบก่อนออกใบแจ้งหนี้",
  "tuition.charges.due_date_required": "กรุณาเลือกวันครบกำหนดชำระ",
  "tuition.charges.due_date_past": "วันครบกำหนดชำระต้องไม่เป็นวันที่ผ่านมาแล้ว",
  "tuition.charges.remove_draft": "ลบร่าง",
  "tuition.charges.remake_pdfs": "สร้าง PDF ใหม่ทั้งหมด",
  "tuition.charges.remake_confirm": "สร้าง PDF ของใบแจ้งหนี้ที่ออกแล้วทั้งหมดใหม่หรือไม่ ใช้เมื่อมีการเปลี่ยนรูปแบบใบแจ้งหนี้",
  "tuition.students.withdraw_confirm": "ยกเลิกส่วนลดนี้หรือไม่ ร่างที่สร้างหลังจากนี้จะคิดค่าเล่าเรียนเต็มจำนวน",
  "tuition.tab_payments": "การชำระเงิน",
  "tuition.charges.paid_of": "ชำระแล้ว {{paid}} · คงเหลือ {{balance}}",
  "tuition.payments.empty": "ยังไม่มีใบแจ้งหนี้ที่ออกแล้วสำหรับภาคเรียนนี้",
  "tuition.payments.amount": "จำนวนเงิน (บาท)",
  "tuition.payments.amount_invalid": "จำนวนเต็มบาท ตั้งแต่ 1 ขึ้นไป",
  "tuition.payments.reported": "แจ้งเมื่อ",
  "tuition.payments.status.declared": "รอตรวจสอบ",
  "tuition.payments.status.confirmed": "ยืนยันแล้ว",
  "tuition.payments.status.rejected": "ปฏิเสธ",
  "tuition.payments.methods.bank_transfer": "โอนเงินผ่านธนาคาร",
  "tuition.payments.methods.cheque": "เช็ค",
  "tuition.payments.methods.cash": "เงินสด",
  "tuition.payments.methods.credit_card": "บัตรเครดิต",
  "tuition.payments.methods.salary_deduction": "หักจากเงินเดือน",
  "tuition.payments.method": "วิธีชำระเงิน",
  "tuition.payments.received_on": "วันที่ได้รับเงิน",
  "tuition.payments.received_on_required": "กรุณาเลือกวันที่ได้รับเงิน",
  "tuition.payments.note": "หมายเหตุ",
  "tuition.payments.slip": "สลิป",
  "tuition.payments.confirmed": "ยืนยันการชำระเงินแล้ว",
  "tuition.payments.reject": "ปฏิเสธ…",
  "tuition.payments.reject_hint": "ผู้ปกครองจะเห็นหมายเหตุนี้ในพอร์ทัลและแจ้งการชำระใหม่ได้",
  "tuition.payments.reject_note": "เหตุผลที่ตรวจสอบไม่ตรง",
  "tuition.payments.reject_note_required": "กรุณาแจ้งเหตุผลให้ผู้ปกครองทราบ",
  "tuition.payments.reject_save": "ปฏิเสธการชำระเงิน",
  "tuition.payments.rejected": "ปฏิเสธการชำระเงินแล้ว",
  "tuition.payments.create_receipt": "ออกใบเสร็จ",
  "tuition.payments.receipt_created": "ออกใบเสร็จ {{number}} แล้ว",
  "tuition.payments.receipt_pdf": "PDF ใบเสร็จ",
  "tuition.payments.void_receipt": "ยกเลิกใบเสร็จ",
  "tuition.payments.void_hint": "เลขที่นี้จะไม่ถูกใช้ซ้ำ ออกใบเสร็จใหม่ภายหลังได้หากจำเป็น",
  "tuition.payments.void_reason": "เหตุผล",
  "tuition.payments.void_reason_required": "กรุณาระบุเหตุผลในการยกเลิก",
  "tuition.payments.receipt_voided": "ยกเลิกใบเสร็จแล้ว",
  "tuition.payments.record": "บันทึกการชำระ",
  "tuition.payments.record_save": "บันทึกการชำระ",
  "tuition.payments.recorded": "บันทึกการชำระเงินแล้ว",
  "tuition.payments.record_waiting": "ผู้ปกครองแจ้งชำระ {{amount}} สำหรับใบแจ้งหนี้เหล่านี้และกำลังรอตรวจสอบ หากเป็นเงินก้อนเดียวกัน กรุณายืนยันรายการที่แจ้งแทนการบันทึกซ้ำ",
  "tuition.payments.totals_to_collect": "ยอดที่ต้องเก็บ",
  "tuition.payments.totals_confirmed": "ยืนยันแล้ว",
  "tuition.payments.totals_waiting": "รอคุณตรวจสอบ",
  "tuition.payments.totals_still_to_come": "ยังไม่ได้รับ",
  "tuition.payments.families_count_one": "{{count}} ครอบครัว",
  "tuition.payments.families_count_other": "{{count}} ครอบครัว",
  "tuition.payments.paid_in_full_one": "ชำระครบแล้ว {{count}} ครอบครัว",
  "tuition.payments.paid_in_full_other": "ชำระครบแล้ว {{count}} ครอบครัว",
  "tuition.payments.reports_count_one": "{{count}} รายการแจ้ง",
  "tuition.payments.reports_count_other": "{{count}} รายการแจ้ง",
  "tuition.payments.filter_label": "สถานะ",
  "tuition.payments.filter_all": "ทั้งหมด",
  "tuition.payments.family_status.to_check": "รอตรวจสอบ",
  "tuition.payments.family_status.owing": "ค้างชำระ",
  "tuition.payments.family_status.paid": "ชำระแล้ว",
  "tuition.payments.search": "ค้นหาผู้ปกครอง นักเรียน หรือเลขที่ใบแจ้งหนี้",
  "tuition.payments.export": "ส่งออก",
  "tuition.payments.last_reported": "แจ้งโอนเงินเมื่อ {{when}}",
  "tuition.payments.nothing_reported": "ยังไม่มีการแจ้งชำระ",
  "tuition.payments.invoices_count_one": "{{count}} ใบแจ้งหนี้",
  "tuition.payments.invoices_count_other": "{{count}} ใบแจ้งหนี้",
  "tuition.payments.confirmed_label": "ยืนยันแล้ว",
  "tuition.payments.still_to_pay": "คงเหลือ",
  "tuition.payments.invoices_for": "ใบแจ้งหนี้ภาคเรียนที่ {{n}} ปีการศึกษา {{year}}",
  "tuition.payments.due_on": "ครบกำหนด {{date}}",
  "tuition.payments.no_transfers": "ยังไม่มีการแจ้งโอนเงินสำหรับใบแจ้งหนี้เหล่านี้",
  "tuition.payments.match_exact": "ตรงกับยอดใบแจ้งหนี้",
  "tuition.payments.match_less": "น้อยกว่ายอดใบแจ้งหนี้ {{amount}}",
  "tuition.payments.match_more": "มากกว่ายอดใบแจ้งหนี้ {{amount}}",
  "tuition.payments.match_other_semester": "ชำระใบแจ้งหนี้อื่นที่ไม่ได้แสดงที่นี่ด้วย",
  "tuition.payments.also_pays": "ชำระ {{invoice}} ภาคเรียนที่ {{n}} ปีการศึกษา {{year}} ด้วย · {{amount}}",
  "tuition.payments.confirm_amount": "ยืนยัน {{amount}}",
  "tuition.payments.confirm_transfer_hint": "ตรวจสอบยอดกับรายการเดินบัญชี แล้วแบ่งยอดลงในใบแจ้งหนี้แต่ละใบ ยอดที่แบ่งต้องรวมเท่ากับยอดที่ยืนยัน หากใส่ 0 ใบแจ้งหนี้นั้นจะไม่ถูกนับ",
  "tuition.payments.reported_amount": "ผู้ปกครองแจ้งยอด {{amount}}",
  "tuition.payments.split_title": "แบ่งยอดลงใน",
  "tuition.payments.split_sum": "ยอดที่แบ่งรวม {{sum}} จาก {{amount}}",
  "tuition.payments.shares_mismatch": "ยอดที่แบ่งต้องรวมเท่ากับ {{amount}}",
  "tuition.payments.share_over": "ใบแจ้งหนี้นี้คงเหลือเพียง {{amount}}",
  "tuition.payments.share_invalid": "จำนวนเต็มบาท ตั้งแต่ 0 ขึ้นไป",
  "tuition.payments.outstanding": "คงเหลือ {{amount}}",
  "tuition.payments.other_semester_share": "ภาคเรียนที่ {{n}} ปีการศึกษา {{year}}",
  "tuition.payments.record_family": "บันทึกการชำระ",
  "tuition.payments.record_family_hint": "เงินที่สำนักงานรับเอง เช่น เงินสด บัตร เช็ค หักจากเงินเดือน หรือยอดโอนที่เห็นในรายการเดินบัญชี เลือกใบแจ้งหนี้ที่ชำระ ระบบจะยืนยันทันทีที่บันทึก",
  "tuition.payments.record_pays_for": "การชำระนี้สำหรับ",
  "tuition.payments.record_pick_one": "กรุณาเลือกใบแจ้งหนี้อย่างน้อยหนึ่งใบ",
  "tuition.payments.record_total": "รวม {{amount}}",
  "tuition.notices.email_invoices": "ส่งอีเมลใบแจ้งหนี้ ({{count}})",
  "tuition.notices.send_reminders": "ส่งการแจ้งเตือน (ยังไม่ชำระ {{count}})",
  "tuition.notices.email_confirm": "ส่งอีเมลแจ้งผู้ปกครอง {{parents}} คนว่าใบแจ้งหนี้ {{count}} ใบพร้อมแล้วหรือไม่ แต่ละอีเมลมีลิงก์ไปยังพอร์ทัล ใบแจ้งหนี้ที่ยังไม่มีไฟล์ PDF จะไม่รวมอยู่ด้วย",
  "tuition.notices.email_confirm_without": "ใบแจ้งหนี้ {{count}} ใบไม่มีอีเมลผู้ปกครองและจะไม่ถูกส่ง",
  "tuition.notices.remind_confirm": "ส่งการแจ้งเตือนอย่างสุภาพถึงผู้ปกครอง {{parents}} คนเรื่องใบแจ้งหนี้ที่ยังไม่ชำระ {{count}} ใบหรือไม่ ครอบครัวที่ได้รับการแจ้งเตือนใน 7 วันที่ผ่านมาจะถูกข้าม",
  "tuition.notices.progress": "กำลังส่ง: {{done}} จาก {{total}}",
  "tuition.notices.done_invoices": "ส่งอีเมลใบแจ้งหนี้ถึงผู้ปกครอง {{emails}} คนแล้ว",
  "tuition.notices.done_reminders": "ส่งการแจ้งเตือนถึงผู้ปกครอง {{emails}} คนแล้ว",
  "tuition.notices.failed": "ส่งอีเมลไม่สำเร็จ {{count}} ฉบับ — กดส่งอีกครั้งเพื่อลองใหม่",
  "tuition.notices.without": "ใบแจ้งหนี้ {{count}} ใบไม่มีอีเมลผู้ปกครอง",
  "tuition.notices.emailed_on": "ส่งอีเมลเมื่อ {{date}}",
  "tuition.notices.reminded_on": "แจ้งเตือนเมื่อ {{date}}",
  "tuition.copies.title": "คำขอใบเสร็จต้นฉบับประทับตรา",
  "tuition.copies.hint": "ผู้ปกครองขอใบเสร็จฉบับกระดาษประทับตรา พิมพ์และประทับตรา กดพร้อมรับ (ระบบจะส่งอีเมลแจ้งผู้ปกครอง) แล้วกดรับแล้ว",
  "tuition.copies.requested_by": "ขอโดย {{name}} เมื่อ {{date}}",
  "tuition.copies.status.requested": "ขอแล้ว",
  "tuition.copies.status.ready": "พร้อมรับ",
  "tuition.copies.status.collected": "รับแล้ว",
  "tuition.copies.mark_ready": "พร้อมรับ",
  "tuition.copies.mark_collected": "รับแล้ว",
  "tuition.copies.marked_ready": "บันทึกว่าพร้อมรับแล้ว — ส่งอีเมลแจ้งผู้ปกครองแล้ว",
  "tuition.copies.marked_collected": "บันทึกว่ารับแล้ว",
  "report_cards.periods.download_action": "ดาวน์โหลดทั้งหมด",
  "report_cards.periods.views_summary": "ผู้ปกครองเปิดดูแล้ว {{opened}} จาก {{cards}}",
  "report_cards.periods.views_title": "ผู้ที่เปิดดู {{name}}",
  "report_cards.periods.views_description": "นับการเปิดดูในพอร์ทัลผู้ปกครองและนักเรียน ผู้ปกครองที่อ่านเฉพาะอีเมลแจ้งเตือนจะไม่ถูกนับ",
  "report_cards.periods.views_opened_by_parent": "ผู้ปกครองเปิดดูแล้ว",
  "report_cards.periods.views_parents": "จำนวนผู้ปกครองที่เปิดดู",
  "report_cards.periods.views_pdf": "ผู้ปกครองดาวน์โหลด PDF",
  "report_cards.periods.views_student": "นักเรียนเปิดดูแล้ว",
  "report_cards.periods.views_of": "{{value}} จาก {{total}}",
  "report_cards.periods.views_show": "แสดง",
  "report_cards.periods.views_show_all": "นักเรียนทั้งหมด",
  "report_cards.periods.views_show_unopened": "ยังไม่เปิดดู",
  "report_cards.periods.views_empty": "ทุกครอบครัวในรายการนี้เปิดดูสมุดรายงานผลแล้ว",
  "report_cards.periods.views_col_student": "นักเรียน",
  "report_cards.periods.views_col_parents": "ผู้ปกครองที่เปิดดู",
  "report_cards.periods.views_col_pdf": "PDF",
  "report_cards.periods.views_col_student_opened": "นักเรียนเปิดดู",
  "report_cards.periods.views_col_first": "เปิดดูครั้งแรก",
  "report_cards.periods.views_no_parent": "ไม่มีผู้ปกครองที่เชื่อมโยง",
  "report_cards.periods.download_title": "ดาวน์โหลดสมุดรายงานผล {{name}}",
  "report_cards.periods.download_description": "ไฟล์ PDF ที่เผยแพร่แล้ว ตรงกับที่ผู้ปกครองได้รับ สำหรับเก็บเป็นหลักฐานหรือพิมพ์",
  "report_cards.periods.download_all_grades": "ทุกระดับชั้น",
  "report_cards.periods.download_formats": "ZIP แยกเป็นไฟล์ PDF รายนักเรียน จัดเป็นโฟลเดอร์ตามระดับชั้น ส่วนการพิมพ์จะรวมเป็น PDF ไฟล์เดียว",
  "report_cards.periods.download_zip": "ดาวน์โหลด ZIP",
  "report_cards.periods.download_pdf": "ดาวน์โหลดสำหรับพิมพ์",
  "report_cards.periods.download_preparing": "กำลังเตรียมไฟล์…",
  "report_cards.periods.download_filename": "สมุดรายงานผล {{name}} - {{scope}}",
  "report_cards.entry.section_label": "ส่วนของโรงเรียน",
  "report_cards.entry.section_early_years": "ปฐมวัย",
  "report_cards.entry.section_grades": "ประถม 1 ขึ้นไป",
  "report_cards.entry.class_label": "ชั้นเรียน",
  "report_cards.entry.subjects_label": "รายวิชา",
  "report_cards.entry.tab_homeroom": "รายงานปฐมวัย",
  "common.showing_last_received": "กำลังแสดงผลล่าสุดที่ได้รับ",
  "common.try_again": "ลองอีกครั้ง",
  "common.through": "ถึง",
  "common.all_history": "ประวัติที่บันทึกไว้ทั้งหมด",
  "common.date_range_invalid_one": "เลือกช่วงวันที่ไม่เกิน {{count}} วัน โดยวันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น",
  "common.date_range_invalid_other": "เลือกช่วงวันที่ไม่เกิน {{count}} วัน โดยวันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น",
  "sparky.duration.hours": "{{hours}} ชม. {{minutes}} นาที",
  "sparky.duration.minutes": "{{minutes}} นาที {{seconds}} วินาที",
  "sparky.signal.needs_practice": "ควรฝึกเพิ่ม",
  "sparky.signal.review": "ทบทวนกับนักเรียน",
  "sparky.signal.excellent": "ยอดเยี่ยม",
  "sparky.signal.progressing": "กำลังก้าวหน้า",
  "sparky.signal.getting_started": "เพิ่งเริ่มต้น",
  "sparky.signal.no_play": "ยังไม่มีการเล่นที่บันทึกไว้",
  "sparky.live_status.playing": "กำลังเล่น",
  "sparky.live_status.idle": "ไม่มีการใช้งาน",
  "sparky.live_status.paused": "หยุดชั่วคราว",
  "sparky.live_status.disconnected": "ขาดการเชื่อมต่อ",
  "sparky.live_status.offline": "ออฟไลน์",
  "sparky.live_status.unavailable": "ไม่สามารถอัปเดตได้",
  "sparky.live_status.finished": "ไม่ได้เล่นอยู่",
  "sparky.live_status.recorded": "เล่นไปแล้ววันนี้",
  "sparky.evidence.mistakes_one": "ผิด {{count}} ครั้ง",
  "sparky.evidence.mistakes_other": "ผิด {{count}} ครั้ง",
  "sparky.evidence.successes_one": "ขั้นที่ถูก {{count}} ขั้น",
  "sparky.evidence.successes_other": "ขั้นที่ถูก {{count}} ขั้น",
  "sparky.evidence.hints_one": "คำใบ้ {{count}} ครั้ง",
  "sparky.evidence.hints_other": "คำใบ้ {{count}} ครั้ง",
  "sparky.evidence.retries_one": "ลองใหม่ {{count}} ครั้ง",
  "sparky.evidence.retries_other": "ลองใหม่ {{count}} ครั้ง",
  "sparky.evidence.skips_one": "ข้าม {{count}} ครั้ง",
  "sparky.evidence.skips_other": "ข้าม {{count}} ครั้ง",
  "sparky.evidence.low_stars_one": "ทำเสร็จได้ไม่ถึง 3 ดาว {{count}} ครั้ง",
  "sparky.evidence.low_stars_other": "ทำเสร็จได้ไม่ถึง 3 ดาว {{count}} ครั้ง",
  "sparky.evidence.none": "ไม่มีข้อผิดพลาดหรือการขอความช่วยเหลือที่บันทึกไว้",
  "sparky.interaction.rapid_bursts_one": "กดรัวเร็ว {{count}} ชุด",
  "sparky.interaction.rapid_bursts_other": "กดรัวเร็ว {{count}} ชุด",
  "sparky.interaction.blocked_presses_one": "กดขณะเกมยังทำงานอยู่ {{count}} ครั้ง",
  "sparky.interaction.blocked_presses_other": "กดขณะเกมยังทำงานอยู่ {{count}} ครั้ง",
  "sparky.interaction.rapid_answers_one": "รูปแบบการตอบเร็วเกินไป {{count}} ครั้ง",
  "sparky.interaction.rapid_answers_other": "รูปแบบการตอบเร็วเกินไป {{count}} ครั้ง",
  "sparky.stars.tier_1": "1 ดาว",
  "sparky.stars.tier_2": "2 ดาว",
  "sparky.stars.tier_3": "3 ดาว",
  "sparky.stars.unfinished": "ยังไม่เสร็จ",
  "sparky.stars.not_visited": "ยังไม่ได้เข้าเล่น",
  "sparky.stars.of_max_one": "{{count}} จาก {{max}} ดาว",
  "sparky.stars.of_max_other": "{{count}} จาก {{max}} ดาว",
  "sparky.topic.of_completed": "/ {{total}} เสร็จแล้ว",
  "sparky.topic.unfinished_count_one": "ยังไม่เสร็จ {{count}} ด่าน",
  "sparky.topic.unfinished_count_other": "ยังไม่เสร็จ {{count}} ด่าน",
  "sparky.control.solution_next": "วิธีทำ · ขั้นถัดไป",
  "sparky.control.review_next": "ทบทวนข้อผิดพลาด · ขั้นถัดไป",
  "sparky.control.trace_next": "ไล่โค้ด · ขั้นถัดไป",
  "sparky.control.tutorial_next": "บทเรียนเขียนโค้ด · ขั้นถัดไป",
  "sparky.control.code_run": "รันโค้ด",
  "sparky.control.code_step": "รันโค้ดทีละขั้น",
  "sparky.control.code_reset": "รีเซ็ตโค้ด",
  "sparky.control.multiple_choice": "คำตอบแบบเลือกตอบ",
  "sparky.interaction_event.correct": "ถูก",
  "sparky.interaction_event.incorrect": "ผิด",
  "sparky.interaction_event.answer": "{{result}} · ตอบใน {{seconds}} วินาที · {{choices}} ตัวเลือก",
  "sparky.interaction_event.rapid_answers": "ตอบเร็ว 5 ข้อ ผิด {{wrong}} ข้อ · แต่ละข้อภายใน {{seconds}} วินาที · ตอบเร็วมาก ส่วนใหญ่ผิด ควรทบทวน",
  "sparky.interaction_event.activated": "ระบบรับคำสั่งแล้ว",
  "sparky.interaction_event.rapid_clicks": "กด 5 ครั้งภายใน {{seconds}} วินาที",
  "sparky.interaction_event.blocked_disabled": "ไม่นับ: เกมยังทำงานอยู่",
  "sparky.interaction_event.blocked_pending": "กำลังรอให้ขั้นที่แสดงอัปเดต",
  "sparky.interaction_event.advanced": "ไปจากขั้นที่ {{step}} เป็นขั้นที่ {{next}} จาก {{total}}",
  "sparky.mistake.incorrect_answer": "คำตอบไม่ถูกต้อง",
  "sparky.mistake.math_counting": "คำตอบการนับ / การจับคู่",
  "sparky.mistake.math_sequence": "คำตอบเรื่องลำดับ",
  "sparky.mistake.math_strategy": "กลยุทธ์การคำนวณ",
  "sparky.mistake.math_place_value": "คำตอบเรื่องทศนิยม / ค่าประจำหลัก",
  "sparky.mistake.math_calculation": "คำตอบการคำนวณ",
  "sparky.mistake.math_geometry": "คำตอบเรื่องรูปทรง / มุม",
  "sparky.mistake.math_shape": "คำตอบเรื่องรูปทรง",
  "sparky.mistake.math_fraction": "คำตอบเรื่องเศษส่วน",
  "sparky.mistake.math_measurement": "คำตอบเรื่องการวัด / หน่วย",
  "sparky.mistake.checkup_answer": "คำตอบแบบทดสอบ",
  "sparky.mistake.checkup_concept": "คำตอบเรื่องแนวคิด",
  "sparky.mistake.checkup_vocabulary": "คำตอบเรื่องความหมายของคำ",
  "sparky.mistake.checkup_code_reading": "คำตอบเรื่องการอ่านโค้ด",
  "sparky.mistake.checkup_debugging": "คำตอบเรื่องการหาจุดผิดพลาด",
  "sparky.mistake.coding_obstacle": "โปรแกรมชนสิ่งกีดขวาง",
  "sparky.mistake.coding_incomplete": "โปรแกรมจบก่อนถึงเป้าหมาย",
  "sparky.mistake.coding_required_block": "ขาดบล็อกคำสั่งที่จำเป็น",
  "sparky.mistake.coding_program_error": "โปรแกรมทำงานไม่ได้",
  "sparky.mistake.coding_stuck_loop": "ลูปไม่คืบหน้า",
  "sparky.mistake.coding_message": "ส่งข้อความถึงหุ่นยนต์ตัวอื่นไม่ถูกต้อง",
  "sparky.mistake.coding_interaction": "ใช้สวิตช์หรือการโต้ตอบไม่ถูกต้อง",
  "sparky.mistake.coding_repeat_count": "จำนวนรอบการทำซ้ำ",
  "sparky.mistake.coding_condition": "เงื่อนไข",
  "sparky.mistake.coding_direction": "ทิศทาง",
  "sparky.mistake.coding_variable": "ตัวแปร",
  "sparky.mistake.coding_function": "ฟังก์ชัน",
  "sparky.mistake.coding_event": "เหตุการณ์",
  "sparky.mistake.coding_block_order": "ลำดับบล็อก",
  "sparky.mistake.illegal_move": "การเคลื่อนที่ที่ไม่อนุญาต",
  "sparky.mistake.task_failed": "ทำภารกิจไม่สำเร็จ",
  "sparky.mistake.other": "ข้อผิดพลาดอื่นที่บันทึกไว้",
  "sparky.mistake.student_response": "คำตอบของนักเรียน:",
  "sparky.mistake.observed_result": "สิ่งที่เกิดขึ้น:",
  "sparky.mistake.missing_block": "โปรแกรมไม่มี{{block}}",
  "sparky.mistake.block.repeat": "บล็อก REPEAT",
  "sparky.mistake.block.nested_repeat": "บล็อก REPEAT ที่ซ้อนอยู่ใน REPEAT อีกอัน",
  "sparky.mistake.block.condition": "บล็อก IF",
  "sparky.mistake.block.variable": "ตัวแปร",
  "sparky.mistake.block.function": "บล็อก DEFINE",
  "sparky.mistake.block.event": "สคริปต์ WHEN",
  "sparky.mistake.run_error.invalid": "Sparky รันโปรแกรมนี้ไม่ได้",
  "sparky.mistake.run_error.stuck": "Sparky ติดอยู่ในลูป: ไม่มีอะไรเปลี่ยนในลูป จึงไม่มีวันหยุด",
  "sparky.mistake.run_error.wrong_tell": "TELL บอกตัวเลขที่ไม่ถูกต้องให้ประตู",
  "sparky.mistake.run_error.gate": "ยังมีประตูที่ปิดอยู่",
  "sparky.mistake.run_error.press": "ใช้ PRESS ขณะที่ Sparky ไม่ได้ยืนอยู่บนสวิตช์",
  "sparky.mistake.expected": "คำตอบที่ถูกต้อง:",
  "sparky.mistake.none": "ไม่มีข้อผิดพลาดที่บันทึกไว้",
  "sparky.mistake.fixed": "แก้ไขแล้ว {{date}}",
  "sparky.mistake.unclassified_one": "ข้อผิดพลาด {{count}} ครั้งไม่มีรายละเอียดที่บันทึกไว้",
  "sparky.mistake.unclassified_other": "ข้อผิดพลาด {{count}} ครั้งไม่มีรายละเอียดที่บันทึกไว้",
  "sparky.mistake.latest_example": "ตัวอย่างล่าสุดที่บันทึกไว้",
  "sparky.mistake.examples_in_order": "สิ่งที่ตอบ ตามลำดับ",
  "sparky.story.result_completed": "จบด่านด้วย {{stars}} จาก 3 ดาว",
  "sparky.story.result_skipped": "ข้าม",
  "sparky.story.result_unfinished": "ออกโดยยังไม่เสร็จ",
  "sparky.story.result_playing": "กำลังเล่นอยู่",
  "sparky.story.no_mistakes": "ไม่มีข้อผิดพลาดที่บันทึกไว้",
  "sparky.story.mistake_count": "{{label}} ×{{count}}",
  "sparky.story.answered": "ตอบว่า “{{actual}}”",
  "sparky.story.observed": "สิ่งที่เกิดขึ้น: {{actual}}",
  "sparky.story.answered_expected": "ตอบว่า “{{actual}}” คำตอบที่ถูกคือ “{{expected}}”",
  "sparky.story.expected_only": "คำตอบที่ถูกคือ “{{expected}}”",
  "sparky.story.answers_in_order": "คำตอบตามลำดับ: {{answers}}",
  "sparky.story.answer_right": "ถูก ({{seconds}} วินาที)",
  "sparky.story.answer_wrong": "ผิด ({{seconds}} วินาที)",
  "sparky.story.hints_one": "ขอคำใบ้ {{count}} ครั้ง",
  "sparky.story.hints_other": "ขอคำใบ้ {{count}} ครั้ง",
  "sparky.story.retries_one": "เริ่มใหม่ {{count}} ครั้ง",
  "sparky.story.retries_other": "เริ่มใหม่ {{count}} ครั้ง",
  "sparky.story.example_unrecorded": "เกมนี้ไม่ได้บันทึกสิ่งที่ตอบ",
  "sparky.story.unrecorded_examples_one": "อีก {{count}} ครั้งไม่มีตัวอย่างที่บันทึกไว้",
  "sparky.story.unrecorded_examples_other": "อีก {{count}} ครั้งไม่มีตัวอย่างที่บันทึกไว้",
  "sparky.mistake.no_example": "เกมนี้ไม่ได้บันทึกคำตอบที่เลือก ดูได้ที่ส่วนการฟื้นตัวและพัฒนาการ หรือประวัติกิจกรรมว่าเกิดในด่านใด",
  "sparky.mistake.answers_given": "คำตอบที่ผิดและจำนวนนักเรียนที่ตอบแบบนั้น",
  "sparky.checkup.self_not_yet": "ยังทำไม่ได้",
  "sparky.checkup.self_getting_there": "ใกล้ทำได้แล้ว",
  "sparky.checkup.self_can_do": "หนูทำได้",
  "sparky.report.level_target": "ด่าน {{level}}",
  "sparky.report.suggest_practise": "ฝึก{{target}}ด้วยกัน แล้วให้นักเรียนลองทำเอง",
  "sparky.report.suggest_review": "ถามว่านักเรียนแก้{{target}}อย่างไร แล้วทบทวนส่วนที่ต้องการความช่วยเหลือ",
  "sparky.report.suggest_next": "ให้แบบฝึกหัดถัดไปในทักษะนี้",
  "sparky.report.suggest_finish": "ให้เวลานักเรียนทำแบบฝึกหัดปัจจุบันให้เสร็จ",
  "sparky.report.result_skipped": "ข้ามไป",
  "sparky.report.result_left_unfinished": "ออกก่อนทำเสร็จ",
  "sparky.course_level": "{{course}} · ด่าน {{level}}",
  "sparky.level": "ด่าน {{level}}",
  "sparky.score.none": "ยังไม่มีด่านที่ทำเสร็จ",
  "sparky.score.stars": "{{earned}}/{{possible}} ดาว",
  "sparky.assignment.complete": "ครบแล้ว",
  "sparky.assignment.target_achieved": "บรรลุเป้าหมายของบทเรียนแล้ว",
  "sparky.assignment.target_achieved_free": "บรรลุเป้าหมายของบทเรียนแล้ว · เลือกกิจกรรมได้อิสระ",
  "sparky.assignment.in_progress": "กำลังทำ",
  "sparky.assignment.not_started": "ยังไม่เริ่ม",
  "sparky.assignment.incomplete": "ไม่ครบ",
  "sparky.assignment.not_completed_count_one": "แบบฝึกหัดที่ยังไม่เสร็จ {{count}} ข้อ",
  "sparky.assignment.not_completed_count_other": "แบบฝึกหัดที่ยังไม่เสร็จ {{count}} ข้อ",
  "sparky.assignment.remaining_count_one": "เหลือแบบฝึกหัดอีก {{count}} ข้อ",
  "sparky.assignment.remaining_count_other": "เหลือแบบฝึกหัดอีก {{count}} ข้อ",
  "sparky.assignment.of": "จาก {{required}}",
  "sparky.assignment.progress_value": "ทำเสร็จ {{completed}} จาก {{required}} แบบฝึกหัด",
  "sparky.assignment.of_exercises": "จาก {{required}} แบบฝึกหัด",
  "sparky.assignment.all_done": "ทำครบทุกแบบฝึกหัดแล้ว",
  "sparky.checkup.title": "{{name}} · ผลตามหัวข้อ",
  "sparky.checkup.description": "แบบทดสอบ {{grade}}: ความครอบคลุม ข้อผิดพลาดและความช่วยเหลือที่บันทึกไว้ การประเมินตนเองของเด็ก และข้อที่ควรกลับมาทบทวน",
  "sparky.checkup.no_measured": "ไม่มีข้อที่วัดผลได้ในชุดนี้",
  "sparky.checkup.completed_of": "เสร็จ {{completed}}/{{total}}",
  "sparky.checkup.measured_line": "ทำได้โดยไม่ผิดพลาด {{clean}}/{{completed}} · เสร็จ {{completed}}/{{total}}",
  "sparky.checkup.self_rating": "ประเมินตนเอง: {{rating}}",
  "sparky.checkup.rated": "ประเมินตนเองแล้ว",
  "sparky.checkup.rated_as": "ประเมินตนเองแล้ว: {{rating}}",
  "sparky.checkup.not_rated": "ยังไม่ได้ประเมิน",
  "sparky.checkup.mismatch_overconfident": "บอกว่า “หนูทำได้” แต่ตอบถูกในครั้งแรกไม่ถึงครึ่งหนึ่ง",
  "sparky.checkup.mismatch_underconfident": "บอกว่า “ยังทำไม่ได้” แต่ตอบถูกตั้งแต่ครั้งแรกทุกข้อ",
  "sparky.checkup.coverage": "ความครอบคลุมของ {{name}}",
  "sparky.checkup.clean_count_one": "ทำเสร็จโดยไม่มีข้อผิดพลาด การขอความช่วยเหลือ หรือการลองใหม่ {{count}} ข้อ",
  "sparky.checkup.clean_count_other": "ทำเสร็จโดยไม่มีข้อผิดพลาด การขอความช่วยเหลือ หรือการลองใหม่ {{count}} ข้อ",
  "sparky.checkup.unfinished_unvisited": "ยังไม่เสร็จ {{unfinished}} · ยังไม่ได้ทำ {{unvisited}}",
  "sparky.checkup.next": "ขั้นต่อไป: {{next}}",
  "sparky.checkup.band_secure": "มั่นคง",
  "sparky.checkup.band_developing": "กำลังพัฒนา",
  "sparky.checkup.band_not_yet": "ยังไม่ได้",
  "sparky.checkup.band_insufficient": "หลักฐานยังไม่พอ",
  "sparky.checkup.band_basis": "ระดับนี้มาจาก {{secure}}/{{evidence}} ข้อที่ทำได้ตั้งแต่ครั้งแรก (คำตอบแรก และได้สามดาวในงานปฏิบัติครั้งแรกที่ทำสำเร็จ)",
  "sparky.checkup.band_insufficient_basis_one": "มีผลการทำครั้งแรกเพียง {{count}} ข้อ ต้องมีอย่างน้อย 3 ข้อจึงจะจัดระดับได้",
  "sparky.checkup.band_insufficient_basis_other": "มีผลการทำครั้งแรกเพียง {{count}} ข้อ ต้องมีอย่างน้อย 3 ข้อจึงจะจัดระดับได้",
  "sparky.checkup.secure_early": "มั่นคงตั้งแต่ต้น",
  "sparky.checkup.secure_early_hint": "ตอบข้อหลักสามข้อแรกถูกตั้งแต่ครั้งแรก จึงข้ามข้อหลักที่เหลือ",
  "sparky.checkup.stopped_early": "หยุดก่อนกำหนด",
  "sparky.checkup.stopped_early_hint": "ตอบข้อหลักสองข้อแรกผิดตั้งแต่ครั้งแรก จึงข้ามข้อที่เหลือของหัวข้อนี้",
  "sparky.checkup.skipped_by_rule_one": "· ข้าม {{count}} ข้อเมื่อหัวข้อหยุดก่อนกำหนด",
  "sparky.checkup.skipped_by_rule_other": "· ข้าม {{count}} ข้อเมื่อหัวข้อหยุดก่อนกำหนด",
  "sparky.checkup.band_next_secure": "ไปต่อได้: ให้ลองข้อขยายหรืองานที่ยากขึ้น",
  "sparky.checkup.band_next_developing": "ฝึกเพิ่ม: ทบทวนข้อที่ควรทบทวนด้วยกัน แล้วลองทำข้อใหม่",
  "sparky.checkup.band_next_not_yet": "สอนซ้ำ: อธิบายแนวคิดอีกครั้งในกลุ่มเล็กพร้อมตัวอย่างที่จับต้องได้ ก่อนตรวจสอบอีกครั้ง",
  "sparky.checkup.band_next_insufficient": "เก็บหลักฐานเพิ่ม: ถามคำถามในหัวข้อนี้อีกสองสามข้อก่อนตัดสินใจ",
  "sparky.checkup.review_heading": "ข้อที่ควรทบทวน:",
  "sparky.checkup.footnote": "คำถามเหล่านี้เป็นจุดเริ่มต้น ไม่ใช่การตัดสินความเชี่ยวชาญหรือคะแนนสอบ การเล่นซ้ำอาจเพิ่มดาวได้ แต่ข้อผิดพลาดและความช่วยเหลือที่บันทึกไว้ยังคงแสดงอยู่ การประเมินตนเองเป็นมุมมองของเด็กเองและไม่นำมาคิดคะแนน ให้เด็กแสดงวิธีคิดและลองโจทย์ใหม่ก่อนตัดสินใจขั้นต่อไป ความช่วยเหลือจากผู้ใหญ่นอก Sparky จะไม่ถูกบันทึกโดยอัตโนมัติ",
  "sparky.checkup.measured": "ผลที่วัดได้: {{line}}",
  "sparky.checkup.self_title": "การประเมินตนเอง",
  "sparky.checkup.self_description": "สิ่งที่เด็กบอกว่าทำได้ เทียบกับผลที่ Sparky วัดได้ในหัวข้อเดียวกัน",
  "sparky.interactions.not_recorded": "ไม่มีการบันทึกการโต้ตอบสำหรับการเข้าเล่นครั้งนี้",
  "sparky.interactions.steps_advanced_one": "เลื่อนไป {{count}} ขั้น",
  "sparky.interactions.steps_advanced_other": "เลื่อนไป {{count}} ขั้น",
  "sparky.interactions.code_actions_one": "คำสั่งโค้ด {{count}} ครั้ง",
  "sparky.interactions.code_actions_other": "คำสั่งโค้ด {{count}} ครั้ง",
  "sparky.interactions.timed_answers_one": "คำตอบที่จับเวลา {{count}} ข้อ",
  "sparky.interactions.timed_answers_other": "คำตอบที่จับเวลา {{count}} ข้อ",
  "sparky.interactions.timeline": "ลำดับเวลาการโต้ตอบ",
  "sparky.interactions.rapid_clicks": "กดรัวเร็ว",
  "sparky.interactions.review_answers": "ทบทวนคำตอบ",
  "sparky.interactions.no_presses": "ไม่มีการกดปุ่มที่ติดตามซึ่งบันทึกไว้",
  "sparky.interactions.showing_events": "แสดง {{shown}} จาก {{total}} เหตุการณ์ของการเข้าเล่นครั้งนี้ (เก็บไว้ 60 รายการล่าสุด) เวลาที่แสดงนับจากเปิดด่าน",
  "sparky.interactions.title": "รูปแบบการตอบและการโต้ตอบ",
  "sparky.interactions.description": "ทบทวนเวลาในการตอบ การกดซ้ำ และหลักฐานเบื้องหลังข้อสังเกตแต่ละข้อ",
  "sparky.interactions.export": "ส่งออกลำดับเวลาการโต้ตอบ",
  "sparky.interactions.tile_steps": "ขั้นที่เลื่อนไป",
  "sparky.interactions.tile_code_actions": "คำสั่งโค้ดที่ระบบรับ",
  "sparky.interactions.tile_blocked": "กดซ้ำขณะเกมยังทำงานอยู่",
  "sparky.interactions.tile_bursts": "การกดรัวเร็ว",
  "sparky.interactions.tile_answers": "คำตอบแบบเลือกตอบที่จับเวลา",
  "sparky.interactions.tile_rapid_answers": "รูปแบบการตอบเร็วเกินไป",
  "sparky.interactions.coverage": "การติดตามครอบคลุม {{tracked}} จาก {{visits}} การเข้าเล่น การกดรัวเร็วไม่ได้พิสูจน์ว่าเด็กหงุดหงิดและไม่มีผลต่อคะแนน การจับเวลาคำตอบครอบคลุม {{answerVisits}} การเข้าเล่น เวลาตอบก่อนหน้านั้นไม่ได้บันทึกไว้",
  "sparky.interactions.how_to_read": "วิธีอ่านสัญญาณเหล่านี้",
  "sparky.interactions.how_bursts": "การกดรัวเร็วหมายถึงกดปุ่มเดียวกันอย่างน้อย 5 ครั้งภายใน 2 วินาที โดยมีช่วงเงียบคั่น 2 วินาที เปรียบเทียบขั้นที่เลื่อนไปจริงกับการกดขณะปุ่มใช้งานไม่ได้หรือกำลังรอ เพื่อดูว่านักเรียนผ่านเนื้อหาเร็ว หรือกดปุ่มที่ยังใช้ไม่ได้ซ้ำ ๆ",
  "sparky.interactions.how_controls": "ติดตามปุ่มขั้นถัดไปในวิธีทำ การทบทวน และการเขียนโค้ด รวมถึงปุ่มรัน ทีละขั้น และรีเซ็ตของโค้ดแบบบล็อก การแตะกระดานและการพิมพ์ไม่นับในการตรวจจับการกด คำตอบแบบเลือกตอบที่ระบบรับจะจับเวลาแยกต่างหาก",
  "sparky.interactions.how_rapid_answers": "รูปแบบการตอบเร็วเกินไปหมายถึงตอบติดกัน 5 ข้อ แต่ละข้อภายใน 1 วินาที ผิดอย่างน้อย 3 ข้อ ภายใน 90 วินาทีในกิจกรรมและทักษะเดียวกัน การขอความช่วยเหลือ การหยุด และการตอบช้าลงจะตัดรูปแบบนี้ คำตอบที่ถูกแม้ตอบเร็วจะไม่ถูกตั้งข้อสังเกต สิ่งนี้บ่งชี้ว่าตอบเร็วมากและส่วนใหญ่ผิด ไม่ใช่ข้อพิสูจน์ ให้นักเรียนอธิบายวิธีคิดก่อนตัดสินใจให้ความช่วยเหลือ คะแนนไม่ได้รับผลกระทบ",
  "sparky.interactions.visit_debug": "การเข้าเล่น {{id}} · {{status}} · อัปเดตล่าสุด {{updated}}",
  "sparky.interactions.none_flagged": "ไม่มีรูปแบบการโต้ตอบที่ต้องทบทวนในการเข้าเล่นล่าสุดที่แสดงไว้",
  "sparky.interactions.tracking_starts": "การติดตามการโต้ตอบจะเริ่มกับการเข้าเล่นครั้งใหม่หลังการอัปเดตนี้",
  "sparky.interactions.flagged_from_one": "การเข้าเล่นที่ถูกตั้งข้อสังเกตด้านบนมาจากการเข้าเล่นล่าสุด {{count}} ครั้งในช่วงนี้ เปิดประวัติกิจกรรมเพื่อดูลำดับเวลาของทุกการเข้าเล่น ส่วนยอดรวมด้านบนครอบคลุมทั้งช่วง",
  "sparky.interactions.flagged_from_other": "การเข้าเล่นที่ถูกตั้งข้อสังเกตด้านบนมาจากการเข้าเล่นล่าสุด {{count}} ครั้งในช่วงนี้ เปิดประวัติกิจกรรมเพื่อดูลำดับเวลาของทุกการเข้าเล่น ส่วนยอดรวมด้านบนครอบคลุมทั้งช่วง",
  "sparky.preview.open": "ดูตัวอย่างด่าน {{level}}",
  "sparky.preview.button": "ดูตัวอย่าง",
  "sparky.preview.title": "ตัวอย่างแบบฝึกหัด · ด่าน {{level}}",
  "sparky.preview.description": "{{grade}} · ลองทำแบบฝึกหัดหรือดูวิธีสอน",
  "sparky.preview.tab_play": "เล่นแบบฝึกหัด",
  "sparky.preview.tab_guide": "คู่มือการสอน",
  "sparky.preview.tabs_label": "มุมมองตัวอย่างแบบฝึกหัด",
  "sparky.preview.loading": "กำลังโหลดแบบฝึกหัด…",
  "sparky.preview.unavailable": "ไม่สามารถแสดงตัวอย่างแบบฝึกหัดได้",
  "sparky.preview.preparing": "กำลังเตรียมตัวอย่างที่เล่นได้…",
  "sparky.preview.frame_title": "แบบฝึกหัด {{course}} ที่เล่นได้ · ด่าน {{level}}",
  "sparky.preview.playable_unavailable": "ไม่สามารถแสดงตัวอย่างที่เล่นได้ ปิดแล้วเปิดตัวอย่างนี้ใหม่เพื่อลองอีกครั้ง",
  "sparky.preview.footer_note": "เป็นตัวอย่างเท่านั้น · ไม่มีผลต่อความก้าวหน้าและรายงานของนักเรียน",
  "sparky.preview.close": "ปิดตัวอย่าง",
  "sparky.preview.played_board": "กระดานที่นักเรียนคนนี้เล่น",
  "sparky.preview.support_board": "ด่านช่วยเสริม: ด่าน {{level}} ในแบบที่ง่ายกว่า",
  "sparky.preview.stretch_board": "ด่านท้าทาย: ด่าน {{level}} ในแบบที่ยากกว่า",
  "sparky.preview.example_board": "กระดานตัวอย่าง: การเล่นครั้งนี้บันทึกไว้ก่อนที่ระบบจะเก็บกระดาน รูปแบบจึงอาจต่างจากที่นักเรียนเห็น",
  "sparky.preview.guide_example": "คู่มือการสอนและเฉลยอธิบายกระดานตัวอย่างของด่านนี้ จึงอาจไม่ตรงกับกระดานของนักเรียน",
  "sparky.guide.row_clues": "คำใบ้แถว",
  "sparky.guide.column_clue": "คำใบ้คอลัมน์ {{column}}: {{clue}}",
  "sparky.guide.row_clue": "คำใบ้แถว {{row}}: {{clue}}",
  "sparky.guide.cell_filled": "ระบายแล้ว",
  "sparky.guide.cell_empty": "ว่าง",
  "sparky.guide.cell": "แถว {{row}} คอลัมน์ {{column}}: {{label}}",
  "sparky.guide.goal": "เป้าหมายการเรียนรู้",
  "sparky.guide.readiness": "ก่อนมอบหมายงาน",
  "sparky.guide.task": "สิ่งที่นักเรียนทำ",
  "sparky.guide.dot_intro": "นักเรียนจะเห็นตัวเลขนี้และบัตรจุดเหล่านี้",
  "sparky.guide.numeral": "ตัวเลข {{value}}",
  "sparky.guide.dot_option_one": "ตัวเลือก {{option}}: {{count}} จุด",
  "sparky.guide.dot_option_other": "ตัวเลือก {{option}}: {{count}} จุด",
  "sparky.guide.card": "บัตร {{card}}",
  "sparky.guide.solution": "อธิบายวิธีทำทีละขั้น",
  "sparky.guide.correct_solution": "คำตอบที่ถูกต้อง",
  "sparky.guide.look_for": "สิ่งที่ควรสังเกต",
  "sparky.guide.support": "ช่วยเหลืออย่างไรเมื่อนักเรียนติด",
  "sparky.guide.extension": "เมื่อนักเรียนพร้อมสำหรับงานที่ยากขึ้น",
  "sparky.guide.footnote": "คู่มือนี้อธิบายแบบฝึกหัดที่แสดงในตัวอย่างที่เล่นได้ ระหว่างเล่นจริง การฝึกแบบปรับระดับอาจเปลี่ยนตัวเลขหรือรูปแบบได้",
  "sparky.active_time": "ใช้งาน {{time}}",
  "sparky.open_learning_report": "เปิดรายงานการเรียนรู้",
  "sparky.lesson_form.title_heading": "เตรียมบทเรียน",
  "sparky.lesson_form.description": "บันทึกฉบับร่างไว้วันนี้แล้วเริ่มเมื่อคาบเรียนเริ่มต้น ระหว่างบทเรียนนักเรียนจะทำด่านที่ได้รับมอบหมายให้ครบก่อนเลือกกิจกรรมอื่น การเล่นซ้ำและการข้ามไม่นับรวมในเป้าหมาย",
  "sparky.lesson_form.title": "ชื่อบทเรียน",
  "sparky.lesson_form.target": "จำนวนด่านที่นักเรียนแต่ละคนต้องทำให้สำเร็จ",
  "sparky.lesson_form.target_choices": "ตัวเลือกเป้าหมายแบบเร็ว",
  "sparky.lesson_form.target_all": "ทั้งหมด",
  "sparky.lesson_form.target_percent": "{{percent}}%",
  "sparky.lesson_form.target_half": "ครึ่งหนึ่ง",
  "sparky.lesson_form.target_exact": "กำหนดเอง",
  "sparky.lesson_form.target_summary_one": "{{target}} จาก {{count}} แบบฝึกหัด ({{percent}}%)",
  "sparky.lesson_form.target_summary_other": "{{target}} จาก {{count}} แบบฝึกหัด ({{percent}}%)",
  "sparky.lesson_form.target_hint_one": "นักเรียนต้องทำแบบฝึกหัดข้อเดียวนี้ให้สำเร็จ การเล่นซ้ำและการข้ามด่านไม่นับ",
  "sparky.lesson_form.target_hint_other": "นักเรียนต้องทำให้สำเร็จอย่างน้อย {{target}} จาก {{count}} แบบฝึกหัด การเล่นซ้ำและการข้ามด่านไม่นับ",
  "sparky.lesson_form.target_unknown": "เลือกหลักสูตรและแบบฝึกหัดก่อน จึงจะเห็นว่ามีแบบฝึกหัดให้ทำกี่ข้อ",
  "sparky.lesson_form.target_varies": "จำนวนแบบฝึกหัดต่างกันตามระดับชั้น {{count}} คือจำนวนน้อยที่สุดที่นักเรียนที่เลือกไว้คนหนึ่งมี ทุกคนจึงทำถึงเป้าหมายได้",
  "sparky.lesson_form.target_cap": "บทเรียนหนึ่งกำหนดได้ไม่เกิน {{max}} แบบฝึกหัด ตัวเลือกแบบเร็วที่มากกว่านั้นจึงใช้ไม่ได้",
  "sparky.lesson_form.target_over_one": "ตอนนี้กำหนดได้ไม่เกิน {{count}} แบบฝึกหัด เพิ่มแบบฝึกหัดหรือลดเป้าหมายลง",
  "sparky.lesson_form.target_over_other": "ตอนนี้กำหนดได้ไม่เกิน {{count}} แบบฝึกหัด เพิ่มแบบฝึกหัดหรือลดเป้าหมายลง",
  "sparky.lesson_form.target_lowered_one": "ลดเป้าหมายเป็น {{count}} แบบฝึกหัดแล้ว ซึ่งเป็นจำนวนสูงสุดที่บทเรียนนี้กำหนดได้ตอนนี้",
  "sparky.lesson_form.target_lowered_other": "ลดเป้าหมายเป็น {{count}} แบบฝึกหัดแล้ว ซึ่งเป็นจำนวนสูงสุดที่บทเรียนนี้กำหนดได้ตอนนี้",
  "sparky.lesson_form.checkup_all_exercises_one": "ทุกคนทำแบบฝึกหัด {{count}} ข้อ",
  "sparky.lesson_form.checkup_all_exercises_other": "ทุกคนทำแบบฝึกหัดทั้งหมด {{count}} ข้อ",
  "sparky.lesson_form.checkup_all_exercises_grades": "ทุกคนทำแบบฝึกหัดทั้งหมดของระดับชั้นตัวเอง",
  "sparky.lesson_form.students_legend_one": "นักเรียน (เลือกแล้ว {{count}} คน)",
  "sparky.lesson_form.students_legend_other": "นักเรียน (เลือกแล้ว {{count}} คน)",
  "sparky.lesson_form.class": "ชั้นเรียน",
  "sparky.lesson_form.individual_students": "เลือกนักเรียนรายคน",
  "sparky.lesson_form.loading_students": "กำลังโหลดรายชื่อนักเรียน…",
  "sparky.lesson_form.select_all": "เลือกทั้งหมดที่แสดง",
  "sparky.lesson_form.clear_selection": "ล้างการเลือก",
  "sparky.lesson_form.exercises_legend": "กิจกรรมและแบบฝึกหัด",
  "sparky.lesson_form.grade": "ระดับชั้นของแบบฝึกหัด",
  "sparky.lesson_form.grade_auto": "ตามระดับชั้นของนักเรียนแต่ละคน",
  "sparky.lesson_form.course": "กิจกรรม / หลักสูตร",
  "sparky.lesson_form.exercises": "แบบฝึกหัด",
  "sparky.lesson_form.exercises_any": "แบบฝึกหัดใดก็ได้ที่ไม่ซ้ำกันในหลักสูตรนี้",
  "sparky.lesson_form.exercises_selected": "เลือกแบบฝึกหัดที่กำหนด",
  "sparky.lesson_form.catalog_error": "ไม่สามารถโหลดกิจกรรมได้",
  "sparky.lesson_form.explore": "ลองดูแบบฝึกหัดก่อนมอบหมาย",
  "sparky.lesson_form.choose_exercise": "เลือกแบบฝึกหัด",
  "sparky.lesson_form.level_in_chapter": "ด่าน {{level}} · {{chapter}}",
  "sparky.lesson_form.preview_grade": "ระดับชั้นที่จะดูตัวอย่าง",
  "sparky.lesson_form.preview_grade_note": "ระดับชั้นที่ใช้ดูตัวอย่างไม่เปลี่ยนระดับชั้นที่มอบหมายให้นักเรียนแต่ละคน",
  "sparky.lesson_form.assigned_legend_one": "แบบฝึกหัดที่มอบหมาย (เลือกแล้ว {{count}} ข้อ)",
  "sparky.lesson_form.assigned_legend_other": "แบบฝึกหัดที่มอบหมาย (เลือกแล้ว {{count}} ข้อ)",
  "sparky.lesson_form.assigned_hint_one": "เลือกบทหรือด่านรายด่าน นักเรียนต้องทำด่านที่เลือกให้ได้อย่างน้อย {{count}} ด่านที่ไม่ซ้ำกัน ได้กี่ดาวก็ได้",
  "sparky.lesson_form.assigned_hint_other": "เลือกบทหรือด่านรายด่าน นักเรียนต้องทำด่านที่เลือกให้ได้อย่างน้อย {{count}} ด่านที่ไม่ซ้ำกัน ได้กี่ดาวก็ได้",
  "sparky.lesson_form.not_valid": "เลือกหลักสูตรที่มีให้และจำนวนแบบฝึกหัดให้พอกับเป้าหมาย",
  "sparky.lesson_form.save": "บันทึกฉบับร่างบทเรียน",
  "sparky.lesson_form.new": "บทเรียนใหม่",
  "sparky.lesson_form.edit_heading": "แก้ไขบทเรียน",
  "sparky.lesson_form.edit_description": "บทเรียนนี้ยังไม่เริ่ม จึงยังแก้ไขชื่อ นักเรียน แบบฝึกหัด และเป้าหมายได้",
  "sparky.lesson_form.save_changes": "บันทึกการเปลี่ยนแปลง",
  "sparky.lesson_form.loading_lesson": "กำลังโหลดบทเรียน…",
  "sparky.lesson_form.removed_students_one": "นักเรียน {{count}} คนไม่อยู่ในรายชื่อนักเรียนแล้ว จึงถูกนำออกจากบทเรียนนี้",
  "sparky.lesson_form.removed_students_other": "นักเรียน {{count}} คนไม่อยู่ในรายชื่อนักเรียนแล้ว จึงถูกนำออกจากบทเรียนนี้",
  "sparky.assign.to_student": "มอบหมายให้ {{name}}",
  "sparky.assign.to_class": "มอบหมายให้ทั้งชั้น",
  "sparky.assign.student_aria": "มอบหมายให้ {{name}} · ด่าน {{level}}",
  "sparky.assign.class_aria": "มอบหมายให้ทั้งชั้น · ด่าน {{level}}",
  "sparky.assign.title": "{{course}} · ด่าน {{level}} · {{name}}",
  "sparky.assign.heading": "มอบหมายด่านนี้",
  "sparky.assign.description": "บทเรียนจะเริ่มทันทีที่บันทึก นักเรียนทำด่านนี้ให้สำเร็จหนึ่งครั้ง แล้วจึงเลือกกิจกรรมอื่นได้",
  "sparky.assign.summary_one": "ด่าน {{level}} ({{grade}}) สำหรับนักเรียน {{count}} คน",
  "sparky.assign.summary_other": "ด่าน {{level}} ({{grade}}) สำหรับนักเรียน {{count}} คน",
  "sparky.assign.show_details": "แสดงการตั้งค่าบทเรียนทั้งหมด",
  "sparky.assign.save": "มอบหมายและเริ่ม",
  "sparky.lesson_form.error_title_required": "กรอกชื่อบทเรียน",
  "sparky.lesson_form.error_title_length": "ใช้ไม่เกิน 160 ตัวอักษร",
  "sparky.lesson_form.error_target_required": "กรอกจำนวนแบบฝึกหัดที่ต้องทำ",
  "sparky.lesson_form.error_target_whole": "ใช้จำนวนเต็ม",
  "sparky.lesson_form.error_target_min": "ต้องกำหนดอย่างน้อย 1 แบบฝึกหัด",
  "sparky.lesson_form.error_target_max": "กำหนดได้ไม่เกิน 30 แบบฝึกหัด",
  "sparky.lesson_form.error_target_available": "กำหนดได้ไม่เกินจำนวนแบบฝึกหัดที่มี",
  "sparky.lesson_form.error_grade_specific": "เลือกระดับชั้นของแบบฝึกหัดก่อนจึงจะกำหนดแบบฝึกหัดเฉพาะได้",
  "sparky.lesson_form.sitting_screen": "คัดกรอง (ประมาณ {{minutes}} นาที): การประเมินตนเองและข้อหลักข้อแรก ๆ ของแต่ละหัวข้อ",
  "sparky.lesson_form.sitting_extension": "รอบต่อยอด: ข้อหลักที่เหลือและข้อที่ยากขึ้น",
  "sparky.lesson_form.sitting_full": "แบบตรวจสอบเต็ม: ทุกข้อ",
  "sparky.lesson_form.sitting_estimate_one": "{{count}} ข้อ · ประมาณ {{minutes}} นาที",
  "sparky.lesson_form.sitting_estimate_other": "{{count}} ข้อ · ประมาณ {{minutes}} นาที",
  "sparky.lesson_form.stop_early": "หยุดหัวข้อก่อนกำหนดเมื่อคำตอบชัดเจนแล้ว",
  "sparky.lesson_form.stop_early_hint": "เมื่อตอบถูกครั้งแรกสามข้อ จะข้ามข้อหลักที่เหลือของหัวข้อ เมื่อตอบผิดสองข้อ หัวข้อนั้นจะหยุด แบบตรวจสอบเต็มจะปิดตัวเลือกนี้ไว้ เพื่อให้การวิเคราะห์รายข้อเห็นทุกข้อ",
  "sparky.lesson_form.wrong_answer_cost": "ตอบผิดถูกหักคะแนน",
  "sparky.lesson_form.wrong_cost_none": "ไม่หัก",
  "sparky.lesson_form.wrong_cost_half": "0.5 คะแนน",
  "sparky.lesson_form.wrong_cost_one": "1 คะแนน",
  "sparky.test.score": "{{points}} / {{questions}} ({{percent}}%)",
  "sparky.test.whole_score": "{{points}} จาก {{total}} คะแนน ({{percent}}%)",
  "sparky.test.answered_score": "ได้ {{points}} คะแนน จาก {{answered}} ข้อที่ตอบ ({{percent}}%)",
  "sparky.test.right": "ถูก {{n}}",
  "sparky.test.wrong": "ผิด {{n}}",
  "sparky.test.wrong_deduction": "ผิด {{n}} (−{{deduction}})",
  "sparky.test.dont_know_count": "ไม่รู้ {{n}}",
  "sparky.test.not_answered": "ไม่ได้ตอบ {{n}}",
  "sparky.test.dont_know": "{{n}} × ไม่รู้",
  "sparky.test.guessing": "คะแนนไม่ดีไปกว่าการเดา",
  "sparky.test.raw": "คะแนน {{raw}}%",
  "sparky.test.raw_chance": "คะแนน {{raw}}%: การกดมั่วได้ประมาณ {{chance}}%",
  "sparky.test.fast": "ตอบภายใน 3 วินาที {{n}} ข้อ",
  "sparky.test.code_runs_one": "รันโค้ดอย่างเร่งรีบหรือรันซ้ำ {{count}} ครั้ง",
  "sparky.test.code_runs_other": "รันโค้ดอย่างเร่งรีบหรือรันซ้ำ {{count}} ครั้ง",
  "sparky.test.review_skipped": "ข้ามคำอธิบายในการทบทวนคำตอบ",
  "sparky.test.student_score": "คะแนนแบบทดสอบ",
  "sparky.test.class_score": "คะแนนแบบทดสอบของชั้น",
  "sparky.test.class_hint": "{{points}} / {{questions}} คะแนน · นักเรียนที่ทำแบบทดสอบ: {{students}} คน",
  "sparky.test.class_hint_whole": "{{points}} จาก {{total}} คะแนน · ได้ {{points}} คะแนน จาก {{questions}} ข้อที่ตอบ ({{percent}}%) · นักเรียนที่ทำแบบทดสอบ: {{students}}",
  "sparky.test.score_note": "นักเรียนทุกคนได้คะแนนเทียบกับจำนวนข้อทั้งหมดในแบบทดสอบที่ได้รับ ทุกคนจึงมีคะแนนเต็มเท่ากัน ข้อที่ไม่ได้ทำถึงได้ 0 คะแนนและไม่ถูกหักคะแนน ตัวเลขของข้อที่ตอบคือคะแนนเดียวกันเทียบกับจำนวนข้อที่นักเรียนทำถึง คะแนนคิดหลังหักคะแนนสำหรับคำตอบที่ผิดตามที่บทเรียนกำหนด คำตอบ \"ไม่รู้\" ได้ 0 คะแนนและไม่ถูกหักคะแนน คะแนนแบบทดสอบของชั้นรวมคะแนนและคะแนนเต็มของนักเรียนทุกคนที่ทำแบบทดสอบ \"คะแนนไม่ดีไปกว่าการเดา\" หมายถึงคะแนน 40% หรือน้อยกว่าจากข้อที่ตอบ (ก่อนหักคะแนน) โดยมีคำตอบอย่างน้อย 3 ข้อ และอย่างน้อยหนึ่งในสามของคำตอบทั้งหมด ตอบภายใน 3 วินาที หรือนักเรียนรันโค้ดเดิมซ้ำโดยไม่ได้แก้ไข หรือรีบรันใหม่หลังรันไม่สำเร็จโดยแก้เพียงเล็กน้อย รวมอย่างน้อย 3 ครั้งในแบบฝึกเขียนโค้ดของแบบทดสอบ",
  "sparky.test.topic_score": "{{topic}} {{points}}/{{questions}}",
  "sparky.test.pace_one": "{{time}} · ตอบเร็ว {{count}} ข้อ",
  "sparky.test.pace_other": "{{time}} · ตอบเร็ว {{count}} ข้อ",
  "sparky.class_test.region": "ผลแบบทดสอบของชั้น",
  "sparky.class_test.title": "ผลแบบทดสอบของชั้น",
  "sparky.class_test.description": "คะแนนเทียบกับทั้งแบบทดสอบ ของนักเรียน {{tested}} จาก {{total}} คนที่ทำแบบทดสอบ",
  "sparky.class_test.average": "คะแนนเฉลี่ย",
  "sparky.class_test.median": "มัธยฐาน {{percent}}%",
  "sparky.class_test.highest": "คะแนนสูงสุด",
  "sparky.class_test.lowest": "คะแนนต่ำสุด",
  "sparky.class_test.finished": "ทำครบทุกแบบฝึก",
  "sparky.class_test.finished_hint": "นักเรียนที่ทำแบบฝึกในแบบทดสอบครบทุกข้อ",
  "sparky.class_test.guessing_hint_one": "นักเรียนที่ถูกทำเครื่องหมาย {{count}} คน",
  "sparky.class_test.guessing_hint_other": "นักเรียนที่ถูกทำเครื่องหมาย {{count}} คน",
  "sparky.class_test.topics_title": "ความถูกต้องตามหัวข้อ",
  "sparky.class_test.topic_points": "{{points}} จาก {{questions}} คะแนน",
  "sparky.class_test.weakest": "หัวข้อที่อ่อนที่สุด",
  "sparky.class_test.most_missed_title": "ข้อที่ตอบผิดมากที่สุด",
  "sparky.class_test.most_missed_hint": "สามข้อที่มีความถูกต้องของคำตอบแรกต่ำที่สุด จากข้อที่มีนักเรียนตอบอย่างน้อยสองคน",
  "sparky.practice.guess_pauses": "ถูกให้ชะลอเพราะเดา: {{n}} ครั้ง",
  "sparky.practice.run_pauses": "ถูกให้ชะลอเพราะรันโค้ดซ้ำหรือเร่งรีบ: {{n}} ครั้ง",
  "sparky.practice.explanation_locks": "อ่านคำอธิบายเร็วเกินไป: {{n}} ครั้ง (+{{seconds}} วินาที)",
  "sparky.practice.runs": "รันบางส่วน {{partial}} ครั้ง รันไม่สำเร็จ {{failed}} ครั้ง",
  "sparky.practice.repeat_runs_one": "รันโค้ดเดิมซ้ำโดยไม่ได้แก้ไข: {{count}} ครั้ง",
  "sparky.practice.repeat_runs_other": "รันโค้ดเดิมซ้ำโดยไม่ได้แก้ไข: {{count}} ครั้ง",
  "sparky.practice.rushed_runs_one": "รันอย่างเร่งรีบ: {{count}} ครั้ง",
  "sparky.practice.rushed_runs_other": "รันอย่างเร่งรีบ: {{count}} ครั้ง",
  "sparky.practice.refused_moves_one": "การเดินที่เกมไม่ยอมรับ: {{count}} ครั้ง (พยายามเดินแบบที่ไม่อนุญาตซ้ำ ๆ)",
  "sparky.practice.refused_moves_other": "การเดินที่เกมไม่ยอมรับ: {{count}} ครั้ง (พยายามเดินแบบที่ไม่อนุญาตซ้ำ ๆ)",
  "sparky.practice.level_runs": "{{partial}} {{failed}}",
  "sparky.practice.level_partial_one": "รันบางส่วน {{count}} ครั้ง",
  "sparky.practice.level_partial_other": "รันบางส่วน {{count}} ครั้ง",
  "sparky.practice.level_failed_one": "รันไม่สำเร็จ {{count}} ครั้ง",
  "sparky.practice.level_failed_other": "รันไม่สำเร็จ {{count}} ครั้ง",
  "sparky.interaction_event.explanation_lock": "ข้ามคำอธิบายเร็วเกินไป: ล็อก {{seconds}} วินาที",
  "sparky.interaction_event.guess_pause": "ถูกให้ชะลอเพราะเดา: หยุดรอ {{seconds}} วินาที",
  "sparky.interaction_event.run_pause": "ถูกให้ชะลอเพราะรันโค้ดซ้ำหรือเร่งรีบ: หยุดรอ {{seconds}} วินาที",
  "sparky.interaction_event.run_refused": "ไม่อนุญาตให้รัน: โค้ดยังไม่ได้เปลี่ยน",
  "sparky.interaction_event.blocked_locked": "ไม่นับ: คำอธิบายยังล็อกอยู่",
  "sparky.lesson_form.error_sitting_grade": "รอบของแบบตรวจสอบต้องใช้ระดับชั้นเดียว: เลือกระดับชั้น หรือเลือกนักเรียนจากระดับชั้นเดียวกัน",
  "sparky.lesson_form.error_grade_students": "เลือกระดับชั้นของแบบฝึกหัดสำหรับนักเรียนกลุ่มนี้",
  "sparky.lesson_form.error_students_min": "เลือกนักเรียนอย่างน้อยหนึ่งคน",
  "sparky.lesson_form.error_students_max": "เลือกนักเรียนได้ไม่เกิน 500 คน",
  "sparky.lesson_form.error_course_required": "เลือกกิจกรรม",
  "sparky.lesson_form.error_course_available": "เลือกกิจกรรมที่นักเรียนกลุ่มนี้เล่นได้",
  "sparky.lesson_form.error_levels_min": "เลือกแบบฝึกหัดอย่างน้อยหนึ่งข้อ",
  "sparky.lesson_form.add_part": "+ เพิ่มหลักสูตรอื่น",
  "sparky.lesson_form.part_legend": "หลักสูตรที่ {{number}}",
  "sparky.lesson_form.remove_part": "นำหลักสูตรนี้ออก",
  "sparky.lesson_form.parts_hint": "ด่านที่ไม่ซ้ำกันซึ่งทำสำเร็จในหลักสูตรใดก็ได้เหล่านี้จะนับรวมเป็นเป้าหมายเดียวกัน การเล่นซ้ำและการข้ามด่านไม่นับ",
  "sparky.lesson_form.error_part_course_available": "เลือกกิจกรรมอื่นที่นักเรียนกลุ่มนี้เล่นได้ แบบตรวจสอบและหลักสูตรที่มีอยู่ในบทเรียนแล้วเพิ่มไม่ได้",
  "sparky.lesson.status_draft": "เตรียมไว้",
  "sparky.lesson.status_active": "กำลังดำเนินการ",
  "sparky.lesson.status_ended": "จบแล้ว",
  "sparky.lesson.results_caption": "ผลบทเรียนรายนักเรียน",
  "sparky.lesson.col_progress": "ความคืบหน้างานที่มอบหมาย",
  "sparky.lesson.col_score": "คะแนน",
  "sparky.lesson.col_activity": "กิจกรรมและเวลา",
  "sparky.lesson.col_evidence": "หลักฐานการเรียนรู้",
  "sparky.lesson.progress_label": "ความคืบหน้างานที่มอบหมายของ {{name}}",
  "sparky.lesson.on_level": "อยู่ในด่าน {{time}}",
  "sparky.lesson.active_visits_one": "ใช้งาน {{time}} · เข้าเล่น {{count}} ครั้ง",
  "sparky.lesson.active_visits_other": "ใช้งาน {{time}} · เข้าเล่น {{count}} ครั้ง",
  "sparky.lesson.selected_students": "นักเรียนที่เลือก",
  "sparky.lesson.required_count_one": "ต้องทำ {{count}} แบบฝึกหัดที่ไม่ซ้ำกัน",
  "sparky.lesson.required_count_other": "ต้องทำ {{count}} แบบฝึกหัดที่ไม่ซ้ำกัน",
  "sparky.lesson.all_exercises": "ทุกแบบฝึกหัด",
  "sparky.lesson.no_answers_yet": "ยังไม่มีคำตอบ",
  "sparky.lesson.started_at": "เริ่ม {{date}}",
  "sparky.lesson.draft_hint": "ฉบับร่าง · เริ่มบทเรียนเมื่อชั้นเรียนพร้อม",
  "sparky.lesson.ended_at": "จบ {{date}}",
  "sparky.lesson.export": "ส่งออกรายงานบทเรียนเป็น CSV",
  "sparky.lesson.any_exercises": "แบบฝึกหัดใดก็ได้ในหลักสูตรนี้",
  "sparky.lesson.updating": "กำลังอัปเดต…",
  "sparky.lesson.start": "เริ่มบทเรียน",
  "sparky.lesson.end": "จบบทเรียน",
  "sparky.lesson.edit": "แก้ไขบทเรียน",
  "sparky.lesson.delete": "ลบบทเรียน",
  "sparky.lesson.delete_title": "ลบบทเรียนนี้หรือไม่",
  "sparky.lesson.delete_description": "“{{title}}” ยังไม่เริ่ม การลบจะลบฉบับร่างและรายชื่อนักเรียนของบทเรียนนี้ และไม่สามารถย้อนกลับได้",
  "sparky.lesson.deleted": "ลบบทเรียนแล้ว",
  "sparky.lesson.showing_students": "แสดง {{shown}} จาก {{total}} คน",
  "sparky.lesson.no_group_students": "ไม่มีนักเรียนในกลุ่มนี้",
  "sparky.lesson.stat_target": "เป้าหมายงานที่มอบหมาย",
  "sparky.lesson.of_students": "{{met}} จาก {{total}}",
  "sparky.lesson.stat_target_hint": "ทำเสร็จ {{done}} จาก {{total}} ที่กำหนด",
  "sparky.lesson.stat_exercise_score": "คะแนนแบบฝึกหัด",
  "sparky.lesson.stat_class_score": "คะแนนของชั้น",
  "sparky.lesson.stat_score_hint": "ดาวสูงสุดของแบบฝึกหัดที่มอบหมายซึ่งทำเสร็จแล้ว",
  "sparky.lesson.stat_active": "เวลาใช้งาน",
  "sparky.lesson.stat_active_hint": "เวลาเล่นที่บันทึกระหว่างบทเรียนนี้",
  "sparky.lesson.stat_improved": "แบบฝึกหัดที่ทำได้ดีขึ้น",
  "sparky.lesson.stat_improved_hint": "ได้ดาวมากขึ้นเมื่อทำเสร็จครั้งหลัง",
  "sparky.lesson.student_results": "ผลของนักเรียน",
  "sparky.lesson.how_calculated": "การทำเสร็จนับแต่ละด่านที่มอบหมายที่ไม่ซ้ำกันครั้งเดียว ได้กี่ดาวก็ได้ คะแนนใช้ดาวสูงสุดของแต่ละด่านที่มอบหมายซึ่งทำเสร็จ (ด่านละ 3 ดาว) กิจกรรมอื่นไม่นับรวมในเป้าหมายหรือคะแนน เวลาใช้งานไม่รวมช่วงหยุดและแท็บที่ซ่อนอยู่ ผลของบทเรียนที่จบแล้วจะคงที่ ข้อผิดพลาดที่บันทึกไว้อธิบายผลในเกม ไม่ใช่การวินิจฉัย",
  "sparky.lesson.loading_report": "กำลังโหลดรายงานบทเรียน…",
  "sparky.lesson.report_unavailable": "ไม่สามารถแสดงรายงานบทเรียนได้",
  "sparky.lesson.updates_unavailable": "ไม่สามารถอัปเดตรายงานแบบสดได้",
  "sparky.lesson.report_region": "รายงานบทเรียน",
  "sparky.lesson.first_to_best": "ครั้งแรก {{first}} ดาว ดีที่สุด {{best}} ดาวหลังเล่นซ้ำ",
  "sparky.lesson.level_results": "ผลรายด่านและความก้าวหน้า",
  "sparky.lesson.details_title": "{{name}} · ผลแบบฝึกหัดในบทเรียน",
  "sparky.lesson.details_description": "{{lesson}} · สิ่งที่บันทึกไว้ระหว่างบทเรียนนี้ ทีละแบบฝึกหัด",
  "sparky.lesson.target_label": "เป้าหมายบทเรียนของ {{name}}",
  "sparky.lesson.assignment_score": "คะแนนงานที่มอบหมาย",
  "sparky.lesson.assigned_exercises": "แบบฝึกหัดที่มอบหมาย",
  "sparky.lesson.none_attempted": "ยังไม่มีการทำแบบฝึกหัดที่มอบหมาย",
  "sparky.lesson.other_activities": "กิจกรรมอื่น",
  "sparky.lesson.other_not_counted": "กิจกรรมเหล่านี้ไม่นับรวมในเป้าหมายหรือคะแนนของงานที่มอบหมาย",
  "sparky.lesson.attempts": "ความพยายามตามลำดับ",
  "sparky.lesson.attempt_n": "ครั้งที่ {{n}}",
  "sparky.lesson.attempts_loading": "กำลังโหลดความพยายาม…",
  "sparky.lesson.attempts_unavailable": "ไม่สามารถแสดงรายละเอียดความพยายามได้ในขณะนี้",
  "sparky.lesson.attempts_none": "ไม่มีความพยายามที่บันทึกไว้ในบทเรียนนี้",
  "sparky.lesson.open_history": "ประวัติกิจกรรมทั้งหมด",
  "sparky.lesson.assigned_levels": "ด่านที่มอบหมาย: {{levels}}",
  "sparky.lessons.list_hint": "แสดงบทเรียนที่กำลังดำเนินอยู่ทั้งหมด มุมมองอื่นแสดงได้สูงสุด 100 บทเรียน โดยบทเรียนที่กำลังดำเนินอยู่แสดงก่อน เลือกบทเรียนเพื่อดูผลของนักเรียนทุกคน",
  "sparky.lessons.loading": "กำลังโหลดบทเรียน…",
  "sparky.lessons.refresh_failed": "ไม่สามารถรีเฟรชบทเรียนได้",
  "sparky.lessons.caption": "บทเรียน",
  "sparky.lessons.col_lesson": "บทเรียน",
  "sparky.lessons.col_activity": "กิจกรรม",
  "sparky.lessons.col_target": "เป้าหมาย",
  "sparky.lessons.empty": "ไม่มีบทเรียนในมุมมองนี้",
  "sparky.lessons.status_filter": "บทเรียน",
  "sparky.lessons.status_active": "กำลังดำเนินอยู่",
  "sparky.lessons.status_draft": "เตรียมไว้แล้ว",
  "sparky.lessons.status_ended": "สิ้นสุดแล้ว",
  "sparky.lessons.status_all": "ทั้งหมด",
  "sparky.lessons.running_long_one": "ดำเนินมาแล้ว {{count}} วัน — สิ้นสุดบทเรียนนี้หรือไม่?",
  "sparky.lessons.running_long_other": "ดำเนินมาแล้ว {{count}} วัน — สิ้นสุดบทเรียนนี้หรือไม่?",
  "sparky.cohort.not_started": "ยังไม่เริ่ม",
  "sparky.cohort.below_target": "ต่ำกว่าเป้าหมาย",
  "sparky.cohort.working": "กำลังทำให้ถึงเป้าหมาย",
  "sparky.cohort.met_target": "ถึงเป้าหมายแล้ว",
  "sparky.cohort.improved": "ดีขึ้นเมื่อเล่นซ้ำ",
  "sparky.cohort.region": "ข้อมูลเชิงลึกของบทเรียนในชั้นเรียน",
  "sparky.cohort.empty": "ไม่มีนักเรียนในกลุ่มนี้",
  "sparky.cohort.results_description": "ดูว่าใครพร้อมไปต่อและใครควรได้รับการติดตาม เลือกกลุ่มด้านบนเพื่อเน้นรายงาน",
  "sparky.cohort.all_count_one": "นักเรียนทั้งหมด ({{count}})",
  "sparky.cohort.all_count_other": "นักเรียนทั้งหมด ({{count}})",
  "sparky.cohort.review_title": "แบบฝึกหัดที่ควรทบทวนกับชั้นเรียน",
  "sparky.cohort.review_description": "เริ่มจากแบบฝึกหัดที่นักเรียนตอบถูกในครั้งแรกน้อยที่สุด ตามด้วยแบบฝึกหัดที่ผิดมากที่สุด รวมเฉพาะแบบฝึกหัดที่มอบหมาย",
  "sparky.cohort.to_review_one": "ควรทบทวน {{count}} ข้อ",
  "sparky.cohort.to_review_other": "ควรทบทวน {{count}} ข้อ",
  "sparky.cohort.review_caption": "แบบฝึกหัดที่มอบหมายซึ่งควรทบทวน",
  "sparky.cohort.col_exercise": "แบบฝึกหัด",
  "sparky.cohort.col_students": "นักเรียนและข้อผิดพลาด",
  "sparky.cohort.col_results": "ผลลัพธ์",
  "sparky.cohort.col_error_types": "ประเภทข้อผิดพลาด",
  "sparky.cohort.affected": "{{affected}} จาก {{tried}} คนที่ลองทำ",
  "sparky.cohort.completed_of": "ทำเสร็จ {{completed}} จาก {{tried}} คน",
  "sparky.cohort.students_improved_one": "นักเรียน {{count}} คนทำได้ดีขึ้น",
  "sparky.cohort.students_improved_other": "นักเรียน {{count}} คนทำได้ดีขึ้น",
  "sparky.cohort.none_flagged": "ไม่มีแบบฝึกหัดที่ต้องทบทวน",
  "sparky.cohort.none_flagged_hint": "ยังไม่มีข้อผิดพลาด การขอความช่วยเหลือ หรือการลองใหม่ในแบบฝึกหัดที่มอบหมาย",
  "sparky.items.none": "ไม่มีการตอบคำถามในแบบตรวจสอบในช่วงนี้",
  "sparky.items.title": "การวิเคราะห์รายข้อ",
  "sparky.items.description": "คำถามทุกข้อในแบบตรวจสอบของทั้งชั้น เรียงจากข้อที่ยากที่สุด: มีกี่คนที่ตอบถูกในครั้งแรก และนักเรียนเลือกตัวเลือกผิดข้อใด เริ่มสอนซ้ำจากข้อที่นักเรียนส่วนใหญ่ตอบผิด",
  "sparky.items.caption": "คำถามในแบบตรวจสอบตามความถูกต้องของคำตอบครั้งแรก",
  "sparky.items.export": "ส่งออกรายข้อ",
  "sparky.items.col_question": "คำถาม",
  "sparky.items.col_first": "ตอบถูกในครั้งแรก",
  "sparky.items.col_wrong": "คำตอบผิดที่เลือก",
  "sparky.items.first_of": "{{correct}} จาก {{answered}} คน",
  "sparky.items.assisted_one": "{{count}} คนตอบหลังได้รับความช่วยเหลือหรือเริ่มใหม่",
  "sparky.items.assisted_other": "{{count}} คนตอบหลังได้รับความช่วยเหลือหรือเริ่มใหม่",
  "sparky.items.chosen_by_one": "เลือกโดย {{count}} คน",
  "sparky.items.chosen_by_other": "เลือกโดย {{count}} คน",
  "sparky.items.unrecorded_one": "คำตอบผิด {{count}} ครั้งที่ไม่ได้บันทึกตัวเลือก",
  "sparky.items.unrecorded_other": "คำตอบผิด {{count}} ครั้งที่ไม่ได้บันทึกตัวเลือก",
  "sparky.items.no_wrong": "ไม่มีคำตอบผิดในครั้งแรก",
  "sparky.items.flag_everyone": "ทุกคนทำได้",
  "sparky.items.flag_most_miss": "ส่วนใหญ่ตอบผิด",
  "sparky.items.flag_hint": "จะทำเครื่องหมายคำถามเมื่อมีนักเรียนตอบอย่างน้อย 5 คนเท่านั้น “ทุกคนทำได้” หมายถึงตอบถูกในครั้งแรกมากกว่า 95% ส่วน “ส่วนใหญ่ตอบผิด” หมายถึงน้อยกว่า 20%",
  "sparky.items.csv_answered": "จำนวนคำตอบครั้งแรก",
  "sparky.items.csv_assisted": "คำตอบครั้งแรกหลังได้รับความช่วยเหลือ",
  "sparky.items.csv_percent": "ความถูกต้องของคำตอบครั้งแรก %",
  "sparky.items.csv_flag": "เครื่องหมาย",
  "sparky.window.school_year": "ปีการศึกษา {{name}}",
  "sparky.window.range": "{{from}} – {{to}}",
  "sparky.window.since": "ตั้งแต่ {{from}}",
  "sparky.window.until": "จนถึง {{to}}",
  "sparky.window.all": "ประวัติทั้งหมดที่บันทึกไว้",
  "sparky.window.counted": "ช่วงที่นับคำตอบครั้งแรก: {{window}}",
  "sparky.window.picker_label": "ช่วงข้อมูลที่นับ",
  "sparky.window.custom": "กำหนดวันที่เอง",
  "sparky.window.apply": "ใช้วันที่นี้",
  "sparky.window.reset": "กลับเป็นค่าเริ่มต้น",
  "sparky.window.from_required": "เลือกวันเริ่มต้น",
  "sparky.window.to_required": "เลือกวันสิ้นสุด",
  "sparky.window.order": "วันเริ่มต้นต้องไม่เกินวันสิ้นสุด",
  "sparky.window.invalid_link": "วันที่ในลิงก์นี้ไม่ถูกต้อง จึงแสดงช่วงเริ่มต้นแทน",
  "sparky.window.unavailable": "ใช้วันที่เหล่านี้ไม่ได้: {{message}}",
  "sparky.growth.title": "พัฒนาการจากแบบตรวจสอบ",
  "sparky.growth.description": "ความถูกต้องของคำตอบครั้งแรกในแต่ละหัวข้อ: ปีการศึกษาแรกที่วัดหัวข้อนั้น เทียบกับช่วงปัจจุบัน ({{window}}) แต่ละปีการศึกษานับคำตอบครั้งแรกแยกกัน คำถามที่เคยทำเมื่อปีที่แล้วจึงนับเป็นคำตอบครั้งแรกใหม่ในปีนี้",
  "sparky.growth.caption": "หัวข้อในแบบตรวจสอบ ผลเริ่มต้นและผลล่าสุด",
  "sparky.growth.col_topic": "หัวข้อ",
  "sparky.growth.col_baseline": "ผลเริ่มต้น",
  "sparky.growth.col_latest": "ผลล่าสุด",
  "sparky.growth.col_change": "การเปลี่ยนแปลง",
  "sparky.growth.measure": "ตอบถูกครั้งแรก {{correct}}/{{answered}} ข้อ · {{score}}%",
  "sparky.growth.change": "{{change}} จุด",
  "sparky.growth.note": "แต่ละหัวข้อวัดด้วยคำถามเพียงไม่กี่ข้อ ผลจึงอาจเปลี่ยนแปลงได้มาก ควรเทียบกับงานในชั้นเรียนก่อนสรุปผล",
  "sparky.snapshot.remaining_one": "เหลืออีก {{count}} แบบฝึกหัดที่ต้องทำ",
  "sparky.snapshot.remaining_other": "เหลืออีก {{count}} แบบฝึกหัดที่ต้องทำ",
  "sparky.snapshot.not_met_one": "ไม่ถึงเป้าหมาย · เหลือแบบฝึกหัดที่ต้องทำ {{count}} ข้อ",
  "sparky.snapshot.not_met_other": "ไม่ถึงเป้าหมาย · เหลือแบบฝึกหัดที่ต้องทำ {{count}} ข้อ",
  "sparky.snapshot.met": "ถึงเป้าหมายแล้ว",
  "sparky.snapshot.current": "งานที่มอบหมายปัจจุบัน",
  "sparky.snapshot.latest": "บทเรียนล่าสุด",
  "sparky.snapshot.loading": "กำลังโหลดผลบทเรียน…",
  "sparky.snapshot.unavailable": "ไม่สามารถอัปเดตบทเรียนได้",
  "sparky.snapshot.course_only": "{{course}} · ผลเฉพาะบทเรียนนี้",
  "sparky.snapshot.required": "แบบฝึกหัดที่ต้องทำ",
  "sparky.snapshot.score": "คะแนน",
  "sparky.snapshot.progress_label": "ความคืบหน้าในการทำบทเรียน",
  "sparky.snapshot.none": "ยังไม่มีบทเรียนที่เริ่มแล้ว เตรียมบทเรียนได้ที่แท็บบทเรียน",
  "sparky.snapshot.open": "ดูผลและประวัติบทเรียน",
  "sparky.student_lessons.title": "งานที่มอบหมายและประวัติบทเรียน",
  "sparky.student_lessons.description": "รายงานบทเรียนครอบคลุมแบบฝึกหัดที่มอบหมาย ไม่ขึ้นกับช่วงวันที่ของรายงานการเรียนรู้",
  "sparky.student_lessons.select_label": "บทเรียนของนักเรียน",
  "sparky.student_lessons.empty": "ยังไม่มีงานที่มอบหมาย",
  "sparky.recovery.title": "การฟื้นตัวและพัฒนาการ",
  "sparky.recovery.description": "ดูว่ามีอะไรเปลี่ยนไปหลังความพยายามที่ยาก การเปรียบเทียบใช้การเข้าเล่นภายในช่วงที่เลือก",
  "sparky.recovery.export": "ส่งออกข้อมูลการฟื้นตัว",
  "sparky.recovery.finished_after_mistakes": "ทำเสร็จหลังทำผิด",
  "sparky.recovery.finished_after_mistakes_hint": "การเข้าเล่นที่ทำเสร็จแม้เคยตอบผิดก่อนหน้า",
  "sparky.recovery.independent_after_help": "ทำได้เองหลังได้รับความช่วยเหลือ",
  "sparky.recovery.independent_after_help_hint": "ด่านที่ทำเสร็จโดยไม่ผิด ไม่ขอความช่วยเหลือ และไม่ลองใหม่ หลังจากเคยได้รับความช่วยเหลือ",
  "sparky.recovery.improved_on_replay": "ดีขึ้นเมื่อเล่นซ้ำ",
  "sparky.recovery.improved_on_replay_hint": "ด่านที่ได้ดาวมากกว่าครั้งแรกที่ทำเสร็จ",
  "sparky.recovery.stars_change": "{{first}} → {{best}} ดาว",
  "sparky.recovery.empty": "ไฮไลต์การฟื้นตัวจะแสดงเมื่อนักเรียนทำเสร็จหลังทำผิด หรือทำได้ดีขึ้นในครั้งต่อมา",
  "sparky.recovery.more_one": "มีอีก {{count}} ด่านที่ดีขึ้น ดูทุกด่านได้ในทักษะและแบบฝึกหัด",
  "sparky.recovery.more_other": "มีอีก {{count}} ด่านที่ดีขึ้น ดูทุกด่านได้ในทักษะและแบบฝึกหัด",
  "sparky.chart.title": "ความก้าวหน้าตามช่วงเวลา",
  "sparky.chart.description": "ผลรายวันตามวันเรียน",
  "sparky.chart.metric": "ตัวชี้วัดของกราฟความก้าวหน้า",
  "sparky.chart.option_completed_levels": "ด่านที่ทำเสร็จ",
  "sparky.chart.option_score": "คะแนน",
  "sparky.chart.option_minutes": "เวลาใช้งาน",
  "sparky.chart.label_completed_levels": "ด่านที่ทำเสร็จ (ไม่ซ้ำกัน)",
  "sparky.chart.label_score": "คะแนนการทำเสร็จ (%)",
  "sparky.chart.label_minutes": "นาทีที่ใช้งาน",
  "sparky.chart.hint_completed_levels": "แต่ละด่านนับครั้งเดียวต่อวัน การเล่นซ้ำในวันอื่นอาจนับอีกครั้ง",
  "sparky.chart.hint_score": "คะแนนรวมทุกครั้งที่ทำเสร็จในวันนั้น รวมถึงการเล่นซ้ำ วันที่ไม่มีการทำเสร็จจะไม่มีคะแนน",
  "sparky.chart.hint_minutes": "เวลาใช้งานไม่รวมแท็บที่ซ่อนอยู่ ช่วงหยุด และช่วงที่ไม่มีการใช้งาน",
  "sparky.chart.aria": "{{label}} ตามวันเรียน",
  "sparky.chart.days_played_one": "มีการเล่นที่บันทึกไว้ {{count}} วัน",
  "sparky.chart.days_played_other": "มีการเล่นที่บันทึกไว้ {{count}} วัน",
  "sparky.chart.empty": "ความก้าวหน้ารายวันจะแสดงหลังมีการเล่นที่บันทึกไว้",
  "sparky.skills.levels_active_one": "ทำเสร็จ {{count}} ด่าน · ใช้งาน {{time}}",
  "sparky.skills.levels_active_other": "ทำเสร็จ {{count}} ด่าน · ใช้งาน {{time}}",
  "sparky.skills.exercises_title": "แบบฝึกหัดและคะแนน",
  "sparky.skills.exercises_description": "ทุกด่านที่เข้าเล่นในช่วงนี้ เลือกด่านเพื่อดูผลและหลักฐานการเรียนรู้",
  "sparky.skills.course_totals": "ทำเสร็จ {{completed}}/{{visited}} ด่านที่เข้าเล่น · {{earned}}/{{possible}} ดาว",
  "sparky.skills.level_button": "{{course}} {{grade}} ด่าน {{level}}: {{result}}",
  "sparky.skills.empty": "ไม่มีแบบฝึกหัดที่เข้าเล่นในช่วงนี้",
  "sparky.skills.selected_region": "รายละเอียดแบบฝึกหัดที่เลือก",
  "sparky.skills.best_result": "ผลดีที่สุด",
  "sparky.skills.no_completion": "ยังไม่ได้ทำเสร็จ",
  "sparky.skills.first_completion": "ทำเสร็จครั้งแรก: {{stars}}/3 ดาว",
  "sparky.skills.level_visits_one": "เข้าเล่นด่านนี้ {{count}} ครั้ง",
  "sparky.skills.level_visits_other": "เข้าเล่นด่านนี้ {{count}} ครั้ง",
  "sparky.skills.completions": "จำนวนครั้งที่ทำเสร็จ",
  "sparky.skills.skipped_visits_one": "ข้าม {{count}} ครั้ง",
  "sparky.skills.skipped_visits_other": "ข้าม {{count}} ครั้ง",
  "sparky.history.title": "ประวัติกิจกรรม",
  "sparky.history.description": "การเข้าเล่นล่าสุด {{limit}} ครั้งในช่วงนี้ ภาพรวมและยอดรายวันรวมการเข้าเล่นทั้งหมด {{count}} ครั้ง",
  "sparky.history.result": "ผลลัพธ์",
  "sparky.history.all_results": "ผลลัพธ์ทั้งหมด",
  "sparky.history.outcome_completed": "ทำเสร็จ",
  "sparky.history.outcome_skipped": "ข้ามไป",
  "sparky.history.outcome_unfinished": "ยังไม่เสร็จ",
  "sparky.history.caption": "ประวัติกิจกรรมล่าสุดของนักเรียน",
  "sparky.history.col_started": "เริ่ม",
  "sparky.history.col_exercise": "แบบฝึกหัด",
  "sparky.history.col_evidence": "หลักฐาน",
  "sparky.history.error_details": "รายละเอียดข้อผิดพลาด",
  "sparky.history.empty": "ไม่มีการเข้าเล่นที่ตรงกับตัวกรองนี้",
  "sparky.overview.next_title": "สิ่งที่ควรฝึกต่อไป",
  "sparky.overview.review_together": "ทบทวนด้วยกัน",
  "sparky.overview.keep_going": "ทำต่อไป",
  "sparky.overview.across_visits_one": "จากการเข้าเล่น {{count}} ครั้ง",
  "sparky.overview.across_visits_other": "จากการเข้าเล่น {{count}} ครั้ง",
  "sparky.overview.no_signals": "ไม่มีสัญญาณที่ควรฝึกเพิ่มในช่วงนี้ ให้แบบฝึกหัดถัดไปแล้วสังเกตวิธีแก้โจทย์",
  "sparky.overview.start_lesson": "เริ่มบทเรียนเพื่อดูความสำเร็จและการฝึกที่แนะนำที่นี่",
  "sparky.overview.more_skills_one": "มีอีก {{count}} ทักษะที่ควรทบทวน",
  "sparky.overview.more_skills_other": "มีอีก {{count}} ทักษะที่ควรทบทวน",
  "sparky.overview.explore_skills": "ดูทักษะและแบบฝึกหัด",
  "sparky.overview.achievements_title": "ความสำเร็จตามกิจกรรม",
  "sparky.overview.completed_count_one": "ทำเสร็จ {{count}}",
  "sparky.overview.completed_count_other": "ทำเสร็จ {{count}}",
  "sparky.overview.no_score": "ยังไม่มีคะแนน",
  "sparky.overview.score_percent": "คะแนน {{score}}%",
  "sparky.overview.visited_completed_label": "{{course}}: ด่านที่เข้าเล่นซึ่งทำเสร็จ",
  "sparky.overview.visited_completed": "ทำเสร็จ {{completed}} จาก {{total}} ด่านที่เข้าเล่น",
  "sparky.overview.course_line": "ได้ 3 ดาว {{threeStars}} ครั้ง · ดีขึ้น {{improved}} ด่าน · เข้าเล่น {{visited}} ด่าน",
  "sparky.overview.no_play": "ไม่มีการเล่นที่บันทึกไว้ในช่วงวันที่นี้",
  "sparky.overview.mistakes_title": "ประเภทของข้อผิดพลาด",
  "sparky.overview.checkups_title": "ผลแบบทดสอบ",
  "sparky.overview.mistakes_description": "ผลในเกมและคำตอบที่บันทึกไว้ในช่วงนี้ ตัวอย่างแสดงครั้งล่าสุดของแต่ละประเภท",
  "sparky.overview.footnote": "คำแนะนำการฝึกใช้ข้อผิดพลาด การขอความช่วยเหลือ การลองใหม่ และดาวที่บันทึกไว้ “ควรฝึกเพิ่ม” ต้องมีหลักฐานซ้ำจากการเข้าเล่นอย่างน้อยสองครั้ง เวลาอย่างเดียวไม่ได้บ่งบอกความยาก คะแนนแบบฝึกหัดใช้เฉพาะด่านที่ทำเสร็จ ด่านที่ยังไม่เสร็จแสดงอยู่ในทักษะและแบบฝึกหัด",
  "sparky.report.region": "รายงานการเรียนรู้ของนักเรียน",
  "sparky.report.eyebrow": "รายงานการเรียนรู้ Sparky",
  "sparky.report.loading": "กำลังโหลดรายงาน…",
  "sparky.report.unavailable": "ไม่สามารถอัปเดตรายงานได้",
  "sparky.report.stat_completed": "แบบฝึกหัดที่ทำเสร็จ",
  "sparky.report.stat_completed_hint": "ได้ 3 ดาว {{threeStars}} · ดีขึ้นหลังเล่นซ้ำ {{improved}}",
  "sparky.report.stat_score_hint": "{{earned}}/{{possible}} ดาว · ผลดีที่สุดของแต่ละด่านที่ทำเสร็จ",
  "sparky.report.stat_score_empty": "ทำด่านให้เสร็จเพื่อรับคะแนน",
  "sparky.report.stat_active_hint": "เข้าเล่น {{visits}} ครั้ง · เล่น {{days}} วัน",
  "sparky.report.stat_review": "ทักษะที่ควรทบทวน",
  "sparky.report.stat_review_hint_one": "{{count}} ทักษะมีสัญญาณควรฝึกเพิ่มซ้ำ ๆ",
  "sparky.report.stat_review_hint_other": "{{count}} ทักษะมีสัญญาณควรฝึกเพิ่มซ้ำ ๆ",
  "sparky.report.tab_overview": "ภาพรวม",
  "sparky.report.tab_skills": "ทักษะและแบบฝึกหัด",
  "sparky.report.tab_lessons": "บทเรียน",
  "sparky.report.tab_history": "ประวัติกิจกรรม",
  "sparky.report.tabs_label": "มุมมองรายงานนักเรียน",
  "sparky.mastery.caption": "ผลของนักเรียนตามหัวข้อ · {{course}} · {{grade}}",
  "sparky.mastery.chapter_levels_one": "{{count}} ด่าน · {{topic}}",
  "sparky.mastery.chapter_levels_other": "{{count}} ด่าน · {{topic}}",
  "sparky.mastery.cell_label": "{{name}}: {{topic}} ทำเสร็จ {{completed}} จาก {{total}}",
  "sparky.mastery.active_view": "ใช้งาน {{time}} · ดูแบบฝึกหัด",
  "sparky.mastery.not_started_view": "ยังไม่เริ่ม · ดูแบบฝึกหัด",
  "sparky.mastery.unavailable_cell": "ไม่มีผล",
  "sparky.mastery.topic_progress": "ความก้าวหน้าตามหัวข้อ",
  "sparky.mastery.level_visits_one": "เข้าเล่น {{count}} ครั้ง · ใช้งาน {{time}}",
  "sparky.mastery.level_visits_other": "เข้าเล่น {{count}} ครั้ง · ใช้งาน {{time}}",
  "sparky.mastery.close_topic": "ปิดหัวข้อ",
  "sparky.mastery.title": "ความเชี่ยวชาญตามหัวข้อของชั้นเรียน",
  "sparky.mastery.description": "เปรียบเทียบสิ่งที่นักเรียนทำเสร็จ ผลดาวที่ดีที่สุด และจุดที่ควรให้ฝึกเพิ่ม แต่ละด่านนับครั้งเดียวในช่วงที่เลือก",
  "sparky.mastery.loading": "กำลังโหลดผลตามหัวข้อ…",
  "sparky.mastery.unavailable": "ไม่สามารถแสดงผลตามหัวข้อได้",
  "sparky.mastery.stat_started": "นักเรียนที่เริ่มแล้ว",
  "sparky.mastery.stat_three_stars": "ด่านที่ได้ 3 ดาว",
  "sparky.mastery.stat_needs_practice": "หัวข้อที่ควรฝึกเพิ่ม",
  "sparky.mastery.show_not_started_one": "แสดงนักเรียนที่ยังไม่เริ่ม {{count}} คน",
  "sparky.mastery.show_not_started_other": "แสดงนักเรียนที่ยังไม่เริ่ม {{count}} คน",
  "sparky.mastery.hide_not_started": "เฉพาะนักเรียนที่เริ่มแล้ว",
  "sparky.mastery.nobody_started": "ยังไม่มีนักเรียนเล่นกิจกรรมนี้ในช่วงเวลานี้",
  "sparky.mastery.export": "ส่งออกผลตามหัวข้อเป็น CSV",
  "sparky.mastery.footer": "เลือกช่องหัวข้อเพื่อดูแบบฝึกหัด ดาวแสดงผลที่บันทึกไว้ “ควรฝึกเพิ่ม” ต้องมีหลักฐานความยากจากการเข้าเล่นอย่างน้อยสองครั้ง",
  "sparky.behavior.title": "กฎนี้ทำงานอย่างไร",
  "sparky.behavior.description": "เปรียบเทียบข้อสังเกตตามระดับชั้นของแบบฝึกหัดและกิจกรรม แล้วใช้ผลการทบทวนของครูตรวจสอบว่าสัญญาณมีประโยชน์หรือไม่",
  "sparky.behavior.current_rule": "เกณฑ์ปัจจุบัน",
  "sparky.behavior.rule": "ตอบติดกัน {{answers}} ข้อ แต่ละข้อภายใน {{seconds}} วินาที ผิดอย่างน้อย {{wrong}} ข้อ ภายใน {{window}} วินาที ในกิจกรรม ทักษะ และระดับชั้นเดียวกัน",
  "sparky.behavior.rule_note": "คำตอบที่ถูกแม้ตอบเร็วจะไม่ถูกตั้งข้อสังเกต การขอความช่วยเหลือ การหยุด และการตอบช้าลงจะตัดรูปแบบนี้ การทบทวนไม่เปลี่ยนคะแนนนักเรียนและไม่เปลี่ยนเกณฑ์เหล่านี้โดยอัตโนมัติ",
  "sparky.behavior.loading": "กำลังโหลดหลักฐานของเกณฑ์…",
  "sparky.behavior.unavailable": "ไม่สามารถโหลดหลักฐานของเกณฑ์ได้",
  "sparky.behavior.groups_count_one": "{{count}} กิจกรรมและทักษะ",
  "sparky.behavior.groups_count_other": "{{count}} กิจกรรมและทักษะ",
  "sparky.behavior.export": "ส่งออกหลักฐานของเกณฑ์",
  "sparky.behavior.caption": "หลักฐานการตอบเร็วเกินไปตามกิจกรรม ทักษะ และระดับชั้นของแบบฝึกหัด",
  "sparky.behavior.col_activity": "กิจกรรม / ระดับชั้นของแบบฝึกหัด",
  "sparky.behavior.col_timed": "คำตอบที่จับเวลา",
  "sparky.behavior.col_patterns": "รูปแบบการตอบเร็วเกินไป",
  "sparky.behavior.col_median": "ค่ามัธยฐานเวลาตอบ",
  "sparky.behavior.col_reviews": "การทบทวนของคุณ",
  "sparky.behavior.timed_visits": "จับเวลา {{timed}} ครั้ง / เข้าเล่น {{visits}} ครั้ง",
  "sparky.behavior.patterns_hint": "ทบทวนหลักฐานก่อนสรุปว่าเป็นการเดา",
  "sparky.behavior.seconds": "{{value}} วินาที",
  "sparky.behavior.sampled_one": "สุ่มจากคำตอบที่เก็บไว้ {{count}} ข้อ",
  "sparky.behavior.sampled_other": "สุ่มจากคำตอบที่เก็บไว้ {{count}} ข้อ",
  "sparky.behavior.reviews": "ต้องการความช่วยเหลือ {{support}} · ไม่น่ากังวล {{fine}}",
  "sparky.behavior.acknowledged_one": "รับทราบแล้ว {{count}} · เฉพาะข้อสังเกตการตอบเร็วปัจจุบัน",
  "sparky.behavior.acknowledged_other": "รับทราบแล้ว {{count}} · เฉพาะข้อสังเกตการตอบเร็วปัจจุบัน",
  "sparky.behavior.empty": "เล่นบทเรียนเพื่อเก็บหลักฐานในชั้นเรียน เวลาตอบก่อนหน้านี้ไม่สามารถสร้างขึ้นใหม่ได้",
  "sparky.behavior.sample_note": "ยอดรวมคำตอบและรูปแบบครอบคลุมทั้งช่วงที่เลือก ค่ามัธยฐานเวลาตอบใช้เหตุการณ์คำตอบที่เก็บไว้จากการเข้าเล่นที่จับเวลาล่าสุด {{sampled}} ครั้ง (สูงสุด {{limit}}) แต่ละการเข้าเล่นเก็บเหตุการณ์การโต้ตอบล่าสุด 60 รายการ ตัวอย่างนี้อาจไม่รวมคำตอบก่อนหน้า จำนวนการทบทวนเป็นศูนย์หมายความว่าคุณยังไม่ได้ทบทวนข้อสังเกตปัจจุบัน",
  "sparky.behavior.how_to_use": "ระหว่างบทเรียน ให้นักเรียนที่ถูกตั้งข้อสังเกตอธิบายคำตอบ ใช้ “ต้องการความช่วยเหลือ” หรือ “ไม่น่ากังวล” ในหน้าที่ครูควรใส่ใจ เปรียบเทียบหลายบทเรียนก่อนตัดสินว่าระดับชั้นหรือกิจกรรมใดควรใช้เกณฑ์ต่างออกไป",
  "sparky.attention.title": "สิ่งที่ครูควรใส่ใจ",
  "sparky.attention.description": "หนึ่งการ์ดต่อนักเรียนหนึ่งคนและหนึ่งหัวข้อ: เกิดอะไรขึ้น ทำไมจึงอยู่ที่นี่ และควรลองทำอะไรต่อ รายการติดตามที่ยังเปิดอยู่จะอยู่ด้านบน ตามด้วยนักเรียนที่กำลังเล่นอยู่ ปุ่มเสร็จแล้ว ติดตาม และไม่น่ากังวล มีผลกับทุกความพยายามบนการ์ด ข้อสังเกตเหล่านี้ชวนให้พูดคุยกับนักเรียน ไม่มีผลต่อคะแนน",
  "sparky.attention.open_count_one": "ข้อสังเกตที่ยังเปิดอยู่ {{count}} รายการ",
  "sparky.attention.open_count_other": "ข้อสังเกตที่ยังเปิดอยู่ {{count}} รายการ",
  "sparky.attention.hide_reviewed": "ซ่อนรายการที่ทบทวนแล้ว",
  "sparky.attention.show_reviewed": "แสดงรายการที่ทบทวนแล้ว",
  "sparky.attention.export": "ส่งออกข้อสังเกต",
  "sparky.attention.loading": "กำลังโหลดข้อสังเกต…",
  "sparky.attention.unavailable": "ไม่สามารถโหลดข้อสังเกตได้",
  "sparky.attention.try_next": "ลองทำต่อไป:",
  "sparky.attention.see_evidence": "ดูหลักฐานการโต้ตอบ",
  "sparky.attention.student_report": "รายงานนักเรียน",
  "sparky.attention.assignment": "บทเรียน",
  "sparky.attention.review_support": "ติดตามผล",
  "sparky.attention.review_fine": "ไม่น่ากังวล",
  "sparky.attention.review_done": "เสร็จแล้ว",
  "sparky.attention.review_acknowledged": "ดูแล้ว",
  "sparky.attention.review_open": "ยังเปิดอยู่",
  "sparky.attention.empty": "ไม่มีข้อสังเกตที่ยังเปิดอยู่สำหรับนักเรียนกลุ่มนี้ในการเข้าเล่นที่โหลดมา",
  "sparky.attention.view_all": "ดูข้อสังเกตทั้งหมด",
  "sparky.attention.footer_one": "การทบทวนจะถูกเก็บไว้ หลักฐานใหม่จะเปิดรายการอีกครั้ง แสดงข้อสังเกตจากการเข้าเล่นที่ตรงเงื่อนไข {{count}} ครั้งในช่วงนี้",
  "sparky.attention.footer_other": "การทบทวนจะถูกเก็บไว้ หลักฐานใหม่จะเปิดรายการอีกครั้ง แสดงข้อสังเกตจากการเข้าเล่นที่ตรงเงื่อนไข {{count}} ครั้งในช่วงนี้",
  "sparky.attention.loading_earlier": "กำลังโหลดการเข้าเล่นก่อนหน้า…",
  "sparky.attention.load_earlier": "โหลดข้อสังเกตก่อนหน้า",
  "sparky.attention.rapid_answers_title": "ตอบเร็วเกินกว่าจะอ่านคำถามทัน",
  "sparky.attention.rapid_answers_evidence_one": "{{count}} ชุดของคำตอบห้าข้อที่ตอบภายในไม่ถึงหนึ่งวินาทีต่อข้อ และส่วนใหญ่ผิด",
  "sparky.attention.rapid_answers_evidence_other": "{{count}} ชุดของคำตอบห้าข้อที่ตอบภายในไม่ถึงหนึ่งวินาทีต่อข้อ และส่วนใหญ่ผิด",
  "sparky.attention.rapid_answers_next": "ให้ {{name}} อ่านคำถามข้อถัดไปออกเสียงและอธิบายคำตอบก่อนเลือก",
  "sparky.attention.blocked_title": "กดซ้ำขณะที่เกมยังทำงานอยู่",
  "sparky.attention.blocked_evidence_one": "กด {{count}} ครั้งขณะที่เกมยังทำงานอยู่ (เช่น ขณะที่โปรแกรมกำลังทำงาน)",
  "sparky.attention.blocked_evidence_other": "กด {{count}} ครั้งขณะที่เกมยังทำงานอยู่ (เช่น ขณะที่โปรแกรมกำลังทำงาน)",
  "sparky.attention.blocked_next": "ดู {{name}} รันโปรแกรมหนึ่งครั้ง และชี้ให้เห็นว่าขั้นตอนถัดไปพร้อมใช้เมื่อใด",
  "sparky.attention.rapid_clicks_title": "แตะผ่านขั้นตอนอย่างรวดเร็ว",
  "sparky.attention.rapid_clicks_evidence_one": "{{count}} ชุดของการแตะห้าครั้งภายในสองวินาทีบนปุ่มเดียวกัน",
  "sparky.attention.rapid_clicks_evidence_other": "{{count}} ชุดของการแตะห้าครั้งภายในสองวินาทีบนปุ่มเดียวกัน",
  "sparky.attention.rapid_clicks_next": "ถาม {{name}} ว่าคำอธิบายล่าสุดพูดถึงอะไร ถ้าตอบไม่ได้ ให้อ่านไปด้วยกัน",
  "sparky.attention.difficulty_title": "ทบทวนแบบฝึกหัดนี้",
  "sparky.attention.difficulty_next_done": "ถาม {{name}} ว่าส่วนไหนยากที่สุด แล้วให้ลองด่านเดิมอีกครั้งโดยไม่ใช้ตัวช่วย",
  "sparky.attention.difficulty_next": "นั่งทำขั้นตอนแรกของด่านนี้ไปกับ {{name}} แล้วให้ทำต่อจนเสร็จด้วยตนเอง",
  "sparky.attention.difficulty_title_stuck": "ติดอยู่ที่ {{skill}}",
  "sparky.attention.difficulty_title_struggled": "ทำ {{skill}} ได้อย่างยากลำบาก",
  "sparky.attention.difficulty_title_helped": "ต้องการความช่วยเหลือใน {{skill}}",
  "sparky.attention.why": "ทำไมจึงอยู่ที่นี่:",
  "sparky.attention.why_sentence": "ในความพยายามล่าสุด {{name}} {{facts}}",
  "sparky.attention.why_join": " และ ",
  "sparky.attention.why_mistakes_one": "ทำผิด {{count}} ครั้ง",
  "sparky.attention.why_mistakes_other": "ทำผิด {{count}} ครั้ง",
  "sparky.attention.why_hints_one": "ขอความช่วยเหลือ {{count}} ครั้ง",
  "sparky.attention.why_hints_other": "ขอความช่วยเหลือ {{count}} ครั้ง",
  "sparky.attention.why_retries_one": "เริ่มใหม่ {{count}} ครั้ง",
  "sparky.attention.why_retries_other": "เริ่มใหม่ {{count}} ครั้ง",
  "sparky.attention.why_low_stars": "จบด่านด้วย {{stars}} จาก 3 ดาว",
  "sparky.attention.why_unfinished": "ออกจากด่านโดยยังไม่เสร็จ",
  "sparky.attention.why_skipped": "ข้ามด่านนี้",
  "sparky.attention.why_repeated_one": "ความพยายาม {{count}} ครั้งในหัวข้อนี้เป็นแบบนี้",
  "sparky.attention.why_repeated_other": "ความพยายาม {{count}} ครั้งในหัวข้อนี้เป็นแบบนี้",
  "sparky.attention.what_happened": "เกิดอะไรขึ้น",
  "sparky.attention.attempts_one": "{{count}} ความพยายาม",
  "sparky.attention.attempts_other": "{{count}} ความพยายาม",
  "sparky.attention.next_counting": "นับหรือจับคู่หนึ่งชุดออกเสียงไปกับ {{name}} โดยชี้ทีละชิ้น แล้วดูให้ทำชุดถัดไปด้วยตนเอง",
  "sparky.attention.next_sequence": "พูดรูปแบบออกเสียงด้วยกันว่าตัวถัดไปคืออะไรและเพราะอะไร แล้วให้ {{name}} ต่ออีกหนึ่งตัว",
  "sparky.attention.next_calculation": "ให้ {{name}} แสดงวิธีทำโจทย์หนึ่งข้อ เช่น “{{expected}}” บนกระดาษ แล้วลองข้อที่คล้ายกัน",
  "sparky.attention.next_place_value": "สร้างจำนวนหนึ่งจำนวนด้วยหลักหรือบล็อกค่าประจำหลักไปกับ {{name}} แล้วให้อ่านกลับ",
  "sparky.attention.next_geometry": "วางรูปร่างหรือมุมสองอย่างเคียงกันกับ {{name}} และบอกความต่าง แล้วลองอีกหนึ่งข้อ",
  "sparky.attention.next_fraction": "วาดหรือพับเศษส่วนหนึ่งจำนวนไปกับ {{name}} แล้วให้แสดงอีกจำนวนหนึ่ง",
  "sparky.attention.next_measurement": "วัดของจริงหนึ่งชิ้นกับ {{name}} และตรวจหน่วย แล้วให้ทำชิ้นถัดไปเอง",
  "sparky.attention.next_checkup": "ให้ {{name}} อธิบายคำตอบด้วยคำพูดของตนเอง แล้วถามแนวคิดเดิมด้วยตัวอย่างใหม่",
  "sparky.attention.next_trace": "ไล่โปรแกรมทีละบล็อกบนกระดานกับ {{name}} และถามว่าสปาร์กี้จะเลี้ยวตรงไหน ก่อนกดรัน",
  "sparky.attention.next_goal": "ถาม {{name}} ว่าเป้าหมายคืออะไรและขั้นตอนไหนยังขาดอยู่ แล้วให้เติมเอง",
  "sparky.attention.next_block": "ชี้ให้ {{name}} เห็นบล็อกที่ด่านนี้ต้องใช้ และสร้างตัวอย่างเล็ก ๆ ด้วยบล็อกนั้นไปด้วยกัน",
  "sparky.attention.next_error": "อ่านข้อความแจ้งข้อผิดพลาดกับ {{name}} และถามว่าข้างในลูปต้องเปลี่ยนอะไร",
  "sparky.attention.next_predict": "ให้ {{name}} บอกก่อนว่าโปรแกรมจะทำอะไรก่อนกดรันแต่ละครั้ง แล้วรันหนึ่งครั้ง",
  "sparky.attention.next_act_out": "แสดงบทบาทข้อความหรือสวิตช์ด้วยคนสองคน แล้วให้ {{name}} สร้างเอง",
  "sparky.attention.next_answer": "ทำโจทย์หนึ่งข้อออกเสียงไปกับ {{name}} แล้วดูให้ลองข้อถัดไปด้วยตนเอง",
  "sparky.attention.next_hints": "ลองด่านถัดไปกับ {{name}} โดยปิดตัวช่วย และถามว่าจะลองทำอะไรก่อน",
  "students.detail_tab_sparky": "Sparky",
  "sparky.page.subtitle": "กิจกรรมในชั้นเรียนแบบสดและประวัติการเรียนรู้",
  "sparky.page.open_sparky": "เปิด Sparky",
  "sparky.tabs.label": "มุมมอง Sparky",
  "sparky.tabs.live": "สด",
  "sparky.tabs.classroom": "ประวัติ",
  "sparky.tabs.mastery": "ความเชี่ยวชาญตามหัวข้อ",
  "sparky.tabs.lessons": "บทเรียน",
  "sparky.tabs.attention": "ต้องติดตาม",
  "sparky.filters.search": "ค้นหานักเรียน",
  "sparky.filters.search_placeholder": "ค้นหาด้วยชื่อหรือชื่อเล่น…",
  "sparky.filters.school_day": "วันเรียน",
  "sparky.filters.recent_days_one": "{{count}} วันเรียนล่าสุด",
  "sparky.filters.recent_days_other": "{{count}} วันเรียนล่าสุด",
  "sparky.filters.class": "ชั้นเรียน",
  "sparky.filters.all_classes": "ทุกชั้นเรียน",
  "sparky.filters.my_classes": "ชั้นเรียนของฉัน",
  "sparky.filters.grade_all_sections": "{{grade}} (ทุกห้อง)",
  "sparky.filters.period": "ช่วงเวลา",
  "sparky.filters.period_today": "วันนี้",
  "sparky.filters.period_range": "ช่วงวันที่",
  "sparky.filters.period_all": "ทั้งหมด",
  "sparky.filters.exercise_grade": "ระดับชั้นของแบบฝึกหัด",
  "sparky.filters.all_exercise_grades": "ทุกระดับชั้นของแบบฝึกหัด",
  "sparky.filters.activity": "กิจกรรม",
  "sparky.filters.all_activities": "ทุกกิจกรรม",
  "sparky.filters.live_activity": "กิจกรรมที่กำลังเล่น",
  "sparky.filters.review_only": "ควรดูเพิ่มเติม",
  "sparky.filters.interaction_only": "กดเร็วหรือเดาคำตอบ",
  "sparky.filters.no_students": "ไม่มีนักเรียนที่ตรงกับตัวกรองนี้",
  "sparky.classroom.loading": "กำลังโหลดชั้นเรียน…",
  "sparky.classroom.loading_roster": "กำลังโหลดรายชื่อชั้นเรียน…",
  "sparky.classroom.roster_unavailable": "ไม่สามารถโหลดรายชื่อชั้นเรียนได้",
  "sparky.classroom.updates_unavailable": "ไม่สามารถอัปเดตได้ ข้อมูลล่าสุดที่ได้รับอาจไม่เป็นปัจจุบัน",
  "sparky.classroom.stat_played": "นักเรียนที่เล่นแล้ว",
  "sparky.classroom.stat_played_hint_one": "จากนักเรียน {{count}} คนในตัวกรองนี้",
  "sparky.classroom.stat_played_hint_other": "จากนักเรียน {{count}} คนในตัวกรองนี้",
  "sparky.classroom.show_not_played_one": "แสดงนักเรียนที่ไม่ได้เล่น {{count}} คน",
  "sparky.classroom.show_not_played_other": "แสดงนักเรียนที่ไม่ได้เล่น {{count}} คน",
  "sparky.classroom.hide_not_played": "เฉพาะนักเรียนที่เล่น",
  "sparky.classroom.nobody_played": "ไม่มีนักเรียนเล่นในช่วงเวลานี้",
  "sparky.classroom.stat_levels": "ด่านที่ทำเสร็จ",
  "sparky.classroom.stat_active_hint": "ไม่รวมแท็บที่ซ่อนอยู่และช่วงหยุด",
  "sparky.classroom.stat_practice": "ควรฝึกเพิ่ม",
  "sparky.classroom.stat_practice_hint": "มีความยากซ้ำ ๆ จากการเข้าเล่นอย่างน้อยสองครั้ง",
  "sparky.classroom.activities_title": "กิจกรรมในช่วงนี้",
  "sparky.classroom.activity_hint": "นักเรียน {{students}} คน · ทำเสร็จ {{levels}} ด่าน",
  "sparky.classroom.export": "ส่งออกมุมมองนี้เป็น CSV",
  "sparky.classroom.help_summary": "ตัวเลขเหล่านี้อัปเดตอย่างไร",
  "sparky.classroom.help_details": "ยอดรวมจะโหลดใหม่ทุกครั้งที่นักเรียนเริ่มหรือจบด่าน หรือตอบคำถาม และเมื่อการเชื่อมต่อกลับมา เวลาใช้งานไม่รวมแท็บที่ซ่อนอยู่และช่วงหยุดหลังไม่มีการใช้งาน 1 นาที",
  "sparky.classroom.history_summary_one": "นักเรียน {{count}} คน",
  "sparky.classroom.history_summary_other": "นักเรียน {{count}} คน",
  "sparky.live.summary_one": "นักเรียน {{count}} คนกำลังเปิด Sparky",
  "sparky.live.summary_other": "นักเรียน {{count}} คนกำลังเปิด Sparky",
  "sparky.live.nobody_playing": "ขณะนี้ไม่มีใครกำลังเล่น",
  "sparky.live.caption": "นักเรียนที่กำลังเล่น Sparky อยู่ในขณะนี้",
  "sparky.live.connected": "อัปเดตสดขณะนักเรียนเล่น",
  "sparky.live.reconnecting": "การอัปเดตสดหยุดชั่วคราว กำลังเชื่อมต่อใหม่…",
  "sparky.live.help_details": "เกมแต่ละเกมส่งข้อมูลทุก 5 วินาที และหน้านี้จะอัปเดตทันทีที่ได้รับ เวลาใช้งานไม่รวมแท็บที่ซ่อนอยู่และช่วงหยุดหลังไม่มีการใช้งาน 1 นาที นักเรียนจะแสดงว่าขาดการเชื่อมต่อเมื่อไม่มีการอัปเดต 30 วินาที และจะหายจากหน้านี้หลัง 2 นาที การเล่นก่อนหน้าและยอดรวมดูได้ในแท็บประวัติ",
  "sparky.classroom.caption": "นักเรียน กิจกรรมสด และความก้าวหน้า",
  "sparky.classroom.col_status": "สถานะสด",
  "sparky.classroom.col_last_played": "เล่นล่าสุด",
  "sparky.classroom.col_level": "ด่านปัจจุบัน",
  "sparky.classroom.col_time": "เวลาในด่าน",
  "sparky.classroom.col_progress": "ความก้าวหน้าในช่วงวันที่",
  "sparky.classroom.updated_ago_one": "อัปเดตเมื่อ {{count}} วินาทีที่แล้ว",
  "sparky.classroom.updated_ago_other": "อัปเดตเมื่อ {{count}} วินาทีที่แล้ว",
  "sparky.classroom.last_played": "เล่นล่าสุด {{date}}",
  "sparky.classroom.no_play": "ยังไม่มีการเล่นที่บันทึกไว้",
  "sparky.classroom.last_action": "การกระทำล่าสุด: {{control}} · {{detail}}",
  "sparky.classroom.since_opening": "{{time}} นับจากเปิดด่าน",
  "sparky.classroom.progress_line": "ทำเสร็จ {{levels}} ด่าน · ทำเสร็จทั้งหมด {{completions}} ครั้ง · ข้าม {{skipped}} ครั้ง",
  "sparky.classroom.view_report": "ดูรายงานของ {{name}}",
  "sparky.summary.title": "Sparky · 30 วันที่ผ่านมา",
  "sparky.summary.open": "เปิดรายงาน Sparky",
  "sparky.summary.loading": "กำลังโหลดสรุปการเรียนรู้…",
  "sparky.summary.unavailable": "ไม่สามารถแสดงสรุปการเรียนรู้ได้",
  "sparky.summary.levels": "ด่านที่ทำเสร็จ (ไม่ซ้ำกัน)",
  "sparky.csv.visit_id": "รหัสการเข้าเล่น",
  "sparky.csv.visit": "การเข้าเล่น",
  "sparky.csv.started": "เริ่ม",
  "sparky.csv.course": "หลักสูตร",
  "sparky.csv.activity": "กิจกรรม",
  "sparky.csv.grade": "ระดับชั้น",
  "sparky.csv.school_grade": "ระดับชั้นเรียน",
  "sparky.csv.exercise_grade": "ระดับชั้นของแบบฝึกหัด",
  "sparky.csv.level": "ด่าน",
  "sparky.csv.skill": "ทักษะ",
  "sparky.csv.topic": "หัวข้อ",
  "sparky.csv.topic_levels": "จำนวนด่านในหัวข้อ",
  "sparky.csv.elapsed_ms": "เวลาที่ผ่านไป (มิลลิวินาที)",
  "sparky.csv.control": "ปุ่มควบคุม",
  "sparky.csv.event": "เหตุการณ์",
  "sparky.csv.step": "ขั้น",
  "sparky.csv.total_steps": "จำนวนขั้นทั้งหมด",
  "sparky.csv.detail": "รายละเอียด",
  "sparky.csv.student": "นักเรียน",
  "sparky.csv.lesson": "บทเรียน",
  "sparky.csv.assigned_levels": "ด่านที่มอบหมาย",
  "sparky.csv.target": "เป้าหมาย",
  "sparky.csv.different_levels_completed": "ด่านที่ทำเสร็จ (ไม่ซ้ำกัน)",
  "sparky.csv.target_met": "ถึงเป้าหมาย",
  "sparky.csv.stars_earned": "ดาวที่ได้",
  "sparky.csv.possible_stars": "ดาวที่เป็นไปได้",
  "sparky.csv.score_percent": "คะแนน (%)",
  "sparky.csv.test_points": "คะแนนที่ได้ในแบบทดสอบ",
  "sparky.csv.test_questions": "จำนวนข้อที่ตอบในแบบทดสอบ",
  "sparky.csv.test_percent": "คะแนนแบบทดสอบเทียบกับข้อที่ตอบ (%)",
  "sparky.csv.test_total": "จำนวนข้อทั้งหมดในแบบทดสอบ",
  "sparky.csv.test_whole_percent": "คะแนนแบบทดสอบเทียบกับทั้งแบบทดสอบ (%)",
  "sparky.csv.test_right": "แบบทดสอบ: ถูก",
  "sparky.csv.test_wrong": "แบบทดสอบ: ผิด",
  "sparky.csv.test_deduction": "คะแนนที่หักจากคำตอบผิด",
  "sparky.csv.test_dont_know": "แบบทดสอบ: ไม่รู้",
  "sparky.csv.test_not_answered": "แบบทดสอบ: ข้อที่ไม่ได้ตอบ",
  "sparky.csv.test_guessing": "คะแนนไม่ดีไปกว่าการเดา",
  "sparky.csv.topic_points": "{{topic}}: คะแนน",
  "sparky.csv.topic_questions": "{{topic}}: จำนวนข้อ",
  "sparky.csv.test_seconds": "เวลาที่ใช้ทำแบบทดสอบ (วินาที)",
  "sparky.csv.test_fast": "แบบทดสอบ: คำตอบภายใน 3 วินาที",
  "sparky.csv.active_seconds": "วินาทีที่ใช้งาน",
  "sparky.csv.mistakes": "ข้อผิดพลาด",
  "sparky.csv.successes": "ขั้นที่ถูก",
  "sparky.csv.refused_moves": "การเดินที่เกมไม่ยอมรับ",
  "sparky.csv.hints": "คำใบ้",
  "sparky.csv.retries": "การลองใหม่",
  "sparky.csv.skipped": "ข้าม",
  "sparky.csv.error_details": "รายละเอียดข้อผิดพลาดที่บันทึกไว้",
  "sparky.csv.result": "ผลลัพธ์",
  "sparky.csv.stars": "ดาว",
  "sparky.csv.completed_after_mistakes": "ทำเสร็จหลังทำผิด",
  "sparky.csv.independent_after_help": "ทำได้เองหลังได้รับความช่วยเหลือ",
  "sparky.csv.first_stars": "ดาวครั้งแรก",
  "sparky.csv.best_stars": "ดาวสูงสุด",
  "sparky.csv.completed_levels": "ด่านที่ทำเสร็จ",
  "sparky.csv.completions": "จำนวนครั้งที่ทำเสร็จ",
  "sparky.csv.one_star_levels": "ด่านที่ได้ 1 ดาว",
  "sparky.csv.two_star_levels": "ด่านที่ได้ 2 ดาว",
  "sparky.csv.three_star_levels": "ด่านที่ได้ 3 ดาว",
  "sparky.csv.signal": "สัญญาณการเรียนรู้",
  "sparky.csv.interaction_visits": "การเข้าเล่นที่มีการติดตามการโต้ตอบ",
  "sparky.csv.steps_advanced": "ขั้นที่เลื่อนไป",
  "sparky.csv.code_actions": "คำสั่งโค้ดที่ระบบรับ",
  "sparky.csv.blocked_presses": "กดซ้ำขณะเกมยังทำงานอยู่",
  "sparky.csv.rapid_bursts": "การกดรัวเร็ว",
  "sparky.csv.answer_visits": "การเข้าเล่นที่ติดตามคำตอบ",
  "sparky.csv.answers": "คำตอบแบบเลือกตอบ",
  "sparky.csv.rapid_answers": "รูปแบบการตอบเร็วเกินไป",
  "sparky.csv.timed_answers": "คำตอบที่จับเวลา",
  "sparky.csv.patterns": "รูปแบบ",
  "sparky.csv.median_response_ms": "ค่ามัธยฐานเวลาตอบ (มิลลิวินาที, ตัวอย่าง)",
  "sparky.csv.sampled_answers": "คำตอบที่สุ่มตัวอย่าง",
  "sparky.csv.needs_support_reviews": "ต้องการความช่วยเหลือ (การทบทวนของคุณ)",
  "sparky.csv.not_concerning_reviews": "ไม่น่ากังวล (การทบทวนของคุณ)",
  "sparky.csv.acknowledged_reviews": "รับทราบแล้ว (การทบทวนของคุณ)",
  "sparky.csv.observation": "ข้อสังเกต",
  "sparky.csv.evidence": "หลักฐาน",
  "sparky.csv.what_happened": "เกิดอะไรขึ้น",
  "sparky.csv.next_step": "ขั้นต่อไป",
  "sparky.csv.your_review": "การทบทวนของคุณ",
  "sparky.checkup.first_accuracy": "ความถูกต้องในการตอบครั้งแรก",
  "sparky.checkup.first_count": "ตอบถูกครั้งแรก {{correct}}/{{answered}} ข้อ",
  "sparky.checkup.guided": "แก้คำตอบหลังดูคำอธิบาย {{count}} ข้อ",
  "sparky.checkup.repeated": "ตอบถูกเมื่อเล่นข้อเดิมซ้ำ {{count}} ข้อ",
  "sparky.checkup.assisted": "คำตอบแรกที่มีการขอความช่วยเหลือหรือเริ่มใหม่ {{count}} ข้อ",
  "sparky.checkup.unknown": "{{count}} คำถามที่ไม่ได้บันทึกคำตอบแรก (เกมเวอร์ชันเก่า)",
  "sparky.checkup.answer_correct": "คำตอบแรก: ถูกต้อง",
  "sparky.checkup.answer_incorrect": "คำตอบแรก: ไม่ถูกต้อง",
  "sparky.checkup.answer_assisted": "คำตอบแรก: มีการขอความช่วยเหลือหรือเริ่มใหม่",
  "sparky.checkup.answer_unknown": "ไม่ได้บันทึกคำตอบแรก (เกมเวอร์ชันเก่า)",
  "sparky.checkup.guided_answer": "แก้ถูกหลังดูคำอธิบาย · การฝึกแบบมีคำแนะนำ",
  "sparky.checkup.repeated_answer": "ตอบถูกเมื่อเล่นซ้ำ · คำตอบแรกเดิมไม่เปลี่ยน",
  "sparky.checkup.first_correct": "คำตอบแรกที่ถูกต้อง",
  "sparky.checkup.answers_recorded": "ข้อที่บันทึกคำตอบแรก",
  "sparky.checkup.guided_label": "การแก้คำตอบแบบมีคำแนะนำ",
  "sparky.checkup.guided_hint": "คำตอบที่แก้ถูกหลังดูคำอธิบาย ไม่นับเพิ่มในความถูกต้องครั้งแรก",
  "sparky.checkup.assessment_note": "ความถูกต้องของแบบตรวจสอบใช้คำตอบแรกที่บันทึกของแต่ละข้อ การแก้ถูกหลังดูคำอธิบายหรือเล่นซ้ำไม่เพิ่มคะแนนนี้ การขอความช่วยเหลือหรือเริ่มใหม่แสดงแยกต่างหาก หากไม่มีหลักฐานคำตอบแรก จะไม่คาดเดาจากดาว แบบตรวจสอบใหม่จะอธิบายเมื่อผิดแล้วไปข้ออื่น ดาวแสดงการทำเสร็จ ไม่ใช่ความถูกต้องในการประเมิน",
  "sparky.checkup.prepare_fresh": "เตรียมแบบตรวจสอบข้อใหม่",
  "sparky.checkup.fresh_title": "แบบตรวจสอบข้อใหม่ · {{name}}",
  "sparky.checkup.fresh_description": "นักเรียนยังไม่เคยเปิดข้อเหล่านี้ และเป็นหัวข้อที่ต้องทบทวน ความยากและทักษะเฉพาะอาจแตกต่างกัน โปรดดูตัวอย่างแต่ละข้อก่อนบันทึกฉบับร่าง การเริ่มฉบับร่างเป็นอีกขั้นตอนหนึ่ง",
  "sparky.checkup.save_fresh": "บันทึกฉบับร่างแบบตรวจสอบข้อใหม่",
  "sparky.checkup.no_fresh": "ไม่มีข้อที่ยังไม่เคยเปิดในหัวข้อที่ต้องทบทวน กรุณาเพิ่มข้อใหม่ก่อนประเมินอีกครั้ง",
  "sparky.checkup.fresh_levels_required": "เลือกอย่างน้อยหนึ่งข้อ",
  "sparky.checkup.group_heading": "ติดตามผลเป็นกลุ่ม",
  "sparky.checkup.group_section_description": "สร้างฉบับร่างบทเรียนติดตามผลหนึ่งบทสำหรับเด็กที่ยังกำลังพัฒนาหรือยังไม่ได้ในหัวข้อที่เลือก",
  "sparky.checkup.group_grade": "ระดับชั้นของแบบฝึกหัด",
  "sparky.checkup.group_prepare": "เตรียมการติดตามผลเป็นกลุ่ม",
  "sparky.checkup.group_none": "ยังไม่มีเด็กคนใดอยู่ในระดับกำลังพัฒนาหรือยังไม่ได้ในหัวข้อที่มีหลักฐานเพียงพอ",
  "sparky.checkup.group_description": "{{grade}}: เลือกหัวข้อ ตรวจสอบรายชื่อเด็ก และเลือกข้อคำถาม ข้อที่ยังไม่มีเด็กในกลุ่มคนใดเคยเห็นจะแสดงก่อน โดยข้อติดตามผลมาก่อนข้ออื่น การเริ่มฉบับร่างเป็นอีกขั้นตอนหนึ่ง",
  "sparky.checkup.group_title": "ติดตามผล · {{topics}}",
  "sparky.checkup.group_topics": "หัวข้อ",
  "sparky.checkup.group_topic_count_one": "เด็กที่กำลังพัฒนาหรือยังไม่ได้ {{count}} คน",
  "sparky.checkup.group_topic_count_other": "เด็กที่กำลังพัฒนาหรือยังไม่ได้ {{count}} คน",
  "sparky.checkup.group_topics_required": "เลือกอย่างน้อยหนึ่งหัวข้อ",
  "sparky.checkup.group_questions_one": "ข้อคำถาม (เลือกแล้ว {{count}} ข้อ)",
  "sparky.checkup.group_questions_other": "ข้อคำถาม (เลือกแล้ว {{count}} ข้อ)",
  "sparky.checkup.group_loading": "กำลังค้นหาข้อที่กลุ่มนี้ยังไม่เคยเห็น…",
  "sparky.checkup.group_error": "โหลดข้อคำถามไม่ได้",
  "sparky.checkup.group_no_questions": "เด็กส่วนใหญ่ในกลุ่มนี้เคยเห็นทุกข้อในหัวข้อเหล่านี้แล้ว",
  "sparky.checkup.group_unseen_all": "ใหม่สำหรับทุกคน",
  "sparky.checkup.group_unseen_some": "ใหม่สำหรับ {{unseen}} จาก {{total}} คน",
  "sparky.checkup.group_save": "บันทึกฉบับร่างการติดตามผลเป็นกลุ่ม",
  "sparky.checkup.followup": "ข้อติดตามผล",
  "timetable.tab_timetable": "ตารางเรียน",
  "timetable.tab_tests": "แบบทดสอบ",
  "timetable.tabs_label": "มุมมองตารางเรียน",
  "tests_calendar.subtitle": "แบบทดสอบของทุกชั้นเรียนในโรงเรียน แยกตามสัปดาห์",
  "tests_calendar.grade_filter": "ระดับชั้น",
  "tests_calendar.all_grades": "ทุกระดับชั้น",
  "tests_calendar.previous_week": "สัปดาห์ก่อน",
  "tests_calendar.next_week": "สัปดาห์ถัดไป",
  "tests_calendar.this_week": "สัปดาห์นี้",
  "tests_calendar.week_of": "สัปดาห์ของวันที่ {{date}}",
  "tests_calendar.col_class": "ชั้นเรียน",
  "tests_calendar.legend_yours": "แบบทดสอบของคุณ",
  "tests_calendar.legend_others": "แบบทดสอบของครูท่านอื่น",
  "tests_calendar.legend_crowded": "มีแบบทดสอบตั้งแต่ 2 รายการขึ้นไปในวันเดียว",
  "edp.tab_registers": "การเช็คชื่อ",
  "edp.registers.heading": "การเช็คชื่อ",
  "edp.registers.subtitle": "ทุกคาบเรียน EDP ว่าเช็คชื่อแล้วหรือยัง และใครเป็นผู้สอน คาบที่ยกเลิกจะไม่นับว่ายังไม่เช็คชื่อ",
  "edp.registers.empty": "ไม่มีคาบเรียน EDP ในช่วงนี้",
  "edp.registers.empty_owed": "ทุกคาบในช่วงนี้เช็คชื่อครบแล้ว",
  "edp.registers.show_all": "ทุกคาบ",
  "edp.registers.show_owed": "ยังไม่เช็คชื่อ",
  "edp.registers.range_label": "ช่วงเวลา",
  "edp.registers.range_week": "หนึ่งสัปดาห์",
  "edp.registers.range_term": "ทั้งภาคเรียนจนถึงวันนี้",
  "edp.registers.col_lesson": "คาบเรียน",
  "edp.registers.col_course": "วิชา",
  "edp.registers.col_teacher": "ครู",
  "edp.registers.col_register": "การเช็คชื่อ",
  "edp.registers.with_assistants": "ร่วมกับ {{names}}",
  "edp.lessons.came": "มา {{attended}} จาก {{total}} คน",
  "edp.lessons.part_done": "เช็คแล้ว {{marked}} จาก {{total}} คน",
  "edp.lessons.state.today": "วันนี้",
  "edp.lessons.state.upcoming": "ยังไม่ถึง",
  "edp.lessons.state.taken": "เช็คชื่อแล้ว",
  "edp.lessons.state.partial": "เช็คไม่ครบ",
  "edp.lessons.state.not_taken": "ยังไม่เช็คชื่อ",
  "edp.lessons.state.no_children": "ไม่มีนักเรียน",
  "edp.lessons.state.cancelled": "ยกเลิก",
  "edp.lessons.state.moved": "ย้ายวันแล้ว",
  "edp.lessons.make_up_for": "ชดเชยคาบวันที่ {{date}}",
  "edp.lessons.overview_held": "สอนไปแล้ว {{held}} จาก {{total}} คาบ",
  "edp.lessons.overview_not_taken": "ยังไม่เช็คชื่อ {{count}} คาบ",
  "edp.lessons.overview_partial": "เช็คไม่ครบ {{count}} คาบ",
  "edp.lessons.overview_cancelled": "ยกเลิก {{count}} คาบ",
  "edp.register.crumb": "เช็คชื่อ",
  "edp.register.tabs_label": "การเช็คชื่อของวิชา",
  "edp.register.tab_lessons": "คาบเรียน",
  "edp.register.tab_summary": "สรุปภาคเรียน",
  "edp.register.lessons_title": "คาบเรียนในภาคเรียนนี้",
  "edp.register.no_lessons": "วิชานี้ไม่มีคาบเรียนในภาคเรียนนี้",
  "edp.register.cancel_lesson": "ยกเลิกคาบนี้",
  "edp.register.moved_notice": "วิชานี้ไม่ได้เรียนในวันนี้แล้ว จึงดูการเช็คชื่อได้แต่แก้ไขไม่ได้"
}
